import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date scalar type */
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** Mongo Object ID scalar type */
  ObjectId: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AbortUploadEvent = {
  __typename?: 'AbortUploadEvent';
  _id: Scalars['String'];
  accountId: Scalars['ObjectId'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isAborted: Scalars['Boolean'];
  isCompleted: Scalars['Boolean'];
  progressStatus?: Maybe<Scalars['String']>;
  progressTrackingId: Scalars['ObjectId'];
  s3FileKey: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type AcceptApiInvitationInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};

export type Account = {
  __typename?: 'Account';
  _id: Scalars['String'];
  archivingReason?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  excludeFromReports?: Maybe<Scalars['Boolean']>;
  hubSpotId?: Maybe<Scalars['String']>;
  isSeeker: Scalars['Boolean'];
  lastAccountTypeSwitchAt?: Maybe<Scalars['Date']>;
  mfaEnabled?: Maybe<Scalars['Boolean']>;
  mfaMethod?: Maybe<MfaMethodsEnum>;
  mfaSecret?: Maybe<Scalars['String']>;
  phone?: Maybe<Phone>;
  productSubscriptionId?: Maybe<Scalars['String']>;
  profile: Profile;
  provider?: Maybe<Scalars['String']>;
  role: Role;
  roleId: Scalars['String'];
  rollbackSubscriptionId?: Maybe<Scalars['String']>;
  showAllBillingPlans?: Maybe<Scalars['Boolean']>;
  ssoId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeDefaultPaymentMethodId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  zohoId?: Maybe<Scalars['String']>;
};

export enum AccountActiveOrArchivedStatusesEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type AccountInput = {
  _id?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
};

export type AddMediaKitItems = {
  mediaIdsToAdd: Array<Scalars['ObjectId']>;
  portfolioId: Scalars['ObjectId'];
};

export type AddSaleTeamUserAccountInput = {
  email: Scalars['String'];
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
};

export type AddSaleTeamUserInput = {
  accountInput: AddSaleTeamUserAccountInput;
  assignedPropertiesIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  profileInput: ProfileInput;
  saleTeamId: Scalars['ObjectId'];
  saleTeamRoleId: Scalars['ObjectId'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AdvancedPropertyDetailsInput = {
  buildingTypes?: InputMaybe<Array<BuildingTypesEnum>>;
  completionDate?: InputMaybe<Scalars['Date']>;
  constructionStartDate?: InputMaybe<Scalars['Date']>;
  interiorDesigner?: InputMaybe<Scalars['String']>;
  landscapeArchitect?: InputMaybe<Scalars['String']>;
  leadArchitect?: InputMaybe<Scalars['String']>;
  localArchitect?: InputMaybe<Scalars['String']>;
  numberOfTowers?: InputMaybe<Scalars['Float']>;
  numberOfUnits?: InputMaybe<Scalars['Float']>;
  overview?: InputMaybe<Scalars['String']>;
  projectDetails?: InputMaybe<Scalars['String']>;
  projectStatus?: InputMaybe<ProjectStatusesEnum>;
  propertyId: Scalars['ObjectId'];
  propertyTags?: InputMaybe<Array<PropertyTagsEnum>>;
  salesGalleryAddress?: InputMaybe<Scalars['String']>;
  salesGalleryHours?: InputMaybe<LocalTimeHoursInput>;
  salesGalleryStatus?: InputMaybe<SalesGalleryStatusesEnum>;
  stories?: InputMaybe<Scalars['Float']>;
  taxInformation?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<PropertyTransactionTypesEnum>;
  virtualTourLinks?: InputMaybe<Array<VirtualTourLinkInput>>;
  workingHours?: InputMaybe<WorkingHoursInput>;
  yearBuilt?: InputMaybe<Scalars['Float']>;
};

export type AmenitiesPayload = {
  __typename?: 'AmenitiesPayload';
  collection: Array<Amenity>;
  totalCount: Scalars['Float'];
};

export type Amenity = {
  __typename?: 'Amenity';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  imageFile?: Maybe<File>;
  imageFileId: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  isPrimary: Scalars['Boolean'];
  name: Scalars['String'];
  primaryAmenityId?: Maybe<Scalars['ObjectId']>;
  propertyId?: Maybe<Scalars['ObjectId']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type AmenityName = {
  __typename?: 'AmenityName';
  amenityId: Scalars['ObjectId'];
  name: Scalars['String'];
};

export type ApiBrokerInfo = {
  __typename?: 'ApiBrokerInfo';
  _id?: Maybe<Scalars['String']>;
};

export type ApiCredentialSafeDto = {
  __typename?: 'ApiCredentialSafeDTO';
  _id: Scalars['String'];
  adminDisabled?: Maybe<Scalars['Boolean']>;
  appId: Scalars['String'];
  associatedAccounts?: Maybe<Array<Scalars['ID']>>;
  associatedCompany?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  disabledAt?: Maybe<Scalars['Date']>;
  disabledBy?: Maybe<Scalars['String']>;
  disabledReason?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  monthlyRequestLimit?: Maybe<Scalars['Float']>;
  partnerDisabled?: Maybe<Scalars['Boolean']>;
  referralCode?: Maybe<Scalars['String']>;
  type: ApiCredentialsTypesEnum;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type ApiCredentialsInput = {
  companyName?: InputMaybe<Scalars['String']>;
  isMarketplacePartner?: InputMaybe<Scalars['Boolean']>;
  referralCode?: InputMaybe<Scalars['String']>;
};

export type ApiCredentialsPluginUserResponse = {
  __typename?: 'ApiCredentialsPluginUserResponse';
  _id: Scalars['String'];
  adminDisabled?: Maybe<Scalars['Boolean']>;
  appId?: Maybe<Scalars['String']>;
  associatedCompany?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  partnerDisabled?: Maybe<Scalars['Boolean']>;
};

export enum ApiCredentialsTypesEnum {
  Company = 'COMPANY',
  PluginUser = 'PLUGIN_USER'
}

export type ApiCredentialsUserResponse = {
  __typename?: 'ApiCredentialsUserResponse';
  _id: Scalars['String'];
  adminDisabled?: Maybe<Scalars['Boolean']>;
  appId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  disabledAt?: Maybe<Scalars['Date']>;
  disabledReason?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
};

export type ApiInvitationSafeDto = {
  __typename?: 'ApiInvitationSafeDTO';
  _id: Scalars['String'];
  acceptedAt?: Maybe<Scalars['Date']>;
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  expiresAt: Scalars['Date'];
  isMarketplacePartner?: Maybe<Scalars['Boolean']>;
  referralCode?: Maybe<Scalars['String']>;
  status: ApiInvitationStatusEnum;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum ApiInvitationStatusEnum {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Fulfilled = 'FULFILLED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export type ApiInvitationValidation = {
  __typename?: 'ApiInvitationValidation';
  companyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  hasExistingAccount: Scalars['Boolean'];
  isValid: Scalars['Boolean'];
  status?: Maybe<ApiInvitationStatusEnum>;
};

export type ApiInvitationsPayload = {
  __typename?: 'ApiInvitationsPayload';
  collection: Array<ApiInvitationSafeDto>;
  totalCount: Scalars['Int'];
};

export type ApiMetric = {
  __typename?: 'ApiMetric';
  _id: Scalars['String'];
  appId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  credentialsType: Scalars['String'];
  dataPoints: Array<MetricDataPoint>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
  totalRequests: Scalars['Float'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type ApiMetricPayload = {
  __typename?: 'ApiMetricPayload';
  collection: Array<ApiMetric>;
  totalCount: Scalars['Float'];
};

export type ApiPluginUser = {
  __typename?: 'ApiPluginUser';
  account: Account;
  apiCredentials?: Maybe<ApiCredentialsPluginUserResponse>;
  broker?: Maybe<ApiBrokerInfo>;
  clientCount?: Maybe<Scalars['Float']>;
  monthlyApiAccess?: Maybe<Scalars['Float']>;
  profile: Profile;
};

export type ApiPluginUsersPayload = {
  __typename?: 'ApiPluginUsersPayload';
  collection: Array<ApiPluginUser>;
  totalCount: Scalars['Float'];
};

export type ApiQuotaStatusPayload = {
  __typename?: 'ApiQuotaStatusPayload';
  limit: Scalars['Float'];
  resetDate: Scalars['Date'];
  usage: Scalars['Float'];
};

export type ApiUser = {
  __typename?: 'ApiUser';
  account: Account;
  apiCredentials?: Maybe<ApiCredentialsUserResponse>;
  clientCount?: Maybe<Scalars['Float']>;
  monthlyApiAccess?: Maybe<Scalars['Float']>;
  profile: Profile;
};

export type ApiUsersPayload = {
  __typename?: 'ApiUsersPayload';
  collection: Array<ApiUser>;
  totalCount: Scalars['Float'];
};

export type ApprovePropertyInput = {
  propertyId: Scalars['ObjectId'];
};

export type ArchivePropertyInput = {
  propertyId: Scalars['ObjectId'];
};

export type AttributionInput = {
  fbclid?: InputMaybe<Scalars['String']>;
  gclid?: InputMaybe<Scalars['String']>;
  referrer?: InputMaybe<Scalars['String']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  utm_term?: InputMaybe<Scalars['String']>;
};

export type AuditPropertyInput = {
  propertyId: Scalars['ObjectId'];
};

export type AuthResult = MfaTempTokenModel | TokensModel;

export type BasicInfoResponse = {
  __typename?: 'BasicInfoResponse';
  appId: Scalars['String'];
  hasKey: Scalars['Boolean'];
  isActive?: Maybe<Scalars['Boolean']>;
  referralCode?: Maybe<Scalars['String']>;
  type?: Maybe<ApiCredentialsTypesEnum>;
};

export type Branding = {
  __typename?: 'Branding';
  backgroundColor: Scalars['String'];
  mainColor: Scalars['String'];
  textColor: Scalars['String'];
};

export type BrandingInput = {
  backgroundColor: Scalars['String'];
  mainColor: Scalars['String'];
  textColor: Scalars['String'];
};

export enum BrandingTypeEnum {
  Branded = 'BRANDED',
  Shared = 'SHARED',
  Unbranded = 'UNBRANDED'
}

export enum BrandingTypeFilterEnum {
  All = 'ALL',
  Branded = 'BRANDED',
  Shared = 'SHARED',
  Unbranded = 'UNBRANDED'
}

export type Broker = {
  __typename?: 'Broker';
  _id: Scalars['String'];
  account: Account;
  accountId: Scalars['String'];
  accountSubscription?: Maybe<ProductSubscription>;
  agencyName?: Maybe<Scalars['String']>;
  agencyWebsite?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  demoExpirationDate?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  hasActiveApiCredential: Scalars['Boolean'];
  isRealUser: Scalars['Boolean'];
  isSeeker: Scalars['Boolean'];
  license?: Maybe<BrokerLicense>;
  preferredPropertySettings?: Maybe<PreferredPropertySettings>;
  profile: Profile;
  profileId: Scalars['String'];
  subscriptionType: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  workingHours?: Maybe<WorkingHours>;
};

export enum BrokerActivitiesTypesEnum {
  PortfolioAdded = 'PORTFOLIO_ADDED',
  PropertyVisited = 'PROPERTY_VISITED'
}

export type BrokerActivity = {
  __typename?: 'BrokerActivity';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type BrokerAlertConfig = {
  __typename?: 'BrokerAlertConfig';
  _id: Scalars['String'];
  brokerId: Scalars['ObjectId'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  filter: BrokerAlertConfigFilter;
  name: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type BrokerAlertConfigConstructionDateRangeFilter = {
  __typename?: 'BrokerAlertConfigConstructionDateRangeFilter';
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

export type BrokerAlertConfigFilter = {
  __typename?: 'BrokerAlertConfigFilter';
  amenities?: Maybe<Array<Scalars['String']>>;
  amenityIds?: Maybe<Array<Scalars['ObjectId']>>;
  buildingTypes?: Maybe<Array<BuildingTypesEnum>>;
  constructionDateRange?: Maybe<BrokerAlertConfigConstructionDateRangeFilter>;
  locationFilter?: Maybe<BrokerAlertConfigLocationFilter>;
  marketAreaIds?: Maybe<Array<Scalars['ObjectId']>>;
  priceRange?: Maybe<MinMaxRangePayload>;
  projectStatuses?: Maybe<Array<ProjectStatusesEnum>>;
  propertyTags?: Maybe<Array<PropertyTagsEnum>>;
  transactionType?: Maybe<PropertyTransactionTypesEnum>;
  unitNumberOfBathrooms?: Maybe<MinMaxRangePayload>;
  unitNumberOfBedrooms?: Maybe<MinMaxRangePayload>;
  unitNumberOfUnits?: Maybe<MinMaxRangePayload>;
  yearBuildRange?: Maybe<MinMaxRangePayload>;
};

export type BrokerAlertConfigLocationFilter = {
  __typename?: 'BrokerAlertConfigLocationFilter';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  radiusToSearchInMiles: Scalars['Float'];
};

export type BrokerAlertConfigPayload = {
  __typename?: 'BrokerAlertConfigPayload';
  collection: Array<BrokerAlertConfig>;
  totalCount: Scalars['Float'];
};

export type BrokerAlertItem = {
  __typename?: 'BrokerAlertItem';
  _id: Scalars['String'];
  brokerAlertConfig: BrokerAlertConfig;
  brokerAlertConfigId: Scalars['ObjectId'];
  brokerId: Scalars['ObjectId'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isHidden: Scalars['Boolean'];
  isNew: Scalars['Boolean'];
  isPropertyPublic: Scalars['Boolean'];
  property: Property;
  propertyId: Scalars['ObjectId'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type BrokerAlertItemPayload = {
  __typename?: 'BrokerAlertItemPayload';
  collection: Array<BrokerAlertItem>;
  totalCount: Scalars['Float'];
};

export type BrokerLicense = {
  __typename?: 'BrokerLicense';
  licenseExpirationDate?: Maybe<Scalars['Date']>;
  licenseJurisdictionCode?: Maybe<Scalars['String']>;
  licenseNumber: Scalars['String'];
  licenseStatus: Scalars['String'];
};

export enum BrokerLicenseStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  PendingReview = 'PENDING_REVIEW'
}

export enum BrokerPortfolioComparisonFields {
  BuildingType = 'BUILDING_TYPE',
  Location = 'LOCATION',
  NumberOfBathrooms = 'NUMBER_OF_BATHROOMS',
  NumberOfBedrooms = 'NUMBER_OF_BEDROOMS',
  ProjectStatus = 'PROJECT_STATUS',
  StartingPrice = 'STARTING_PRICE',
  TaxInformation = 'TAX_INFORMATION',
  UnitsAvailable = 'UNITS_AVAILABLE',
  UnitSizes = 'UNIT_SIZES'
}

export enum BrokerPortfolioStatusesEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type BrokerReactionsStats = {
  __typename?: 'BrokerReactionsStats';
  negative: Scalars['Float'];
  neutral: Scalars['Float'];
  positive: Scalars['Float'];
  total: Scalars['Float'];
};

export type BrokerSavedFeaturedPortfolio = {
  __typename?: 'BrokerSavedFeaturedPortfolio';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  portfolio?: Maybe<FeaturedPortfolio>;
  portfolioId: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type BrokerSavedFeaturedPortfoliosPayload = {
  __typename?: 'BrokerSavedFeaturedPortfoliosPayload';
  collection: Array<BrokerSavedFeaturedPortfolio>;
  totalCount: Scalars['Float'];
};

export enum BrokerSubscriptionTypesEnum {
  Billable = 'BILLABLE',
  Demo = 'DEMO'
}

export type BrokerTrackedPropertiesPayload = {
  __typename?: 'BrokerTrackedPropertiesPayload';
  collection: Array<BrokerTrackedProperty>;
  totalCount: Scalars['Float'];
};

export type BrokerTrackedProperty = {
  __typename?: 'BrokerTrackedProperty';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  property: Property;
  propertyId: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type BrokerViewedPortfoliosFilter = {
  portfolioIds: Array<Scalars['ObjectId']>;
  range?: InputMaybe<DateRangeInput>;
};

export type BrokersPayload = {
  __typename?: 'BrokersPayload';
  collection: Array<Broker>;
  totalCount: Scalars['Float'];
};

export enum BuildingTypesEnum {
  ActiveAdult = 'ACTIVE_ADULT',
  Boutique = 'BOUTIQUE',
  Condo = 'CONDO',
  CondoConversion = 'CONDO_CONVERSION',
  CondoHotel = 'CONDO_HOTEL',
  LuxuryApartment = 'LUXURY_APARTMENT',
  Penthouse = 'PENTHOUSE',
  PrivateResidence = 'PRIVATE_RESIDENCE',
  ShortTermRentalFriendly = 'SHORT_TERM_RENTAL_FRIENDLY',
  SingleFamilyHome = 'SINGLE_FAMILY_HOME',
  Townhome = 'TOWNHOME',
  Villa = 'VILLA',
  WorkforceHousing = 'WORKFORCE_HOUSING'
}

export type CanUserTrialForProductInput = {
  stripeProductId: Scalars['String'];
};

export type CancelProductSubscriptionInput = {
  cancelationReason: Scalars['String'];
  downgradeTo?: InputMaybe<Scalars['String']>;
  otherReason?: InputMaybe<Scalars['String']>;
};

export type ChangelogDocument = PropertyAboutChangelog | PropertyAdditionalInformationChangelog | PropertyCmsStatusChangelog | PropertyDataReviewedChangelog | PropertyDeveloperOrganizationChangelog | PropertyFeaturesAndAmenitiesChangelog | PropertyHighlightsChangelog | PropertyInventoryUnitAddedChangelog | PropertyInventoryUnitRemovedChangelog | PropertyInventoryUnitUpdatedChangelog | PropertyLocationChangelog | PropertyMediaFilesMovedChangelog | PropertyMediaRemovedChangelog | PropertyMediaRenamedChangelog | PropertyMediaUploadedChangelog | PropertyNameChangelog | PropertyOrganizationSalesTeamsChangelog | PropertyPriceChangelog | PropertyVirtualToursChangelog | PropertyVisibilityChangelog | PropertyWebsiteChangelog;

export type CheckoutSessionDetails = {
  __typename?: 'CheckoutSessionDetails';
  customerName: Scalars['String'];
  status: Scalars['String'];
  totalAmount: Scalars['Int'];
  trialEndAt?: Maybe<Scalars['Int']>;
};

export type CmsSettings = {
  __typename?: 'CmsSettings';
  _id: Scalars['String'];
  activeToAwaitingAuditDays: Scalars['Float'];
  automatedTransitionsEnabled: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  newListingToActiveDays: Scalars['Float'];
  recentlyUpdatedToActiveDays: Scalars['Float'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum CmsStatusEnum {
  ActiveListing = 'ACTIVE_LISTING',
  Archived = 'ARCHIVED',
  AwaitingAudit = 'AWAITING_AUDIT',
  Draft = 'DRAFT',
  NewListing = 'NEW_LISTING',
  NotSet = 'NOT_SET',
  PendingApproval = 'PENDING_APPROVAL',
  PendingArchive = 'PENDING_ARCHIVE',
  Proposed = 'PROPOSED',
  RecentlyUpdated = 'RECENTLY_UPDATED'
}

export type Comparison = {
  __typename?: 'Comparison';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  fieldsToCompare: Array<Scalars['String']>;
  portfolioFolderId?: Maybe<Scalars['String']>;
  portfolioIds: Array<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type ContactPhone = {
  __typename?: 'ContactPhone';
  dialCode: Scalars['String'];
  number: Scalars['String'];
};

export type ContentActivity = {
  __typename?: 'ContentActivity';
  changes: Scalars['Int'];
  changesByType: Array<ContentActivityChangeType>;
  contributors: Array<ContentActivityContributor>;
  filesUploaded: Scalars['Int'];
  propertiesCreated: Scalars['Int'];
  propertiesEdited: Scalars['Int'];
};

export type ContentActivityChangeType = {
  __typename?: 'ContentActivityChangeType';
  changes: Scalars['Int'];
  properties: Scalars['Int'];
  type?: Maybe<PropertyChangelogTypesEnum>;
};

export type ContentActivityContributor = {
  __typename?: 'ContentActivityContributor';
  accountId?: Maybe<Scalars['ObjectId']>;
  changes: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  filesUploaded: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  propertiesCreated: Scalars['Int'];
  propertiesEdited: Scalars['Int'];
};

export type ContentActivityLog = {
  __typename?: 'ContentActivityLog';
  collection: Array<ContentActivityLogEntry>;
  totalCount: Scalars['Int'];
};

export type ContentActivityLogEntry = {
  __typename?: 'ContentActivityLogEntry';
  _id: Scalars['ObjectId'];
  accountId?: Maybe<Scalars['ObjectId']>;
  authorEmail?: Maybe<Scalars['String']>;
  authorName?: Maybe<Scalars['String']>;
  cmsStatusChange?: Maybe<ContentActivityValueChange>;
  createdAt: Scalars['Date'];
  propertyId: Scalars['ObjectId'];
  propertyName?: Maybe<Scalars['String']>;
  type?: Maybe<PropertyChangelogTypesEnum>;
  visibilityChange?: Maybe<ContentActivityValueChange>;
};

export type ContentActivityValueChange = {
  __typename?: 'ContentActivityValueChange';
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type CopyFeaturedPortfolioToBrokerPortfolioArgs = {
  featuredPortfolioId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type CopyFeaturedPortfolioToBrokerPortfolioResult = {
  __typename?: 'CopyFeaturedPortfolioToBrokerPortfolioResult';
  _id: Scalars['String'];
  name: Scalars['String'];
  propertyCount: Scalars['Float'];
};

export type CreateAlertConfigFilterInput = {
  amenityIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  buildingTypes?: InputMaybe<Array<BuildingTypesEnum>>;
  cityNames?: InputMaybe<Array<Scalars['String']>>;
  cmsStatus?: InputMaybe<CmsStatusEnum>;
  completionDate?: InputMaybe<Scalars['Date']>;
  constructionDateRange?: InputMaybe<DateRangeInput>;
  countyNames?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  locationFilter?: InputMaybe<GetBrokerPropertiesLocationFilterInput>;
  marketAreaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  organizationIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  priceRange?: InputMaybe<PartialMinMaxRangeInput>;
  projectStatuses?: InputMaybe<Array<Scalars['String']>>;
  propertyTags?: InputMaybe<Array<PropertyTagsEnum>>;
  stateIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  strictPriceRange?: InputMaybe<PartialMinMaxRangeInput>;
  transactionType?: InputMaybe<PropertyTransactionTypesEnum>;
  unitNumberOfBathrooms?: InputMaybe<PartialMinMaxRangeInput>;
  unitNumberOfBedrooms?: InputMaybe<PartialMinMaxRangeInput>;
  unitNumberOfUnits?: InputMaybe<PartialMinMaxRangeInput>;
  yearBuildRange?: InputMaybe<MinMaxRangeInput>;
};

export type CreateAmenityInput = {
  imageFileId: Scalars['ObjectId'];
  isPrimary?: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CreateApiInvitationInput = {
  companyName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  expiresAt: Scalars['Date'];
  isMarketplacePartner?: InputMaybe<Scalars['Boolean']>;
  referralCode?: InputMaybe<Scalars['String']>;
};

export type CreateBrokerInput = {
  apiReferralCode?: InputMaybe<Scalars['String']>;
  dialCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  isSeeker?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  licenseNumber?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  ssoId?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
};

export type CreateBrokerSsoInput = {
  dialCode: Scalars['String'];
  licenseNumber?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  stateCode?: InputMaybe<Scalars['String']>;
};

export type CreateCheckoutSessionInput = {
  attribution?: InputMaybe<AttributionInput>;
  cancelUrl?: InputMaybe<Scalars['String']>;
  couponCode?: InputMaybe<Scalars['String']>;
  priceId: Scalars['String'];
  productId: Scalars['String'];
  successUrl?: InputMaybe<Scalars['String']>;
};

export type CreateCheckoutSessionPayload = {
  __typename?: 'CreateCheckoutSessionPayload';
  sessionUrl: Scalars['String'];
};

export type CreateFeaturedPortfolioInput = {
  cardDescription?: InputMaybe<Scalars['String']>;
  coverImageFileId?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Float']>;
  overview?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  visibility?: InputMaybe<Scalars['String']>;
};

export type CreateFeaturedPropertyInput = {
  coverImageFileId?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Float']>;
  overview?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['String'];
  shortOverview?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  visibility?: InputMaybe<Scalars['String']>;
};

export type CreateIdxFeedInput = {
  name: Scalars['String'];
  type: IdxFeedTypeEnum;
};

export type CreateMarketAreaInput = {
  name: Scalars['String'];
  stateId: Scalars['ObjectId'];
};

export type CreateMediaFileInput = {
  brandingType?: InputMaybe<BrandingTypeEnum>;
  fileUpload: FileUploadInput;
  mediaFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
};

export type CreateMediaFolderInput = {
  folderName: Scalars['String'];
  mediaFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
};

export type CreateOrganizationInput = {
  locationInput?: InputMaybe<LocationSaveInput>;
  logoFileId?: InputMaybe<Scalars['ObjectId']>;
  name: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type CreateOrganizationUserAccountInput = {
  email: Scalars['String'];
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
};

export type CreateOrganizationUserInput = {
  accountInput: CreateOrganizationUserAccountInput;
  assignedPropertiesIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  organizationId: Scalars['ObjectId'];
  profileInput: ProfileInput;
  roleId: Scalars['ObjectId'];
};

export type CreateProductSubscriptionInput = {
  stripeCouponId?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']>;
  subscriptionProductId: Scalars['ObjectId'];
};

export type CreatePropertyInput = {
  cmsStatus?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationSaveInput>;
  marketAreaId?: InputMaybe<Scalars['ObjectId']>;
  name: Scalars['String'];
  primaryOrganizationId?: InputMaybe<Scalars['ObjectId']>;
};

export type CreateSaleTeamInput = {
  logoFileId?: InputMaybe<Scalars['ObjectId']>;
  name: Scalars['String'];
  phone?: InputMaybe<PhoneInput>;
  website?: InputMaybe<Scalars['String']>;
  workingHours?: InputMaybe<WorkingHoursInput>;
};

export type CreateSimpleBrokerInput = {
  isSeeker?: InputMaybe<Scalars['Boolean']>;
};

export type CreateSinglePropertyPortfolioInput = {
  name: Scalars['String'];
  propertyId: Scalars['ObjectId'];
};

export type CreateUnitInput = {
  averageBathroomsNumber?: InputMaybe<PartialMinMaxRangeInput>;
  averageBedroomsNumber?: InputMaybe<PartialMinMaxRangeInput>;
  averageExteriorSqft?: InputMaybe<PartialMinMaxRangeInput>;
  averageInteriorSqft?: InputMaybe<PartialMinMaxRangeInput>;
  averageTotalSqft?: InputMaybe<PartialMinMaxRangeInput>;
  customRooms?: InputMaybe<Scalars['String']>;
  floorPlanFileId?: InputMaybe<Scalars['ObjectId']>;
  highestPrice?: InputMaybe<Scalars['Float']>;
  inventoryType: Scalars['String'];
  name: Scalars['String'];
  propertyId: Scalars['ObjectId'];
  startingPrice?: InputMaybe<Scalars['Float']>;
};

export type DateRangeInput = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

export type DeleteApiAccountResult = {
  __typename?: 'DeleteApiAccountResult';
  revokedPluginUsers: Scalars['Int'];
};

export type Developer = {
  __typename?: 'Developer';
  account: Account;
  accountId: Scalars['String'];
  assignedPropertiesIds?: Maybe<Array<Scalars['ObjectId']>>;
  organizationIds?: Maybe<Array<Scalars['ObjectId']>>;
  organizations?: Maybe<Array<Organization>>;
  profile: Profile;
  profileId: Scalars['String'];
  roleId: Scalars['String'];
  saleTeamId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type DeveloperAsSaleUser = OrganizationUser | SaleTeamUser;

export type EditAmenityInput = {
  _id: Scalars['ObjectId'];
  imageFileId: Scalars['ObjectId'];
  name: Scalars['String'];
};

export type EditMarketAreaInput = {
  _id: Scalars['ObjectId'];
  name: Scalars['String'];
  stateId: Scalars['ObjectId'];
};

export type EditMediaFileInput = {
  name: Scalars['String'];
};

export type EditMediaFolderInput = {
  mediaDetails: MediaFolderInput;
  mediaFolderId: Scalars['ObjectId'];
  noChangelog?: InputMaybe<Scalars['Boolean']>;
};

export type EditOrganizationInput = {
  locationInput?: InputMaybe<LocationSaveInput>;
  logoFileId?: InputMaybe<Scalars['ObjectId']>;
  name: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type EditOrganizationUserAccountInput = {
  email?: InputMaybe<Scalars['String']>;
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
};

export type EditOrganizationUserInput = {
  accountInput?: InputMaybe<EditOrganizationUserAccountInput>;
  assignedPropertiesIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  organizationUserId: Scalars['ObjectId'];
  profileInput?: InputMaybe<EditOrganizationUserProfileInput>;
  roleId: Scalars['ObjectId'];
};

export type EditOrganizationUserProfileInput = {
  _id?: InputMaybe<Scalars['String']>;
  avatarFileId?: InputMaybe<Scalars['ObjectId']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type EditSaleTeamInput = {
  logoFileId?: InputMaybe<Scalars['ObjectId']>;
  name: Scalars['String'];
  phone?: InputMaybe<PhoneInput>;
  website?: InputMaybe<Scalars['String']>;
  workingHours?: InputMaybe<WorkingHoursInput>;
};

export type EditSaleTeamUserAccountInput = {
  email: Scalars['String'];
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
};

export type EditSaleTeamUserInput = {
  accountInput?: InputMaybe<EditSaleTeamUserAccountInput>;
  assignedPropertiesIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  profileInput?: InputMaybe<EditSaleTeamUserProfileInput>;
  saleTeamRoleId: Scalars['ObjectId'];
  saleTeamUserId: Scalars['ObjectId'];
};

export type EditSaleTeamUserProfileInput = {
  _id?: InputMaybe<Scalars['String']>;
  avatarFileId?: InputMaybe<Scalars['ObjectId']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type EditUnitInput = {
  noChangelog?: InputMaybe<Scalars['Boolean']>;
  unitDetails: UnitInput;
  unitId: Scalars['ObjectId'];
};

export type FeaturedPortfolio = {
  __typename?: 'FeaturedPortfolio';
  _id: Scalars['String'];
  cardDescription?: Maybe<Scalars['String']>;
  coverImageFile?: Maybe<File>;
  coverImageFileId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Float']>;
  overview?: Maybe<Scalars['String']>;
  propertyIds?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  visibility: FeaturedPortfolioVisibilityEnum;
};

export type FeaturedPortfolioOrder = {
  displayOrder: Scalars['Float'];
  featuredPortfolioId: Scalars['String'];
};

export type FeaturedPortfolioPropertiesPayload = {
  __typename?: 'FeaturedPortfolioPropertiesPayload';
  collection: Array<PropertyDetail>;
  totalCount: Scalars['Float'];
};

export type FeaturedPortfolioSummary = {
  __typename?: 'FeaturedPortfolioSummary';
  completionYearRange?: Maybe<MinMax>;
  marketAreas: Array<MarketAreaCount>;
  priceRange?: Maybe<MinMax>;
  propertyCount: Scalars['Float'];
};

export enum FeaturedPortfolioVisibilityEnum {
  Hidden = 'HIDDEN',
  Public = 'PUBLIC'
}

export type FeaturedPortfoliosPayload = {
  __typename?: 'FeaturedPortfoliosPayload';
  collection: Array<FeaturedPortfolio>;
  totalCount: Scalars['Float'];
};

export type FeaturedPropertiesPayload = {
  __typename?: 'FeaturedPropertiesPayload';
  collection: Array<FeaturedProperty>;
  totalCount: Scalars['Float'];
};

export type FeaturedProperty = {
  __typename?: 'FeaturedProperty';
  _id: Scalars['String'];
  coverImageFile?: Maybe<File>;
  coverImageFileId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Float']>;
  overview?: Maybe<Scalars['String']>;
  property: Property;
  propertyId: Scalars['String'];
  shortOverview?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  visibility: FeaturedPropertyVisibilityEnum;
};

export type FeaturedPropertyOrder = {
  displayOrder: Scalars['Float'];
  featuredPropertyId: Scalars['String'];
};

export enum FeaturedPropertyVisibilityEnum {
  Hidden = 'HIDDEN',
  Public = 'PUBLIC'
}

export type File = {
  __typename?: 'File';
  _id: Scalars['String'];
  copyFromFileId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  publicUrl: Scalars['String'];
  s3Key: Scalars['String'];
  size: Scalars['Float'];
  status: Scalars['String'];
  thumbnailFile?: Maybe<File>;
  thumbnailFileId?: Maybe<File>;
  thumbnailFileUrl?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type FileUploadInput = {
  file: Scalars['Upload'];
  fileSize?: InputMaybe<Scalars['Float']>;
  progressTrackingId?: InputMaybe<Scalars['String']>;
};

export type FlatPaginationInput = {
  endingBefore?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  startingAfter?: InputMaybe<Scalars['String']>;
};

export type FolderPathModel = {
  __typename?: 'FolderPathModel';
  _id: Scalars['String'];
  folderName: Scalars['String'];
};

export type GeneralPropertyDetailsInput = {
  averageBathroomsNumber?: InputMaybe<PartialMinMaxRangeInput>;
  averageBedroomsNumber?: InputMaybe<PartialMinMaxRangeInput>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<PhoneInput>;
  defaultInventoryDetails?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationSaveInput>;
  mainPropertyMediaId?: InputMaybe<Scalars['ObjectId']>;
  marketAreaId?: InputMaybe<Scalars['ObjectId']>;
  name?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  priceRange?: InputMaybe<PartialMinMaxRangeInput>;
  primaryOrganizationId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
  saleTeams?: InputMaybe<Array<PropertySaleTeamInput>>;
  website?: InputMaybe<Scalars['String']>;
};

export type GenerateQrCodeResult = {
  __typename?: 'GenerateQrCodeResult';
  qrCode: Scalars['String'];
};

export type GeoLocationBoundsJson = {
  east: Scalars['Float'];
  north: Scalars['Float'];
  south: Scalars['Float'];
  west: Scalars['Float'];
};

export type GeoLocationJson = {
  __typename?: 'GeoLocationJSON';
  coordinates: Array<Scalars['Float']>;
  type: Scalars['String'];
};

export type GetAlertItemsFilterInput = {
  alertConfigIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  range?: InputMaybe<DateRangeInput>;
};

export type GetAllFilesInPropertyFilterInput = {
  brandingType?: InputMaybe<BrandingTypeFilterEnum>;
  excludeAgentsOnlyFolder?: InputMaybe<Scalars['Boolean']>;
  excludeSlideshowFolder?: Scalars['Boolean'];
  excludedMediaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  fileTypes?: InputMaybe<Array<MediaFileTypesFilterEnum>>;
  mediaFolderIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  portfolioId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetAllPropertyChangelogsFilterInput = {
  isHidden?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ObjectId'];
};

export type GetAmenitiesFilterInput = {
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  propertyId?: InputMaybe<Scalars['ObjectId']>;
  searchByName?: InputMaybe<Scalars['String']>;
};

export type GetAmenitiesForManageFilterInput = {
  propertyId: Scalars['ObjectId'];
  searchByName?: InputMaybe<Scalars['String']>;
};

export type GetApiUsersFilterInput = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetBrokerPropertiesFilterInput = {
  amenityIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  buildingTypes?: InputMaybe<Array<BuildingTypesEnum>>;
  cityNames?: InputMaybe<Array<Scalars['String']>>;
  cmsStatus?: InputMaybe<CmsStatusEnum>;
  completionDate?: InputMaybe<Scalars['Date']>;
  constructionDateRange?: InputMaybe<DateRangeInput>;
  countyNames?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  locationFilter?: InputMaybe<GetBrokerPropertiesLocationFilterInput>;
  marketAreaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  organizationIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  priceRange?: InputMaybe<PartialMinMaxRangeInput>;
  projectStatuses?: InputMaybe<Array<Scalars['String']>>;
  propertyTags?: InputMaybe<Array<PropertyTagsEnum>>;
  searchText?: InputMaybe<Scalars['String']>;
  stateIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  strictPriceRange?: InputMaybe<PartialMinMaxRangeInput>;
  transactionType?: InputMaybe<PropertyTransactionTypesEnum>;
  unitNumberOfBathrooms?: InputMaybe<PartialMinMaxRangeInput>;
  unitNumberOfBedrooms?: InputMaybe<PartialMinMaxRangeInput>;
  unitNumberOfUnits?: InputMaybe<PartialMinMaxRangeInput>;
  yearBuildRange?: InputMaybe<MinMaxRangeInput>;
};

export type GetBrokerPropertiesLocationFilterInput = {
  bounds?: InputMaybe<GeoLocationBoundsJson>;
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  radiusToSearchInMiles?: InputMaybe<Scalars['Float']>;
};

export type GetBrokersFilter = {
  accountStatus?: InputMaybe<Array<Scalars['String']>>;
  isRealUser?: InputMaybe<Array<Scalars['Boolean']>>;
  isSeeker?: InputMaybe<Scalars['Boolean']>;
  licenseStatuses?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Array<Scalars['String']>>;
  subscriptionPlanTypes?: InputMaybe<Array<Scalars['String']>>;
  subscriptionStatuses?: InputMaybe<Array<Scalars['String']>>;
};

export type GetCmsUsersFilterInput = {
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetFeaturedPortfoliosFilter = {
  visibility?: InputMaybe<Array<FeaturedPortfolioVisibilityEnum>>;
};

export type GetFeaturedPropertiesFilter = {
  visibility?: InputMaybe<Array<FeaturedPropertyVisibilityEnum>>;
};

export type GetFileDownloadStatisticsArgsFilterInput = {
  dateRange?: InputMaybe<PartialDateRangeInput>;
  propertyId: Scalars['ObjectId'];
};

export type GetFileDownloadsStatisticItem = {
  __typename?: 'GetFileDownloadsStatisticItem';
  count: Scalars['Float'];
  file: File;
};

export type GetFileDownloadsStatisticPayload = {
  __typename?: 'GetFileDownloadsStatisticPayload';
  collection: Array<GetFileDownloadsStatisticItem>;
  totalCount: Scalars['Float'];
};

export type GetIdxEmbeddedPortfolioFeedInput = {
  idxFeedId: Scalars['ObjectId'];
};

export type GetIdxEmbeddedPropertyFeedInput = {
  idxFeedId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
  unitsArgs?: InputMaybe<GetUnitsArgs>;
};

export type GetIdxEmbeddedSearchBarFeedInput = {
  idxFeedId: Scalars['ObjectId'];
};

export type GetIdxFeedListFilterInput = {
  nameSearch?: InputMaybe<Scalars['String']>;
};

export type GetIdxFeedListInput = {
  filter?: InputMaybe<GetIdxFeedListFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};

export type GetIdxFeedListPayload = {
  __typename?: 'GetIdxFeedListPayload';
  collection: Array<IdxFeed>;
  totalCount: Scalars['Float'];
};

export type GetIdxPortfolioFeedPropertiesInput = {
  idxFeedId: Scalars['ObjectId'];
  pagination?: InputMaybe<PaginationInput>;
  portfolioFolderId: Scalars['ObjectId'];
};

export type GetIdxPropertyFilesInput = {
  idxFeedId: Scalars['ObjectId'];
  mediaFolderIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  pagination?: InputMaybe<PaginationInput>;
  propertyId: Scalars['ObjectId'];
};

export type GetIdxSearchFeedPropertiesFiltersInput = {
  buildingTypes?: InputMaybe<Array<BuildingTypesEnum>>;
  locationFilter?: InputMaybe<GetBrokerPropertiesLocationFilterInput>;
  marketAreaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  priceRange?: InputMaybe<PartialMinMaxRangeInput>;
  projectStatus?: InputMaybe<Array<ProjectStatusesEnum>>;
  propertyTags?: InputMaybe<Array<PropertyTagsEnum>>;
  searchText?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<PropertyTransactionTypesEnum>;
};

export type GetIdxSearchFeedPropertiesInput = {
  filters?: InputMaybe<GetIdxSearchFeedPropertiesFiltersInput>;
  idxFeedId: Scalars['ObjectId'];
  pagination?: InputMaybe<PaginationInput>;
};

export type GetMarketAreasFilterInput = {
  code?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  stateNames?: InputMaybe<Array<Scalars['String']>>;
};

export type GetMarketAreasForFilterInput = {
  idxFeedId?: InputMaybe<Scalars['ObjectId']>;
  pagination?: InputMaybe<PaginationInput>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetMediaFoldersAndFilesFilterInput = {
  brandingType?: InputMaybe<BrandingTypeFilterEnum>;
  excludeSlideshowFolder?: Scalars['Boolean'];
  fileTypes?: InputMaybe<Array<MediaFileTypesFilterEnum>>;
  ignoreHierarchy?: InputMaybe<Scalars['Boolean']>;
  mediaFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetOrganizationUsersFilterInput = {
  organizationId: Scalars['ObjectId'];
  roleId?: InputMaybe<Scalars['ObjectId']>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetPortfolioMediaKitItemsInput = {
  excludeAgentsOnlyFolder?: InputMaybe<Scalars['Boolean']>;
  excludedMediaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  mediaFolderIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  portfolioId: Scalars['ObjectId'];
};

export type GetPortfolioPropertiesChangelogsFilterInput = {
  dateRange?: InputMaybe<PartialDateRangeInput>;
};

export type GetPortfoliosFilter = {
  status?: InputMaybe<BrokerPortfolioStatusesEnum>;
};

export type GetPortfoliosWithReactionsFilter = {
  guestUserId?: InputMaybe<Scalars['ObjectId']>;
};

export type GetPreviewInvoiceInput = {
  mode: Scalars['String'];
  newStripePriceId: Scalars['String'];
  promoCode?: InputMaybe<Scalars['String']>;
};

export type GetPropertiesFilterInput = {
  buildingTypes?: InputMaybe<Array<BuildingTypesEnum>>;
  cmsStatuses?: InputMaybe<Array<CmsStatusEnum>>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  marketAreaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  organizationId?: InputMaybe<Scalars['ObjectId']>;
  projectStatuses?: InputMaybe<Array<ProjectStatusesEnum>>;
  propertyTags?: InputMaybe<Array<PropertyTagsEnum>>;
  searchByName?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<PropertyStatusesEnum>>;
  transactionTypes?: InputMaybe<Array<PropertyTransactionTypesEnum>>;
};

export type GetPropertyChangelogsFilterInput = {
  propertyId: Scalars['ObjectId'];
};

export type GetPropertyViewsByBrokerAFilter = {
  propertyIds?: Array<Scalars['ObjectId']>;
  range?: InputMaybe<DateRangeInput>;
};

export type GetSaleTeamUsersFilterInput = {
  saleTeamId: Scalars['ObjectId'];
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetSaleTeamsFilterInput = {
  internalTeamsByOrganizationIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  saleTeamIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetSavedFeaturedPortfoliosFilterInput = {
  portfolioIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type GetStatesFilterInput = {
  withMarketArea?: InputMaybe<Scalars['Boolean']>;
};

export type GetSubscriptionProductsFilterInput = {
  includeApiPlan?: InputMaybe<Scalars['Boolean']>;
  isApiUser?: InputMaybe<Scalars['Boolean']>;
  recurringTypes?: InputMaybe<Array<RecurringTypesEnum>>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
};

export type GetSystemActionLogsFilterInput = {
  dateRange?: InputMaybe<PartialDateRangeInput>;
  propertyId: Scalars['ObjectId'];
  type: SystemActionLogsTypeEnum;
};

export type GetTrackedPropertiesFilterInput = {
  propertyChangelogTypes?: InputMaybe<Array<PropertyChangelogTypesEnum>>;
  propertyIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  propertyUpdatesRange?: InputMaybe<DateRangeInput>;
  searchByName?: InputMaybe<Scalars['String']>;
};

export type GetUnitsArgs = {
  filter?: InputMaybe<GetUnitsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type GetUnitsFilterInput = {
  inventoryType?: InputMaybe<Scalars['String']>;
  isRestricted?: InputMaybe<Scalars['Boolean']>;
  propertyId?: InputMaybe<Scalars['ObjectId']>;
};

export type GetUserByApiCredentialsFilterInput = {
  apiCredentialsId: Scalars['ObjectId'];
  withBrokerInfo?: InputMaybe<Scalars['Boolean']>;
};

export type GuestUser = {
  __typename?: 'GuestUser';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fingerprintHash: Array<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type GuestUserPayload = {
  __typename?: 'GuestUserPayload';
  collection: Array<GuestUser>;
  totalCount: Scalars['Float'];
};

export type IdxActivity = {
  __typename?: 'IdxActivity';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  idxId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type IdxActivityCollection = {
  __typename?: 'IdxActivityCollection';
  date: Scalars['Date'];
  propertyClicks?: Maybe<Array<PropertyClick>>;
  totalClicks: Scalars['Float'];
};

export type IdxActivityPayload = {
  __typename?: 'IdxActivityPayload';
  collection: Array<IdxActivityCollection>;
};

export type IdxEmbeddedPortfolioFeedData = {
  __typename?: 'IdxEmbeddedPortfolioFeedData';
  idxFeed: IdxFeed;
  idxSettings: IdxSettings;
};

export type IdxEmbeddedPropertyFeedData = {
  __typename?: 'IdxEmbeddedPropertyFeedData';
  broker: Broker;
  idxFeed: IdxFeed;
  idxSettings: IdxSettings;
  property: Property;
  propertyAmenities: Array<Amenity>;
};

export type IdxEmbeddedSearchBarFeedData = {
  __typename?: 'IdxEmbeddedSearchBarFeedData';
  idxFeed: IdxFeed;
  idxSettings: IdxSettings;
};

export type IdxFeed = {
  __typename?: 'IdxFeed';
  _id: Scalars['String'];
  accountId: Scalars['ObjectId'];
  cities?: Maybe<Array<Place>>;
  counties?: Maybe<Array<Place>>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  marketAreaIds?: Maybe<Array<Scalars['ObjectId']>>;
  name: Scalars['String'];
  portfolioContent?: Maybe<Scalars['String']>;
  portfolioFolderId?: Maybe<Scalars['ObjectId']>;
  propertiesPerPage?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['ObjectId']>;
  searchBarContent?: Maybe<Scalars['String']>;
  showCustomPropertyDownloads?: Maybe<Scalars['Boolean']>;
  showPropertyDownloads?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum IdxFeedPortfolioContentEnum {
  ListInGrid = 'LIST_IN_GRID',
  ListInMap = 'LIST_IN_MAP'
}

export enum IdxFeedSearchBarContentEnum {
  ListInGrid = 'LIST_IN_GRID',
  ListInMap = 'LIST_IN_MAP',
  SearchBarOnly = 'SEARCH_BAR_ONLY'
}

export enum IdxFeedTypeEnum {
  MarketArea = 'MARKET_AREA',
  Portfolio = 'PORTFOLIO',
  SearchBar = 'SEARCH_BAR',
  SingleProperty = 'SINGLE_PROPERTY'
}

export type IdxPortfolioFeedPropertiesData = {
  __typename?: 'IdxPortfolioFeedPropertiesData';
  broker: Broker;
  portfolioFolder: Portfolio;
  portfolioItemCount: Scalars['Float'];
  portfolioItems: Array<Portfolio>;
};

export type IdxSearchFeedPropertiesData = {
  __typename?: 'IdxSearchFeedPropertiesData';
  properties: PropertiesPayload;
};

export type IdxSettings = {
  __typename?: 'IdxSettings';
  _id: Scalars['String'];
  accountId: Scalars['ObjectId'];
  branding: Branding;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isWixSite?: Maybe<Scalars['Boolean']>;
  showDashCredit?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  websiteDomain?: Maybe<Scalars['String']>;
};

export type InvoiceCoupon = {
  __typename?: 'InvoiceCoupon';
  amountOff?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  percentOff?: Maybe<Scalars['Float']>;
};

export type LocalTimeHours = {
  __typename?: 'LocalTimeHours';
  friday?: Maybe<LocalTimeRange>;
  monday?: Maybe<LocalTimeRange>;
  saturday?: Maybe<LocalTimeRange>;
  sunday?: Maybe<LocalTimeRange>;
  thursday?: Maybe<LocalTimeRange>;
  tuesday?: Maybe<LocalTimeRange>;
  wednesday?: Maybe<LocalTimeRange>;
};

export type LocalTimeHoursInput = {
  friday?: InputMaybe<LocalTimeRangeInput>;
  monday?: InputMaybe<LocalTimeRangeInput>;
  saturday?: InputMaybe<LocalTimeRangeInput>;
  sunday?: InputMaybe<LocalTimeRangeInput>;
  thursday?: InputMaybe<LocalTimeRangeInput>;
  tuesday?: InputMaybe<LocalTimeRangeInput>;
  wednesday?: InputMaybe<LocalTimeRangeInput>;
};

export type LocalTimeRange = {
  __typename?: 'LocalTimeRange';
  from: Scalars['String'];
  to: Scalars['String'];
};

export type LocalTimeRangeInput = {
  from: Scalars['String'];
  to: Scalars['String'];
};

export type Location = {
  __typename?: 'Location';
  _id: Scalars['String'];
  address?: Maybe<Address>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  geoLocation: GeoLocationJson;
  googlePlaceId: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type LocationSaveInput = {
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  googlePlaceId: Scalars['String'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  locationId?: InputMaybe<Scalars['ObjectId']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type MarketArea = {
  __typename?: 'MarketArea';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  state: State;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type MarketAreaCount = {
  __typename?: 'MarketAreaCount';
  count: Scalars['Float'];
  marketArea?: Maybe<MarketArea>;
};

export type MarketAreaPlaceOption = {
  __typename?: 'MarketAreaPlaceOption';
  cityKeys: Array<Scalars['String']>;
  count: Scalars['Int'];
  countyKeys: Array<Scalars['String']>;
  marketAreaId: Scalars['ObjectId'];
};

export type MarketAreasPayload = {
  __typename?: 'MarketAreasPayload';
  collection: Array<MarketArea>;
  totalCount: Scalars['Float'];
};

export type Media = {
  __typename?: 'Media';
  _id: Scalars['String'];
  brandingType?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  files: Array<File>;
  folderName?: Maybe<Scalars['String']>;
  foldersPathCollection?: Maybe<Array<FolderPathModel>>;
  mediaFolderId?: Maybe<Scalars['String']>;
  mediaItemsCount: Scalars['Float'];
  parentMediaFoldersIds?: Maybe<Array<Scalars['String']>>;
  propertyId: Scalars['String'];
  sizeInBytes: Scalars['Float'];
  systemFolderType?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum MediaFileTypesFilterEnum {
  Docs = 'DOCS',
  Images = 'IMAGES',
  Videos = 'VIDEOS'
}

export type MediaFilesAndFoldersPayload = {
  __typename?: 'MediaFilesAndFoldersPayload';
  filesCollection?: Maybe<Array<Media>>;
  filesTotalCount: Scalars['Float'];
  foldersCollection: Array<Media>;
  foldersTotalCount: Scalars['Float'];
};

export type MediaFilesPayload = {
  __typename?: 'MediaFilesPayload';
  filesCollection?: Maybe<Array<Media>>;
  filesTotalCount: Scalars['Float'];
};

export type MediaFolderInput = {
  folderName: Scalars['String'];
};

export type MediaKitPayload = {
  __typename?: 'MediaKitPayload';
  collection: Array<PortfolioMediaKit>;
  totalCount: Scalars['Float'];
};

export type MediaObserveSubscriptionPayload = {
  __typename?: 'MediaObserveSubscriptionPayload';
  document: Media;
  trigger: Scalars['String'];
};

export type MetricDataPoint = {
  __typename?: 'MetricDataPoint';
  requestCount: Scalars['Float'];
  timestamp: Scalars['Date'];
};

export enum MfaMethodsEnum {
  App = 'APP',
  Email = 'EMAIL'
}

export type MfaTempTokenModel = {
  __typename?: 'MfaTempTokenModel';
  mfaEnabled: Scalars['Boolean'];
  mfaMethod?: Maybe<MfaMethodsEnum>;
  tempToken: Scalars['String'];
};

export type MinMax = {
  __typename?: 'MinMax';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type MinMaxRange = {
  __typename?: 'MinMaxRange';
  max?: Maybe<Scalars['Float']>;
  min: Scalars['Float'];
};

export type MinMaxRangeInput = {
  max?: InputMaybe<Scalars['Float']>;
  min: Scalars['Float'];
};

export type MinMaxRangePayload = {
  __typename?: 'MinMaxRangePayload';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  abortAllUploads: AbortUploadEvent;
  abortUpload: AbortUploadEvent;
  acceptApiInvitation: AuthResult;
  acceptApiInvitationForAccount: AuthResult;
  addAllMarketingFilesToPortfolio: Array<PortfolioMediaKit>;
  addFeaturedPortfolioToSaved: BrokerSavedFeaturedPortfolio;
  addFloorPlanToUnit: Unit;
  addNoteToProperty: PropertyNote;
  addPortfolioToComparison: Comparison;
  addPropertiesToPortfolio: Portfolio;
  addPropertyToPortfolio: Portfolio;
  addPropertyToTrack: BrokerTrackedProperty;
  addReactionByPortfolioAndProperty: PortfolioReaction;
  addSaleTeamUser: SaleTeamUser;
  addUserToAPI: ApiUser;
  addUserToCMS: User;
  approveProperty: Property;
  archiveBroker: Broker;
  archiveCMSUser: Scalars['Boolean'];
  archiveProperty: Property;
  attachDefaultStripePaymentMethod: Account;
  attachStripePaymentMethod: StripeAccount;
  auditProperty: Property;
  authorization: AuthResult;
  bulkUpdateMediaBrandingType: Array<Media>;
  cancelProductSubscription: ProductSubscription;
  cancelScheduledDowngrade: ProductSubscription;
  changeCurrentProductSubscription: ProductSubscriptionPayload;
  changePortfolioStatus: Portfolio;
  changeVerifiedStatusInProperty: Property;
  copyFeaturedPortfolioToBrokerPortfolio: CopyFeaturedPortfolioToBrokerPortfolioResult;
  createAlertConfig: BrokerAlertConfig;
  createAmenity: Amenity;
  createApiInvitation: ApiInvitationSafeDto;
  createApiPluginUser: ApiCredentialsUserResponse;
  createBroker: TokensModel;
  createBrokerSSO: TokensModel;
  createCheckoutSession: CreateCheckoutSessionPayload;
  createFeaturedPortfolio: FeaturedPortfolio;
  createFeaturedProperty: FeaturedProperty;
  createIdxFeed: IdxFeed;
  createIdxSettings: IdxSettings;
  createMarketArea: MarketArea;
  createMediaFile: Media;
  createMediaFolder: Media;
  createOrganization: Organization;
  createOrganizationUser: OrganizationUser;
  createPortfolioFolder: Portfolio;
  createProductSubscription: ProductSubscriptionPayload;
  createProperty: Property;
  createSaleTeam: SaleTeam;
  createSimpleBroker: Broker;
  createSinglePropertyPortfolio: Portfolio;
  createUnit: Unit;
  deleteAllBrokerActivities: Array<BrokerActivity>;
  deleteAmenity: Array<Amenity>;
  deleteApiAccount: DeleteApiAccountResult;
  deleteBroker: Broker;
  deleteBrokerActivityById: BrokerActivity;
  deleteFeaturedPortfolio: FeaturedPortfolio;
  deleteFeaturedProperty: FeaturedProperty;
  deleteIdxFeed: Scalars['Boolean'];
  deleteMarketArea: MarketArea;
  deleteMediaFileById: Media;
  deleteMediaFiles: Array<Media>;
  deleteMediaFolderById: Media;
  deleteOrganization: Organization;
  deleteOrganizationUser: OrganizationUser;
  deletePortfolioById: Array<Portfolio>;
  deletePropertiesFromPortfolioByIds: Array<Portfolio>;
  deletePropertyFromPortfolioById: Portfolio;
  deleteSaleTeam: SaleTeam;
  deleteSaleTeamUser: SaleTeamUser;
  deleteUnit: Unit;
  deleteUserCMS: User;
  detachPaymentMethodFromCustomer: Account;
  duplicateAmenity: Property;
  duplicateUnit: Unit;
  editAmenity: Amenity;
  editInternalSaleTeamByOrganizationId: SaleTeam;
  editMarketArea: MarketArea;
  editMediaFile: File;
  editMediaFolder: Media;
  editOrganization: Organization;
  editOrganizationUser: OrganizationUser;
  editPortfolioFolderName: Portfolio;
  editPropertyNote: PropertyNote;
  editSaleTeam: SaleTeam;
  editSaleTeamUser: SaleTeamUser;
  editUnit: Unit;
  enableMfa: TokensModel;
  forgotPassword: Scalars['Boolean'];
  generateMagicLink: Scalars['Boolean'];
  generateNewApiToken: TokenResponse;
  getTokenWithMagicLink: AuthResult;
  logout: Scalars['Boolean'];
  makeFeaturedPropertyPublic: Scalars['String'];
  makePortfolioPublic: Scalars['String'];
  manuallyRegisterPortfolioView?: Maybe<ViewHistory>;
  mfaAuthentication: TokensModel;
  moveMediaInSortOrder: Media;
  moveMediaToFolder: Media;
  movePortfolios: Portfolio;
  orderFeaturedPortfolios: Array<FeaturedPortfolio>;
  orderFeaturedProperties: Array<FeaturedProperty>;
  orderPropertiesInPortfolio: FeaturedPortfolio;
  readPropertyNotes: PropertyNote;
  recordLastTouchAttribution: Scalars['Boolean'];
  refreshTokens: TokensModel;
  registerBroker: TokensModel;
  registerDeveloperUser: TokensModel;
  registerIdxActivity: IdxActivity;
  removeAlertConfig: BrokerAlertConfig;
  removeAllMarketingFilesFromPortfolio: Array<PortfolioMediaKit>;
  removeAmenitiesFromProperty: Property;
  removeFeaturedPortfolioFromSaved: BrokerSavedFeaturedPortfolio;
  removePropertyById: Scalars['Boolean'];
  removePropertyFromTracked: BrokerTrackedProperty;
  removePropertyNote: PropertyNote;
  renewProductSubscription: ProductSubscriptionPayload;
  resendApiInvitation: ApiInvitationSafeDto;
  resetCmsSettingsToDefaults: CmsSettings;
  resetPassword: Scalars['Boolean'];
  restoreApiAccount: RestoreApiAccountResult;
  retryProductSubscriptionCharge: ProductSubscriptionPayload;
  revokeApiInvitation: ApiInvitationSafeDto;
  scheduleDowngrade: SubscriptionSchedule;
  sendEmailVerificationCode: Account;
  sendMessageToAgent: Scalars['Boolean'];
  sendMfaEmailCode: Scalars['Boolean'];
  sendRegistrationLinkToDeveloper: Scalars['Boolean'];
  sendVerificationCode: Account;
  setAdvancedPropertyDetails: Property;
  setAmenitiesToProperty: Property;
  setAmenityNameInProperty: Property;
  setApiCredentialAdminDisabled: ApiCredentialSafeDto;
  setApiCredentialMonthlyRequestLimit: ApiCredentialSafeDto;
  setBrokerShowAllBillingPlans: Broker;
  setGeneralPropertyDetails: Property;
  setGuestUserData: GuestUser;
  setHiddenStateToAlertItem: BrokerAlertItem;
  setMyPluginUserDisabled: ApiCredentialSafeDto;
  setOrganizationUserStatus: Scalars['Boolean'];
  setPortfolioMediaKitMedia: Scalars['Boolean'];
  setPropertyStatus: Property;
  setSaleTeamUserStatus: Scalars['Boolean'];
  switchAccountType: Account;
  temporaryAuthentication: TempAuthResult;
  toggleChangelogVisibility: PropertyChangelog;
  unarchiveBroker: Broker;
  updateAlertConfig: BrokerAlertConfig;
  updateBrandedFilesReady: Property;
  updateBroker: Broker;
  updateBrokerLicenseStatus: Broker;
  updateCmsSettings: CmsSettings;
  updateCmsStatus: Property;
  updateCurrentBroker: Broker;
  updateCurrentUser: Profile;
  updateEmail: TokensModel;
  updateFeaturedPortfolio: FeaturedPortfolio;
  updateFeaturedProperty: FeaturedProperty;
  updateIdxFeed: IdxFeed;
  updateIdxSettings: IdxSettings;
  updateMediaBrandingType: Media;
  updatePassword: Scalars['Boolean'];
  updatePortfolioLocations: Portfolio;
  updatePortfolioPassword: Portfolio;
  updatePortfolioSettings: Portfolio;
  updateSSOId: Account;
  updateShowPopupOnPortfolio: Portfolio;
  updateSubscriptionEmailSettings: SubscriptionEmailSettings;
  updateUserAPI: ApiUser;
  updateUserCMS: User;
  uploadDraftFile: File;
  upsertComparison: Comparison;
  validateCoupon: ValidateCouponPayload;
  validatePhoneNumber: Account;
  verifyPhoneNumberAndUpdateAccount: Account;
};


export type MutationAbortUploadArgs = {
  progressTrackingId: Scalars['String'];
};


export type MutationAcceptApiInvitationArgs = {
  input: AcceptApiInvitationInput;
  token: Scalars['String'];
};


export type MutationAcceptApiInvitationForAccountArgs = {
  token: Scalars['String'];
};


export type MutationAddAllMarketingFilesToPortfolioArgs = {
  portfolioItemId: Scalars['String'];
};


export type MutationAddFeaturedPortfolioToSavedArgs = {
  portfolioId: Scalars['ObjectId'];
};


export type MutationAddFloorPlanToUnitArgs = {
  floorPlanFileId: Scalars['ObjectId'];
  unitId: Scalars['ObjectId'];
};


export type MutationAddNoteToPropertyArgs = {
  attachedFilesIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  message: Scalars['String'];
  propertyId: Scalars['ObjectId'];
};


export type MutationAddPortfolioToComparisonArgs = {
  portfolioFolderId: Scalars['ObjectId'];
  portfolioItemId: Scalars['ObjectId'];
};


export type MutationAddPropertiesToPortfolioArgs = {
  portfolioFolderId: Scalars['ObjectId'];
  propertyIds: Array<Scalars['ObjectId']>;
};


export type MutationAddPropertyToPortfolioArgs = {
  portfolioFolderId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
  status?: InputMaybe<BrokerPortfolioStatusesEnum>;
};


export type MutationAddPropertyToTrackArgs = {
  propertyId: Scalars['ObjectId'];
};


export type MutationAddReactionByPortfolioAndPropertyArgs = {
  guestUserData?: InputMaybe<SetGuestUserDataArgs>;
  portfolioId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
  reaction: PortfolioReactionsEnum;
};


export type MutationAddSaleTeamUserArgs = {
  input: AddSaleTeamUserInput;
};


export type MutationAddUserToApiArgs = {
  accountInput: AccountInput;
  apiCredentialsInput?: InputMaybe<ApiCredentialsInput>;
  profileInput: ProfileInput;
};


export type MutationAddUserToCmsArgs = {
  accountInput: AccountInput;
  apiCredentialsInput?: InputMaybe<ApiCredentialsInput>;
  profileInput: ProfileInput;
};


export type MutationApprovePropertyArgs = {
  input: ApprovePropertyInput;
};


export type MutationArchiveBrokerArgs = {
  archivingReason: Scalars['String'];
  brokerId: Scalars['ObjectId'];
};


export type MutationArchiveCmsUserArgs = {
  archive?: Scalars['Boolean'];
  cmsUserAccountId: Scalars['ObjectId'];
};


export type MutationArchivePropertyArgs = {
  input: ArchivePropertyInput;
};


export type MutationAttachDefaultStripePaymentMethodArgs = {
  stripePaymentMethodId: Scalars['String'];
};


export type MutationAttachStripePaymentMethodArgs = {
  stripePaymentMethodId: Scalars['String'];
};


export type MutationAuditPropertyArgs = {
  input: AuditPropertyInput;
};


export type MutationAuthorizationArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationBulkUpdateMediaBrandingTypeArgs = {
  brandingType: BrandingTypeEnum;
  excludedIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  filter?: InputMaybe<GetMediaFoldersAndFilesFilterInput>;
  mediaFilesIds: Array<Scalars['ObjectId']>;
};


export type MutationCancelProductSubscriptionArgs = {
  input: CancelProductSubscriptionInput;
};


export type MutationChangeCurrentProductSubscriptionArgs = {
  input: UpdateProductSubscriptionInput;
};


export type MutationChangePortfolioStatusArgs = {
  isAddedMediaKit?: InputMaybe<Scalars['Boolean']>;
  portfolioId: Scalars['ObjectId'];
  status: BrokerPortfolioStatusesEnum;
};


export type MutationChangeVerifiedStatusInPropertyArgs = {
  isMarkedAsVerified: Scalars['Boolean'];
  propertyId: Scalars['ObjectId'];
};


export type MutationCopyFeaturedPortfolioToBrokerPortfolioArgs = {
  args: CopyFeaturedPortfolioToBrokerPortfolioArgs;
};


export type MutationCreateAlertConfigArgs = {
  filter: CreateAlertConfigFilterInput;
  name: Scalars['String'];
};


export type MutationCreateAmenityArgs = {
  input: CreateAmenityInput;
};


export type MutationCreateApiInvitationArgs = {
  input: CreateApiInvitationInput;
};


export type MutationCreateApiPluginUserArgs = {
  referralCode: Scalars['String'];
};


export type MutationCreateBrokerArgs = {
  input: CreateBrokerInput;
};


export type MutationCreateBrokerSsoArgs = {
  input: CreateBrokerSsoInput;
};


export type MutationCreateCheckoutSessionArgs = {
  input: CreateCheckoutSessionInput;
};


export type MutationCreateFeaturedPortfolioArgs = {
  input: CreateFeaturedPortfolioInput;
};


export type MutationCreateFeaturedPropertyArgs = {
  input: CreateFeaturedPropertyInput;
};


export type MutationCreateIdxFeedArgs = {
  input: CreateIdxFeedInput;
};


export type MutationCreateIdxSettingsArgs = {
  branding?: InputMaybe<BrandingInput>;
  isWixSite?: InputMaybe<Scalars['Boolean']>;
  showDashCredit: Scalars['Boolean'];
  websiteDomain: Scalars['String'];
};


export type MutationCreateMarketAreaArgs = {
  input: CreateMarketAreaInput;
};


export type MutationCreateMediaFileArgs = {
  input: CreateMediaFileInput;
};


export type MutationCreateMediaFolderArgs = {
  input: CreateMediaFolderInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationUserArgs = {
  input: CreateOrganizationUserInput;
};


export type MutationCreatePortfolioFolderArgs = {
  locations?: InputMaybe<PlaceTargetInput>;
  name: Scalars['String'];
};


export type MutationCreateProductSubscriptionArgs = {
  input: CreateProductSubscriptionInput;
};


export type MutationCreatePropertyArgs = {
  input: CreatePropertyInput;
};


export type MutationCreateSaleTeamArgs = {
  input: CreateSaleTeamInput;
};


export type MutationCreateSimpleBrokerArgs = {
  input: CreateSimpleBrokerInput;
};


export type MutationCreateSinglePropertyPortfolioArgs = {
  input: CreateSinglePropertyPortfolioInput;
};


export type MutationCreateUnitArgs = {
  input: CreateUnitInput;
};


export type MutationDeleteAllBrokerActivitiesArgs = {
  activityTypes: Array<BrokerActivitiesTypesEnum>;
};


export type MutationDeleteAmenityArgs = {
  amenityId: Scalars['ObjectId'];
};


export type MutationDeleteApiAccountArgs = {
  apiCredentialsId: Scalars['String'];
};


export type MutationDeleteBrokerArgs = {
  brokerId: Scalars['ObjectId'];
};


export type MutationDeleteBrokerActivityByIdArgs = {
  activityId: Scalars['ObjectId'];
};


export type MutationDeleteFeaturedPortfolioArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type MutationDeleteFeaturedPropertyArgs = {
  featuredPropertyId: Scalars['String'];
};


export type MutationDeleteIdxFeedArgs = {
  idxFeedId: Scalars['ObjectId'];
};


export type MutationDeleteMarketAreaArgs = {
  marketAreaId: Scalars['ObjectId'];
};


export type MutationDeleteMediaFileByIdArgs = {
  mediaId: Scalars['ObjectId'];
  withContent?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteMediaFilesArgs = {
  excludedIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  filter?: InputMaybe<GetMediaFoldersAndFilesFilterInput>;
  mediaFilesIds: Array<Scalars['ObjectId']>;
};


export type MutationDeleteMediaFolderByIdArgs = {
  mediaId: Scalars['ObjectId'];
  withContent?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteOrganizationArgs = {
  organizationId: Scalars['ObjectId'];
};


export type MutationDeleteOrganizationUserArgs = {
  organizationUserId: Scalars['ObjectId'];
};


export type MutationDeletePortfolioByIdArgs = {
  portfolioId: Scalars['ObjectId'];
};


export type MutationDeletePropertiesFromPortfolioByIdsArgs = {
  portfolioFolderId: Scalars['ObjectId'];
  propertyIds: Array<Scalars['ObjectId']>;
};


export type MutationDeletePropertyFromPortfolioByIdArgs = {
  portfolioFolderId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
};


export type MutationDeleteSaleTeamArgs = {
  saleTeamId: Scalars['ObjectId'];
};


export type MutationDeleteSaleTeamUserArgs = {
  saleTeamId: Scalars['ObjectId'];
  saleTeamUserId: Scalars['ObjectId'];
};


export type MutationDeleteUnitArgs = {
  unitId: Scalars['ObjectId'];
};


export type MutationDeleteUserCmsArgs = {
  accountId: Scalars['ObjectId'];
  profileId: Scalars['ObjectId'];
};


export type MutationDetachPaymentMethodFromCustomerArgs = {
  stripePaymentMethodId: Scalars['String'];
};


export type MutationDuplicateAmenityArgs = {
  amenityId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
};


export type MutationDuplicateUnitArgs = {
  unitId: Scalars['ObjectId'];
};


export type MutationEditAmenityArgs = {
  input: EditAmenityInput;
};


export type MutationEditInternalSaleTeamByOrganizationIdArgs = {
  input: EditSaleTeamInput;
  organizationId: Scalars['ObjectId'];
};


export type MutationEditMarketAreaArgs = {
  input: EditMarketAreaInput;
};


export type MutationEditMediaFileArgs = {
  fileId: Scalars['ObjectId'];
  input: EditMediaFileInput;
};


export type MutationEditMediaFolderArgs = {
  input: EditMediaFolderInput;
};


export type MutationEditOrganizationArgs = {
  input: EditOrganizationInput;
  organizationId: Scalars['ObjectId'];
};


export type MutationEditOrganizationUserArgs = {
  input: EditOrganizationUserInput;
};


export type MutationEditPortfolioFolderNameArgs = {
  name: Scalars['String'];
  portfolioFolderId: Scalars['ObjectId'];
};


export type MutationEditPropertyNoteArgs = {
  attachedFilesIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  message: Scalars['String'];
  propertyNoteId: Scalars['ObjectId'];
};


export type MutationEditSaleTeamArgs = {
  input: EditSaleTeamInput;
  saleTeamId: Scalars['ObjectId'];
};


export type MutationEditSaleTeamUserArgs = {
  input: EditSaleTeamUserInput;
};


export type MutationEditUnitArgs = {
  input: EditUnitInput;
};


export type MutationEnableMfaArgs = {
  method?: InputMaybe<MfaMethodsEnum>;
  token: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationGenerateMagicLinkArgs = {
  email: Scalars['String'];
};


export type MutationMakeFeaturedPropertyPublicArgs = {
  featuredPropertyId: Scalars['String'];
  position: Scalars['String'];
};


export type MutationMakePortfolioPublicArgs = {
  featuredPortfolioId: Scalars['String'];
  position: Scalars['String'];
};


export type MutationManuallyRegisterPortfolioViewArgs = {
  viewedPortfolioId: Scalars['ObjectId'];
};


export type MutationMfaAuthenticationArgs = {
  token: Scalars['String'];
};


export type MutationMoveMediaInSortOrderArgs = {
  sortedMediaIds: Array<SortedMediaIdsInput>;
};


export type MutationMoveMediaToFolderArgs = {
  excludedIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  filter?: InputMaybe<GetMediaFoldersAndFilesFilterInput>;
  mediaFolderId: Scalars['ObjectId'];
  mediaIds: Array<Scalars['ObjectId']>;
};


export type MutationMovePortfoliosArgs = {
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  portfolioIds: Array<Scalars['ObjectId']>;
};


export type MutationOrderFeaturedPortfoliosArgs = {
  orders: Array<FeaturedPortfolioOrder>;
};


export type MutationOrderFeaturedPropertiesArgs = {
  orders: Array<FeaturedPropertyOrder>;
};


export type MutationOrderPropertiesInPortfolioArgs = {
  featuredPortfolioId: Scalars['String'];
  propertyIds: Array<Scalars['String']>;
};


export type MutationReadPropertyNotesArgs = {
  propertyNotesIds: Array<Scalars['ObjectId']>;
};


export type MutationRecordLastTouchAttributionArgs = {
  attribution: AttributionInput;
};


export type MutationRegisterBrokerArgs = {
  input: RegisterBrokerInput;
};


export type MutationRegisterDeveloperUserArgs = {
  input: AccountInput;
  signUpVerificationCode: Scalars['String'];
};


export type MutationRegisterIdxActivityArgs = {
  idxId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
};


export type MutationRemoveAlertConfigArgs = {
  alertConfigId: Scalars['ObjectId'];
};


export type MutationRemoveAllMarketingFilesFromPortfolioArgs = {
  portfolioItemId: Scalars['String'];
};


export type MutationRemoveAmenitiesFromPropertyArgs = {
  amenitiesIds: Array<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
};


export type MutationRemoveFeaturedPortfolioFromSavedArgs = {
  brokerSavedFeaturedPortfolioId: Scalars['ObjectId'];
};


export type MutationRemovePropertyByIdArgs = {
  propertyId: Scalars['ObjectId'];
};


export type MutationRemovePropertyFromTrackedArgs = {
  brokerTrackedPropertyId: Scalars['ObjectId'];
};


export type MutationRemovePropertyNoteArgs = {
  propertyNoteId: Scalars['ObjectId'];
};


export type MutationResendApiInvitationArgs = {
  input: ResendApiInvitationInput;
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String'];
};


export type MutationRestoreApiAccountArgs = {
  apiCredentialsId: Scalars['String'];
};


export type MutationRevokeApiInvitationArgs = {
  invitationId: Scalars['String'];
};


export type MutationScheduleDowngradeArgs = {
  input: ScheduleDowngradeInput;
};


export type MutationSendMessageToAgentArgs = {
  input: SendMessageToAgentInput;
};


export type MutationSendRegistrationLinkToDeveloperArgs = {
  accountId: Scalars['ObjectId'];
};


export type MutationSendVerificationCodeArgs = {
  phone: PhoneInput;
};


export type MutationSetAdvancedPropertyDetailsArgs = {
  input: SetAdvancedPropertyDetailsInput;
};


export type MutationSetAmenitiesToPropertyArgs = {
  input: SetAmenitiesToPropertyInput;
};


export type MutationSetAmenityNameInPropertyArgs = {
  amenityId: Scalars['ObjectId'];
  isPrimary: Scalars['Boolean'];
  name: Scalars['String'];
  propertyId: Scalars['ObjectId'];
};


export type MutationSetApiCredentialAdminDisabledArgs = {
  adminDisabled: Scalars['Boolean'];
  apiCredentialsId: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationSetApiCredentialMonthlyRequestLimitArgs = {
  apiCredentialsId: Scalars['String'];
  monthlyRequestLimit?: InputMaybe<Scalars['Int']>;
};


export type MutationSetBrokerShowAllBillingPlansArgs = {
  brokerId: Scalars['ObjectId'];
  showAllBillingPlans: Scalars['Boolean'];
};


export type MutationSetGeneralPropertyDetailsArgs = {
  input: SetGeneralPropertyDetailsInput;
};


export type MutationSetGuestUserDataArgs = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  guestUserId?: InputMaybe<Scalars['ObjectId']>;
};


export type MutationSetHiddenStateToAlertItemArgs = {
  alertItemId: Scalars['ObjectId'];
  isHidden: Scalars['Boolean'];
};


export type MutationSetMyPluginUserDisabledArgs = {
  apiCredentialsId: Scalars['String'];
  disabled: Scalars['Boolean'];
};


export type MutationSetOrganizationUserStatusArgs = {
  organizationUserId: Scalars['ObjectId'];
  status: AccountActiveOrArchivedStatusesEnum;
};


export type MutationSetPortfolioMediaKitMediaArgs = {
  input: UpdateMediaKitInput;
};


export type MutationSetPropertyStatusArgs = {
  input: SetPropertyStatusInput;
};


export type MutationSetSaleTeamUserStatusArgs = {
  saleTeamUserId: Scalars['ObjectId'];
  status: AccountActiveOrArchivedStatusesEnum;
};


export type MutationSwitchAccountTypeArgs = {
  input: SwitchAccountInput;
};


export type MutationTemporaryAuthenticationArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationToggleChangelogVisibilityArgs = {
  input: ToggleChangelogVisibilityInput;
};


export type MutationUnarchiveBrokerArgs = {
  brokerId: Scalars['ObjectId'];
};


export type MutationUpdateAlertConfigArgs = {
  alertConfigId: Scalars['ObjectId'];
  filter: CreateAlertConfigFilterInput;
  name: Scalars['String'];
};


export type MutationUpdateBrandedFilesReadyArgs = {
  input: UpdateBrandedFilesReadyInput;
};


export type MutationUpdateBrokerArgs = {
  brokerId: Scalars['ObjectId'];
  input: UpdateBrokerInCmsInput;
};


export type MutationUpdateBrokerLicenseStatusArgs = {
  brokerId: Scalars['ObjectId'];
  input: UpdateBrokerLicenseStatusInput;
};


export type MutationUpdateCmsSettingsArgs = {
  input: UpdateCmsSettingsInput;
};


export type MutationUpdateCmsStatusArgs = {
  input: UpdateCmsStatusInput;
};


export type MutationUpdateCurrentBrokerArgs = {
  input: UpdateBrokerInput;
};


export type MutationUpdateCurrentUserArgs = {
  profileInput: ProfileInput;
};


export type MutationUpdateEmailArgs = {
  newEmail: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUpdateFeaturedPortfolioArgs = {
  featuredPortfolioId: Scalars['String'];
  input: UpdateFeaturedPortfolioInput;
};


export type MutationUpdateFeaturedPropertyArgs = {
  featuredPropertyId: Scalars['String'];
  input: UpdateFeaturedPropertyInput;
};


export type MutationUpdateIdxFeedArgs = {
  input: UpdateIdxFeedInput;
};


export type MutationUpdateIdxSettingsArgs = {
  input: UpdateIdxSettingsInput;
};


export type MutationUpdateMediaBrandingTypeArgs = {
  brandingType: BrandingTypeEnum;
  mediaId: Scalars['ObjectId'];
};


export type MutationUpdatePasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationUpdatePortfolioLocationsArgs = {
  locations: PlaceTargetInput;
  portfolioFolderId: Scalars['ObjectId'];
};


export type MutationUpdatePortfolioPasswordArgs = {
  password?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['ObjectId'];
};


export type MutationUpdatePortfolioSettingsArgs = {
  isAddedMediaKit?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['ObjectId'];
  showPopup?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BrokerPortfolioStatusesEnum>;
};


export type MutationUpdateSsoIdArgs = {
  ssoId: Scalars['String'];
};


export type MutationUpdateShowPopupOnPortfolioArgs = {
  portfolioId: Scalars['ObjectId'];
  showPopup: Scalars['Boolean'];
};


export type MutationUpdateSubscriptionEmailSettingsArgs = {
  input: UpdateSubscriptionEmailSettingsInput;
};


export type MutationUpdateUserApiArgs = {
  accountUpdateInput: UpdateAccountInput;
  apiCredentialsInput?: InputMaybe<ApiCredentialsInput>;
  profileInput: ProfileInput;
};


export type MutationUpdateUserCmsArgs = {
  accountUpdateInput: UpdateAccountInput;
  apiCredentialsInput?: InputMaybe<ApiCredentialsInput>;
  profileInput: ProfileInput;
};


export type MutationUploadDraftFileArgs = {
  input: FileUploadInput;
};


export type MutationUpsertComparisonArgs = {
  fieldsToCompare: Array<BrokerPortfolioComparisonFields>;
  portfolioFolderId: Scalars['ObjectId'];
  portfolioIds: Array<Scalars['ObjectId']>;
};


export type MutationValidateCouponArgs = {
  args: ValidateCouponInput;
};


export type MutationValidatePhoneNumberArgs = {
  attribution?: InputMaybe<SignupAttributionInput>;
  code: Scalars['String'];
};


export type MutationVerifyPhoneNumberAndUpdateAccountArgs = {
  code: Scalars['String'];
  phone: PhoneInput;
};

export type NewPortfolioItemActivitiesPayload = {
  __typename?: 'NewPortfolioItemActivitiesPayload';
  collection: Array<NewPortfolioItemActivity>;
  totalCount: Scalars['Float'];
};

export type NewPortfolioItemActivity = {
  __typename?: 'NewPortfolioItemActivity';
  _id: Scalars['String'];
  activityDoc: NewPortfolioItemActivityDoc;
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  portfolioItem?: Maybe<Portfolio>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type NewPortfolioItemActivityDoc = {
  __typename?: 'NewPortfolioItemActivityDoc';
  portfolioItemId: Scalars['ObjectId'];
};

export type ObserveAccountPayload = {
  __typename?: 'ObserveAccountPayload';
  account: Account;
  trigger: Scalars['String'];
};

export type ObserveBrokerAlertItemsPayload = {
  __typename?: 'ObserveBrokerAlertItemsPayload';
  document: BrokerAlertItem;
  trigger: Scalars['String'];
};

export type ObserveBrokerPortfolioPayload = {
  __typename?: 'ObserveBrokerPortfolioPayload';
  document: Portfolio;
  trigger: Scalars['String'];
};

export type ObserveProgressTrackingPayload = {
  __typename?: 'ObserveProgressTrackingPayload';
  document: ProgressTrackingModel;
};

export type ObservePropertyNotesPayload = {
  __typename?: 'ObservePropertyNotesPayload';
  document: PropertyNote;
  trigger: Scalars['String'];
};

export type ObservePropertyPayload = {
  __typename?: 'ObservePropertyPayload';
  document: Property;
  trigger: Scalars['String'];
};

export type Organization = {
  __typename?: 'Organization';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  internalSaleTeam: SaleTeam;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  logoFile?: Maybe<File>;
  logoFileId?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  propertiesCount: Scalars['Float'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  _id: Scalars['String'];
  account: Account;
  accountId: Scalars['String'];
  assignedPropertiesIds?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  internalSaleTeamId?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  profile: Profile;
  profileId: Scalars['String'];
  saleTeamRole?: Maybe<Role>;
  saleTeamRoleId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type OrganizationUsersPayload = {
  __typename?: 'OrganizationUsersPayload';
  collection: Array<OrganizationUser>;
  totalCount: Scalars['Float'];
};

export type OrganizationsPayload = {
  __typename?: 'OrganizationsPayload';
  collection: Array<Organization>;
  totalCount: Scalars['Float'];
};

export type PaginationInput = {
  allowLimit?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type PartialDateRangeInput = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type PartialMinMaxRangeInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type Phone = {
  __typename?: 'Phone';
  dialCode?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type PhoneInput = {
  dialCode: Scalars['String'];
  number: Scalars['String'];
};

export type Place = {
  __typename?: 'Place';
  key: Scalars['String'];
  name: Scalars['String'];
  state: Scalars['String'];
};

export type PlaceInput = {
  name: Scalars['String'];
  state: Scalars['String'];
};

export type PlaceOption = {
  __typename?: 'PlaceOption';
  cityKeys: Array<Scalars['String']>;
  count: Scalars['Int'];
  countyKeys: Array<Scalars['String']>;
  key: Scalars['String'];
  name: Scalars['String'];
  state: Scalars['String'];
};

export type PlaceOptionsPayload = {
  __typename?: 'PlaceOptionsPayload';
  cities: Array<PlaceOption>;
  counties: Array<PlaceOption>;
  marketAreas: Array<MarketAreaPlaceOption>;
};

export type PlaceTargetInput = {
  cities?: InputMaybe<Array<PlaceInput>>;
  counties?: InputMaybe<Array<PlaceInput>>;
  marketAreaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type PluginUserOwnTotalApiUsageFilterInput = {
  range?: InputMaybe<DateRangeInput>;
};

export type Portfolio = {
  __typename?: 'Portfolio';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isAddedMediaKit?: Maybe<Scalars['Boolean']>;
  isParentRoot: Scalars['Boolean'];
  locations?: Maybe<PortfolioLocations>;
  name?: Maybe<Scalars['String']>;
  portfolioFolder?: Maybe<Portfolio>;
  portfolioFolderId?: Maybe<Scalars['String']>;
  portfolioPropertiesIds?: Maybe<Array<Scalars['ObjectId']>>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  reactions: BrokerReactionsStats;
  reactionsCount: Scalars['Float'];
  showPopup?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  viewsCount: Scalars['Float'];
  withPassword: Scalars['Boolean'];
};

export type PortfolioFolderItemsGroup = {
  __typename?: 'PortfolioFolderItemsGroup';
  collection: Array<Portfolio>;
  folderId: Scalars['String'];
  totalCount: Scalars['Float'];
};

export type PortfolioLocations = {
  __typename?: 'PortfolioLocations';
  cities: Array<Place>;
  counties: Array<Place>;
  marketAreaIds: Array<Scalars['ObjectId']>;
};

export type PortfolioMediaKit = {
  __typename?: 'PortfolioMediaKit';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isAddedToMediaKit?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Media>;
  mediaId: Scalars['ObjectId'];
  portfolioId: Scalars['ObjectId'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type PortfolioReaction = {
  __typename?: 'PortfolioReaction';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  guestUser: GuestUser;
  guestUserId: Scalars['String'];
  portfolioId: Scalars['String'];
  reaction: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum PortfolioReactionsEnum {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type PortfolioTree = {
  __typename?: 'PortfolioTree';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isAddedMediaKit?: Maybe<Scalars['Boolean']>;
  isParentRoot: Scalars['Boolean'];
  items: Array<Portfolio>;
  name?: Maybe<Scalars['String']>;
  portfolioFolder?: Maybe<Portfolio>;
  portfolioFolderId?: Maybe<Scalars['String']>;
  portfolioPropertiesIds?: Maybe<Array<Scalars['ObjectId']>>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  reactions: BrokerReactionsStats;
  reactionsCount: Scalars['Float'];
  showPopup?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  viewsCount: Scalars['Float'];
  withPassword: Scalars['Boolean'];
};

export type PortfoliosPayload = {
  __typename?: 'PortfoliosPayload';
  collection: Array<Portfolio>;
  totalCount: Scalars['Float'];
};

export type PortfoliosTreePayload = {
  __typename?: 'PortfoliosTreePayload';
  collection: Array<PortfolioTree>;
  totalCount: Scalars['Float'];
};

export type PreferredPropertySettings = {
  __typename?: 'PreferredPropertySettings';
  buildingTypes?: Maybe<Array<BuildingTypesEnum>>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  priceRange?: Maybe<MinMax>;
  radiusInMiles?: Maybe<Scalars['Float']>;
};

export type PreferredPropertySettingsInput = {
  buildingTypes?: InputMaybe<Array<BuildingTypesEnum>>;
  locationInput?: InputMaybe<LocationSaveInput>;
  priceRange?: InputMaybe<PartialMinMaxRangeInput>;
  radiusInMiles?: InputMaybe<Scalars['Float']>;
};

export type PreviewInvoiceItem = {
  __typename?: 'PreviewInvoiceItem';
  amount: Scalars['Float'];
  description: Scalars['String'];
  id: Scalars['String'];
};

export type PreviewInvoicePayload = {
  __typename?: 'PreviewInvoicePayload';
  amountDue: Scalars['Float'];
  coupon?: Maybe<InvoiceCoupon>;
  dueDateMillis: Scalars['Float'];
  items: Array<PreviewInvoiceItem>;
};

export type ProductSubscription = {
  __typename?: 'ProductSubscription';
  _id: Scalars['String'];
  cancelationReason?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  currentPeriodEndAt: Scalars['Date'];
  currentPeriodStartAt: Scalars['Date'];
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  downgradeTo?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  otherReason?: Maybe<Scalars['String']>;
  schedule?: Maybe<SubscriptionSchedule>;
  status: Scalars['String'];
  stripeSubscriptionId: Scalars['String'];
  subscriptionInactiveAt?: Maybe<Scalars['Date']>;
  subscriptionProduct: SubscriptionProduct;
  subscriptionProductId: Scalars['String'];
  trialEndAt?: Maybe<Scalars['Date']>;
  trialStartAt?: Maybe<Scalars['Date']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type ProductSubscriptionPayload = {
  __typename?: 'ProductSubscriptionPayload';
  productSubscription: ProductSubscription;
  productSubscriptionPayment?: Maybe<ProductSubscriptionPayment>;
};

export type ProductSubscriptionPayment = {
  __typename?: 'ProductSubscriptionPayment';
  clientSecret?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
};

export type ProductSubscriptionsPayload = {
  __typename?: 'ProductSubscriptionsPayload';
  collection: Array<ProductSubscription>;
  totalCount: Scalars['Float'];
};

export type ProductsSubscriptionsObserveSubscriptionPayload = {
  __typename?: 'ProductsSubscriptionsObserveSubscriptionPayload';
  document: ProductSubscription;
  trigger: Scalars['String'];
};

export type Profile = {
  __typename?: 'Profile';
  _id: Scalars['String'];
  accountId: Scalars['String'];
  avatarFile?: Maybe<File>;
  avatarFileId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type ProfileInput = {
  _id?: InputMaybe<Scalars['String']>;
  avatarFileId?: InputMaybe<Scalars['ObjectId']>;
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type ProgressTrackingModel = {
  __typename?: 'ProgressTrackingModel';
  expectedOperations?: Maybe<Array<Scalars['String']>>;
  operation?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['Float']>;
  progressTrackingId: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export enum ProjectStatusesEnum {
  ComingSoon = 'COMING_SOON',
  Completed = 'COMPLETED',
  LeavingSoon = 'LEAVING_SOON',
  NewConstruction = 'NEW_CONSTRUCTION',
  NewListing = 'NEW_LISTING',
  PreConstruction = 'PRE_CONSTRUCTION',
  Proposed = 'PROPOSED',
  SoldOut = 'SOLD_OUT',
  UnderConstruction = 'UNDER_CONSTRUCTION'
}

export type PropertiesPayload = {
  __typename?: 'PropertiesPayload';
  collection: Array<Property>;
  totalCount: Scalars['Float'];
};

export type Property = {
  __typename?: 'Property';
  _id: Scalars['String'];
  amenities: Array<Amenity>;
  amenityIds?: Maybe<Array<Scalars['String']>>;
  amenityNames?: Maybe<Array<AmenityName>>;
  availableUnitsNumber: Scalars['Float'];
  averageBathroomsNumber?: Maybe<MinMax>;
  averageBathroomsNumberValue?: Maybe<MinMaxRangePayload>;
  averageBedroomsNumber?: Maybe<MinMax>;
  averageBedroomsNumberValue?: Maybe<MinMaxRangePayload>;
  brandedFilesReady?: Maybe<Scalars['Boolean']>;
  buildingTypes: Array<BuildingTypesEnum>;
  cheapestUnit?: Maybe<Unit>;
  cmsStatus?: Maybe<Scalars['String']>;
  cmsStatusUpdatedAt?: Maybe<Scalars['Date']>;
  comingSoon?: Maybe<Scalars['Boolean']>;
  completionDate?: Maybe<Scalars['Date']>;
  constructionStartDate?: Maybe<Scalars['Date']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<ContactPhone>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  defaultInventoryDetails?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  firstPublicStatusDate?: Maybe<Scalars['Date']>;
  hasChangelog: Scalars['Boolean'];
  hasUnreadNotes: Scalars['Boolean'];
  interiorDesigner?: Maybe<Scalars['String']>;
  isMarkedAsVerified: Scalars['Boolean'];
  isRestricted: Scalars['Boolean'];
  landscapeArchitect?: Maybe<Scalars['String']>;
  lastChangelogType?: Maybe<PropertyChangelogTypesEnum>;
  lastUpdatedAtByChangelog?: Maybe<Scalars['Date']>;
  leadArchitect?: Maybe<Scalars['String']>;
  localArchitect?: Maybe<Scalars['String']>;
  location: Location;
  locationId: Scalars['ObjectId'];
  mainPropertyMediaFile?: Maybe<Media>;
  mainPropertyMediaId?: Maybe<Scalars['String']>;
  market?: Maybe<Scalars['String']>;
  marketArea?: Maybe<MarketArea>;
  name: Scalars['String'];
  numberOfTowers?: Maybe<Scalars['Float']>;
  numberOfUnits?: Maybe<Scalars['Float']>;
  organizationIds?: Maybe<Array<Scalars['String']>>;
  organizations?: Maybe<Array<Organization>>;
  overview?: Maybe<Scalars['String']>;
  priceRange?: Maybe<MinMax>;
  primaryOrganization?: Maybe<Organization>;
  primaryOrganizationId?: Maybe<Scalars['String']>;
  projectDetails?: Maybe<Scalars['String']>;
  projectStatus?: Maybe<Scalars['String']>;
  propertyTags?: Maybe<Array<PropertyTagsEnum>>;
  rootMediaFolderId: Scalars['String'];
  saleTeams?: Maybe<Array<PropertySaleTeam>>;
  salesGalleryAddress?: Maybe<Scalars['String']>;
  salesGalleryHours?: Maybe<LocalTimeHours>;
  salesGalleryStatus?: Maybe<SalesGalleryStatusesEnum>;
  slideshowMedia: Array<Media>;
  slideshowMediaFolderId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stories?: Maybe<Scalars['Float']>;
  taxInformation?: Maybe<Scalars['String']>;
  transactionType: PropertyTransactionTypesEnum;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  verifiedAt?: Maybe<Scalars['Date']>;
  virtualTourLinks?: Maybe<Array<VirtualTourLink>>;
  website?: Maybe<Scalars['String']>;
  workingHours?: Maybe<WorkingHours>;
  yearBuilt?: Maybe<Scalars['Float']>;
};

export type PropertyAboutChangelog = {
  __typename?: 'PropertyAboutChangelog';
  projectDetails?: Maybe<Scalars['String']>;
};

export type PropertyAdditionalInformationChangelog = {
  __typename?: 'PropertyAdditionalInformationChangelog';
  buildingTypes: Array<BuildingTypesEnum>;
  completionDate?: Maybe<Scalars['Date']>;
  constructionStartDate?: Maybe<Scalars['Date']>;
  numberOfTowers?: Maybe<Scalars['Float']>;
  numberOfUnits?: Maybe<Scalars['Float']>;
  projectStatus?: Maybe<Scalars['String']>;
  propertyTags?: Maybe<Array<PropertyTagsEnum>>;
  salesGalleryAddress?: Maybe<Scalars['String']>;
  salesGalleryHours?: Maybe<LocalTimeHours>;
  salesGalleryStatus?: Maybe<SalesGalleryStatusesEnum>;
  stories?: Maybe<Scalars['Float']>;
  transactionType?: Maybe<PropertyTransactionTypesEnum>;
  yearBuilt?: Maybe<Scalars['Float']>;
};

export type PropertyChangelog = {
  __typename?: 'PropertyChangelog';
  _id: Scalars['String'];
  afterUpdate: ChangelogDocument;
  beforeUpdate?: Maybe<ChangelogDocument>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  property: Property;
  propertyId: Scalars['ObjectId'];
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum PropertyChangelogTypesEnum {
  PropertyAbout = 'PROPERTY_ABOUT',
  PropertyAdditionalInformation = 'PROPERTY_ADDITIONAL_INFORMATION',
  PropertyCmsStatus = 'PROPERTY_CMS_STATUS',
  PropertyDataReviewed = 'PROPERTY_DATA_REVIEWED',
  PropertyDeveloperOrganization = 'PROPERTY_DEVELOPER_ORGANIZATION',
  PropertyFeaturesAndAmenities = 'PROPERTY_FEATURES_AND_AMENITIES',
  PropertyHighlights = 'PROPERTY_HIGHLIGHTS',
  PropertyInventoryUnitAdded = 'PROPERTY_INVENTORY_UNIT_ADDED',
  PropertyInventoryUnitRemoved = 'PROPERTY_INVENTORY_UNIT_REMOVED',
  PropertyInventoryUnitUpdated = 'PROPERTY_INVENTORY_UNIT_UPDATED',
  PropertyLocation = 'PROPERTY_LOCATION',
  PropertyMediaFilesMoved = 'PROPERTY_MEDIA_FILES_MOVED',
  PropertyMediaRemoved = 'PROPERTY_MEDIA_REMOVED',
  PropertyMediaRenamed = 'PROPERTY_MEDIA_RENAMED',
  PropertyMediaUploaded = 'PROPERTY_MEDIA_UPLOADED',
  PropertyName = 'PROPERTY_NAME',
  PropertyPrice = 'PROPERTY_PRICE',
  PropertySalesTeams = 'PROPERTY_SALES_TEAMS',
  PropertyVirtualTours = 'PROPERTY_VIRTUAL_TOURS',
  PropertyVisibility = 'PROPERTY_VISIBILITY',
  PropertyWebsite = 'PROPERTY_WEBSITE'
}

export type PropertyChangelogsPayload = {
  __typename?: 'PropertyChangelogsPayload';
  collection: Array<PropertyChangelog>;
  totalCount: Scalars['Float'];
};

export type PropertyClick = {
  __typename?: 'PropertyClick';
  address?: Maybe<Scalars['String']>;
  clickCount: Scalars['Float'];
  name: Scalars['String'];
  propertyId: Scalars['ObjectId'];
};

export type PropertyCmsStatusChangelog = {
  __typename?: 'PropertyCmsStatusChangelog';
  cmsStatus?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type PropertyDataReviewedChangelog = {
  __typename?: 'PropertyDataReviewedChangelog';
  reviewed: Scalars['Boolean'];
};

export type PropertyDetail = {
  __typename?: 'PropertyDetail';
  _id: Scalars['String'];
  averageBathroomsNumber?: Maybe<MinMax>;
  averageBedroomsNumber?: Maybe<MinMax>;
  completionDate?: Maybe<Scalars['Date']>;
  mainPropertyMediaFile?: Maybe<Media>;
  marketArea?: Maybe<MarketArea>;
  name: Scalars['String'];
  overview?: Maybe<Scalars['String']>;
  priceRange?: Maybe<MinMax>;
  projectStatus?: Maybe<Scalars['String']>;
  yearBuilt?: Maybe<Scalars['Float']>;
};

export type PropertyDeveloperOrganizationChangelog = {
  __typename?: 'PropertyDeveloperOrganizationChangelog';
  interiorDesigner?: Maybe<Scalars['String']>;
  landscapeArchitect?: Maybe<Scalars['String']>;
  leadArchitect?: Maybe<Scalars['String']>;
  localArchitect?: Maybe<Scalars['String']>;
  logoFileId?: Maybe<Scalars['ObjectId']>;
  name?: Maybe<Scalars['String']>;
  organizationIds: Array<Scalars['String']>;
};

export type PropertyFeaturesAndAmenitiesChangelog = {
  __typename?: 'PropertyFeaturesAndAmenitiesChangelog';
  amenityIds?: Maybe<Array<Scalars['String']>>;
  amenityNames?: Maybe<Array<AmenityName>>;
};

export type PropertyHighlightsChangelog = {
  __typename?: 'PropertyHighlightsChangelog';
  overview?: Maybe<Scalars['String']>;
};

export type PropertyInventoryUnitAddedChangelog = {
  __typename?: 'PropertyInventoryUnitAddedChangelog';
  newUnitId: Scalars['String'];
};

export type PropertyInventoryUnitRemovedChangelog = {
  __typename?: 'PropertyInventoryUnitRemovedChangelog';
  removedUnitId: Scalars['String'];
};

export type PropertyInventoryUnitUpdatedChangelog = {
  __typename?: 'PropertyInventoryUnitUpdatedChangelog';
  averageBathroomsNumber: MinMaxRange;
  averageBedroomsNumber: MinMaxRange;
  averageExteriorSqft: MinMaxRange;
  averageInteriorSqft: MinMaxRange;
  averageTotalSqft: MinMaxRange;
  floorPlanFileId?: Maybe<Scalars['String']>;
  highestPrice?: Maybe<Scalars['Float']>;
  inventoryType: Scalars['String'];
  name: Scalars['String'];
  startingPrice?: Maybe<Scalars['Float']>;
};

export type PropertyLocationChangelog = {
  __typename?: 'PropertyLocationChangelog';
  address: Address;
};

export type PropertyMediaFilesMovedChangelog = {
  __typename?: 'PropertyMediaFilesMovedChangelog';
  mediaFilesIds: Array<Scalars['ObjectId']>;
  mediaFolderId?: Maybe<Scalars['ObjectId']>;
};

export type PropertyMediaRemovedChangelog = {
  __typename?: 'PropertyMediaRemovedChangelog';
  removedMediaIds: Array<Scalars['ObjectId']>;
};

export type PropertyMediaRenamedChangelog = {
  __typename?: 'PropertyMediaRenamedChangelog';
  name: Scalars['String'];
};

export type PropertyMediaUploadedChangelog = {
  __typename?: 'PropertyMediaUploadedChangelog';
  folderName?: Maybe<Scalars['String']>;
  mediaFolderId: Scalars['String'];
  uploadedMediaId: Scalars['String'];
};

export type PropertyNameChangelog = {
  __typename?: 'PropertyNameChangelog';
  name: Scalars['String'];
};

export type PropertyNote = {
  __typename?: 'PropertyNote';
  _id: Scalars['String'];
  attachedFiles?: Maybe<Array<File>>;
  attachedFilesIds: Array<Scalars['String']>;
  authorAccount?: Maybe<Account>;
  authorProfile?: Maybe<Profile>;
  createdAt: Scalars['Date'];
  createdBy: Scalars['String'];
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  propertyId: Scalars['String'];
  readBy: Array<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type PropertyNotesPayload = {
  __typename?: 'PropertyNotesPayload';
  collection: Array<PropertyNote>;
  totalCount: Scalars['Float'];
};

export type PropertyOrganizationSalesTeamsChangelog = {
  __typename?: 'PropertyOrganizationSalesTeamsChangelog';
  saleTeams?: Maybe<Array<PropertySaleTeam>>;
};

export type PropertyPriceChangelog = {
  __typename?: 'PropertyPriceChangelog';
  priceRange?: Maybe<MinMax>;
};

export type PropertySaleTeam = {
  __typename?: 'PropertySaleTeam';
  commission?: Maybe<Scalars['Float']>;
  contactUrl?: Maybe<Scalars['String']>;
  saleAssociateIds?: Maybe<Array<Scalars['String']>>;
  saleAssociates?: Maybe<Array<DeveloperAsSaleUser>>;
  saleDirector?: Maybe<DeveloperAsSaleUser>;
  saleDirectorId?: Maybe<Scalars['String']>;
  saleTeam: SaleTeam;
  saleTeamId: Scalars['String'];
};

export type PropertySaleTeamInput = {
  commission?: InputMaybe<Scalars['Float']>;
  contactUrl?: InputMaybe<Scalars['String']>;
  saleAssociateIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  saleDirectorId?: InputMaybe<Scalars['ObjectId']>;
  saleTeamId: Scalars['ObjectId'];
};

export enum PropertyStatusesEnum {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  SoldOut = 'SOLD_OUT'
}

export type PropertySummary = {
  __typename?: 'PropertySummary';
  _id: Scalars['String'];
  name: Scalars['String'];
};

export enum PropertyTagsEnum {
  ActiveAdult = 'ACTIVE_ADULT',
  Boutique = 'BOUTIQUE',
  BrandedResidences = 'BRANDED_RESIDENCES',
  CondoConversion = 'CONDO_CONVERSION',
  Eb5Program = 'EB5_PROGRAM',
  LimitedInventory = 'LIMITED_INVENTORY',
  MasterPlanned = 'MASTER_PLANNED',
  Penthouse = 'PENTHOUSE',
  ResortStyle = 'RESORT_STYLE',
  ShortTermRentalFriendly = 'SHORT_TERM_RENTAL_FRIENDLY',
  Waterfront = 'WATERFRONT',
  WorkforceHousing = 'WORKFORCE_HOUSING'
}

export enum PropertyTransactionTypesEnum {
  ForRent = 'FOR_RENT',
  ForSale = 'FOR_SALE'
}

export type PropertyVirtualToursChangelog = {
  __typename?: 'PropertyVirtualToursChangelog';
  virtualTourLinks: Array<VirtualTourLink>;
};

export type PropertyVisibilityChangelog = {
  __typename?: 'PropertyVisibilityChangelog';
  visibility?: Maybe<Scalars['String']>;
};

export type PropertyVisitActivitiesPayload = {
  __typename?: 'PropertyVisitActivitiesPayload';
  collection: Array<PropertyVisitActivity>;
  totalCount: Scalars['Float'];
};

export type PropertyVisitActivity = {
  __typename?: 'PropertyVisitActivity';
  _id: Scalars['String'];
  activityDoc: PropertyVisitActivityDoc;
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  property: Property;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type PropertyVisitActivityDoc = {
  __typename?: 'PropertyVisitActivityDoc';
  propertyId: Scalars['ObjectId'];
};

export type PropertyWebsiteChangelog = {
  __typename?: 'PropertyWebsiteChangelog';
  website?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  apiInvitations: ApiInvitationsPayload;
  canUserTrialForProduct: Scalars['Boolean'];
  checkIfPortfolioHasMediaKit: Scalars['Boolean'];
  countPropertiesInPlaces: Scalars['Int'];
  currentBrokerHasAlertConfigs: Scalars['Boolean'];
  currentBrokerHasPortfolios: Scalars['Boolean'];
  downloadPropertiesXml: XmlDownloadResponse;
  generateMfaQrCode: GenerateQrCodeResult;
  getAccount: Account;
  getAccountBySignUpVerificationCode: Account;
  getAlertConfigById: BrokerAlertConfig;
  getAlertConfigs: BrokerAlertConfigPayload;
  getAlertItems: BrokerAlertItemPayload;
  getAllFilesInProperty: MediaFilesAndFoldersPayload;
  getAllFilesInPropertyPreview: MediaFilesAndFoldersPayload;
  getAllFoldersInProperty: Array<Media>;
  getAllPortfolioFolders: Array<Portfolio>;
  getAllPropertyChangelogs: PropertyChangelogsPayload;
  getAmenities: AmenitiesPayload;
  getAmenitiesForManage: AmenitiesPayload;
  getApiCredentialsBasicInfo?: Maybe<BasicInfoResponse>;
  getApiCredentialsById: ApiCredentialSafeDto;
  getApiPluginUsers: ApiPluginUsersPayload;
  getApiQuotaStatusByAppId: ApiQuotaStatusPayload;
  getApiUsers: ApiUsersPayload;
  getBrokerById: Broker;
  getBrokerForAccountManagement: Broker;
  getBrokerGuestUser: GuestUserPayload;
  getBrokerNewPortfolioItemActivities: NewPortfolioItemActivitiesPayload;
  getBrokerProperties: PropertiesPayload;
  getBrokerViewedPortfolios: ViewHistoryPayload;
  getBrokers: BrokersPayload;
  getCMSUsers: UsersPayload;
  getCheckoutSessionDetails: CheckoutSessionDetails;
  getCmsSettings: CmsSettings;
  getCompanyOwnApiQuotaStatus: ApiQuotaStatusPayload;
  getCompanyOwnMonthlyApiUsage: Scalars['Int'];
  getCompanyOwnTotalApiUsage: ApiMetricPayload;
  getComparison?: Maybe<Comparison>;
  getContentActivity: ContentActivity;
  getContentActivityLog: ContentActivityLog;
  getCurrentAccountProductSubscription?: Maybe<ProductSubscription>;
  getCurrentAccountTrialProductSubscriptions?: Maybe<ProductSubscriptionsPayload>;
  getCurrentBroker: Broker;
  getCurrentDeveloperProperties: PropertiesPayload;
  getCurrentDeveloperUser: Developer;
  getCurrentStripeAccount?: Maybe<StripeAccount>;
  getCurrentStripeAccountTransactions: StripeAccountTransactionsFlatPayload;
  getDevelopersAsSaleUsersBySaleTeamAndRole: Array<DeveloperAsSaleUser>;
  getExternalSaleTeamByIdForDeveloper: SaleTeam;
  getExternalSaleTeamsForDeveloper: SaleTeamsPayload;
  getFeaturedPortfolioById: FeaturedPortfolio;
  getFeaturedPortfolioByIdPublic: FeaturedPortfolio;
  getFeaturedPortfolioMarketAreas: Array<MarketAreaCount>;
  getFeaturedPortfolioMarketAreasPublic: Array<MarketAreaCount>;
  getFeaturedPortfolioProperties: FeaturedPortfolioPropertiesPayload;
  getFeaturedPortfolioPropertiesAdmin: Array<PropertySummary>;
  getFeaturedPortfolioPropertiesPublic: FeaturedPortfolioPropertiesPayload;
  getFeaturedPortfolioSummary?: Maybe<FeaturedPortfolioSummary>;
  getFeaturedPortfolioSummaryPublic?: Maybe<FeaturedPortfolioSummary>;
  getFeaturedPortfolios: FeaturedPortfoliosPayload;
  getFeaturedProperties: FeaturedPropertiesPayload;
  getFeaturedPropertyById: FeaturedProperty;
  getFileDownloadsStatistic: GetFileDownloadsStatisticPayload;
  getFoldersPathOfMedia?: Maybe<Scalars['String']>;
  getGuestUserReactionsCount: Scalars['Float'];
  getIdxActivity: IdxActivityPayload;
  getIdxEmbeddedPortfolioFeed: IdxEmbeddedPortfolioFeedData;
  getIdxEmbeddedPropertyFeed: IdxEmbeddedPropertyFeedData;
  getIdxEmbeddedSearchBarFeed: IdxEmbeddedSearchBarFeedData;
  getIdxFeedDetails: IdxFeed;
  getIdxFeedList: GetIdxFeedListPayload;
  getIdxPortfolioFeedProperties: IdxPortfolioFeedPropertiesData;
  getIdxPropertyFiles: MediaFilesPayload;
  getIdxSearchFeedProperties: IdxSearchFeedPropertiesData;
  getIdxSettings: IdxSettings;
  getInternalOrganizationSaleTeam: SaleTeam;
  getIsFeaturedPortfolioSaved?: Maybe<BrokerSavedFeaturedPortfolio>;
  getIsPropertyTracked?: Maybe<BrokerTrackedProperty>;
  getMarketAreas: MarketAreasPayload;
  getMarketAreasForFilter: Array<MarketArea>;
  getMediaFolderById: Media;
  getMediaFoldersAndFiles: MediaFilesAndFoldersPayload;
  getMonthlyApiUsageByAppId: Scalars['Int'];
  getMyApiPluginUsers: ApiPluginUsersPayload;
  getNumberOfNewAlertItems: Scalars['Float'];
  getNumberOfPortfolioPropertiesChangelogs: Scalars['Float'];
  getOrganizationById: Organization;
  getOrganizationRoles: RolesPayload;
  getOrganizationUsers: OrganizationUsersPayload;
  getOrganizationUsersByOrganizationRole: OrganizationUsersPayload;
  getOrganizations: OrganizationsPayload;
  getPlaceOptions: PlaceOptionsPayload;
  getPluginUserOwnApiQuotaStatus: ApiQuotaStatusPayload;
  getPluginUserOwnMonthlyApiUsage: Scalars['Int'];
  getPluginUserOwnTotalApiUsage: ApiMetricPayload;
  getPortfolioFirstPublicProperty?: Maybe<Portfolio>;
  getPortfolioFolderById: Portfolio;
  getPortfolioFolderItems: PortfoliosPayload;
  getPortfolioFolderItemsBulk: Array<PortfolioFolderItemsGroup>;
  getPortfolioFolderRoot: Portfolio;
  getPortfolioMediaKitItems: MediaKitPayload;
  getPortfolioPassword?: Maybe<Scalars['String']>;
  getPortfolioPropertiesChangelogs: PropertyChangelogsPayload;
  getPortfolioPropertiesToCompare: PropertiesPayload;
  getPortfolios: PortfoliosPayload;
  getPortfoliosByPublicFolder: PortfoliosPayload;
  getPortfoliosTree: PortfoliosTreePayload;
  getPortfoliosWithReactions: PortfoliosPayload;
  getPreviewInvoice: PreviewInvoicePayload;
  getProperties: PropertiesPayload;
  getPropertiesByOrganizationRole: PropertiesPayload;
  getPropertyAmenitiesInPublicBrokerPortfolio: AmenitiesPayload;
  getPropertyById: Property;
  getPropertyChangelogs: PropertyChangelogsPayload;
  getPropertyNotes: PropertyNotesPayload;
  getPropertySlideshowMediaInPublicBrokerPortfolio: Array<Media>;
  getPropertyUnitsInPublicBrokerPortfolio: UnitsPayload;
  getPropertyUnitsSqftRange?: Maybe<MinMaxRangePayload>;
  getPropertyViewsByBroker: ViewHistoryPayload;
  getPropertyVisitActivities: PropertyVisitActivitiesPayload;
  getPublicBrokerPortfolio: Portfolio;
  getReactionsStatsForBroker: BrokerReactionsStats;
  getSaleTeamById: SaleTeam;
  getSaleTeamUserNameByEmail?: Maybe<SaleTeamUserNamePayload>;
  getSaleTeamUsers: SaleTeamUsersPayload;
  getSaleTeams: SaleTeamsPayload;
  getSalesTeamRoles: RolesPayload;
  getSavedFeaturedPortfolios: BrokerSavedFeaturedPortfoliosPayload;
  getSavedFeaturedPortfoliosCount: Scalars['Float'];
  getSingleBrokerById: Broker;
  getSlideshowMediaByProperty: Array<Media>;
  getSubscriptionEmailSettings: SubscriptionEmailSettings;
  getSubscriptionProducts: Array<SubscriptionProduct>;
  getSystemActionCount: Scalars['Float'];
  getTopLevelFoldersInProperty: Array<Media>;
  getTotalApiUsage: ApiMetricPayload;
  getTotalApiUsageByAppId: Scalars['Int'];
  getTrackedProperties: BrokerTrackedPropertiesPayload;
  getTrackedPropertiesByOrganizationCount: Scalars['Float'];
  getTrackedPropertyIds: Array<TrackedPropertyId>;
  getTrendingList?: Maybe<TrendingList>;
  getUSStateByName: State;
  getUSStates: Array<State>;
  getUniqPropertiesAmenities: Array<Scalars['String']>;
  getUniqPropertiesMarkets: Array<UnitPropertyMarket>;
  getUnits: UnitsPayload;
  getUnitsInPublicProperty: UnitsPayload;
  getUserByApiCredentialsId: ApiPluginUser;
  getUserPublicPortfolioFolders: Array<Portfolio>;
  globalSearch: SearchIndexPayload;
  myPendingApiAccess: Scalars['Boolean'];
  recommendedProperties: Array<Property>;
  similarProperties: Array<Property>;
  simulateError: Broker;
  validateApiInvitation: ApiInvitationValidation;
};


export type QueryApiInvitationsArgs = {
  searchText?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ApiInvitationStatusEnum>;
};


export type QueryCanUserTrialForProductArgs = {
  input: CanUserTrialForProductInput;
};


export type QueryCheckIfPortfolioHasMediaKitArgs = {
  portfolioId: Scalars['ObjectId'];
};


export type QueryCountPropertiesInPlacesArgs = {
  input: PlaceTargetInput;
};


export type QueryGetAccountBySignUpVerificationCodeArgs = {
  signUpVerificationCode: Scalars['String'];
};


export type QueryGetAlertConfigByIdArgs = {
  alertConfigId: Scalars['ObjectId'];
};


export type QueryGetAlertConfigsArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetAlertItemsArgs = {
  filter?: InputMaybe<GetAlertItemsFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetAllFilesInPropertyArgs = {
  filter: GetAllFilesInPropertyFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  isRestricted?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetAllFilesInPropertyPreviewArgs = {
  filter: GetAllFilesInPropertyFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  isRestricted?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  previewAsSeeker?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetAllFoldersInPropertyArgs = {
  excludeSlideshowFolder?: Scalars['Boolean'];
  includeRootFolder?: InputMaybe<Scalars['Boolean']>;
  mediaFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
};


export type QueryGetAllPropertyChangelogsArgs = {
  filter: GetAllPropertyChangelogsFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetAmenitiesArgs = {
  filter?: InputMaybe<GetAmenitiesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetAmenitiesForManageArgs = {
  filter: GetAmenitiesForManageFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetApiCredentialsByIdArgs = {
  apiCredentialsId: Scalars['String'];
};


export type QueryGetApiPluginUsersArgs = {
  filter?: InputMaybe<GetApiUsersFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetApiQuotaStatusByAppIdArgs = {
  appId: Scalars['String'];
};


export type QueryGetApiUsersArgs = {
  filter?: InputMaybe<GetApiUsersFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetBrokerByIdArgs = {
  brokerId: Scalars['ObjectId'];
};


export type QueryGetBrokerGuestUserArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetBrokerNewPortfolioItemActivitiesArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetBrokerPropertiesArgs = {
  filter?: InputMaybe<GetBrokerPropertiesFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetBrokerViewedPortfoliosArgs = {
  filter?: InputMaybe<BrokerViewedPortfoliosFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetBrokersArgs = {
  filter?: InputMaybe<GetBrokersFilter>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetCmsUsersArgs = {
  filter?: InputMaybe<GetCmsUsersFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetCheckoutSessionDetailsArgs = {
  sessionId: Scalars['String'];
};


export type QueryGetCompanyOwnMonthlyApiUsageArgs = {
  targetMonth: Scalars['Int'];
};


export type QueryGetCompanyOwnTotalApiUsageArgs = {
  filter?: InputMaybe<PluginUserOwnTotalApiUsageFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetComparisonArgs = {
  portfolioFolderId: Scalars['ObjectId'];
};


export type QueryGetContentActivityArgs = {
  range: DateRangeInput;
};


export type QueryGetContentActivityLogArgs = {
  pagination?: InputMaybe<PaginationInput>;
  range: DateRangeInput;
};


export type QueryGetCurrentDeveloperPropertiesArgs = {
  filter?: InputMaybe<GetPropertiesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetCurrentStripeAccountTransactionsArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetDevelopersAsSaleUsersBySaleTeamAndRoleArgs = {
  roleType?: InputMaybe<RoleTypesEnum>;
  saleTeamId: Scalars['ObjectId'];
};


export type QueryGetExternalSaleTeamByIdForDeveloperArgs = {
  saleTeamId: Scalars['ObjectId'];
};


export type QueryGetExternalSaleTeamsForDeveloperArgs = {
  filter?: InputMaybe<GetSaleTeamsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetFeaturedPortfolioByIdArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfolioByIdPublicArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfolioMarketAreasArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfolioMarketAreasPublicArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfolioPropertiesArgs = {
  featuredPortfolioId: Scalars['String'];
  pagination?: InputMaybe<FlatPaginationInput>;
};


export type QueryGetFeaturedPortfolioPropertiesAdminArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfolioPropertiesPublicArgs = {
  featuredPortfolioId: Scalars['String'];
  pagination?: InputMaybe<FlatPaginationInput>;
};


export type QueryGetFeaturedPortfolioSummaryArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfolioSummaryPublicArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfoliosArgs = {
  filter?: InputMaybe<GetFeaturedPortfoliosFilter>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetFeaturedPropertiesArgs = {
  filter?: InputMaybe<GetFeaturedPropertiesFilter>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetFeaturedPropertyByIdArgs = {
  featuredPropertyId: Scalars['String'];
};


export type QueryGetFileDownloadsStatisticArgs = {
  filter?: InputMaybe<GetFileDownloadStatisticsArgsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetFoldersPathOfMediaArgs = {
  mediaId: Scalars['ObjectId'];
};


export type QueryGetGuestUserReactionsCountArgs = {
  filter: GetPortfoliosWithReactionsFilter;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetIdxActivityArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  idxId: Scalars['ObjectId'];
};


export type QueryGetIdxEmbeddedPortfolioFeedArgs = {
  input: GetIdxEmbeddedPortfolioFeedInput;
};


export type QueryGetIdxEmbeddedPropertyFeedArgs = {
  input: GetIdxEmbeddedPropertyFeedInput;
};


export type QueryGetIdxEmbeddedSearchBarFeedArgs = {
  input: GetIdxEmbeddedSearchBarFeedInput;
};


export type QueryGetIdxFeedDetailsArgs = {
  idxFeedId?: InputMaybe<Scalars['ObjectId']>;
};


export type QueryGetIdxFeedListArgs = {
  input: GetIdxFeedListInput;
};


export type QueryGetIdxPortfolioFeedPropertiesArgs = {
  input: GetIdxPortfolioFeedPropertiesInput;
};


export type QueryGetIdxPropertyFilesArgs = {
  input: GetIdxPropertyFilesInput;
};


export type QueryGetIdxSearchFeedPropertiesArgs = {
  input: GetIdxSearchFeedPropertiesInput;
};


export type QueryGetInternalOrganizationSaleTeamArgs = {
  organizationId: Scalars['ObjectId'];
};


export type QueryGetIsFeaturedPortfolioSavedArgs = {
  portfolioId: Scalars['ObjectId'];
};


export type QueryGetIsPropertyTrackedArgs = {
  propertyId: Scalars['ObjectId'];
};


export type QueryGetMarketAreasArgs = {
  filter?: InputMaybe<GetMarketAreasFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetMarketAreasForFilterArgs = {
  input: GetMarketAreasForFilterInput;
};


export type QueryGetMediaFolderByIdArgs = {
  folderId: Scalars['ObjectId'];
};


export type QueryGetMediaFoldersAndFilesArgs = {
  filter: GetMediaFoldersAndFilesFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetMonthlyApiUsageByAppIdArgs = {
  appId: Scalars['String'];
  targetMonth: Scalars['Int'];
};


export type QueryGetMyApiPluginUsersArgs = {
  filter?: InputMaybe<GetApiUsersFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetNumberOfNewAlertItemsArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  range?: InputMaybe<DateRangeInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetNumberOfPortfolioPropertiesChangelogsArgs = {
  dateRange?: InputMaybe<PartialDateRangeInput>;
};


export type QueryGetOrganizationByIdArgs = {
  organizationId: Scalars['ObjectId'];
};


export type QueryGetOrganizationUsersArgs = {
  filter: GetOrganizationUsersFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetOrganizationUsersByOrganizationRoleArgs = {
  filter: GetOrganizationUsersFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetOrganizationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchByName?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPluginUserOwnMonthlyApiUsageArgs = {
  targetMonth: Scalars['Int'];
};


export type QueryGetPluginUserOwnTotalApiUsageArgs = {
  filter?: InputMaybe<PluginUserOwnTotalApiUsageFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPortfolioFirstPublicPropertyArgs = {
  brokerId: Scalars['String'];
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderName: Scalars['String'];
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfolioFolderByIdArgs = {
  portfolioFolderId: Scalars['ObjectId'];
};


export type QueryGetPortfolioFolderItemsArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  portfolioFolderId: Scalars['ObjectId'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfolioFolderItemsBulkArgs = {
  folderIds: Array<Scalars['ObjectId']>;
  limitPerFolder?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetPortfolioMediaKitItemsArgs = {
  filter: GetPortfolioMediaKitItemsInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfolioPasswordArgs = {
  portfolioId: Scalars['ObjectId'];
};


export type QueryGetPortfolioPropertiesChangelogsArgs = {
  filter?: InputMaybe<GetPortfolioPropertiesChangelogsFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfolioPropertiesToCompareArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  portfolioFolderId: Scalars['ObjectId'];
  portfolioIds: Array<Scalars['ObjectId']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfoliosArgs = {
  filter?: InputMaybe<GetPortfoliosFilter>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfoliosByPublicFolderArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderId: Scalars['ObjectId'];
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfoliosTreeArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfoliosWithReactionsArgs = {
  filter?: InputMaybe<GetPortfoliosWithReactionsFilter>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPreviewInvoiceArgs = {
  input: GetPreviewInvoiceInput;
};


export type QueryGetPropertiesArgs = {
  filter?: InputMaybe<GetPropertiesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPropertiesByOrganizationRoleArgs = {
  filter?: InputMaybe<GetPropertiesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPropertyAmenitiesInPublicBrokerPortfolioArgs = {
  brokerId: Scalars['ObjectId'];
  filter?: InputMaybe<GetAmenitiesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPropertyByIdArgs = {
  propertyId: Scalars['ObjectId'];
};


export type QueryGetPropertyChangelogsArgs = {
  filter: GetPropertyChangelogsFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPropertyNotesArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  propertyId: Scalars['ObjectId'];
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPropertySlideshowMediaInPublicBrokerPortfolioArgs = {
  brokerId: Scalars['ObjectId'];
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
};


export type QueryGetPropertyUnitsInPublicBrokerPortfolioArgs = {
  brokerId: Scalars['ObjectId'];
  filter?: InputMaybe<GetUnitsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPropertyUnitsSqftRangeArgs = {
  propertyId: Scalars['ObjectId'];
};


export type QueryGetPropertyViewsByBrokerArgs = {
  filter: GetPropertyViewsByBrokerAFilter;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPropertyVisitActivitiesArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPublicBrokerPortfolioArgs = {
  brokerId: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderName?: InputMaybe<Scalars['String']>;
  portfolioName: Scalars['String'];
};


export type QueryGetReactionsStatsForBrokerArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type QueryGetSaleTeamByIdArgs = {
  saleTeamId: Scalars['ObjectId'];
};


export type QueryGetSaleTeamUserNameByEmailArgs = {
  email: Scalars['String'];
};


export type QueryGetSaleTeamUsersArgs = {
  filter: GetSaleTeamUsersFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetSaleTeamsArgs = {
  filter?: InputMaybe<GetSaleTeamsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetSavedFeaturedPortfoliosArgs = {
  filter?: InputMaybe<GetSavedFeaturedPortfoliosFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetSavedFeaturedPortfoliosCountArgs = {
  filter?: InputMaybe<GetSavedFeaturedPortfoliosFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetSingleBrokerByIdArgs = {
  brokerId: Scalars['ObjectId'];
};


export type QueryGetSlideshowMediaByPropertyArgs = {
  propertyId: Scalars['ObjectId'];
};


export type QueryGetSubscriptionProductsArgs = {
  filter?: InputMaybe<GetSubscriptionProductsFilterInput>;
};


export type QueryGetSystemActionCountArgs = {
  filter: GetSystemActionLogsFilterInput;
};


export type QueryGetTopLevelFoldersInPropertyArgs = {
  propertyId: Scalars['ObjectId'];
};


export type QueryGetTotalApiUsageArgs = {
  filter?: InputMaybe<TotalApiUsageFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetTotalApiUsageByAppIdArgs = {
  appId: Scalars['String'];
};


export type QueryGetTrackedPropertiesArgs = {
  filter?: InputMaybe<GetTrackedPropertiesFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetTrackedPropertiesByOrganizationCountArgs = {
  filter?: InputMaybe<GetTrackedPropertiesFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetTrendingListArgs = {
  type: Scalars['String'];
};


export type QueryGetUsStateByNameArgs = {
  stateName: Scalars['String'];
};


export type QueryGetUsStatesArgs = {
  filter?: InputMaybe<GetStatesFilterInput>;
};


export type QueryGetUniqPropertiesAmenitiesArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetUnitsArgs = {
  filter?: InputMaybe<GetUnitsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetUnitsInPublicPropertyArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  propertyId: Scalars['ObjectId'];
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetUserByApiCredentialsIdArgs = {
  filter?: InputMaybe<GetUserByApiCredentialsFilterInput>;
};


export type QueryGlobalSearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type QueryRecommendedPropertiesArgs = {
  excludePropertyIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QuerySimilarPropertiesArgs = {
  propertyId: Scalars['ID'];
};


export type QueryValidateApiInvitationArgs = {
  token: Scalars['String'];
};

export enum RecurringTypesEnum {
  Day = 'DAY',
  Free = 'FREE',
  Month = 'MONTH',
  Sixmonth = 'SIXMONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type RegisterBrokerInput = {
  accountInput: AccountInput;
  profileInput: ProfileInput;
};

export type RemoveMediaKitItems = {
  mediaIdsToRemove: Array<Scalars['ObjectId']>;
  portfolioId: Scalars['ObjectId'];
};

export type ResendApiInvitationInput = {
  expiresAt?: InputMaybe<Scalars['Date']>;
  invitationId: Scalars['String'];
};

export type RestoreApiAccountResult = {
  __typename?: 'RestoreApiAccountResult';
  isActive: Scalars['Boolean'];
  restoredPluginUsers: Scalars['Int'];
};

export type Role = {
  __typename?: 'Role';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum RoleTypesEnum {
  ApiUser = 'API_USER',
  Broker = 'BROKER',
  OrgDeveloper = 'ORG_DEVELOPER',
  OrgOwner = 'ORG_OWNER',
  OrgSalesAssociate = 'ORG_SALES_ASSOCIATE',
  OrgSalesDirector = 'ORG_SALES_DIRECTOR',
  OrgSalesStuff = 'ORG_SALES_STUFF',
  SuperAdmin = 'SUPER_ADMIN'
}

export type RolesPayload = {
  __typename?: 'RolesPayload';
  collection: Array<Role>;
  totalCount: Scalars['Float'];
};

export type SaleTeam = {
  __typename?: 'SaleTeam';
  _id: Scalars['String'];
  countOfUsers?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  logoFile?: Maybe<File>;
  logoFileId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  phone?: Maybe<SalesTeamPhone>;
  relatedToSaleTeamOrganizationsNames?: Maybe<Array<Scalars['String']>>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  workingHours?: Maybe<WorkingHours>;
};

export type SaleTeamUser = {
  __typename?: 'SaleTeamUser';
  _id: Scalars['String'];
  account: Account;
  accountId: Scalars['String'];
  assignedPropertiesIds?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  profile: Profile;
  profileId: Scalars['String'];
  role: Role;
  saleTeamId: Scalars['String'];
  saleTeamRoleId: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type SaleTeamUserNamePayload = {
  __typename?: 'SaleTeamUserNamePayload';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type SaleTeamUsersPayload = {
  __typename?: 'SaleTeamUsersPayload';
  collection: Array<SaleTeamUser>;
  totalCount: Scalars['Float'];
};

export type SaleTeamsPayload = {
  __typename?: 'SaleTeamsPayload';
  collection: Array<SaleTeam>;
  totalCount: Scalars['Float'];
};

export enum SalesGalleryStatusesEnum {
  AppointmentOnly = 'APPOINTMENT_ONLY',
  ComingSoon = 'COMING_SOON',
  HoursAvailable = 'HOURS_AVAILABLE',
  NoInformation = 'NO_INFORMATION'
}

export type SalesTeamPhone = {
  __typename?: 'SalesTeamPhone';
  dialCode: Scalars['String'];
  number: Scalars['String'];
};

export type ScheduleDowngradeInput = {
  newStripePriceId: Scalars['String'];
};

export type SearchIndex = {
  __typename?: 'SearchIndex';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  display: SearchIndexDisplay;
  meta: SearchIndexMeta;
  refId: Scalars['String'];
  refs?: Maybe<SearchIndexRefs>;
  search: SearchIndexSearch;
  subtype: SearchIndexSubtypeEnum;
  type: SearchIndexTypeEnum;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type SearchIndexDisplay = {
  __typename?: 'SearchIndexDisplay';
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SearchIndexMeta = {
  __typename?: 'SearchIndexMeta';
  isActive: Scalars['Boolean'];
  popularityScore?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SearchIndexPayload = {
  __typename?: 'SearchIndexPayload';
  collection: Array<SearchIndex>;
  totalCount: Scalars['Float'];
};

export type SearchIndexRefs = {
  __typename?: 'SearchIndexRefs';
  locationId?: Maybe<Scalars['ObjectId']>;
  marketAreaId?: Maybe<Scalars['ObjectId']>;
  organizationId?: Maybe<Scalars['ObjectId']>;
  propertyId?: Maybe<Scalars['ObjectId']>;
  stateId?: Maybe<Scalars['ObjectId']>;
};

export type SearchIndexSearch = {
  __typename?: 'SearchIndexSearch';
  primaryTokens: Array<Scalars['String']>;
  secondaryTokens: Array<Scalars['String']>;
};

export enum SearchIndexSubtypeEnum {
  City = 'CITY',
  County = 'COUNTY',
  Developer = 'DEVELOPER',
  MarketArea = 'MARKET_AREA',
  Property = 'PROPERTY',
  State = 'STATE'
}

export enum SearchIndexTypeEnum {
  Location = 'LOCATION',
  Organization = 'ORGANIZATION',
  Property = 'PROPERTY'
}

export type SendMessageToAgentInput = {
  broker_email: Scalars['String'];
  broker_name: Scalars['String'];
  customer_email: Scalars['String'];
  customer_message: Scalars['String'];
  customer_name: Scalars['String'];
  customer_phone: Scalars['String'];
  portfolio_folder_name: Scalars['String'];
  property_name: Scalars['String'];
};

export type SetAdvancedPropertyDetailsInput = {
  noChangelog?: InputMaybe<Scalars['Boolean']>;
  propertyDetails: AdvancedPropertyDetailsInput;
};

export type SetAmenitiesToPropertyInput = {
  amenityIds: Array<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
};

export type SetGeneralPropertyDetailsInput = {
  noChangelog?: InputMaybe<Scalars['Boolean']>;
  propertyDetails: GeneralPropertyDetailsInput;
};

export type SetGuestUserDataArgs = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  guestUserId?: InputMaybe<Scalars['ObjectId']>;
};

export type SetPropertyStatusInput = {
  propertyId: Scalars['ObjectId'];
  status?: InputMaybe<PropertyStatusesEnum>;
};

export type SignupAttributionInput = {
  first?: InputMaybe<AttributionInput>;
  signup?: InputMaybe<AttributionInput>;
};

export type SimilarityBreakdown = {
  __typename?: 'SimilarityBreakdown';
  amenities?: Maybe<Scalars['Float']>;
  bedrooms?: Maybe<Scalars['Float']>;
  buildingTypes?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['Float']>;
  marketArea?: Maybe<Scalars['Float']>;
  priceRange?: Maybe<Scalars['Float']>;
  projectStatus?: Maybe<Scalars['Float']>;
};

export type SimilarityEntry = {
  __typename?: 'SimilarityEntry';
  breakdown?: Maybe<SimilarityBreakdown>;
  propertyId: Scalars['String'];
  score: Scalars['Float'];
};

export type SortInput = {
  fieldName: Scalars['String'];
  sortOrder: Scalars['Float'];
};

export type SortedMediaIdsInput = {
  mediaIdToMove: Scalars['ObjectId'];
  mediaIdToReplace: Scalars['ObjectId'];
};

export type State = {
  __typename?: 'State';
  _id: Scalars['String'];
  code: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  withMarketArea: Scalars['Boolean'];
};

export type StripeAccount = {
  __typename?: 'StripeAccount';
  paymentMethods?: Maybe<Array<StripeAccountPaymentMethod>>;
};

export type StripeAccountPaymentMethod = {
  __typename?: 'StripeAccountPaymentMethod';
  cardBrand: Scalars['String'];
  cardNumber: Scalars['String'];
  expiredMonth: Scalars['Float'];
  expiredYear: Scalars['Float'];
  paymentMethodId: Scalars['String'];
};

export type StripeAccountTransaction = {
  __typename?: 'StripeAccountTransaction';
  amount: Scalars['Float'];
  dateOfCharge: Scalars['Date'];
  invoiceId: Scalars['String'];
  invoiceName: Scalars['String'];
  invoicePdfUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type StripeAccountTransactionsFlatPayload = {
  __typename?: 'StripeAccountTransactionsFlatPayload';
  collection: Array<StripeAccountTransaction>;
  hasMore: Scalars['Boolean'];
};

export type Subscription = {
  __typename?: 'Subscription';
  observeBrokerAlertItemChanges: ObserveBrokerAlertItemsPayload;
  observeCurrentAccountChanges: ObserveAccountPayload;
  observeCurrentAccountProductSubscription: ProductsSubscriptionsObserveSubscriptionPayload;
  observeMediaChanges: MediaObserveSubscriptionPayload;
  observePortfoliosChanges: ObserveBrokerPortfolioPayload;
  observeProgressTrackingByType: ObserveProgressTrackingPayload;
  observePropertiesChanges: ObservePropertyPayload;
  observePropertyNotesChanges: ObservePropertyNotesPayload;
  observeSubscriptionProductsChanges: SubscriptionProductsObserveSubscriptionPayload;
};


export type SubscriptionObserveMediaChangesArgs = {
  filter: GetMediaFoldersAndFilesFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type SubscriptionObserveProgressTrackingByTypeArgs = {
  type: Scalars['String'];
};


export type SubscriptionObservePropertyNotesChangesArgs = {
  propertyId: Scalars['ObjectId'];
};

export type SubscriptionEmailSettings = {
  __typename?: 'SubscriptionEmailSettings';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  pausedReason?: Maybe<Scalars['String']>;
  pausedUntil?: Maybe<Scalars['Date']>;
  planChangeEmailsPaused: Scalars['Boolean'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type SubscriptionProduct = {
  __typename?: 'SubscriptionProduct';
  _id: Scalars['String'];
  coupons?: Maybe<Array<SubscriptionProductCoupon>>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  features: Array<SubscriptionProductFeature>;
  legacy?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  price: Scalars['Float'];
  recurringType: Scalars['String'];
  stripePriceId: Scalars['String'];
  stripeProductId: Scalars['String'];
  trial?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type SubscriptionProductCoupon = {
  __typename?: 'SubscriptionProductCoupon';
  active?: Maybe<Scalars['Boolean']>;
  amountOff?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration: Scalars['String'];
  duration_in_months?: Maybe<Scalars['Float']>;
  limitation?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['Float']>;
  stripeCouponId: Scalars['String'];
};

export type SubscriptionProductFeature = {
  __typename?: 'SubscriptionProductFeature';
  active: Scalars['Boolean'];
  feature: Scalars['String'];
};

export type SubscriptionProductsObserveSubscriptionPayload = {
  __typename?: 'SubscriptionProductsObserveSubscriptionPayload';
  document: SubscriptionProduct;
  trigger: Scalars['String'];
};

export type SubscriptionSchedule = {
  __typename?: 'SubscriptionSchedule';
  metadata?: Maybe<Scalars['JSON']>;
  nextPhasePriceId?: Maybe<Scalars['String']>;
  nextPhaseStart?: Maybe<Scalars['Date']>;
  scheduleId: Scalars['String'];
};

export type SwitchAccountInput = {
  licenseNumber?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  toSeeker?: InputMaybe<Scalars['Boolean']>;
};

export type SystemActionLogsMetadata = {
  __typename?: 'SystemActionLogsMetadata';
  mediaId?: Maybe<Scalars['ObjectId']>;
  portfolioId?: Maybe<Scalars['ObjectId']>;
  propertyId?: Maybe<Scalars['ObjectId']>;
};

export enum SystemActionLogsTypeEnum {
  MediaAddedToMediaKit = 'MEDIA_ADDED_TO_MEDIA_KIT',
  MediaDownloaded = 'MEDIA_DOWNLOADED',
  PropertyAddedToPortfolio = 'PROPERTY_ADDED_TO_PORTFOLIO',
  PropertyAddedToTrackFolder = 'PROPERTY_ADDED_TO_TRACK_FOLDER',
  PropertyShared = 'PROPERTY_SHARED'
}

export type TempAuthResult = {
  __typename?: 'TempAuthResult';
  account: Account;
  tempToken: Scalars['String'];
};

export type ToggleChangelogVisibilityInput = {
  changelogId: Scalars['ObjectId'];
};

export type TokenResponse = {
  __typename?: 'TokenResponse';
  token: Scalars['String'];
};

export type TokensModel = {
  __typename?: 'TokensModel';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  refreshTokenExpiry?: Maybe<Scalars['String']>;
};

export type TotalApiUsageFilterInput = {
  appId?: InputMaybe<Scalars['String']>;
  getCompanyClients?: InputMaybe<Scalars['Boolean']>;
  getCompanyTotal?: InputMaybe<Scalars['Boolean']>;
  range?: InputMaybe<DateRangeInput>;
  type?: InputMaybe<Scalars['String']>;
};

export type TrackedPropertyId = {
  __typename?: 'TrackedPropertyId';
  _id: Scalars['String'];
  propertyId: Scalars['String'];
};

export type TrendingList = {
  __typename?: 'TrendingList';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  items: Array<TrendingListItem>;
  periodEnd: Scalars['Date'];
  periodStart: Scalars['Date'];
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type TrendingListItem = {
  __typename?: 'TrendingListItem';
  portfolio?: Maybe<Portfolio>;
  portfolioId?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
};

export type Unit = {
  __typename?: 'Unit';
  _id: Scalars['String'];
  averageBathroomsNumber: MinMaxRange;
  averageBedroomsNumber: MinMaxRange;
  averageExteriorSqft: MinMaxRange;
  averageInteriorSqft: MinMaxRange;
  averageTotalSqft: MinMaxRange;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  customRooms?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  floorPlanFile?: Maybe<File>;
  floorPlanFileId?: Maybe<Scalars['String']>;
  highestPrice?: Maybe<Scalars['Float']>;
  inventoryType: Scalars['String'];
  name: Scalars['String'];
  propertyId: Scalars['String'];
  startingPrice?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type UnitInput = {
  averageBathroomsNumber: MinMaxRangeInput;
  averageBedroomsNumber: MinMaxRangeInput;
  averageExteriorSqft: MinMaxRangeInput;
  averageInteriorSqft: MinMaxRangeInput;
  averageTotalSqft: MinMaxRangeInput;
  customRooms?: InputMaybe<Scalars['String']>;
  floorPlanFileId?: InputMaybe<Scalars['ObjectId']>;
  highestPrice?: InputMaybe<Scalars['Float']>;
  inventoryType: Scalars['String'];
  name: Scalars['String'];
  startingPrice?: InputMaybe<Scalars['Float']>;
};

export type UnitPropertyMarket = {
  __typename?: 'UnitPropertyMarket';
  _id: Scalars['String'];
  name: Scalars['String'];
};

export type UnitsPayload = {
  __typename?: 'UnitsPayload';
  collection: Array<Unit>;
  totalCount: Scalars['Float'];
};

export type UpdateAccountInput = {
  _id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
};

export type UpdateBrandedFilesReadyInput = {
  brandedFilesReady: Scalars['Boolean'];
  propertyId: Scalars['ObjectId'];
};

export type UpdateBrokerAccountInput = {
  phone?: InputMaybe<PhoneInput>;
};

export type UpdateBrokerInCmsInput = {
  accountInput?: InputMaybe<UpdateBrokerAccountInput>;
  agencyName?: InputMaybe<Scalars['String']>;
  agencyWebsite?: InputMaybe<Scalars['String']>;
  demoExpirationDate?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
  isRealUser?: InputMaybe<Scalars['Boolean']>;
  license?: InputMaybe<UpdateBrokerLicenseInput>;
  preferredPropertySettingsInput?: InputMaybe<PreferredPropertySettingsInput>;
  profileInput?: InputMaybe<UpdateBrokerProfileInput>;
  subscriptionType: BrokerSubscriptionTypesEnum;
  workingHours?: InputMaybe<WorkingHoursInput>;
};

export type UpdateBrokerInput = {
  accountInput?: InputMaybe<UpdateBrokerAccountInput>;
  agencyName?: InputMaybe<Scalars['String']>;
  agencyWebsite?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
  isRealUser?: InputMaybe<Scalars['Boolean']>;
  license?: InputMaybe<UpdateBrokerLicenseInput>;
  preferredPropertySettingsInput?: InputMaybe<PreferredPropertySettingsInput>;
  profileInput?: InputMaybe<UpdateBrokerProfileInput>;
  workingHours?: InputMaybe<WorkingHoursInput>;
};

export type UpdateBrokerLicenseInput = {
  licenseJurisdictionCode?: InputMaybe<Scalars['String']>;
  licenseNumber: Scalars['String'];
};

export type UpdateBrokerLicenseStatusInput = {
  notify: Scalars['Boolean'];
  reason: Scalars['String'];
  status: BrokerLicenseStatusesEnum;
};

export type UpdateBrokerProfileInput = {
  avatarFileId?: InputMaybe<Scalars['ObjectId']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateCmsSettingsInput = {
  activeToAwaitingAuditDays?: InputMaybe<Scalars['Float']>;
  automatedTransitionsEnabled?: InputMaybe<Scalars['Boolean']>;
  newListingToActiveDays?: InputMaybe<Scalars['Float']>;
  recentlyUpdatedToActiveDays?: InputMaybe<Scalars['Float']>;
};

export type UpdateCmsStatusInput = {
  propertyId: Scalars['ObjectId'];
  status: CmsStatusEnum;
};

export type UpdateFeaturedPortfolioInput = {
  cardDescription?: InputMaybe<Scalars['String']>;
  coverImageFileId?: InputMaybe<Scalars['String']>;
  overview?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['String']>;
};

export type UpdateFeaturedPropertyInput = {
  coverImageFileId?: InputMaybe<Scalars['String']>;
  overview?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  shortOverview?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['String']>;
};

export type UpdateIdxFeedInput = {
  cities?: InputMaybe<Array<PlaceInput>>;
  counties?: InputMaybe<Array<PlaceInput>>;
  idxFeedId: Scalars['ObjectId'];
  marketAreaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  name?: InputMaybe<Scalars['String']>;
  portfolioContent?: InputMaybe<IdxFeedPortfolioContentEnum>;
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertiesPerPage?: InputMaybe<Scalars['Float']>;
  propertyId?: InputMaybe<Scalars['ObjectId']>;
  searchBarContent?: InputMaybe<IdxFeedSearchBarContentEnum>;
  showCustomPropertyDownloads?: InputMaybe<Scalars['Boolean']>;
  showPropertyDownloads?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<IdxFeedTypeEnum>;
};

export type UpdateIdxSettingsInput = {
  branding?: InputMaybe<BrandingInput>;
  idxSettingsId: Scalars['ObjectId'];
  isWixSite?: InputMaybe<Scalars['Boolean']>;
  showDashCredit: Scalars['Boolean'];
  websiteDomain: Scalars['String'];
};

export type UpdateMediaKitInput = {
  addMediaKitItems: Array<AddMediaKitItems>;
  removeMediaKitItems: Array<RemoveMediaKitItems>;
};

export type UpdateProductSubscriptionInput = {
  stripeCouponId?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']>;
  subscriptionProductId: Scalars['ObjectId'];
};

export type UpdateSubscriptionEmailSettingsInput = {
  pausedReason?: InputMaybe<Scalars['String']>;
  pausedUntil?: InputMaybe<Scalars['Date']>;
  planChangeEmailsPaused: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  account: Account;
  profile: Profile;
};

export type UsersPayload = {
  __typename?: 'UsersPayload';
  collection: Array<User>;
  totalCount: Scalars['Float'];
};

export type ValidateCouponInput = {
  couponCode?: InputMaybe<Scalars['String']>;
  subscriptionProductId: Scalars['ObjectId'];
  userHasTrialed: Scalars['Boolean'];
};

export type ValidateCouponPayload = {
  __typename?: 'ValidateCouponPayload';
  coupon?: Maybe<SubscriptionProductCoupon>;
  invalidMessageType?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
};

export type ViewHistory = {
  __typename?: 'ViewHistory';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  historyType: Scalars['String'];
  lastViewAt?: Maybe<Scalars['Date']>;
  portfolio?: Maybe<Portfolio>;
  portfolioId?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  viewedByAccountId?: Maybe<Scalars['String']>;
  viewedByVisitorHash?: Maybe<Scalars['String']>;
  visitorType: Scalars['String'];
};

export type ViewHistoryPayload = {
  __typename?: 'ViewHistoryPayload';
  collection: Array<ViewHistory>;
  totalCount: Scalars['Float'];
};

export type VirtualTourLink = {
  __typename?: 'VirtualTourLink';
  label?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type VirtualTourLinkInput = {
  label?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type WorkingHours = {
  __typename?: 'WorkingHours';
  friday?: Maybe<WorkingRange>;
  monday?: Maybe<WorkingRange>;
  saturday?: Maybe<WorkingRange>;
  sunday?: Maybe<WorkingRange>;
  thursday?: Maybe<WorkingRange>;
  tuesday?: Maybe<WorkingRange>;
  wednesday?: Maybe<WorkingRange>;
};

export type WorkingHoursInput = {
  friday?: InputMaybe<WorkingRangeInput>;
  monday?: InputMaybe<WorkingRangeInput>;
  saturday?: InputMaybe<WorkingRangeInput>;
  sunday?: InputMaybe<WorkingRangeInput>;
  thursday?: InputMaybe<WorkingRangeInput>;
  tuesday?: InputMaybe<WorkingRangeInput>;
  wednesday?: InputMaybe<WorkingRangeInput>;
};

export type WorkingRange = {
  __typename?: 'WorkingRange';
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type WorkingRangeInput = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type XmlDownloadResponse = {
  __typename?: 'XmlDownloadResponse';
  content: Scalars['String'];
  filename: Scalars['String'];
};

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  AbortUploadEvent: ResolverTypeWrapper<AbortUploadEvent>;
  AcceptApiInvitationInput: AcceptApiInvitationInput;
  Account: ResolverTypeWrapper<Account>;
  AccountActiveOrArchivedStatusesEnum: AccountActiveOrArchivedStatusesEnum;
  AccountInput: AccountInput;
  AddMediaKitItems: AddMediaKitItems;
  AddSaleTeamUserAccountInput: AddSaleTeamUserAccountInput;
  AddSaleTeamUserInput: AddSaleTeamUserInput;
  Address: ResolverTypeWrapper<Address>;
  AdvancedPropertyDetailsInput: AdvancedPropertyDetailsInput;
  AmenitiesPayload: ResolverTypeWrapper<AmenitiesPayload>;
  Amenity: ResolverTypeWrapper<Amenity>;
  AmenityName: ResolverTypeWrapper<AmenityName>;
  ApiBrokerInfo: ResolverTypeWrapper<ApiBrokerInfo>;
  ApiCredentialSafeDTO: ResolverTypeWrapper<ApiCredentialSafeDto>;
  ApiCredentialsInput: ApiCredentialsInput;
  ApiCredentialsPluginUserResponse: ResolverTypeWrapper<ApiCredentialsPluginUserResponse>;
  ApiCredentialsTypesEnum: ApiCredentialsTypesEnum;
  ApiCredentialsUserResponse: ResolverTypeWrapper<ApiCredentialsUserResponse>;
  ApiInvitationSafeDTO: ResolverTypeWrapper<ApiInvitationSafeDto>;
  ApiInvitationStatusEnum: ApiInvitationStatusEnum;
  ApiInvitationValidation: ResolverTypeWrapper<ApiInvitationValidation>;
  ApiInvitationsPayload: ResolverTypeWrapper<ApiInvitationsPayload>;
  ApiMetric: ResolverTypeWrapper<ApiMetric>;
  ApiMetricPayload: ResolverTypeWrapper<ApiMetricPayload>;
  ApiPluginUser: ResolverTypeWrapper<ApiPluginUser>;
  ApiPluginUsersPayload: ResolverTypeWrapper<ApiPluginUsersPayload>;
  ApiQuotaStatusPayload: ResolverTypeWrapper<ApiQuotaStatusPayload>;
  ApiUser: ResolverTypeWrapper<ApiUser>;
  ApiUsersPayload: ResolverTypeWrapper<ApiUsersPayload>;
  ApprovePropertyInput: ApprovePropertyInput;
  ArchivePropertyInput: ArchivePropertyInput;
  AttributionInput: AttributionInput;
  AuditPropertyInput: AuditPropertyInput;
  AuthResult: ResolversTypes['MfaTempTokenModel'] | ResolversTypes['TokensModel'];
  BasicInfoResponse: ResolverTypeWrapper<BasicInfoResponse>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Branding: ResolverTypeWrapper<Branding>;
  BrandingInput: BrandingInput;
  BrandingTypeEnum: BrandingTypeEnum;
  BrandingTypeFilterEnum: BrandingTypeFilterEnum;
  Broker: ResolverTypeWrapper<Broker>;
  BrokerActivitiesTypesEnum: BrokerActivitiesTypesEnum;
  BrokerActivity: ResolverTypeWrapper<BrokerActivity>;
  BrokerAlertConfig: ResolverTypeWrapper<BrokerAlertConfig>;
  BrokerAlertConfigConstructionDateRangeFilter: ResolverTypeWrapper<BrokerAlertConfigConstructionDateRangeFilter>;
  BrokerAlertConfigFilter: ResolverTypeWrapper<BrokerAlertConfigFilter>;
  BrokerAlertConfigLocationFilter: ResolverTypeWrapper<BrokerAlertConfigLocationFilter>;
  BrokerAlertConfigPayload: ResolverTypeWrapper<BrokerAlertConfigPayload>;
  BrokerAlertItem: ResolverTypeWrapper<BrokerAlertItem>;
  BrokerAlertItemPayload: ResolverTypeWrapper<BrokerAlertItemPayload>;
  BrokerLicense: ResolverTypeWrapper<BrokerLicense>;
  BrokerLicenseStatusesEnum: BrokerLicenseStatusesEnum;
  BrokerPortfolioComparisonFields: BrokerPortfolioComparisonFields;
  BrokerPortfolioStatusesEnum: BrokerPortfolioStatusesEnum;
  BrokerReactionsStats: ResolverTypeWrapper<BrokerReactionsStats>;
  BrokerSavedFeaturedPortfolio: ResolverTypeWrapper<BrokerSavedFeaturedPortfolio>;
  BrokerSavedFeaturedPortfoliosPayload: ResolverTypeWrapper<BrokerSavedFeaturedPortfoliosPayload>;
  BrokerSubscriptionTypesEnum: BrokerSubscriptionTypesEnum;
  BrokerTrackedPropertiesPayload: ResolverTypeWrapper<BrokerTrackedPropertiesPayload>;
  BrokerTrackedProperty: ResolverTypeWrapper<BrokerTrackedProperty>;
  BrokerViewedPortfoliosFilter: BrokerViewedPortfoliosFilter;
  BrokersPayload: ResolverTypeWrapper<BrokersPayload>;
  BuildingTypesEnum: BuildingTypesEnum;
  CanUserTrialForProductInput: CanUserTrialForProductInput;
  CancelProductSubscriptionInput: CancelProductSubscriptionInput;
  ChangelogDocument: ResolversTypes['PropertyAboutChangelog'] | ResolversTypes['PropertyAdditionalInformationChangelog'] | ResolversTypes['PropertyCmsStatusChangelog'] | ResolversTypes['PropertyDataReviewedChangelog'] | ResolversTypes['PropertyDeveloperOrganizationChangelog'] | ResolversTypes['PropertyFeaturesAndAmenitiesChangelog'] | ResolversTypes['PropertyHighlightsChangelog'] | ResolversTypes['PropertyInventoryUnitAddedChangelog'] | ResolversTypes['PropertyInventoryUnitRemovedChangelog'] | ResolversTypes['PropertyInventoryUnitUpdatedChangelog'] | ResolversTypes['PropertyLocationChangelog'] | ResolversTypes['PropertyMediaFilesMovedChangelog'] | ResolversTypes['PropertyMediaRemovedChangelog'] | ResolversTypes['PropertyMediaRenamedChangelog'] | ResolversTypes['PropertyMediaUploadedChangelog'] | ResolversTypes['PropertyNameChangelog'] | ResolversTypes['PropertyOrganizationSalesTeamsChangelog'] | ResolversTypes['PropertyPriceChangelog'] | ResolversTypes['PropertyVirtualToursChangelog'] | ResolversTypes['PropertyVisibilityChangelog'] | ResolversTypes['PropertyWebsiteChangelog'];
  CheckoutSessionDetails: ResolverTypeWrapper<CheckoutSessionDetails>;
  CmsSettings: ResolverTypeWrapper<CmsSettings>;
  CmsStatusEnum: CmsStatusEnum;
  Comparison: ResolverTypeWrapper<Comparison>;
  ContactPhone: ResolverTypeWrapper<ContactPhone>;
  ContentActivity: ResolverTypeWrapper<ContentActivity>;
  ContentActivityChangeType: ResolverTypeWrapper<ContentActivityChangeType>;
  ContentActivityContributor: ResolverTypeWrapper<ContentActivityContributor>;
  ContentActivityLog: ResolverTypeWrapper<ContentActivityLog>;
  ContentActivityLogEntry: ResolverTypeWrapper<ContentActivityLogEntry>;
  ContentActivityValueChange: ResolverTypeWrapper<ContentActivityValueChange>;
  CopyFeaturedPortfolioToBrokerPortfolioArgs: CopyFeaturedPortfolioToBrokerPortfolioArgs;
  CopyFeaturedPortfolioToBrokerPortfolioResult: ResolverTypeWrapper<CopyFeaturedPortfolioToBrokerPortfolioResult>;
  CreateAlertConfigFilterInput: CreateAlertConfigFilterInput;
  CreateAmenityInput: CreateAmenityInput;
  CreateApiInvitationInput: CreateApiInvitationInput;
  CreateBrokerInput: CreateBrokerInput;
  CreateBrokerSSOInput: CreateBrokerSsoInput;
  CreateCheckoutSessionInput: CreateCheckoutSessionInput;
  CreateCheckoutSessionPayload: ResolverTypeWrapper<CreateCheckoutSessionPayload>;
  CreateFeaturedPortfolioInput: CreateFeaturedPortfolioInput;
  CreateFeaturedPropertyInput: CreateFeaturedPropertyInput;
  CreateIdxFeedInput: CreateIdxFeedInput;
  CreateMarketAreaInput: CreateMarketAreaInput;
  CreateMediaFileInput: CreateMediaFileInput;
  CreateMediaFolderInput: CreateMediaFolderInput;
  CreateOrganizationInput: CreateOrganizationInput;
  CreateOrganizationUserAccountInput: CreateOrganizationUserAccountInput;
  CreateOrganizationUserInput: CreateOrganizationUserInput;
  CreateProductSubscriptionInput: CreateProductSubscriptionInput;
  CreatePropertyInput: CreatePropertyInput;
  CreateSaleTeamInput: CreateSaleTeamInput;
  CreateSimpleBrokerInput: CreateSimpleBrokerInput;
  CreateSinglePropertyPortfolioInput: CreateSinglePropertyPortfolioInput;
  CreateUnitInput: CreateUnitInput;
  Date: ResolverTypeWrapper<Scalars['Date']>;
  DateRangeInput: DateRangeInput;
  DeleteApiAccountResult: ResolverTypeWrapper<DeleteApiAccountResult>;
  Developer: ResolverTypeWrapper<Developer>;
  DeveloperAsSaleUser: ResolversTypes['OrganizationUser'] | ResolversTypes['SaleTeamUser'];
  EditAmenityInput: EditAmenityInput;
  EditMarketAreaInput: EditMarketAreaInput;
  EditMediaFileInput: EditMediaFileInput;
  EditMediaFolderInput: EditMediaFolderInput;
  EditOrganizationInput: EditOrganizationInput;
  EditOrganizationUserAccountInput: EditOrganizationUserAccountInput;
  EditOrganizationUserInput: EditOrganizationUserInput;
  EditOrganizationUserProfileInput: EditOrganizationUserProfileInput;
  EditSaleTeamInput: EditSaleTeamInput;
  EditSaleTeamUserAccountInput: EditSaleTeamUserAccountInput;
  EditSaleTeamUserInput: EditSaleTeamUserInput;
  EditSaleTeamUserProfileInput: EditSaleTeamUserProfileInput;
  EditUnitInput: EditUnitInput;
  FeaturedPortfolio: ResolverTypeWrapper<FeaturedPortfolio>;
  FeaturedPortfolioOrder: FeaturedPortfolioOrder;
  FeaturedPortfolioPropertiesPayload: ResolverTypeWrapper<FeaturedPortfolioPropertiesPayload>;
  FeaturedPortfolioSummary: ResolverTypeWrapper<FeaturedPortfolioSummary>;
  FeaturedPortfolioVisibilityEnum: FeaturedPortfolioVisibilityEnum;
  FeaturedPortfoliosPayload: ResolverTypeWrapper<FeaturedPortfoliosPayload>;
  FeaturedPropertiesPayload: ResolverTypeWrapper<FeaturedPropertiesPayload>;
  FeaturedProperty: ResolverTypeWrapper<FeaturedProperty>;
  FeaturedPropertyOrder: FeaturedPropertyOrder;
  FeaturedPropertyVisibilityEnum: FeaturedPropertyVisibilityEnum;
  File: ResolverTypeWrapper<File>;
  FileUploadInput: FileUploadInput;
  FlatPaginationInput: FlatPaginationInput;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  FolderPathModel: ResolverTypeWrapper<FolderPathModel>;
  GeneralPropertyDetailsInput: GeneralPropertyDetailsInput;
  GenerateQrCodeResult: ResolverTypeWrapper<GenerateQrCodeResult>;
  GeoLocationBoundsJSON: GeoLocationBoundsJson;
  GeoLocationJSON: ResolverTypeWrapper<GeoLocationJson>;
  GetAlertItemsFilterInput: GetAlertItemsFilterInput;
  GetAllFilesInPropertyFilterInput: GetAllFilesInPropertyFilterInput;
  GetAllPropertyChangelogsFilterInput: GetAllPropertyChangelogsFilterInput;
  GetAmenitiesFilterInput: GetAmenitiesFilterInput;
  GetAmenitiesForManageFilterInput: GetAmenitiesForManageFilterInput;
  GetApiUsersFilterInput: GetApiUsersFilterInput;
  GetBrokerPropertiesFilterInput: GetBrokerPropertiesFilterInput;
  GetBrokerPropertiesLocationFilterInput: GetBrokerPropertiesLocationFilterInput;
  GetBrokersFilter: GetBrokersFilter;
  GetCMSUsersFilterInput: GetCmsUsersFilterInput;
  GetFeaturedPortfoliosFilter: GetFeaturedPortfoliosFilter;
  GetFeaturedPropertiesFilter: GetFeaturedPropertiesFilter;
  GetFileDownloadStatisticsArgsFilterInput: GetFileDownloadStatisticsArgsFilterInput;
  GetFileDownloadsStatisticItem: ResolverTypeWrapper<GetFileDownloadsStatisticItem>;
  GetFileDownloadsStatisticPayload: ResolverTypeWrapper<GetFileDownloadsStatisticPayload>;
  GetIdxEmbeddedPortfolioFeedInput: GetIdxEmbeddedPortfolioFeedInput;
  GetIdxEmbeddedPropertyFeedInput: GetIdxEmbeddedPropertyFeedInput;
  GetIdxEmbeddedSearchBarFeedInput: GetIdxEmbeddedSearchBarFeedInput;
  GetIdxFeedListFilterInput: GetIdxFeedListFilterInput;
  GetIdxFeedListInput: GetIdxFeedListInput;
  GetIdxFeedListPayload: ResolverTypeWrapper<GetIdxFeedListPayload>;
  GetIdxPortfolioFeedPropertiesInput: GetIdxPortfolioFeedPropertiesInput;
  GetIdxPropertyFilesInput: GetIdxPropertyFilesInput;
  GetIdxSearchFeedPropertiesFiltersInput: GetIdxSearchFeedPropertiesFiltersInput;
  GetIdxSearchFeedPropertiesInput: GetIdxSearchFeedPropertiesInput;
  GetMarketAreasFilterInput: GetMarketAreasFilterInput;
  GetMarketAreasForFilterInput: GetMarketAreasForFilterInput;
  GetMediaFoldersAndFilesFilterInput: GetMediaFoldersAndFilesFilterInput;
  GetOrganizationUsersFilterInput: GetOrganizationUsersFilterInput;
  GetPortfolioMediaKitItemsInput: GetPortfolioMediaKitItemsInput;
  GetPortfolioPropertiesChangelogsFilterInput: GetPortfolioPropertiesChangelogsFilterInput;
  GetPortfoliosFilter: GetPortfoliosFilter;
  GetPortfoliosWithReactionsFilter: GetPortfoliosWithReactionsFilter;
  GetPreviewInvoiceInput: GetPreviewInvoiceInput;
  GetPropertiesFilterInput: GetPropertiesFilterInput;
  GetPropertyChangelogsFilterInput: GetPropertyChangelogsFilterInput;
  GetPropertyViewsByBrokerAFilter: GetPropertyViewsByBrokerAFilter;
  GetSaleTeamUsersFilterInput: GetSaleTeamUsersFilterInput;
  GetSaleTeamsFilterInput: GetSaleTeamsFilterInput;
  GetSavedFeaturedPortfoliosFilterInput: GetSavedFeaturedPortfoliosFilterInput;
  GetStatesFilterInput: GetStatesFilterInput;
  GetSubscriptionProductsFilterInput: GetSubscriptionProductsFilterInput;
  GetSystemActionLogsFilterInput: GetSystemActionLogsFilterInput;
  GetTrackedPropertiesFilterInput: GetTrackedPropertiesFilterInput;
  GetUnitsArgs: GetUnitsArgs;
  GetUnitsFilterInput: GetUnitsFilterInput;
  GetUserByApiCredentialsFilterInput: GetUserByApiCredentialsFilterInput;
  GuestUser: ResolverTypeWrapper<GuestUser>;
  GuestUserPayload: ResolverTypeWrapper<GuestUserPayload>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  IdxActivity: ResolverTypeWrapper<IdxActivity>;
  IdxActivityCollection: ResolverTypeWrapper<IdxActivityCollection>;
  IdxActivityPayload: ResolverTypeWrapper<IdxActivityPayload>;
  IdxEmbeddedPortfolioFeedData: ResolverTypeWrapper<IdxEmbeddedPortfolioFeedData>;
  IdxEmbeddedPropertyFeedData: ResolverTypeWrapper<IdxEmbeddedPropertyFeedData>;
  IdxEmbeddedSearchBarFeedData: ResolverTypeWrapper<IdxEmbeddedSearchBarFeedData>;
  IdxFeed: ResolverTypeWrapper<IdxFeed>;
  IdxFeedPortfolioContentEnum: IdxFeedPortfolioContentEnum;
  IdxFeedSearchBarContentEnum: IdxFeedSearchBarContentEnum;
  IdxFeedTypeEnum: IdxFeedTypeEnum;
  IdxPortfolioFeedPropertiesData: ResolverTypeWrapper<IdxPortfolioFeedPropertiesData>;
  IdxSearchFeedPropertiesData: ResolverTypeWrapper<IdxSearchFeedPropertiesData>;
  IdxSettings: ResolverTypeWrapper<IdxSettings>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  InvoiceCoupon: ResolverTypeWrapper<InvoiceCoupon>;
  JSON: ResolverTypeWrapper<Scalars['JSON']>;
  LocalTimeHours: ResolverTypeWrapper<LocalTimeHours>;
  LocalTimeHoursInput: LocalTimeHoursInput;
  LocalTimeRange: ResolverTypeWrapper<LocalTimeRange>;
  LocalTimeRangeInput: LocalTimeRangeInput;
  Location: ResolverTypeWrapper<Location>;
  LocationSaveInput: LocationSaveInput;
  MarketArea: ResolverTypeWrapper<MarketArea>;
  MarketAreaCount: ResolverTypeWrapper<MarketAreaCount>;
  MarketAreaPlaceOption: ResolverTypeWrapper<MarketAreaPlaceOption>;
  MarketAreasPayload: ResolverTypeWrapper<MarketAreasPayload>;
  Media: ResolverTypeWrapper<Media>;
  MediaFileTypesFilterEnum: MediaFileTypesFilterEnum;
  MediaFilesAndFoldersPayload: ResolverTypeWrapper<MediaFilesAndFoldersPayload>;
  MediaFilesPayload: ResolverTypeWrapper<MediaFilesPayload>;
  MediaFolderInput: MediaFolderInput;
  MediaKitPayload: ResolverTypeWrapper<MediaKitPayload>;
  MediaObserveSubscriptionPayload: ResolverTypeWrapper<MediaObserveSubscriptionPayload>;
  MetricDataPoint: ResolverTypeWrapper<MetricDataPoint>;
  MfaMethodsEnum: MfaMethodsEnum;
  MfaTempTokenModel: ResolverTypeWrapper<MfaTempTokenModel>;
  MinMax: ResolverTypeWrapper<MinMax>;
  MinMaxRange: ResolverTypeWrapper<MinMaxRange>;
  MinMaxRangeInput: MinMaxRangeInput;
  MinMaxRangePayload: ResolverTypeWrapper<MinMaxRangePayload>;
  Mutation: ResolverTypeWrapper<{}>;
  NewPortfolioItemActivitiesPayload: ResolverTypeWrapper<NewPortfolioItemActivitiesPayload>;
  NewPortfolioItemActivity: ResolverTypeWrapper<NewPortfolioItemActivity>;
  NewPortfolioItemActivityDoc: ResolverTypeWrapper<NewPortfolioItemActivityDoc>;
  ObjectId: ResolverTypeWrapper<Scalars['ObjectId']>;
  ObserveAccountPayload: ResolverTypeWrapper<ObserveAccountPayload>;
  ObserveBrokerAlertItemsPayload: ResolverTypeWrapper<ObserveBrokerAlertItemsPayload>;
  ObserveBrokerPortfolioPayload: ResolverTypeWrapper<ObserveBrokerPortfolioPayload>;
  ObserveProgressTrackingPayload: ResolverTypeWrapper<ObserveProgressTrackingPayload>;
  ObservePropertyNotesPayload: ResolverTypeWrapper<ObservePropertyNotesPayload>;
  ObservePropertyPayload: ResolverTypeWrapper<ObservePropertyPayload>;
  Organization: ResolverTypeWrapper<Organization>;
  OrganizationUser: ResolverTypeWrapper<OrganizationUser>;
  OrganizationUsersPayload: ResolverTypeWrapper<OrganizationUsersPayload>;
  OrganizationsPayload: ResolverTypeWrapper<OrganizationsPayload>;
  PaginationInput: PaginationInput;
  PartialDateRangeInput: PartialDateRangeInput;
  PartialMinMaxRangeInput: PartialMinMaxRangeInput;
  Phone: ResolverTypeWrapper<Phone>;
  PhoneInput: PhoneInput;
  Place: ResolverTypeWrapper<Place>;
  PlaceInput: PlaceInput;
  PlaceOption: ResolverTypeWrapper<PlaceOption>;
  PlaceOptionsPayload: ResolverTypeWrapper<PlaceOptionsPayload>;
  PlaceTargetInput: PlaceTargetInput;
  PluginUserOwnTotalApiUsageFilterInput: PluginUserOwnTotalApiUsageFilterInput;
  Portfolio: ResolverTypeWrapper<Portfolio>;
  PortfolioFolderItemsGroup: ResolverTypeWrapper<PortfolioFolderItemsGroup>;
  PortfolioLocations: ResolverTypeWrapper<PortfolioLocations>;
  PortfolioMediaKit: ResolverTypeWrapper<PortfolioMediaKit>;
  PortfolioReaction: ResolverTypeWrapper<PortfolioReaction>;
  PortfolioReactionsEnum: PortfolioReactionsEnum;
  PortfolioTree: ResolverTypeWrapper<PortfolioTree>;
  PortfoliosPayload: ResolverTypeWrapper<PortfoliosPayload>;
  PortfoliosTreePayload: ResolverTypeWrapper<PortfoliosTreePayload>;
  PreferredPropertySettings: ResolverTypeWrapper<PreferredPropertySettings>;
  PreferredPropertySettingsInput: PreferredPropertySettingsInput;
  PreviewInvoiceItem: ResolverTypeWrapper<PreviewInvoiceItem>;
  PreviewInvoicePayload: ResolverTypeWrapper<PreviewInvoicePayload>;
  ProductSubscription: ResolverTypeWrapper<ProductSubscription>;
  ProductSubscriptionPayload: ResolverTypeWrapper<ProductSubscriptionPayload>;
  ProductSubscriptionPayment: ResolverTypeWrapper<ProductSubscriptionPayment>;
  ProductSubscriptionsPayload: ResolverTypeWrapper<ProductSubscriptionsPayload>;
  ProductsSubscriptionsObserveSubscriptionPayload: ResolverTypeWrapper<ProductsSubscriptionsObserveSubscriptionPayload>;
  Profile: ResolverTypeWrapper<Profile>;
  ProfileInput: ProfileInput;
  ProgressTrackingModel: ResolverTypeWrapper<ProgressTrackingModel>;
  ProjectStatusesEnum: ProjectStatusesEnum;
  PropertiesPayload: ResolverTypeWrapper<PropertiesPayload>;
  Property: ResolverTypeWrapper<Property>;
  PropertyAboutChangelog: ResolverTypeWrapper<PropertyAboutChangelog>;
  PropertyAdditionalInformationChangelog: ResolverTypeWrapper<PropertyAdditionalInformationChangelog>;
  PropertyChangelog: ResolverTypeWrapper<Omit<PropertyChangelog, 'afterUpdate' | 'beforeUpdate'> & { afterUpdate: ResolversTypes['ChangelogDocument'], beforeUpdate?: Maybe<ResolversTypes['ChangelogDocument']> }>;
  PropertyChangelogTypesEnum: PropertyChangelogTypesEnum;
  PropertyChangelogsPayload: ResolverTypeWrapper<PropertyChangelogsPayload>;
  PropertyClick: ResolverTypeWrapper<PropertyClick>;
  PropertyCmsStatusChangelog: ResolverTypeWrapper<PropertyCmsStatusChangelog>;
  PropertyDataReviewedChangelog: ResolverTypeWrapper<PropertyDataReviewedChangelog>;
  PropertyDetail: ResolverTypeWrapper<PropertyDetail>;
  PropertyDeveloperOrganizationChangelog: ResolverTypeWrapper<PropertyDeveloperOrganizationChangelog>;
  PropertyFeaturesAndAmenitiesChangelog: ResolverTypeWrapper<PropertyFeaturesAndAmenitiesChangelog>;
  PropertyHighlightsChangelog: ResolverTypeWrapper<PropertyHighlightsChangelog>;
  PropertyInventoryUnitAddedChangelog: ResolverTypeWrapper<PropertyInventoryUnitAddedChangelog>;
  PropertyInventoryUnitRemovedChangelog: ResolverTypeWrapper<PropertyInventoryUnitRemovedChangelog>;
  PropertyInventoryUnitUpdatedChangelog: ResolverTypeWrapper<PropertyInventoryUnitUpdatedChangelog>;
  PropertyLocationChangelog: ResolverTypeWrapper<PropertyLocationChangelog>;
  PropertyMediaFilesMovedChangelog: ResolverTypeWrapper<PropertyMediaFilesMovedChangelog>;
  PropertyMediaRemovedChangelog: ResolverTypeWrapper<PropertyMediaRemovedChangelog>;
  PropertyMediaRenamedChangelog: ResolverTypeWrapper<PropertyMediaRenamedChangelog>;
  PropertyMediaUploadedChangelog: ResolverTypeWrapper<PropertyMediaUploadedChangelog>;
  PropertyNameChangelog: ResolverTypeWrapper<PropertyNameChangelog>;
  PropertyNote: ResolverTypeWrapper<PropertyNote>;
  PropertyNotesPayload: ResolverTypeWrapper<PropertyNotesPayload>;
  PropertyOrganizationSalesTeamsChangelog: ResolverTypeWrapper<PropertyOrganizationSalesTeamsChangelog>;
  PropertyPriceChangelog: ResolverTypeWrapper<PropertyPriceChangelog>;
  PropertySaleTeam: ResolverTypeWrapper<Omit<PropertySaleTeam, 'saleAssociates' | 'saleDirector'> & { saleAssociates?: Maybe<Array<ResolversTypes['DeveloperAsSaleUser']>>, saleDirector?: Maybe<ResolversTypes['DeveloperAsSaleUser']> }>;
  PropertySaleTeamInput: PropertySaleTeamInput;
  PropertyStatusesEnum: PropertyStatusesEnum;
  PropertySummary: ResolverTypeWrapper<PropertySummary>;
  PropertyTagsEnum: PropertyTagsEnum;
  PropertyTransactionTypesEnum: PropertyTransactionTypesEnum;
  PropertyVirtualToursChangelog: ResolverTypeWrapper<PropertyVirtualToursChangelog>;
  PropertyVisibilityChangelog: ResolverTypeWrapper<PropertyVisibilityChangelog>;
  PropertyVisitActivitiesPayload: ResolverTypeWrapper<PropertyVisitActivitiesPayload>;
  PropertyVisitActivity: ResolverTypeWrapper<PropertyVisitActivity>;
  PropertyVisitActivityDoc: ResolverTypeWrapper<PropertyVisitActivityDoc>;
  PropertyWebsiteChangelog: ResolverTypeWrapper<PropertyWebsiteChangelog>;
  Query: ResolverTypeWrapper<{}>;
  RecurringTypesEnum: RecurringTypesEnum;
  RegisterBrokerInput: RegisterBrokerInput;
  RemoveMediaKitItems: RemoveMediaKitItems;
  ResendApiInvitationInput: ResendApiInvitationInput;
  RestoreApiAccountResult: ResolverTypeWrapper<RestoreApiAccountResult>;
  Role: ResolverTypeWrapper<Role>;
  RoleTypesEnum: RoleTypesEnum;
  RolesPayload: ResolverTypeWrapper<RolesPayload>;
  SaleTeam: ResolverTypeWrapper<SaleTeam>;
  SaleTeamUser: ResolverTypeWrapper<SaleTeamUser>;
  SaleTeamUserNamePayload: ResolverTypeWrapper<SaleTeamUserNamePayload>;
  SaleTeamUsersPayload: ResolverTypeWrapper<SaleTeamUsersPayload>;
  SaleTeamsPayload: ResolverTypeWrapper<SaleTeamsPayload>;
  SalesGalleryStatusesEnum: SalesGalleryStatusesEnum;
  SalesTeamPhone: ResolverTypeWrapper<SalesTeamPhone>;
  ScheduleDowngradeInput: ScheduleDowngradeInput;
  SearchIndex: ResolverTypeWrapper<SearchIndex>;
  SearchIndexDisplay: ResolverTypeWrapper<SearchIndexDisplay>;
  SearchIndexMeta: ResolverTypeWrapper<SearchIndexMeta>;
  SearchIndexPayload: ResolverTypeWrapper<SearchIndexPayload>;
  SearchIndexRefs: ResolverTypeWrapper<SearchIndexRefs>;
  SearchIndexSearch: ResolverTypeWrapper<SearchIndexSearch>;
  SearchIndexSubtypeEnum: SearchIndexSubtypeEnum;
  SearchIndexTypeEnum: SearchIndexTypeEnum;
  SendMessageToAgentInput: SendMessageToAgentInput;
  SetAdvancedPropertyDetailsInput: SetAdvancedPropertyDetailsInput;
  SetAmenitiesToPropertyInput: SetAmenitiesToPropertyInput;
  SetGeneralPropertyDetailsInput: SetGeneralPropertyDetailsInput;
  SetGuestUserDataArgs: SetGuestUserDataArgs;
  SetPropertyStatusInput: SetPropertyStatusInput;
  SignupAttributionInput: SignupAttributionInput;
  SimilarityBreakdown: ResolverTypeWrapper<SimilarityBreakdown>;
  SimilarityEntry: ResolverTypeWrapper<SimilarityEntry>;
  SortInput: SortInput;
  SortedMediaIdsInput: SortedMediaIdsInput;
  State: ResolverTypeWrapper<State>;
  String: ResolverTypeWrapper<Scalars['String']>;
  StripeAccount: ResolverTypeWrapper<StripeAccount>;
  StripeAccountPaymentMethod: ResolverTypeWrapper<StripeAccountPaymentMethod>;
  StripeAccountTransaction: ResolverTypeWrapper<StripeAccountTransaction>;
  StripeAccountTransactionsFlatPayload: ResolverTypeWrapper<StripeAccountTransactionsFlatPayload>;
  Subscription: ResolverTypeWrapper<{}>;
  SubscriptionEmailSettings: ResolverTypeWrapper<SubscriptionEmailSettings>;
  SubscriptionProduct: ResolverTypeWrapper<SubscriptionProduct>;
  SubscriptionProductCoupon: ResolverTypeWrapper<SubscriptionProductCoupon>;
  SubscriptionProductFeature: ResolverTypeWrapper<SubscriptionProductFeature>;
  SubscriptionProductsObserveSubscriptionPayload: ResolverTypeWrapper<SubscriptionProductsObserveSubscriptionPayload>;
  SubscriptionSchedule: ResolverTypeWrapper<SubscriptionSchedule>;
  SwitchAccountInput: SwitchAccountInput;
  SystemActionLogsMetadata: ResolverTypeWrapper<SystemActionLogsMetadata>;
  SystemActionLogsTypeEnum: SystemActionLogsTypeEnum;
  TempAuthResult: ResolverTypeWrapper<TempAuthResult>;
  ToggleChangelogVisibilityInput: ToggleChangelogVisibilityInput;
  TokenResponse: ResolverTypeWrapper<TokenResponse>;
  TokensModel: ResolverTypeWrapper<TokensModel>;
  TotalApiUsageFilterInput: TotalApiUsageFilterInput;
  TrackedPropertyId: ResolverTypeWrapper<TrackedPropertyId>;
  TrendingList: ResolverTypeWrapper<TrendingList>;
  TrendingListItem: ResolverTypeWrapper<TrendingListItem>;
  Unit: ResolverTypeWrapper<Unit>;
  UnitInput: UnitInput;
  UnitPropertyMarket: ResolverTypeWrapper<UnitPropertyMarket>;
  UnitsPayload: ResolverTypeWrapper<UnitsPayload>;
  UpdateAccountInput: UpdateAccountInput;
  UpdateBrandedFilesReadyInput: UpdateBrandedFilesReadyInput;
  UpdateBrokerAccountInput: UpdateBrokerAccountInput;
  UpdateBrokerInCMSInput: UpdateBrokerInCmsInput;
  UpdateBrokerInput: UpdateBrokerInput;
  UpdateBrokerLicenseInput: UpdateBrokerLicenseInput;
  UpdateBrokerLicenseStatusInput: UpdateBrokerLicenseStatusInput;
  UpdateBrokerProfileInput: UpdateBrokerProfileInput;
  UpdateCmsSettingsInput: UpdateCmsSettingsInput;
  UpdateCmsStatusInput: UpdateCmsStatusInput;
  UpdateFeaturedPortfolioInput: UpdateFeaturedPortfolioInput;
  UpdateFeaturedPropertyInput: UpdateFeaturedPropertyInput;
  UpdateIdxFeedInput: UpdateIdxFeedInput;
  UpdateIdxSettingsInput: UpdateIdxSettingsInput;
  UpdateMediaKitInput: UpdateMediaKitInput;
  UpdateProductSubscriptionInput: UpdateProductSubscriptionInput;
  UpdateSubscriptionEmailSettingsInput: UpdateSubscriptionEmailSettingsInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']>;
  User: ResolverTypeWrapper<User>;
  UsersPayload: ResolverTypeWrapper<UsersPayload>;
  ValidateCouponInput: ValidateCouponInput;
  ValidateCouponPayload: ResolverTypeWrapper<ValidateCouponPayload>;
  ViewHistory: ResolverTypeWrapper<ViewHistory>;
  ViewHistoryPayload: ResolverTypeWrapper<ViewHistoryPayload>;
  VirtualTourLink: ResolverTypeWrapper<VirtualTourLink>;
  VirtualTourLinkInput: VirtualTourLinkInput;
  WorkingHours: ResolverTypeWrapper<WorkingHours>;
  WorkingHoursInput: WorkingHoursInput;
  WorkingRange: ResolverTypeWrapper<WorkingRange>;
  WorkingRangeInput: WorkingRangeInput;
  XmlDownloadResponse: ResolverTypeWrapper<XmlDownloadResponse>;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  AbortUploadEvent: AbortUploadEvent;
  AcceptApiInvitationInput: AcceptApiInvitationInput;
  Account: Account;
  AccountInput: AccountInput;
  AddMediaKitItems: AddMediaKitItems;
  AddSaleTeamUserAccountInput: AddSaleTeamUserAccountInput;
  AddSaleTeamUserInput: AddSaleTeamUserInput;
  Address: Address;
  AdvancedPropertyDetailsInput: AdvancedPropertyDetailsInput;
  AmenitiesPayload: AmenitiesPayload;
  Amenity: Amenity;
  AmenityName: AmenityName;
  ApiBrokerInfo: ApiBrokerInfo;
  ApiCredentialSafeDTO: ApiCredentialSafeDto;
  ApiCredentialsInput: ApiCredentialsInput;
  ApiCredentialsPluginUserResponse: ApiCredentialsPluginUserResponse;
  ApiCredentialsUserResponse: ApiCredentialsUserResponse;
  ApiInvitationSafeDTO: ApiInvitationSafeDto;
  ApiInvitationValidation: ApiInvitationValidation;
  ApiInvitationsPayload: ApiInvitationsPayload;
  ApiMetric: ApiMetric;
  ApiMetricPayload: ApiMetricPayload;
  ApiPluginUser: ApiPluginUser;
  ApiPluginUsersPayload: ApiPluginUsersPayload;
  ApiQuotaStatusPayload: ApiQuotaStatusPayload;
  ApiUser: ApiUser;
  ApiUsersPayload: ApiUsersPayload;
  ApprovePropertyInput: ApprovePropertyInput;
  ArchivePropertyInput: ArchivePropertyInput;
  AttributionInput: AttributionInput;
  AuditPropertyInput: AuditPropertyInput;
  AuthResult: ResolversParentTypes['MfaTempTokenModel'] | ResolversParentTypes['TokensModel'];
  BasicInfoResponse: BasicInfoResponse;
  Boolean: Scalars['Boolean'];
  Branding: Branding;
  BrandingInput: BrandingInput;
  Broker: Broker;
  BrokerActivity: BrokerActivity;
  BrokerAlertConfig: BrokerAlertConfig;
  BrokerAlertConfigConstructionDateRangeFilter: BrokerAlertConfigConstructionDateRangeFilter;
  BrokerAlertConfigFilter: BrokerAlertConfigFilter;
  BrokerAlertConfigLocationFilter: BrokerAlertConfigLocationFilter;
  BrokerAlertConfigPayload: BrokerAlertConfigPayload;
  BrokerAlertItem: BrokerAlertItem;
  BrokerAlertItemPayload: BrokerAlertItemPayload;
  BrokerLicense: BrokerLicense;
  BrokerReactionsStats: BrokerReactionsStats;
  BrokerSavedFeaturedPortfolio: BrokerSavedFeaturedPortfolio;
  BrokerSavedFeaturedPortfoliosPayload: BrokerSavedFeaturedPortfoliosPayload;
  BrokerTrackedPropertiesPayload: BrokerTrackedPropertiesPayload;
  BrokerTrackedProperty: BrokerTrackedProperty;
  BrokerViewedPortfoliosFilter: BrokerViewedPortfoliosFilter;
  BrokersPayload: BrokersPayload;
  CanUserTrialForProductInput: CanUserTrialForProductInput;
  CancelProductSubscriptionInput: CancelProductSubscriptionInput;
  ChangelogDocument: ResolversParentTypes['PropertyAboutChangelog'] | ResolversParentTypes['PropertyAdditionalInformationChangelog'] | ResolversParentTypes['PropertyCmsStatusChangelog'] | ResolversParentTypes['PropertyDataReviewedChangelog'] | ResolversParentTypes['PropertyDeveloperOrganizationChangelog'] | ResolversParentTypes['PropertyFeaturesAndAmenitiesChangelog'] | ResolversParentTypes['PropertyHighlightsChangelog'] | ResolversParentTypes['PropertyInventoryUnitAddedChangelog'] | ResolversParentTypes['PropertyInventoryUnitRemovedChangelog'] | ResolversParentTypes['PropertyInventoryUnitUpdatedChangelog'] | ResolversParentTypes['PropertyLocationChangelog'] | ResolversParentTypes['PropertyMediaFilesMovedChangelog'] | ResolversParentTypes['PropertyMediaRemovedChangelog'] | ResolversParentTypes['PropertyMediaRenamedChangelog'] | ResolversParentTypes['PropertyMediaUploadedChangelog'] | ResolversParentTypes['PropertyNameChangelog'] | ResolversParentTypes['PropertyOrganizationSalesTeamsChangelog'] | ResolversParentTypes['PropertyPriceChangelog'] | ResolversParentTypes['PropertyVirtualToursChangelog'] | ResolversParentTypes['PropertyVisibilityChangelog'] | ResolversParentTypes['PropertyWebsiteChangelog'];
  CheckoutSessionDetails: CheckoutSessionDetails;
  CmsSettings: CmsSettings;
  Comparison: Comparison;
  ContactPhone: ContactPhone;
  ContentActivity: ContentActivity;
  ContentActivityChangeType: ContentActivityChangeType;
  ContentActivityContributor: ContentActivityContributor;
  ContentActivityLog: ContentActivityLog;
  ContentActivityLogEntry: ContentActivityLogEntry;
  ContentActivityValueChange: ContentActivityValueChange;
  CopyFeaturedPortfolioToBrokerPortfolioArgs: CopyFeaturedPortfolioToBrokerPortfolioArgs;
  CopyFeaturedPortfolioToBrokerPortfolioResult: CopyFeaturedPortfolioToBrokerPortfolioResult;
  CreateAlertConfigFilterInput: CreateAlertConfigFilterInput;
  CreateAmenityInput: CreateAmenityInput;
  CreateApiInvitationInput: CreateApiInvitationInput;
  CreateBrokerInput: CreateBrokerInput;
  CreateBrokerSSOInput: CreateBrokerSsoInput;
  CreateCheckoutSessionInput: CreateCheckoutSessionInput;
  CreateCheckoutSessionPayload: CreateCheckoutSessionPayload;
  CreateFeaturedPortfolioInput: CreateFeaturedPortfolioInput;
  CreateFeaturedPropertyInput: CreateFeaturedPropertyInput;
  CreateIdxFeedInput: CreateIdxFeedInput;
  CreateMarketAreaInput: CreateMarketAreaInput;
  CreateMediaFileInput: CreateMediaFileInput;
  CreateMediaFolderInput: CreateMediaFolderInput;
  CreateOrganizationInput: CreateOrganizationInput;
  CreateOrganizationUserAccountInput: CreateOrganizationUserAccountInput;
  CreateOrganizationUserInput: CreateOrganizationUserInput;
  CreateProductSubscriptionInput: CreateProductSubscriptionInput;
  CreatePropertyInput: CreatePropertyInput;
  CreateSaleTeamInput: CreateSaleTeamInput;
  CreateSimpleBrokerInput: CreateSimpleBrokerInput;
  CreateSinglePropertyPortfolioInput: CreateSinglePropertyPortfolioInput;
  CreateUnitInput: CreateUnitInput;
  Date: Scalars['Date'];
  DateRangeInput: DateRangeInput;
  DeleteApiAccountResult: DeleteApiAccountResult;
  Developer: Developer;
  DeveloperAsSaleUser: ResolversParentTypes['OrganizationUser'] | ResolversParentTypes['SaleTeamUser'];
  EditAmenityInput: EditAmenityInput;
  EditMarketAreaInput: EditMarketAreaInput;
  EditMediaFileInput: EditMediaFileInput;
  EditMediaFolderInput: EditMediaFolderInput;
  EditOrganizationInput: EditOrganizationInput;
  EditOrganizationUserAccountInput: EditOrganizationUserAccountInput;
  EditOrganizationUserInput: EditOrganizationUserInput;
  EditOrganizationUserProfileInput: EditOrganizationUserProfileInput;
  EditSaleTeamInput: EditSaleTeamInput;
  EditSaleTeamUserAccountInput: EditSaleTeamUserAccountInput;
  EditSaleTeamUserInput: EditSaleTeamUserInput;
  EditSaleTeamUserProfileInput: EditSaleTeamUserProfileInput;
  EditUnitInput: EditUnitInput;
  FeaturedPortfolio: FeaturedPortfolio;
  FeaturedPortfolioOrder: FeaturedPortfolioOrder;
  FeaturedPortfolioPropertiesPayload: FeaturedPortfolioPropertiesPayload;
  FeaturedPortfolioSummary: FeaturedPortfolioSummary;
  FeaturedPortfoliosPayload: FeaturedPortfoliosPayload;
  FeaturedPropertiesPayload: FeaturedPropertiesPayload;
  FeaturedProperty: FeaturedProperty;
  FeaturedPropertyOrder: FeaturedPropertyOrder;
  File: File;
  FileUploadInput: FileUploadInput;
  FlatPaginationInput: FlatPaginationInput;
  Float: Scalars['Float'];
  FolderPathModel: FolderPathModel;
  GeneralPropertyDetailsInput: GeneralPropertyDetailsInput;
  GenerateQrCodeResult: GenerateQrCodeResult;
  GeoLocationBoundsJSON: GeoLocationBoundsJson;
  GeoLocationJSON: GeoLocationJson;
  GetAlertItemsFilterInput: GetAlertItemsFilterInput;
  GetAllFilesInPropertyFilterInput: GetAllFilesInPropertyFilterInput;
  GetAllPropertyChangelogsFilterInput: GetAllPropertyChangelogsFilterInput;
  GetAmenitiesFilterInput: GetAmenitiesFilterInput;
  GetAmenitiesForManageFilterInput: GetAmenitiesForManageFilterInput;
  GetApiUsersFilterInput: GetApiUsersFilterInput;
  GetBrokerPropertiesFilterInput: GetBrokerPropertiesFilterInput;
  GetBrokerPropertiesLocationFilterInput: GetBrokerPropertiesLocationFilterInput;
  GetBrokersFilter: GetBrokersFilter;
  GetCMSUsersFilterInput: GetCmsUsersFilterInput;
  GetFeaturedPortfoliosFilter: GetFeaturedPortfoliosFilter;
  GetFeaturedPropertiesFilter: GetFeaturedPropertiesFilter;
  GetFileDownloadStatisticsArgsFilterInput: GetFileDownloadStatisticsArgsFilterInput;
  GetFileDownloadsStatisticItem: GetFileDownloadsStatisticItem;
  GetFileDownloadsStatisticPayload: GetFileDownloadsStatisticPayload;
  GetIdxEmbeddedPortfolioFeedInput: GetIdxEmbeddedPortfolioFeedInput;
  GetIdxEmbeddedPropertyFeedInput: GetIdxEmbeddedPropertyFeedInput;
  GetIdxEmbeddedSearchBarFeedInput: GetIdxEmbeddedSearchBarFeedInput;
  GetIdxFeedListFilterInput: GetIdxFeedListFilterInput;
  GetIdxFeedListInput: GetIdxFeedListInput;
  GetIdxFeedListPayload: GetIdxFeedListPayload;
  GetIdxPortfolioFeedPropertiesInput: GetIdxPortfolioFeedPropertiesInput;
  GetIdxPropertyFilesInput: GetIdxPropertyFilesInput;
  GetIdxSearchFeedPropertiesFiltersInput: GetIdxSearchFeedPropertiesFiltersInput;
  GetIdxSearchFeedPropertiesInput: GetIdxSearchFeedPropertiesInput;
  GetMarketAreasFilterInput: GetMarketAreasFilterInput;
  GetMarketAreasForFilterInput: GetMarketAreasForFilterInput;
  GetMediaFoldersAndFilesFilterInput: GetMediaFoldersAndFilesFilterInput;
  GetOrganizationUsersFilterInput: GetOrganizationUsersFilterInput;
  GetPortfolioMediaKitItemsInput: GetPortfolioMediaKitItemsInput;
  GetPortfolioPropertiesChangelogsFilterInput: GetPortfolioPropertiesChangelogsFilterInput;
  GetPortfoliosFilter: GetPortfoliosFilter;
  GetPortfoliosWithReactionsFilter: GetPortfoliosWithReactionsFilter;
  GetPreviewInvoiceInput: GetPreviewInvoiceInput;
  GetPropertiesFilterInput: GetPropertiesFilterInput;
  GetPropertyChangelogsFilterInput: GetPropertyChangelogsFilterInput;
  GetPropertyViewsByBrokerAFilter: GetPropertyViewsByBrokerAFilter;
  GetSaleTeamUsersFilterInput: GetSaleTeamUsersFilterInput;
  GetSaleTeamsFilterInput: GetSaleTeamsFilterInput;
  GetSavedFeaturedPortfoliosFilterInput: GetSavedFeaturedPortfoliosFilterInput;
  GetStatesFilterInput: GetStatesFilterInput;
  GetSubscriptionProductsFilterInput: GetSubscriptionProductsFilterInput;
  GetSystemActionLogsFilterInput: GetSystemActionLogsFilterInput;
  GetTrackedPropertiesFilterInput: GetTrackedPropertiesFilterInput;
  GetUnitsArgs: GetUnitsArgs;
  GetUnitsFilterInput: GetUnitsFilterInput;
  GetUserByApiCredentialsFilterInput: GetUserByApiCredentialsFilterInput;
  GuestUser: GuestUser;
  GuestUserPayload: GuestUserPayload;
  ID: Scalars['ID'];
  IdxActivity: IdxActivity;
  IdxActivityCollection: IdxActivityCollection;
  IdxActivityPayload: IdxActivityPayload;
  IdxEmbeddedPortfolioFeedData: IdxEmbeddedPortfolioFeedData;
  IdxEmbeddedPropertyFeedData: IdxEmbeddedPropertyFeedData;
  IdxEmbeddedSearchBarFeedData: IdxEmbeddedSearchBarFeedData;
  IdxFeed: IdxFeed;
  IdxPortfolioFeedPropertiesData: IdxPortfolioFeedPropertiesData;
  IdxSearchFeedPropertiesData: IdxSearchFeedPropertiesData;
  IdxSettings: IdxSettings;
  Int: Scalars['Int'];
  InvoiceCoupon: InvoiceCoupon;
  JSON: Scalars['JSON'];
  LocalTimeHours: LocalTimeHours;
  LocalTimeHoursInput: LocalTimeHoursInput;
  LocalTimeRange: LocalTimeRange;
  LocalTimeRangeInput: LocalTimeRangeInput;
  Location: Location;
  LocationSaveInput: LocationSaveInput;
  MarketArea: MarketArea;
  MarketAreaCount: MarketAreaCount;
  MarketAreaPlaceOption: MarketAreaPlaceOption;
  MarketAreasPayload: MarketAreasPayload;
  Media: Media;
  MediaFilesAndFoldersPayload: MediaFilesAndFoldersPayload;
  MediaFilesPayload: MediaFilesPayload;
  MediaFolderInput: MediaFolderInput;
  MediaKitPayload: MediaKitPayload;
  MediaObserveSubscriptionPayload: MediaObserveSubscriptionPayload;
  MetricDataPoint: MetricDataPoint;
  MfaTempTokenModel: MfaTempTokenModel;
  MinMax: MinMax;
  MinMaxRange: MinMaxRange;
  MinMaxRangeInput: MinMaxRangeInput;
  MinMaxRangePayload: MinMaxRangePayload;
  Mutation: {};
  NewPortfolioItemActivitiesPayload: NewPortfolioItemActivitiesPayload;
  NewPortfolioItemActivity: NewPortfolioItemActivity;
  NewPortfolioItemActivityDoc: NewPortfolioItemActivityDoc;
  ObjectId: Scalars['ObjectId'];
  ObserveAccountPayload: ObserveAccountPayload;
  ObserveBrokerAlertItemsPayload: ObserveBrokerAlertItemsPayload;
  ObserveBrokerPortfolioPayload: ObserveBrokerPortfolioPayload;
  ObserveProgressTrackingPayload: ObserveProgressTrackingPayload;
  ObservePropertyNotesPayload: ObservePropertyNotesPayload;
  ObservePropertyPayload: ObservePropertyPayload;
  Organization: Organization;
  OrganizationUser: OrganizationUser;
  OrganizationUsersPayload: OrganizationUsersPayload;
  OrganizationsPayload: OrganizationsPayload;
  PaginationInput: PaginationInput;
  PartialDateRangeInput: PartialDateRangeInput;
  PartialMinMaxRangeInput: PartialMinMaxRangeInput;
  Phone: Phone;
  PhoneInput: PhoneInput;
  Place: Place;
  PlaceInput: PlaceInput;
  PlaceOption: PlaceOption;
  PlaceOptionsPayload: PlaceOptionsPayload;
  PlaceTargetInput: PlaceTargetInput;
  PluginUserOwnTotalApiUsageFilterInput: PluginUserOwnTotalApiUsageFilterInput;
  Portfolio: Portfolio;
  PortfolioFolderItemsGroup: PortfolioFolderItemsGroup;
  PortfolioLocations: PortfolioLocations;
  PortfolioMediaKit: PortfolioMediaKit;
  PortfolioReaction: PortfolioReaction;
  PortfolioTree: PortfolioTree;
  PortfoliosPayload: PortfoliosPayload;
  PortfoliosTreePayload: PortfoliosTreePayload;
  PreferredPropertySettings: PreferredPropertySettings;
  PreferredPropertySettingsInput: PreferredPropertySettingsInput;
  PreviewInvoiceItem: PreviewInvoiceItem;
  PreviewInvoicePayload: PreviewInvoicePayload;
  ProductSubscription: ProductSubscription;
  ProductSubscriptionPayload: ProductSubscriptionPayload;
  ProductSubscriptionPayment: ProductSubscriptionPayment;
  ProductSubscriptionsPayload: ProductSubscriptionsPayload;
  ProductsSubscriptionsObserveSubscriptionPayload: ProductsSubscriptionsObserveSubscriptionPayload;
  Profile: Profile;
  ProfileInput: ProfileInput;
  ProgressTrackingModel: ProgressTrackingModel;
  PropertiesPayload: PropertiesPayload;
  Property: Property;
  PropertyAboutChangelog: PropertyAboutChangelog;
  PropertyAdditionalInformationChangelog: PropertyAdditionalInformationChangelog;
  PropertyChangelog: Omit<PropertyChangelog, 'afterUpdate' | 'beforeUpdate'> & { afterUpdate: ResolversParentTypes['ChangelogDocument'], beforeUpdate?: Maybe<ResolversParentTypes['ChangelogDocument']> };
  PropertyChangelogsPayload: PropertyChangelogsPayload;
  PropertyClick: PropertyClick;
  PropertyCmsStatusChangelog: PropertyCmsStatusChangelog;
  PropertyDataReviewedChangelog: PropertyDataReviewedChangelog;
  PropertyDetail: PropertyDetail;
  PropertyDeveloperOrganizationChangelog: PropertyDeveloperOrganizationChangelog;
  PropertyFeaturesAndAmenitiesChangelog: PropertyFeaturesAndAmenitiesChangelog;
  PropertyHighlightsChangelog: PropertyHighlightsChangelog;
  PropertyInventoryUnitAddedChangelog: PropertyInventoryUnitAddedChangelog;
  PropertyInventoryUnitRemovedChangelog: PropertyInventoryUnitRemovedChangelog;
  PropertyInventoryUnitUpdatedChangelog: PropertyInventoryUnitUpdatedChangelog;
  PropertyLocationChangelog: PropertyLocationChangelog;
  PropertyMediaFilesMovedChangelog: PropertyMediaFilesMovedChangelog;
  PropertyMediaRemovedChangelog: PropertyMediaRemovedChangelog;
  PropertyMediaRenamedChangelog: PropertyMediaRenamedChangelog;
  PropertyMediaUploadedChangelog: PropertyMediaUploadedChangelog;
  PropertyNameChangelog: PropertyNameChangelog;
  PropertyNote: PropertyNote;
  PropertyNotesPayload: PropertyNotesPayload;
  PropertyOrganizationSalesTeamsChangelog: PropertyOrganizationSalesTeamsChangelog;
  PropertyPriceChangelog: PropertyPriceChangelog;
  PropertySaleTeam: Omit<PropertySaleTeam, 'saleAssociates' | 'saleDirector'> & { saleAssociates?: Maybe<Array<ResolversParentTypes['DeveloperAsSaleUser']>>, saleDirector?: Maybe<ResolversParentTypes['DeveloperAsSaleUser']> };
  PropertySaleTeamInput: PropertySaleTeamInput;
  PropertySummary: PropertySummary;
  PropertyVirtualToursChangelog: PropertyVirtualToursChangelog;
  PropertyVisibilityChangelog: PropertyVisibilityChangelog;
  PropertyVisitActivitiesPayload: PropertyVisitActivitiesPayload;
  PropertyVisitActivity: PropertyVisitActivity;
  PropertyVisitActivityDoc: PropertyVisitActivityDoc;
  PropertyWebsiteChangelog: PropertyWebsiteChangelog;
  Query: {};
  RegisterBrokerInput: RegisterBrokerInput;
  RemoveMediaKitItems: RemoveMediaKitItems;
  ResendApiInvitationInput: ResendApiInvitationInput;
  RestoreApiAccountResult: RestoreApiAccountResult;
  Role: Role;
  RolesPayload: RolesPayload;
  SaleTeam: SaleTeam;
  SaleTeamUser: SaleTeamUser;
  SaleTeamUserNamePayload: SaleTeamUserNamePayload;
  SaleTeamUsersPayload: SaleTeamUsersPayload;
  SaleTeamsPayload: SaleTeamsPayload;
  SalesTeamPhone: SalesTeamPhone;
  ScheduleDowngradeInput: ScheduleDowngradeInput;
  SearchIndex: SearchIndex;
  SearchIndexDisplay: SearchIndexDisplay;
  SearchIndexMeta: SearchIndexMeta;
  SearchIndexPayload: SearchIndexPayload;
  SearchIndexRefs: SearchIndexRefs;
  SearchIndexSearch: SearchIndexSearch;
  SendMessageToAgentInput: SendMessageToAgentInput;
  SetAdvancedPropertyDetailsInput: SetAdvancedPropertyDetailsInput;
  SetAmenitiesToPropertyInput: SetAmenitiesToPropertyInput;
  SetGeneralPropertyDetailsInput: SetGeneralPropertyDetailsInput;
  SetGuestUserDataArgs: SetGuestUserDataArgs;
  SetPropertyStatusInput: SetPropertyStatusInput;
  SignupAttributionInput: SignupAttributionInput;
  SimilarityBreakdown: SimilarityBreakdown;
  SimilarityEntry: SimilarityEntry;
  SortInput: SortInput;
  SortedMediaIdsInput: SortedMediaIdsInput;
  State: State;
  String: Scalars['String'];
  StripeAccount: StripeAccount;
  StripeAccountPaymentMethod: StripeAccountPaymentMethod;
  StripeAccountTransaction: StripeAccountTransaction;
  StripeAccountTransactionsFlatPayload: StripeAccountTransactionsFlatPayload;
  Subscription: {};
  SubscriptionEmailSettings: SubscriptionEmailSettings;
  SubscriptionProduct: SubscriptionProduct;
  SubscriptionProductCoupon: SubscriptionProductCoupon;
  SubscriptionProductFeature: SubscriptionProductFeature;
  SubscriptionProductsObserveSubscriptionPayload: SubscriptionProductsObserveSubscriptionPayload;
  SubscriptionSchedule: SubscriptionSchedule;
  SwitchAccountInput: SwitchAccountInput;
  SystemActionLogsMetadata: SystemActionLogsMetadata;
  TempAuthResult: TempAuthResult;
  ToggleChangelogVisibilityInput: ToggleChangelogVisibilityInput;
  TokenResponse: TokenResponse;
  TokensModel: TokensModel;
  TotalApiUsageFilterInput: TotalApiUsageFilterInput;
  TrackedPropertyId: TrackedPropertyId;
  TrendingList: TrendingList;
  TrendingListItem: TrendingListItem;
  Unit: Unit;
  UnitInput: UnitInput;
  UnitPropertyMarket: UnitPropertyMarket;
  UnitsPayload: UnitsPayload;
  UpdateAccountInput: UpdateAccountInput;
  UpdateBrandedFilesReadyInput: UpdateBrandedFilesReadyInput;
  UpdateBrokerAccountInput: UpdateBrokerAccountInput;
  UpdateBrokerInCMSInput: UpdateBrokerInCmsInput;
  UpdateBrokerInput: UpdateBrokerInput;
  UpdateBrokerLicenseInput: UpdateBrokerLicenseInput;
  UpdateBrokerLicenseStatusInput: UpdateBrokerLicenseStatusInput;
  UpdateBrokerProfileInput: UpdateBrokerProfileInput;
  UpdateCmsSettingsInput: UpdateCmsSettingsInput;
  UpdateCmsStatusInput: UpdateCmsStatusInput;
  UpdateFeaturedPortfolioInput: UpdateFeaturedPortfolioInput;
  UpdateFeaturedPropertyInput: UpdateFeaturedPropertyInput;
  UpdateIdxFeedInput: UpdateIdxFeedInput;
  UpdateIdxSettingsInput: UpdateIdxSettingsInput;
  UpdateMediaKitInput: UpdateMediaKitInput;
  UpdateProductSubscriptionInput: UpdateProductSubscriptionInput;
  UpdateSubscriptionEmailSettingsInput: UpdateSubscriptionEmailSettingsInput;
  Upload: Scalars['Upload'];
  User: User;
  UsersPayload: UsersPayload;
  ValidateCouponInput: ValidateCouponInput;
  ValidateCouponPayload: ValidateCouponPayload;
  ViewHistory: ViewHistory;
  ViewHistoryPayload: ViewHistoryPayload;
  VirtualTourLink: VirtualTourLink;
  VirtualTourLinkInput: VirtualTourLinkInput;
  WorkingHours: WorkingHours;
  WorkingHoursInput: WorkingHoursInput;
  WorkingRange: WorkingRange;
  WorkingRangeInput: WorkingRangeInput;
  XmlDownloadResponse: XmlDownloadResponse;
}>;

export type AbortUploadEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['AbortUploadEvent'] = ResolversParentTypes['AbortUploadEvent']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAborted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCompleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  progressStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progressTrackingId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  s3FileKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  archivingReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  excludeFromReports?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hubSpotId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSeeker?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastAccountTypeSwitchAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  mfaEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mfaMethod?: Resolver<Maybe<ResolversTypes['MfaMethodsEnum']>, ParentType, ContextType>;
  mfaSecret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['Phone']>, ParentType, ContextType>;
  productSubscriptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  roleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rollbackSubscriptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showAllBillingPlans?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ssoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripeDefaultPaymentMethodId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zohoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = ResolversObject<{
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmenitiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AmenitiesPayload'] = ResolversParentTypes['AmenitiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Amenity']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmenityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Amenity'] = ResolversParentTypes['Amenity']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  imageFileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isPrimary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  primaryAmenityId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmenityNameResolvers<ContextType = any, ParentType extends ResolversParentTypes['AmenityName'] = ResolversParentTypes['AmenityName']> = ResolversObject<{
  amenityId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiBrokerInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiBrokerInfo'] = ResolversParentTypes['ApiBrokerInfo']> = ResolversObject<{
  _id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiCredentialSafeDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiCredentialSafeDTO'] = ResolversParentTypes['ApiCredentialSafeDTO']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  adminDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  appId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  associatedAccounts?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  associatedCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disabledAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  disabledBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disabledReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  monthlyRequestLimit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  partnerDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ApiCredentialsTypesEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiCredentialsPluginUserResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiCredentialsPluginUserResponse'] = ResolversParentTypes['ApiCredentialsPluginUserResponse']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  adminDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  appId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  associatedCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  partnerDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiCredentialsUserResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiCredentialsUserResponse'] = ResolversParentTypes['ApiCredentialsUserResponse']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  adminDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  appId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  disabledAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  disabledReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiInvitationSafeDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiInvitationSafeDTO'] = ResolversParentTypes['ApiInvitationSafeDTO']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  acceptedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  isMarketplacePartner?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ApiInvitationStatusEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiInvitationValidationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiInvitationValidation'] = ResolversParentTypes['ApiInvitationValidation']> = ResolversObject<{
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasExistingAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ApiInvitationStatusEnum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiInvitationsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiInvitationsPayload'] = ResolversParentTypes['ApiInvitationsPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['ApiInvitationSafeDTO']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiMetricResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiMetric'] = ResolversParentTypes['ApiMetric']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  appId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  credentialsType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dataPoints?: Resolver<Array<ResolversTypes['MetricDataPoint']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  totalRequests?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiMetricPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiMetricPayload'] = ResolversParentTypes['ApiMetricPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['ApiMetric']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiPluginUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiPluginUser'] = ResolversParentTypes['ApiPluginUser']> = ResolversObject<{
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  apiCredentials?: Resolver<Maybe<ResolversTypes['ApiCredentialsPluginUserResponse']>, ParentType, ContextType>;
  broker?: Resolver<Maybe<ResolversTypes['ApiBrokerInfo']>, ParentType, ContextType>;
  clientCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  monthlyApiAccess?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiPluginUsersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiPluginUsersPayload'] = ResolversParentTypes['ApiPluginUsersPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['ApiPluginUser']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiQuotaStatusPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiQuotaStatusPayload'] = ResolversParentTypes['ApiQuotaStatusPayload']> = ResolversObject<{
  limit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  resetDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  usage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiUser'] = ResolversParentTypes['ApiUser']> = ResolversObject<{
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  apiCredentials?: Resolver<Maybe<ResolversTypes['ApiCredentialsUserResponse']>, ParentType, ContextType>;
  clientCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  monthlyApiAccess?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiUsersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiUsersPayload'] = ResolversParentTypes['ApiUsersPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['ApiUser']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuthResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthResult'] = ResolversParentTypes['AuthResult']> = ResolversObject<{
  __resolveType: TypeResolveFn<'MfaTempTokenModel' | 'TokensModel', ParentType, ContextType>;
}>;

export type BasicInfoResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BasicInfoResponse'] = ResolversParentTypes['BasicInfoResponse']> = ResolversObject<{
  appId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasKey?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ApiCredentialsTypesEnum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrandingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Branding'] = ResolversParentTypes['Branding']> = ResolversObject<{
  backgroundColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mainColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  textColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Broker'] = ResolversParentTypes['Broker']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountSubscription?: Resolver<Maybe<ResolversTypes['ProductSubscription']>, ParentType, ContextType>;
  agencyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agencyWebsite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  demoExpirationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasActiveApiCredential?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRealUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSeeker?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  license?: Resolver<Maybe<ResolversTypes['BrokerLicense']>, ParentType, ContextType>;
  preferredPropertySettings?: Resolver<Maybe<ResolversTypes['PreferredPropertySettings']>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workingHours?: Resolver<Maybe<ResolversTypes['WorkingHours']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerActivity'] = ResolversParentTypes['BrokerActivity']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertConfig'] = ResolversParentTypes['BrokerAlertConfig']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filter?: Resolver<ResolversTypes['BrokerAlertConfigFilter'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertConfigConstructionDateRangeFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertConfigConstructionDateRangeFilter'] = ResolversParentTypes['BrokerAlertConfigConstructionDateRangeFilter']> = ResolversObject<{
  endDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertConfigFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertConfigFilter'] = ResolversParentTypes['BrokerAlertConfigFilter']> = ResolversObject<{
  amenities?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  amenityIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  buildingTypes?: Resolver<Maybe<Array<ResolversTypes['BuildingTypesEnum']>>, ParentType, ContextType>;
  constructionDateRange?: Resolver<Maybe<ResolversTypes['BrokerAlertConfigConstructionDateRangeFilter']>, ParentType, ContextType>;
  locationFilter?: Resolver<Maybe<ResolversTypes['BrokerAlertConfigLocationFilter']>, ParentType, ContextType>;
  marketAreaIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  priceRange?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  projectStatuses?: Resolver<Maybe<Array<ResolversTypes['ProjectStatusesEnum']>>, ParentType, ContextType>;
  propertyTags?: Resolver<Maybe<Array<ResolversTypes['PropertyTagsEnum']>>, ParentType, ContextType>;
  transactionType?: Resolver<Maybe<ResolversTypes['PropertyTransactionTypesEnum']>, ParentType, ContextType>;
  unitNumberOfBathrooms?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  unitNumberOfBedrooms?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  unitNumberOfUnits?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  yearBuildRange?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertConfigLocationFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertConfigLocationFilter'] = ResolversParentTypes['BrokerAlertConfigLocationFilter']> = ResolversObject<{
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lng?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  radiusToSearchInMiles?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertConfigPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertConfigPayload'] = ResolversParentTypes['BrokerAlertConfigPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['BrokerAlertConfig']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertItem'] = ResolversParentTypes['BrokerAlertItem']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerAlertConfig?: Resolver<ResolversTypes['BrokerAlertConfig'], ParentType, ContextType>;
  brokerAlertConfigId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isNew?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPropertyPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  property?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertItemPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertItemPayload'] = ResolversParentTypes['BrokerAlertItemPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['BrokerAlertItem']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerLicenseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerLicense'] = ResolversParentTypes['BrokerLicense']> = ResolversObject<{
  licenseExpirationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  licenseJurisdictionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  licenseNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  licenseStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerReactionsStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerReactionsStats'] = ResolversParentTypes['BrokerReactionsStats']> = ResolversObject<{
  negative?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  neutral?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  positive?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerSavedFeaturedPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerSavedFeaturedPortfolio'] = ResolversParentTypes['BrokerSavedFeaturedPortfolio']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolio?: Resolver<Maybe<ResolversTypes['FeaturedPortfolio']>, ParentType, ContextType>;
  portfolioId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerSavedFeaturedPortfoliosPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerSavedFeaturedPortfoliosPayload'] = ResolversParentTypes['BrokerSavedFeaturedPortfoliosPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['BrokerSavedFeaturedPortfolio']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerTrackedPropertiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerTrackedPropertiesPayload'] = ResolversParentTypes['BrokerTrackedPropertiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['BrokerTrackedProperty']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerTrackedPropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerTrackedProperty'] = ResolversParentTypes['BrokerTrackedProperty']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  property?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokersPayload'] = ResolversParentTypes['BrokersPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Broker']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChangelogDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangelogDocument'] = ResolversParentTypes['ChangelogDocument']> = ResolversObject<{
  __resolveType: TypeResolveFn<'PropertyAboutChangelog' | 'PropertyAdditionalInformationChangelog' | 'PropertyCmsStatusChangelog' | 'PropertyDataReviewedChangelog' | 'PropertyDeveloperOrganizationChangelog' | 'PropertyFeaturesAndAmenitiesChangelog' | 'PropertyHighlightsChangelog' | 'PropertyInventoryUnitAddedChangelog' | 'PropertyInventoryUnitRemovedChangelog' | 'PropertyInventoryUnitUpdatedChangelog' | 'PropertyLocationChangelog' | 'PropertyMediaFilesMovedChangelog' | 'PropertyMediaRemovedChangelog' | 'PropertyMediaRenamedChangelog' | 'PropertyMediaUploadedChangelog' | 'PropertyNameChangelog' | 'PropertyOrganizationSalesTeamsChangelog' | 'PropertyPriceChangelog' | 'PropertyVirtualToursChangelog' | 'PropertyVisibilityChangelog' | 'PropertyWebsiteChangelog', ParentType, ContextType>;
}>;

export type CheckoutSessionDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionDetails'] = ResolversParentTypes['CheckoutSessionDetails']> = ResolversObject<{
  customerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  trialEndAt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CmsSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CmsSettings'] = ResolversParentTypes['CmsSettings']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activeToAwaitingAuditDays?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  automatedTransitionsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newListingToActiveDays?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  recentlyUpdatedToActiveDays?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ComparisonResolvers<ContextType = any, ParentType extends ResolversParentTypes['Comparison'] = ResolversParentTypes['Comparison']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldsToCompare?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioFolderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactPhoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactPhone'] = ResolversParentTypes['ContactPhone']> = ResolversObject<{
  dialCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContentActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentActivity'] = ResolversParentTypes['ContentActivity']> = ResolversObject<{
  changes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  changesByType?: Resolver<Array<ResolversTypes['ContentActivityChangeType']>, ParentType, ContextType>;
  contributors?: Resolver<Array<ResolversTypes['ContentActivityContributor']>, ParentType, ContextType>;
  filesUploaded?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertiesCreated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertiesEdited?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContentActivityChangeTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentActivityChangeType'] = ResolversParentTypes['ContentActivityChangeType']> = ResolversObject<{
  changes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  properties?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['PropertyChangelogTypesEnum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContentActivityContributorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentActivityContributor'] = ResolversParentTypes['ContentActivityContributor']> = ResolversObject<{
  accountId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  changes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filesUploaded?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  propertiesCreated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertiesEdited?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContentActivityLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentActivityLog'] = ResolversParentTypes['ContentActivityLog']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['ContentActivityLogEntry']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContentActivityLogEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentActivityLogEntry'] = ResolversParentTypes['ContentActivityLogEntry']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  authorEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cmsStatusChange?: Resolver<Maybe<ResolversTypes['ContentActivityValueChange']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  propertyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['PropertyChangelogTypesEnum']>, ParentType, ContextType>;
  visibilityChange?: Resolver<Maybe<ResolversTypes['ContentActivityValueChange']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContentActivityValueChangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentActivityValueChange'] = ResolversParentTypes['ContentActivityValueChange']> = ResolversObject<{
  from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CopyFeaturedPortfolioToBrokerPortfolioResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CopyFeaturedPortfolioToBrokerPortfolioResult'] = ResolversParentTypes['CopyFeaturedPortfolioToBrokerPortfolioResult']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateCheckoutSessionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateCheckoutSessionPayload'] = ResolversParentTypes['CreateCheckoutSessionPayload']> = ResolversObject<{
  sessionUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export type DeleteApiAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteApiAccountResult'] = ResolversParentTypes['DeleteApiAccountResult']> = ResolversObject<{
  revokedPluginUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeveloperResolvers<ContextType = any, ParentType extends ResolversParentTypes['Developer'] = ResolversParentTypes['Developer']> = ResolversObject<{
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  assignedPropertiesIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  organizationIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  organizations?: Resolver<Maybe<Array<ResolversTypes['Organization']>>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  saleTeamId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeveloperAsSaleUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeveloperAsSaleUser'] = ResolversParentTypes['DeveloperAsSaleUser']> = ResolversObject<{
  __resolveType: TypeResolveFn<'OrganizationUser' | 'SaleTeamUser', ParentType, ContextType>;
}>;

export type FeaturedPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedPortfolio'] = ResolversParentTypes['FeaturedPortfolio']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cardDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coverImageFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  coverImageFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayOrder?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  overview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  propertyIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visibility?: Resolver<ResolversTypes['FeaturedPortfolioVisibilityEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeaturedPortfolioPropertiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedPortfolioPropertiesPayload'] = ResolversParentTypes['FeaturedPortfolioPropertiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['PropertyDetail']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeaturedPortfolioSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedPortfolioSummary'] = ResolversParentTypes['FeaturedPortfolioSummary']> = ResolversObject<{
  completionYearRange?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  marketAreas?: Resolver<Array<ResolversTypes['MarketAreaCount']>, ParentType, ContextType>;
  priceRange?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  propertyCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeaturedPortfoliosPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedPortfoliosPayload'] = ResolversParentTypes['FeaturedPortfoliosPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['FeaturedPortfolio']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeaturedPropertiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedPropertiesPayload'] = ResolversParentTypes['FeaturedPropertiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['FeaturedProperty']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeaturedPropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedProperty'] = ResolversParentTypes['FeaturedProperty']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coverImageFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  coverImageFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayOrder?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  overview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  property?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortOverview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visibility?: Resolver<ResolversTypes['FeaturedPropertyVisibilityEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FileResolvers<ContextType = any, ParentType extends ResolversParentTypes['File'] = ResolversParentTypes['File']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  copyFromFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3Key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  thumbnailFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  thumbnailFileId?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  thumbnailFileUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FolderPathModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['FolderPathModel'] = ResolversParentTypes['FolderPathModel']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  folderName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateQrCodeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateQrCodeResult'] = ResolversParentTypes['GenerateQrCodeResult']> = ResolversObject<{
  qrCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GeoLocationJsonResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeoLocationJSON'] = ResolversParentTypes['GeoLocationJSON']> = ResolversObject<{
  coordinates?: Resolver<Array<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GetFileDownloadsStatisticItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetFileDownloadsStatisticItem'] = ResolversParentTypes['GetFileDownloadsStatisticItem']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  file?: Resolver<ResolversTypes['File'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GetFileDownloadsStatisticPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetFileDownloadsStatisticPayload'] = ResolversParentTypes['GetFileDownloadsStatisticPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['GetFileDownloadsStatisticItem']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GetIdxFeedListPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetIdxFeedListPayload'] = ResolversParentTypes['GetIdxFeedListPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['IdxFeed']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GuestUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuestUser'] = ResolversParentTypes['GuestUser']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fingerprintHash?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GuestUserPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuestUserPayload'] = ResolversParentTypes['GuestUserPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['GuestUser']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxActivity'] = ResolversParentTypes['IdxActivity']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  idxId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxActivityCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxActivityCollection'] = ResolversParentTypes['IdxActivityCollection']> = ResolversObject<{
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  propertyClicks?: Resolver<Maybe<Array<ResolversTypes['PropertyClick']>>, ParentType, ContextType>;
  totalClicks?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxActivityPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxActivityPayload'] = ResolversParentTypes['IdxActivityPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['IdxActivityCollection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxEmbeddedPortfolioFeedDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxEmbeddedPortfolioFeedData'] = ResolversParentTypes['IdxEmbeddedPortfolioFeedData']> = ResolversObject<{
  idxFeed?: Resolver<ResolversTypes['IdxFeed'], ParentType, ContextType>;
  idxSettings?: Resolver<ResolversTypes['IdxSettings'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxEmbeddedPropertyFeedDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxEmbeddedPropertyFeedData'] = ResolversParentTypes['IdxEmbeddedPropertyFeedData']> = ResolversObject<{
  broker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType>;
  idxFeed?: Resolver<ResolversTypes['IdxFeed'], ParentType, ContextType>;
  idxSettings?: Resolver<ResolversTypes['IdxSettings'], ParentType, ContextType>;
  property?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  propertyAmenities?: Resolver<Array<ResolversTypes['Amenity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxEmbeddedSearchBarFeedDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxEmbeddedSearchBarFeedData'] = ResolversParentTypes['IdxEmbeddedSearchBarFeedData']> = ResolversObject<{
  idxFeed?: Resolver<ResolversTypes['IdxFeed'], ParentType, ContextType>;
  idxSettings?: Resolver<ResolversTypes['IdxSettings'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxFeedResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxFeed'] = ResolversParentTypes['IdxFeed']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  cities?: Resolver<Maybe<Array<ResolversTypes['Place']>>, ParentType, ContextType>;
  counties?: Resolver<Maybe<Array<ResolversTypes['Place']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketAreaIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  portfolioContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioFolderId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  propertiesPerPage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  searchBarContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showCustomPropertyDownloads?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  showPropertyDownloads?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxPortfolioFeedPropertiesDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxPortfolioFeedPropertiesData'] = ResolversParentTypes['IdxPortfolioFeedPropertiesData']> = ResolversObject<{
  broker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType>;
  portfolioFolder?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType>;
  portfolioItemCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  portfolioItems?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxSearchFeedPropertiesDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxSearchFeedPropertiesData'] = ResolversParentTypes['IdxSearchFeedPropertiesData']> = ResolversObject<{
  properties?: Resolver<ResolversTypes['PropertiesPayload'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxSettings'] = ResolversParentTypes['IdxSettings']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  branding?: Resolver<ResolversTypes['Branding'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isWixSite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  showDashCredit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websiteDomain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvoiceCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceCoupon'] = ResolversParentTypes['InvoiceCoupon']> = ResolversObject<{
  amountOff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  percentOff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type LocalTimeHoursResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocalTimeHours'] = ResolversParentTypes['LocalTimeHours']> = ResolversObject<{
  friday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  monday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  saturday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  sunday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  thursday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  tuesday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  wednesday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocalTimeRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocalTimeRange'] = ResolversParentTypes['LocalTimeRange']> = ResolversObject<{
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geoLocation?: Resolver<ResolversTypes['GeoLocationJSON'], ParentType, ContextType>;
  googlePlaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarketAreaResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketArea'] = ResolversParentTypes['MarketArea']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['State'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarketAreaCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketAreaCount'] = ResolversParentTypes['MarketAreaCount']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  marketArea?: Resolver<Maybe<ResolversTypes['MarketArea']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarketAreaPlaceOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketAreaPlaceOption'] = ResolversParentTypes['MarketAreaPlaceOption']> = ResolversObject<{
  cityKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  countyKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  marketAreaId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarketAreasPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketAreasPayload'] = ResolversParentTypes['MarketAreasPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['MarketArea']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['Media'] = ResolversParentTypes['Media']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brandingType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Array<ResolversTypes['File']>, ParentType, ContextType>;
  folderName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  foldersPathCollection?: Resolver<Maybe<Array<ResolversTypes['FolderPathModel']>>, ParentType, ContextType>;
  mediaFolderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaItemsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  parentMediaFoldersIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sizeInBytes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  systemFolderType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaFilesAndFoldersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaFilesAndFoldersPayload'] = ResolversParentTypes['MediaFilesAndFoldersPayload']> = ResolversObject<{
  filesCollection?: Resolver<Maybe<Array<ResolversTypes['Media']>>, ParentType, ContextType>;
  filesTotalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  foldersCollection?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType>;
  foldersTotalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaFilesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaFilesPayload'] = ResolversParentTypes['MediaFilesPayload']> = ResolversObject<{
  filesCollection?: Resolver<Maybe<Array<ResolversTypes['Media']>>, ParentType, ContextType>;
  filesTotalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaKitPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaKitPayload'] = ResolversParentTypes['MediaKitPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['PortfolioMediaKit']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaObserveSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaObserveSubscriptionPayload'] = ResolversParentTypes['MediaObserveSubscriptionPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['Media'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MetricDataPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetricDataPoint'] = ResolversParentTypes['MetricDataPoint']> = ResolversObject<{
  requestCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MfaTempTokenModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['MfaTempTokenModel'] = ResolversParentTypes['MfaTempTokenModel']> = ResolversObject<{
  mfaEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mfaMethod?: Resolver<Maybe<ResolversTypes['MfaMethodsEnum']>, ParentType, ContextType>;
  tempToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MinMaxResolvers<ContextType = any, ParentType extends ResolversParentTypes['MinMax'] = ResolversParentTypes['MinMax']> = ResolversObject<{
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MinMaxRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MinMaxRange'] = ResolversParentTypes['MinMaxRange']> = ResolversObject<{
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MinMaxRangePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MinMaxRangePayload'] = ResolversParentTypes['MinMaxRangePayload']> = ResolversObject<{
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  abortAllUploads?: Resolver<ResolversTypes['AbortUploadEvent'], ParentType, ContextType>;
  abortUpload?: Resolver<ResolversTypes['AbortUploadEvent'], ParentType, ContextType, RequireFields<MutationAbortUploadArgs, 'progressTrackingId'>>;
  acceptApiInvitation?: Resolver<ResolversTypes['AuthResult'], ParentType, ContextType, RequireFields<MutationAcceptApiInvitationArgs, 'input' | 'token'>>;
  acceptApiInvitationForAccount?: Resolver<ResolversTypes['AuthResult'], ParentType, ContextType, RequireFields<MutationAcceptApiInvitationForAccountArgs, 'token'>>;
  addAllMarketingFilesToPortfolio?: Resolver<Array<ResolversTypes['PortfolioMediaKit']>, ParentType, ContextType, RequireFields<MutationAddAllMarketingFilesToPortfolioArgs, 'portfolioItemId'>>;
  addFeaturedPortfolioToSaved?: Resolver<ResolversTypes['BrokerSavedFeaturedPortfolio'], ParentType, ContextType, RequireFields<MutationAddFeaturedPortfolioToSavedArgs, 'portfolioId'>>;
  addFloorPlanToUnit?: Resolver<ResolversTypes['Unit'], ParentType, ContextType, RequireFields<MutationAddFloorPlanToUnitArgs, 'floorPlanFileId' | 'unitId'>>;
  addNoteToProperty?: Resolver<ResolversTypes['PropertyNote'], ParentType, ContextType, RequireFields<MutationAddNoteToPropertyArgs, 'message' | 'propertyId'>>;
  addPortfolioToComparison?: Resolver<ResolversTypes['Comparison'], ParentType, ContextType, RequireFields<MutationAddPortfolioToComparisonArgs, 'portfolioFolderId' | 'portfolioItemId'>>;
  addPropertiesToPortfolio?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationAddPropertiesToPortfolioArgs, 'portfolioFolderId' | 'propertyIds'>>;
  addPropertyToPortfolio?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationAddPropertyToPortfolioArgs, 'portfolioFolderId' | 'propertyId'>>;
  addPropertyToTrack?: Resolver<ResolversTypes['BrokerTrackedProperty'], ParentType, ContextType, RequireFields<MutationAddPropertyToTrackArgs, 'propertyId'>>;
  addReactionByPortfolioAndProperty?: Resolver<ResolversTypes['PortfolioReaction'], ParentType, ContextType, RequireFields<MutationAddReactionByPortfolioAndPropertyArgs, 'portfolioId' | 'propertyId' | 'reaction'>>;
  addSaleTeamUser?: Resolver<ResolversTypes['SaleTeamUser'], ParentType, ContextType, RequireFields<MutationAddSaleTeamUserArgs, 'input'>>;
  addUserToAPI?: Resolver<ResolversTypes['ApiUser'], ParentType, ContextType, RequireFields<MutationAddUserToApiArgs, 'accountInput' | 'profileInput'>>;
  addUserToCMS?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationAddUserToCmsArgs, 'accountInput' | 'profileInput'>>;
  approveProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationApprovePropertyArgs, 'input'>>;
  archiveBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationArchiveBrokerArgs, 'archivingReason' | 'brokerId'>>;
  archiveCMSUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationArchiveCmsUserArgs, 'archive' | 'cmsUserAccountId'>>;
  archiveProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationArchivePropertyArgs, 'input'>>;
  attachDefaultStripePaymentMethod?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationAttachDefaultStripePaymentMethodArgs, 'stripePaymentMethodId'>>;
  attachStripePaymentMethod?: Resolver<ResolversTypes['StripeAccount'], ParentType, ContextType, RequireFields<MutationAttachStripePaymentMethodArgs, 'stripePaymentMethodId'>>;
  auditProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationAuditPropertyArgs, 'input'>>;
  authorization?: Resolver<ResolversTypes['AuthResult'], ParentType, ContextType, RequireFields<MutationAuthorizationArgs, 'email' | 'password'>>;
  bulkUpdateMediaBrandingType?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType, RequireFields<MutationBulkUpdateMediaBrandingTypeArgs, 'brandingType' | 'mediaFilesIds'>>;
  cancelProductSubscription?: Resolver<ResolversTypes['ProductSubscription'], ParentType, ContextType, RequireFields<MutationCancelProductSubscriptionArgs, 'input'>>;
  cancelScheduledDowngrade?: Resolver<ResolversTypes['ProductSubscription'], ParentType, ContextType>;
  changeCurrentProductSubscription?: Resolver<ResolversTypes['ProductSubscriptionPayload'], ParentType, ContextType, RequireFields<MutationChangeCurrentProductSubscriptionArgs, 'input'>>;
  changePortfolioStatus?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationChangePortfolioStatusArgs, 'portfolioId' | 'status'>>;
  changeVerifiedStatusInProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationChangeVerifiedStatusInPropertyArgs, 'isMarkedAsVerified' | 'propertyId'>>;
  copyFeaturedPortfolioToBrokerPortfolio?: Resolver<ResolversTypes['CopyFeaturedPortfolioToBrokerPortfolioResult'], ParentType, ContextType, RequireFields<MutationCopyFeaturedPortfolioToBrokerPortfolioArgs, 'args'>>;
  createAlertConfig?: Resolver<ResolversTypes['BrokerAlertConfig'], ParentType, ContextType, RequireFields<MutationCreateAlertConfigArgs, 'filter' | 'name'>>;
  createAmenity?: Resolver<ResolversTypes['Amenity'], ParentType, ContextType, RequireFields<MutationCreateAmenityArgs, 'input'>>;
  createApiInvitation?: Resolver<ResolversTypes['ApiInvitationSafeDTO'], ParentType, ContextType, RequireFields<MutationCreateApiInvitationArgs, 'input'>>;
  createApiPluginUser?: Resolver<ResolversTypes['ApiCredentialsUserResponse'], ParentType, ContextType, RequireFields<MutationCreateApiPluginUserArgs, 'referralCode'>>;
  createBroker?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationCreateBrokerArgs, 'input'>>;
  createBrokerSSO?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationCreateBrokerSsoArgs, 'input'>>;
  createCheckoutSession?: Resolver<ResolversTypes['CreateCheckoutSessionPayload'], ParentType, ContextType, RequireFields<MutationCreateCheckoutSessionArgs, 'input'>>;
  createFeaturedPortfolio?: Resolver<ResolversTypes['FeaturedPortfolio'], ParentType, ContextType, RequireFields<MutationCreateFeaturedPortfolioArgs, 'input'>>;
  createFeaturedProperty?: Resolver<ResolversTypes['FeaturedProperty'], ParentType, ContextType, RequireFields<MutationCreateFeaturedPropertyArgs, 'input'>>;
  createIdxFeed?: Resolver<ResolversTypes['IdxFeed'], ParentType, ContextType, RequireFields<MutationCreateIdxFeedArgs, 'input'>>;
  createIdxSettings?: Resolver<ResolversTypes['IdxSettings'], ParentType, ContextType, RequireFields<MutationCreateIdxSettingsArgs, 'showDashCredit' | 'websiteDomain'>>;
  createMarketArea?: Resolver<ResolversTypes['MarketArea'], ParentType, ContextType, RequireFields<MutationCreateMarketAreaArgs, 'input'>>;
  createMediaFile?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationCreateMediaFileArgs, 'input'>>;
  createMediaFolder?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationCreateMediaFolderArgs, 'input'>>;
  createOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationCreateOrganizationArgs, 'input'>>;
  createOrganizationUser?: Resolver<ResolversTypes['OrganizationUser'], ParentType, ContextType, RequireFields<MutationCreateOrganizationUserArgs, 'input'>>;
  createPortfolioFolder?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationCreatePortfolioFolderArgs, 'name'>>;
  createProductSubscription?: Resolver<ResolversTypes['ProductSubscriptionPayload'], ParentType, ContextType, RequireFields<MutationCreateProductSubscriptionArgs, 'input'>>;
  createProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationCreatePropertyArgs, 'input'>>;
  createSaleTeam?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<MutationCreateSaleTeamArgs, 'input'>>;
  createSimpleBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationCreateSimpleBrokerArgs, 'input'>>;
  createSinglePropertyPortfolio?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationCreateSinglePropertyPortfolioArgs, 'input'>>;
  createUnit?: Resolver<ResolversTypes['Unit'], ParentType, ContextType, RequireFields<MutationCreateUnitArgs, 'input'>>;
  deleteAllBrokerActivities?: Resolver<Array<ResolversTypes['BrokerActivity']>, ParentType, ContextType, RequireFields<MutationDeleteAllBrokerActivitiesArgs, 'activityTypes'>>;
  deleteAmenity?: Resolver<Array<ResolversTypes['Amenity']>, ParentType, ContextType, RequireFields<MutationDeleteAmenityArgs, 'amenityId'>>;
  deleteApiAccount?: Resolver<ResolversTypes['DeleteApiAccountResult'], ParentType, ContextType, RequireFields<MutationDeleteApiAccountArgs, 'apiCredentialsId'>>;
  deleteBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationDeleteBrokerArgs, 'brokerId'>>;
  deleteBrokerActivityById?: Resolver<ResolversTypes['BrokerActivity'], ParentType, ContextType, RequireFields<MutationDeleteBrokerActivityByIdArgs, 'activityId'>>;
  deleteFeaturedPortfolio?: Resolver<ResolversTypes['FeaturedPortfolio'], ParentType, ContextType, RequireFields<MutationDeleteFeaturedPortfolioArgs, 'featuredPortfolioId'>>;
  deleteFeaturedProperty?: Resolver<ResolversTypes['FeaturedProperty'], ParentType, ContextType, RequireFields<MutationDeleteFeaturedPropertyArgs, 'featuredPropertyId'>>;
  deleteIdxFeed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteIdxFeedArgs, 'idxFeedId'>>;
  deleteMarketArea?: Resolver<ResolversTypes['MarketArea'], ParentType, ContextType, RequireFields<MutationDeleteMarketAreaArgs, 'marketAreaId'>>;
  deleteMediaFileById?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationDeleteMediaFileByIdArgs, 'mediaId'>>;
  deleteMediaFiles?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType, RequireFields<MutationDeleteMediaFilesArgs, 'mediaFilesIds'>>;
  deleteMediaFolderById?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationDeleteMediaFolderByIdArgs, 'mediaId'>>;
  deleteOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationDeleteOrganizationArgs, 'organizationId'>>;
  deleteOrganizationUser?: Resolver<ResolversTypes['OrganizationUser'], ParentType, ContextType, RequireFields<MutationDeleteOrganizationUserArgs, 'organizationUserId'>>;
  deletePortfolioById?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType, RequireFields<MutationDeletePortfolioByIdArgs, 'portfolioId'>>;
  deletePropertiesFromPortfolioByIds?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType, RequireFields<MutationDeletePropertiesFromPortfolioByIdsArgs, 'portfolioFolderId' | 'propertyIds'>>;
  deletePropertyFromPortfolioById?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationDeletePropertyFromPortfolioByIdArgs, 'portfolioFolderId' | 'propertyId'>>;
  deleteSaleTeam?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<MutationDeleteSaleTeamArgs, 'saleTeamId'>>;
  deleteSaleTeamUser?: Resolver<ResolversTypes['SaleTeamUser'], ParentType, ContextType, RequireFields<MutationDeleteSaleTeamUserArgs, 'saleTeamId' | 'saleTeamUserId'>>;
  deleteUnit?: Resolver<ResolversTypes['Unit'], ParentType, ContextType, RequireFields<MutationDeleteUnitArgs, 'unitId'>>;
  deleteUserCMS?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationDeleteUserCmsArgs, 'accountId' | 'profileId'>>;
  detachPaymentMethodFromCustomer?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationDetachPaymentMethodFromCustomerArgs, 'stripePaymentMethodId'>>;
  duplicateAmenity?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationDuplicateAmenityArgs, 'amenityId' | 'propertyId'>>;
  duplicateUnit?: Resolver<ResolversTypes['Unit'], ParentType, ContextType, RequireFields<MutationDuplicateUnitArgs, 'unitId'>>;
  editAmenity?: Resolver<ResolversTypes['Amenity'], ParentType, ContextType, RequireFields<MutationEditAmenityArgs, 'input'>>;
  editInternalSaleTeamByOrganizationId?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<MutationEditInternalSaleTeamByOrganizationIdArgs, 'input' | 'organizationId'>>;
  editMarketArea?: Resolver<ResolversTypes['MarketArea'], ParentType, ContextType, RequireFields<MutationEditMarketAreaArgs, 'input'>>;
  editMediaFile?: Resolver<ResolversTypes['File'], ParentType, ContextType, RequireFields<MutationEditMediaFileArgs, 'fileId' | 'input'>>;
  editMediaFolder?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationEditMediaFolderArgs, 'input'>>;
  editOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationEditOrganizationArgs, 'input' | 'organizationId'>>;
  editOrganizationUser?: Resolver<ResolversTypes['OrganizationUser'], ParentType, ContextType, RequireFields<MutationEditOrganizationUserArgs, 'input'>>;
  editPortfolioFolderName?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationEditPortfolioFolderNameArgs, 'name' | 'portfolioFolderId'>>;
  editPropertyNote?: Resolver<ResolversTypes['PropertyNote'], ParentType, ContextType, RequireFields<MutationEditPropertyNoteArgs, 'message' | 'propertyNoteId'>>;
  editSaleTeam?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<MutationEditSaleTeamArgs, 'input' | 'saleTeamId'>>;
  editSaleTeamUser?: Resolver<ResolversTypes['SaleTeamUser'], ParentType, ContextType, RequireFields<MutationEditSaleTeamUserArgs, 'input'>>;
  editUnit?: Resolver<ResolversTypes['Unit'], ParentType, ContextType, RequireFields<MutationEditUnitArgs, 'input'>>;
  enableMfa?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationEnableMfaArgs, 'token'>>;
  forgotPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationForgotPasswordArgs, 'email'>>;
  generateMagicLink?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationGenerateMagicLinkArgs, 'email'>>;
  generateNewApiToken?: Resolver<ResolversTypes['TokenResponse'], ParentType, ContextType>;
  getTokenWithMagicLink?: Resolver<ResolversTypes['AuthResult'], ParentType, ContextType>;
  logout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  makeFeaturedPropertyPublic?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationMakeFeaturedPropertyPublicArgs, 'featuredPropertyId' | 'position'>>;
  makePortfolioPublic?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationMakePortfolioPublicArgs, 'featuredPortfolioId' | 'position'>>;
  manuallyRegisterPortfolioView?: Resolver<Maybe<ResolversTypes['ViewHistory']>, ParentType, ContextType, RequireFields<MutationManuallyRegisterPortfolioViewArgs, 'viewedPortfolioId'>>;
  mfaAuthentication?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationMfaAuthenticationArgs, 'token'>>;
  moveMediaInSortOrder?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationMoveMediaInSortOrderArgs, 'sortedMediaIds'>>;
  moveMediaToFolder?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationMoveMediaToFolderArgs, 'mediaFolderId' | 'mediaIds'>>;
  movePortfolios?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationMovePortfoliosArgs, 'portfolioIds'>>;
  orderFeaturedPortfolios?: Resolver<Array<ResolversTypes['FeaturedPortfolio']>, ParentType, ContextType, RequireFields<MutationOrderFeaturedPortfoliosArgs, 'orders'>>;
  orderFeaturedProperties?: Resolver<Array<ResolversTypes['FeaturedProperty']>, ParentType, ContextType, RequireFields<MutationOrderFeaturedPropertiesArgs, 'orders'>>;
  orderPropertiesInPortfolio?: Resolver<ResolversTypes['FeaturedPortfolio'], ParentType, ContextType, RequireFields<MutationOrderPropertiesInPortfolioArgs, 'featuredPortfolioId' | 'propertyIds'>>;
  readPropertyNotes?: Resolver<ResolversTypes['PropertyNote'], ParentType, ContextType, RequireFields<MutationReadPropertyNotesArgs, 'propertyNotesIds'>>;
  recordLastTouchAttribution?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRecordLastTouchAttributionArgs, 'attribution'>>;
  refreshTokens?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType>;
  registerBroker?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationRegisterBrokerArgs, 'input'>>;
  registerDeveloperUser?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationRegisterDeveloperUserArgs, 'input' | 'signUpVerificationCode'>>;
  registerIdxActivity?: Resolver<ResolversTypes['IdxActivity'], ParentType, ContextType, RequireFields<MutationRegisterIdxActivityArgs, 'idxId' | 'propertyId'>>;
  removeAlertConfig?: Resolver<ResolversTypes['BrokerAlertConfig'], ParentType, ContextType, RequireFields<MutationRemoveAlertConfigArgs, 'alertConfigId'>>;
  removeAllMarketingFilesFromPortfolio?: Resolver<Array<ResolversTypes['PortfolioMediaKit']>, ParentType, ContextType, RequireFields<MutationRemoveAllMarketingFilesFromPortfolioArgs, 'portfolioItemId'>>;
  removeAmenitiesFromProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationRemoveAmenitiesFromPropertyArgs, 'amenitiesIds' | 'propertyId'>>;
  removeFeaturedPortfolioFromSaved?: Resolver<ResolversTypes['BrokerSavedFeaturedPortfolio'], ParentType, ContextType, RequireFields<MutationRemoveFeaturedPortfolioFromSavedArgs, 'brokerSavedFeaturedPortfolioId'>>;
  removePropertyById?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemovePropertyByIdArgs, 'propertyId'>>;
  removePropertyFromTracked?: Resolver<ResolversTypes['BrokerTrackedProperty'], ParentType, ContextType, RequireFields<MutationRemovePropertyFromTrackedArgs, 'brokerTrackedPropertyId'>>;
  removePropertyNote?: Resolver<ResolversTypes['PropertyNote'], ParentType, ContextType, RequireFields<MutationRemovePropertyNoteArgs, 'propertyNoteId'>>;
  renewProductSubscription?: Resolver<ResolversTypes['ProductSubscriptionPayload'], ParentType, ContextType>;
  resendApiInvitation?: Resolver<ResolversTypes['ApiInvitationSafeDTO'], ParentType, ContextType, RequireFields<MutationResendApiInvitationArgs, 'input'>>;
  resetCmsSettingsToDefaults?: Resolver<ResolversTypes['CmsSettings'], ParentType, ContextType>;
  resetPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationResetPasswordArgs, 'newPassword'>>;
  restoreApiAccount?: Resolver<ResolversTypes['RestoreApiAccountResult'], ParentType, ContextType, RequireFields<MutationRestoreApiAccountArgs, 'apiCredentialsId'>>;
  retryProductSubscriptionCharge?: Resolver<ResolversTypes['ProductSubscriptionPayload'], ParentType, ContextType>;
  revokeApiInvitation?: Resolver<ResolversTypes['ApiInvitationSafeDTO'], ParentType, ContextType, RequireFields<MutationRevokeApiInvitationArgs, 'invitationId'>>;
  scheduleDowngrade?: Resolver<ResolversTypes['SubscriptionSchedule'], ParentType, ContextType, RequireFields<MutationScheduleDowngradeArgs, 'input'>>;
  sendEmailVerificationCode?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  sendMessageToAgent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendMessageToAgentArgs, 'input'>>;
  sendMfaEmailCode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sendRegistrationLinkToDeveloper?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendRegistrationLinkToDeveloperArgs, 'accountId'>>;
  sendVerificationCode?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationSendVerificationCodeArgs, 'phone'>>;
  setAdvancedPropertyDetails?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationSetAdvancedPropertyDetailsArgs, 'input'>>;
  setAmenitiesToProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationSetAmenitiesToPropertyArgs, 'input'>>;
  setAmenityNameInProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationSetAmenityNameInPropertyArgs, 'amenityId' | 'isPrimary' | 'name' | 'propertyId'>>;
  setApiCredentialAdminDisabled?: Resolver<ResolversTypes['ApiCredentialSafeDTO'], ParentType, ContextType, RequireFields<MutationSetApiCredentialAdminDisabledArgs, 'adminDisabled' | 'apiCredentialsId'>>;
  setApiCredentialMonthlyRequestLimit?: Resolver<ResolversTypes['ApiCredentialSafeDTO'], ParentType, ContextType, RequireFields<MutationSetApiCredentialMonthlyRequestLimitArgs, 'apiCredentialsId'>>;
  setBrokerShowAllBillingPlans?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationSetBrokerShowAllBillingPlansArgs, 'brokerId' | 'showAllBillingPlans'>>;
  setGeneralPropertyDetails?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationSetGeneralPropertyDetailsArgs, 'input'>>;
  setGuestUserData?: Resolver<ResolversTypes['GuestUser'], ParentType, ContextType, Partial<MutationSetGuestUserDataArgs>>;
  setHiddenStateToAlertItem?: Resolver<ResolversTypes['BrokerAlertItem'], ParentType, ContextType, RequireFields<MutationSetHiddenStateToAlertItemArgs, 'alertItemId' | 'isHidden'>>;
  setMyPluginUserDisabled?: Resolver<ResolversTypes['ApiCredentialSafeDTO'], ParentType, ContextType, RequireFields<MutationSetMyPluginUserDisabledArgs, 'apiCredentialsId' | 'disabled'>>;
  setOrganizationUserStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetOrganizationUserStatusArgs, 'organizationUserId' | 'status'>>;
  setPortfolioMediaKitMedia?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetPortfolioMediaKitMediaArgs, 'input'>>;
  setPropertyStatus?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationSetPropertyStatusArgs, 'input'>>;
  setSaleTeamUserStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetSaleTeamUserStatusArgs, 'saleTeamUserId' | 'status'>>;
  switchAccountType?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationSwitchAccountTypeArgs, 'input'>>;
  temporaryAuthentication?: Resolver<ResolversTypes['TempAuthResult'], ParentType, ContextType, RequireFields<MutationTemporaryAuthenticationArgs, 'email' | 'password'>>;
  toggleChangelogVisibility?: Resolver<ResolversTypes['PropertyChangelog'], ParentType, ContextType, RequireFields<MutationToggleChangelogVisibilityArgs, 'input'>>;
  unarchiveBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationUnarchiveBrokerArgs, 'brokerId'>>;
  updateAlertConfig?: Resolver<ResolversTypes['BrokerAlertConfig'], ParentType, ContextType, RequireFields<MutationUpdateAlertConfigArgs, 'alertConfigId' | 'filter' | 'name'>>;
  updateBrandedFilesReady?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationUpdateBrandedFilesReadyArgs, 'input'>>;
  updateBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationUpdateBrokerArgs, 'brokerId' | 'input'>>;
  updateBrokerLicenseStatus?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationUpdateBrokerLicenseStatusArgs, 'brokerId' | 'input'>>;
  updateCmsSettings?: Resolver<ResolversTypes['CmsSettings'], ParentType, ContextType, RequireFields<MutationUpdateCmsSettingsArgs, 'input'>>;
  updateCmsStatus?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationUpdateCmsStatusArgs, 'input'>>;
  updateCurrentBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationUpdateCurrentBrokerArgs, 'input'>>;
  updateCurrentUser?: Resolver<ResolversTypes['Profile'], ParentType, ContextType, RequireFields<MutationUpdateCurrentUserArgs, 'profileInput'>>;
  updateEmail?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationUpdateEmailArgs, 'newEmail' | 'password'>>;
  updateFeaturedPortfolio?: Resolver<ResolversTypes['FeaturedPortfolio'], ParentType, ContextType, RequireFields<MutationUpdateFeaturedPortfolioArgs, 'featuredPortfolioId' | 'input'>>;
  updateFeaturedProperty?: Resolver<ResolversTypes['FeaturedProperty'], ParentType, ContextType, RequireFields<MutationUpdateFeaturedPropertyArgs, 'featuredPropertyId' | 'input'>>;
  updateIdxFeed?: Resolver<ResolversTypes['IdxFeed'], ParentType, ContextType, RequireFields<MutationUpdateIdxFeedArgs, 'input'>>;
  updateIdxSettings?: Resolver<ResolversTypes['IdxSettings'], ParentType, ContextType, RequireFields<MutationUpdateIdxSettingsArgs, 'input'>>;
  updateMediaBrandingType?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationUpdateMediaBrandingTypeArgs, 'brandingType' | 'mediaId'>>;
  updatePassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdatePasswordArgs, 'newPassword' | 'oldPassword'>>;
  updatePortfolioLocations?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationUpdatePortfolioLocationsArgs, 'locations' | 'portfolioFolderId'>>;
  updatePortfolioPassword?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationUpdatePortfolioPasswordArgs, 'password' | 'portfolioId'>>;
  updatePortfolioSettings?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationUpdatePortfolioSettingsArgs, 'portfolioId'>>;
  updateSSOId?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationUpdateSsoIdArgs, 'ssoId'>>;
  updateShowPopupOnPortfolio?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationUpdateShowPopupOnPortfolioArgs, 'portfolioId' | 'showPopup'>>;
  updateSubscriptionEmailSettings?: Resolver<ResolversTypes['SubscriptionEmailSettings'], ParentType, ContextType, RequireFields<MutationUpdateSubscriptionEmailSettingsArgs, 'input'>>;
  updateUserAPI?: Resolver<ResolversTypes['ApiUser'], ParentType, ContextType, RequireFields<MutationUpdateUserApiArgs, 'accountUpdateInput' | 'profileInput'>>;
  updateUserCMS?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateUserCmsArgs, 'accountUpdateInput' | 'profileInput'>>;
  uploadDraftFile?: Resolver<ResolversTypes['File'], ParentType, ContextType, RequireFields<MutationUploadDraftFileArgs, 'input'>>;
  upsertComparison?: Resolver<ResolversTypes['Comparison'], ParentType, ContextType, RequireFields<MutationUpsertComparisonArgs, 'fieldsToCompare' | 'portfolioFolderId' | 'portfolioIds'>>;
  validateCoupon?: Resolver<ResolversTypes['ValidateCouponPayload'], ParentType, ContextType, RequireFields<MutationValidateCouponArgs, 'args'>>;
  validatePhoneNumber?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationValidatePhoneNumberArgs, 'code'>>;
  verifyPhoneNumberAndUpdateAccount?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationVerifyPhoneNumberAndUpdateAccountArgs, 'code' | 'phone'>>;
}>;

export type NewPortfolioItemActivitiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewPortfolioItemActivitiesPayload'] = ResolversParentTypes['NewPortfolioItemActivitiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['NewPortfolioItemActivity']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NewPortfolioItemActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewPortfolioItemActivity'] = ResolversParentTypes['NewPortfolioItemActivity']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityDoc?: Resolver<ResolversTypes['NewPortfolioItemActivityDoc'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioItem?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NewPortfolioItemActivityDocResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewPortfolioItemActivityDoc'] = ResolversParentTypes['NewPortfolioItemActivityDoc']> = ResolversObject<{
  portfolioItemId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface ObjectIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ObjectId'], any> {
  name: 'ObjectId';
}

export type ObserveAccountPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObserveAccountPayload'] = ResolversParentTypes['ObserveAccountPayload']> = ResolversObject<{
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ObserveBrokerAlertItemsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObserveBrokerAlertItemsPayload'] = ResolversParentTypes['ObserveBrokerAlertItemsPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['BrokerAlertItem'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ObserveBrokerPortfolioPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObserveBrokerPortfolioPayload'] = ResolversParentTypes['ObserveBrokerPortfolioPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ObserveProgressTrackingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObserveProgressTrackingPayload'] = ResolversParentTypes['ObserveProgressTrackingPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['ProgressTrackingModel'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ObservePropertyNotesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObservePropertyNotesPayload'] = ResolversParentTypes['ObservePropertyNotesPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['PropertyNote'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ObservePropertyPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObservePropertyPayload'] = ResolversParentTypes['ObservePropertyPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  internalSaleTeam?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  locationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  logoFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertiesCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationUser'] = ResolversParentTypes['OrganizationUser']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  assignedPropertiesIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  internalSaleTeamId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  saleTeamRole?: Resolver<Maybe<ResolversTypes['Role']>, ParentType, ContextType>;
  saleTeamRoleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationUsersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationUsersPayload'] = ResolversParentTypes['OrganizationUsersPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['OrganizationUser']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationsPayload'] = ResolversParentTypes['OrganizationsPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PhoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['Phone'] = ResolversParentTypes['Phone']> = ResolversObject<{
  dialCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Place'] = ResolversParentTypes['Place']> = ResolversObject<{
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlaceOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlaceOption'] = ResolversParentTypes['PlaceOption']> = ResolversObject<{
  cityKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  countyKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlaceOptionsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlaceOptionsPayload'] = ResolversParentTypes['PlaceOptionsPayload']> = ResolversObject<{
  cities?: Resolver<Array<ResolversTypes['PlaceOption']>, ParentType, ContextType>;
  counties?: Resolver<Array<ResolversTypes['PlaceOption']>, ParentType, ContextType>;
  marketAreas?: Resolver<Array<ResolversTypes['MarketAreaPlaceOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['Portfolio'] = ResolversParentTypes['Portfolio']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAddedMediaKit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isParentRoot?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  locations?: Resolver<Maybe<ResolversTypes['PortfolioLocations']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioFolder?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  portfolioFolderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioPropertiesIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['Property']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reactions?: Resolver<ResolversTypes['BrokerReactionsStats'], ParentType, ContextType>;
  reactionsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  showPopup?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  withPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfolioFolderItemsGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioFolderItemsGroup'] = ResolversParentTypes['PortfolioFolderItemsGroup']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  folderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfolioLocationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioLocations'] = ResolversParentTypes['PortfolioLocations']> = ResolversObject<{
  cities?: Resolver<Array<ResolversTypes['Place']>, ParentType, ContextType>;
  counties?: Resolver<Array<ResolversTypes['Place']>, ParentType, ContextType>;
  marketAreaIds?: Resolver<Array<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfolioMediaKitResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioMediaKit'] = ResolversParentTypes['PortfolioMediaKit']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAddedToMediaKit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  media?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType>;
  mediaId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  portfolioId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfolioReactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioReaction'] = ResolversParentTypes['PortfolioReaction']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  guestUser?: Resolver<ResolversTypes['GuestUser'], ParentType, ContextType>;
  guestUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  portfolioId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reaction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfolioTreeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioTree'] = ResolversParentTypes['PortfolioTree']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAddedMediaKit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isParentRoot?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioFolder?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  portfolioFolderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioPropertiesIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['Property']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reactions?: Resolver<ResolversTypes['BrokerReactionsStats'], ParentType, ContextType>;
  reactionsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  showPopup?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  withPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfoliosPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfoliosPayload'] = ResolversParentTypes['PortfoliosPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfoliosTreePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfoliosTreePayload'] = ResolversParentTypes['PortfoliosTreePayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['PortfolioTree']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PreferredPropertySettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreferredPropertySettings'] = ResolversParentTypes['PreferredPropertySettings']> = ResolversObject<{
  buildingTypes?: Resolver<Maybe<Array<ResolversTypes['BuildingTypesEnum']>>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  locationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priceRange?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  radiusInMiles?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PreviewInvoiceItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreviewInvoiceItem'] = ResolversParentTypes['PreviewInvoiceItem']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PreviewInvoicePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreviewInvoicePayload'] = ResolversParentTypes['PreviewInvoicePayload']> = ResolversObject<{
  amountDue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  coupon?: Resolver<Maybe<ResolversTypes['InvoiceCoupon']>, ParentType, ContextType>;
  dueDateMillis?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['PreviewInvoiceItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSubscription'] = ResolversParentTypes['ProductSubscription']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cancelationReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentPeriodEndAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  currentPeriodStartAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downgradeTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  otherReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schedule?: Resolver<Maybe<ResolversTypes['SubscriptionSchedule']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stripeSubscriptionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionInactiveAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  subscriptionProduct?: Resolver<ResolversTypes['SubscriptionProduct'], ParentType, ContextType>;
  subscriptionProductId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trialEndAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  trialStartAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSubscriptionPayload'] = ResolversParentTypes['ProductSubscriptionPayload']> = ResolversObject<{
  productSubscription?: Resolver<ResolversTypes['ProductSubscription'], ParentType, ContextType>;
  productSubscriptionPayment?: Resolver<Maybe<ResolversTypes['ProductSubscriptionPayment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductSubscriptionPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSubscriptionPayment'] = ResolversParentTypes['ProductSubscriptionPayment']> = ResolversObject<{
  clientSecret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductSubscriptionsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSubscriptionsPayload'] = ResolversParentTypes['ProductSubscriptionsPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['ProductSubscription']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductsSubscriptionsObserveSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductsSubscriptionsObserveSubscriptionPayload'] = ResolversParentTypes['ProductsSubscriptionsObserveSubscriptionPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['ProductSubscription'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['Profile'] = ResolversParentTypes['Profile']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  avatarFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  avatarFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProgressTrackingModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProgressTrackingModel'] = ResolversParentTypes['ProgressTrackingModel']> = ResolversObject<{
  expectedOperations?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  operation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  progressTrackingId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertiesPayload'] = ResolversParentTypes['PropertiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Property']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Property'] = ResolversParentTypes['Property']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amenities?: Resolver<Array<ResolversTypes['Amenity']>, ParentType, ContextType>;
  amenityIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  amenityNames?: Resolver<Maybe<Array<ResolversTypes['AmenityName']>>, ParentType, ContextType>;
  availableUnitsNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  averageBathroomsNumber?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  averageBathroomsNumberValue?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  averageBedroomsNumber?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  averageBedroomsNumberValue?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  brandedFilesReady?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  buildingTypes?: Resolver<Array<ResolversTypes['BuildingTypesEnum']>, ParentType, ContextType>;
  cheapestUnit?: Resolver<Maybe<ResolversTypes['Unit']>, ParentType, ContextType>;
  cmsStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cmsStatusUpdatedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  comingSoon?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  completionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  constructionStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  contactEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactPhone?: Resolver<Maybe<ResolversTypes['ContactPhone']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultInventoryDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstPublicStatusDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  hasChangelog?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasUnreadNotes?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  interiorDesigner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isMarkedAsVerified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRestricted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  landscapeArchitect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastChangelogType?: Resolver<Maybe<ResolversTypes['PropertyChangelogTypesEnum']>, ParentType, ContextType>;
  lastUpdatedAtByChangelog?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  leadArchitect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localArchitect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<ResolversTypes['Location'], ParentType, ContextType>;
  locationId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  mainPropertyMediaFile?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType>;
  mainPropertyMediaId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  market?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketArea?: Resolver<Maybe<ResolversTypes['MarketArea']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numberOfTowers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfUnits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organizationIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  organizations?: Resolver<Maybe<Array<ResolversTypes['Organization']>>, ParentType, ContextType>;
  overview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priceRange?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  primaryOrganization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType>;
  primaryOrganizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  projectDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  projectStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  propertyTags?: Resolver<Maybe<Array<ResolversTypes['PropertyTagsEnum']>>, ParentType, ContextType>;
  rootMediaFolderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  saleTeams?: Resolver<Maybe<Array<ResolversTypes['PropertySaleTeam']>>, ParentType, ContextType>;
  salesGalleryAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesGalleryHours?: Resolver<Maybe<ResolversTypes['LocalTimeHours']>, ParentType, ContextType>;
  salesGalleryStatus?: Resolver<Maybe<ResolversTypes['SalesGalleryStatusesEnum']>, ParentType, ContextType>;
  slideshowMedia?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType>;
  slideshowMediaFolderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stories?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  taxInformation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['PropertyTransactionTypesEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verifiedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  virtualTourLinks?: Resolver<Maybe<Array<ResolversTypes['VirtualTourLink']>>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workingHours?: Resolver<Maybe<ResolversTypes['WorkingHours']>, ParentType, ContextType>;
  yearBuilt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyAboutChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyAboutChangelog'] = ResolversParentTypes['PropertyAboutChangelog']> = ResolversObject<{
  projectDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyAdditionalInformationChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyAdditionalInformationChangelog'] = ResolversParentTypes['PropertyAdditionalInformationChangelog']> = ResolversObject<{
  buildingTypes?: Resolver<Array<ResolversTypes['BuildingTypesEnum']>, ParentType, ContextType>;
  completionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  constructionStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  numberOfTowers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfUnits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  projectStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  propertyTags?: Resolver<Maybe<Array<ResolversTypes['PropertyTagsEnum']>>, ParentType, ContextType>;
  salesGalleryAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesGalleryHours?: Resolver<Maybe<ResolversTypes['LocalTimeHours']>, ParentType, ContextType>;
  salesGalleryStatus?: Resolver<Maybe<ResolversTypes['SalesGalleryStatusesEnum']>, ParentType, ContextType>;
  stories?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  transactionType?: Resolver<Maybe<ResolversTypes['PropertyTransactionTypesEnum']>, ParentType, ContextType>;
  yearBuilt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyChangelog'] = ResolversParentTypes['PropertyChangelog']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  afterUpdate?: Resolver<ResolversTypes['ChangelogDocument'], ParentType, ContextType>;
  beforeUpdate?: Resolver<Maybe<ResolversTypes['ChangelogDocument']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isHidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  property?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyChangelogsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyChangelogsPayload'] = ResolversParentTypes['PropertyChangelogsPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['PropertyChangelog']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyClickResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyClick'] = ResolversParentTypes['PropertyClick']> = ResolversObject<{
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clickCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyCmsStatusChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyCmsStatusChangelog'] = ResolversParentTypes['PropertyCmsStatusChangelog']> = ResolversObject<{
  cmsStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visibility?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyDataReviewedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyDataReviewedChangelog'] = ResolversParentTypes['PropertyDataReviewedChangelog']> = ResolversObject<{
  reviewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyDetail'] = ResolversParentTypes['PropertyDetail']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  averageBathroomsNumber?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  averageBedroomsNumber?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  completionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  mainPropertyMediaFile?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType>;
  marketArea?: Resolver<Maybe<ResolversTypes['MarketArea']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  overview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priceRange?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  projectStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yearBuilt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyDeveloperOrganizationChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyDeveloperOrganizationChangelog'] = ResolversParentTypes['PropertyDeveloperOrganizationChangelog']> = ResolversObject<{
  interiorDesigner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  landscapeArchitect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  leadArchitect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localArchitect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoFileId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyFeaturesAndAmenitiesChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyFeaturesAndAmenitiesChangelog'] = ResolversParentTypes['PropertyFeaturesAndAmenitiesChangelog']> = ResolversObject<{
  amenityIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  amenityNames?: Resolver<Maybe<Array<ResolversTypes['AmenityName']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyHighlightsChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyHighlightsChangelog'] = ResolversParentTypes['PropertyHighlightsChangelog']> = ResolversObject<{
  overview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyInventoryUnitAddedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyInventoryUnitAddedChangelog'] = ResolversParentTypes['PropertyInventoryUnitAddedChangelog']> = ResolversObject<{
  newUnitId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyInventoryUnitRemovedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyInventoryUnitRemovedChangelog'] = ResolversParentTypes['PropertyInventoryUnitRemovedChangelog']> = ResolversObject<{
  removedUnitId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyInventoryUnitUpdatedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyInventoryUnitUpdatedChangelog'] = ResolversParentTypes['PropertyInventoryUnitUpdatedChangelog']> = ResolversObject<{
  averageBathroomsNumber?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageBedroomsNumber?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageExteriorSqft?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageInteriorSqft?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageTotalSqft?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  floorPlanFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highestPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  inventoryType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startingPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyLocationChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyLocationChangelog'] = ResolversParentTypes['PropertyLocationChangelog']> = ResolversObject<{
  address?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyMediaFilesMovedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyMediaFilesMovedChangelog'] = ResolversParentTypes['PropertyMediaFilesMovedChangelog']> = ResolversObject<{
  mediaFilesIds?: Resolver<Array<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  mediaFolderId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyMediaRemovedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyMediaRemovedChangelog'] = ResolversParentTypes['PropertyMediaRemovedChangelog']> = ResolversObject<{
  removedMediaIds?: Resolver<Array<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyMediaRenamedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyMediaRenamedChangelog'] = ResolversParentTypes['PropertyMediaRenamedChangelog']> = ResolversObject<{
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyMediaUploadedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyMediaUploadedChangelog'] = ResolversParentTypes['PropertyMediaUploadedChangelog']> = ResolversObject<{
  folderName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaFolderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadedMediaId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyNameChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyNameChangelog'] = ResolversParentTypes['PropertyNameChangelog']> = ResolversObject<{
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyNote'] = ResolversParentTypes['PropertyNote']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  attachedFiles?: Resolver<Maybe<Array<ResolversTypes['File']>>, ParentType, ContextType>;
  attachedFilesIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  authorAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  authorProfile?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  readBy?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyNotesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyNotesPayload'] = ResolversParentTypes['PropertyNotesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['PropertyNote']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyOrganizationSalesTeamsChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyOrganizationSalesTeamsChangelog'] = ResolversParentTypes['PropertyOrganizationSalesTeamsChangelog']> = ResolversObject<{
  saleTeams?: Resolver<Maybe<Array<ResolversTypes['PropertySaleTeam']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyPriceChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyPriceChangelog'] = ResolversParentTypes['PropertyPriceChangelog']> = ResolversObject<{
  priceRange?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertySaleTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertySaleTeam'] = ResolversParentTypes['PropertySaleTeam']> = ResolversObject<{
  commission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contactUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleAssociateIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  saleAssociates?: Resolver<Maybe<Array<ResolversTypes['DeveloperAsSaleUser']>>, ParentType, ContextType>;
  saleDirector?: Resolver<Maybe<ResolversTypes['DeveloperAsSaleUser']>, ParentType, ContextType>;
  saleDirectorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleTeam?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType>;
  saleTeamId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertySummary'] = ResolversParentTypes['PropertySummary']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyVirtualToursChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyVirtualToursChangelog'] = ResolversParentTypes['PropertyVirtualToursChangelog']> = ResolversObject<{
  virtualTourLinks?: Resolver<Array<ResolversTypes['VirtualTourLink']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyVisibilityChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyVisibilityChangelog'] = ResolversParentTypes['PropertyVisibilityChangelog']> = ResolversObject<{
  visibility?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyVisitActivitiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyVisitActivitiesPayload'] = ResolversParentTypes['PropertyVisitActivitiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['PropertyVisitActivity']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyVisitActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyVisitActivity'] = ResolversParentTypes['PropertyVisitActivity']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityDoc?: Resolver<ResolversTypes['PropertyVisitActivityDoc'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  property?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyVisitActivityDocResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyVisitActivityDoc'] = ResolversParentTypes['PropertyVisitActivityDoc']> = ResolversObject<{
  propertyId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyWebsiteChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyWebsiteChangelog'] = ResolversParentTypes['PropertyWebsiteChangelog']> = ResolversObject<{
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  apiInvitations?: Resolver<ResolversTypes['ApiInvitationsPayload'], ParentType, ContextType, Partial<QueryApiInvitationsArgs>>;
  canUserTrialForProduct?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryCanUserTrialForProductArgs, 'input'>>;
  checkIfPortfolioHasMediaKit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryCheckIfPortfolioHasMediaKitArgs, 'portfolioId'>>;
  countPropertiesInPlaces?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryCountPropertiesInPlacesArgs, 'input'>>;
  currentBrokerHasAlertConfigs?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  currentBrokerHasPortfolios?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  downloadPropertiesXml?: Resolver<ResolversTypes['XmlDownloadResponse'], ParentType, ContextType>;
  generateMfaQrCode?: Resolver<ResolversTypes['GenerateQrCodeResult'], ParentType, ContextType>;
  getAccount?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  getAccountBySignUpVerificationCode?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<QueryGetAccountBySignUpVerificationCodeArgs, 'signUpVerificationCode'>>;
  getAlertConfigById?: Resolver<ResolversTypes['BrokerAlertConfig'], ParentType, ContextType, RequireFields<QueryGetAlertConfigByIdArgs, 'alertConfigId'>>;
  getAlertConfigs?: Resolver<ResolversTypes['BrokerAlertConfigPayload'], ParentType, ContextType, Partial<QueryGetAlertConfigsArgs>>;
  getAlertItems?: Resolver<ResolversTypes['BrokerAlertItemPayload'], ParentType, ContextType, Partial<QueryGetAlertItemsArgs>>;
  getAllFilesInProperty?: Resolver<ResolversTypes['MediaFilesAndFoldersPayload'], ParentType, ContextType, RequireFields<QueryGetAllFilesInPropertyArgs, 'filter'>>;
  getAllFilesInPropertyPreview?: Resolver<ResolversTypes['MediaFilesAndFoldersPayload'], ParentType, ContextType, RequireFields<QueryGetAllFilesInPropertyPreviewArgs, 'filter'>>;
  getAllFoldersInProperty?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType, RequireFields<QueryGetAllFoldersInPropertyArgs, 'excludeSlideshowFolder' | 'includeRootFolder' | 'propertyId'>>;
  getAllPortfolioFolders?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  getAllPropertyChangelogs?: Resolver<ResolversTypes['PropertyChangelogsPayload'], ParentType, ContextType, RequireFields<QueryGetAllPropertyChangelogsArgs, 'filter'>>;
  getAmenities?: Resolver<ResolversTypes['AmenitiesPayload'], ParentType, ContextType, Partial<QueryGetAmenitiesArgs>>;
  getAmenitiesForManage?: Resolver<ResolversTypes['AmenitiesPayload'], ParentType, ContextType, RequireFields<QueryGetAmenitiesForManageArgs, 'filter'>>;
  getApiCredentialsBasicInfo?: Resolver<Maybe<ResolversTypes['BasicInfoResponse']>, ParentType, ContextType>;
  getApiCredentialsById?: Resolver<ResolversTypes['ApiCredentialSafeDTO'], ParentType, ContextType, RequireFields<QueryGetApiCredentialsByIdArgs, 'apiCredentialsId'>>;
  getApiPluginUsers?: Resolver<ResolversTypes['ApiPluginUsersPayload'], ParentType, ContextType, Partial<QueryGetApiPluginUsersArgs>>;
  getApiQuotaStatusByAppId?: Resolver<ResolversTypes['ApiQuotaStatusPayload'], ParentType, ContextType, RequireFields<QueryGetApiQuotaStatusByAppIdArgs, 'appId'>>;
  getApiUsers?: Resolver<ResolversTypes['ApiUsersPayload'], ParentType, ContextType, Partial<QueryGetApiUsersArgs>>;
  getBrokerById?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<QueryGetBrokerByIdArgs, 'brokerId'>>;
  getBrokerForAccountManagement?: Resolver<ResolversTypes['Broker'], ParentType, ContextType>;
  getBrokerGuestUser?: Resolver<ResolversTypes['GuestUserPayload'], ParentType, ContextType, Partial<QueryGetBrokerGuestUserArgs>>;
  getBrokerNewPortfolioItemActivities?: Resolver<ResolversTypes['NewPortfolioItemActivitiesPayload'], ParentType, ContextType, Partial<QueryGetBrokerNewPortfolioItemActivitiesArgs>>;
  getBrokerProperties?: Resolver<ResolversTypes['PropertiesPayload'], ParentType, ContextType, Partial<QueryGetBrokerPropertiesArgs>>;
  getBrokerViewedPortfolios?: Resolver<ResolversTypes['ViewHistoryPayload'], ParentType, ContextType, Partial<QueryGetBrokerViewedPortfoliosArgs>>;
  getBrokers?: Resolver<ResolversTypes['BrokersPayload'], ParentType, ContextType, Partial<QueryGetBrokersArgs>>;
  getCMSUsers?: Resolver<ResolversTypes['UsersPayload'], ParentType, ContextType, Partial<QueryGetCmsUsersArgs>>;
  getCheckoutSessionDetails?: Resolver<ResolversTypes['CheckoutSessionDetails'], ParentType, ContextType, RequireFields<QueryGetCheckoutSessionDetailsArgs, 'sessionId'>>;
  getCmsSettings?: Resolver<ResolversTypes['CmsSettings'], ParentType, ContextType>;
  getCompanyOwnApiQuotaStatus?: Resolver<ResolversTypes['ApiQuotaStatusPayload'], ParentType, ContextType>;
  getCompanyOwnMonthlyApiUsage?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryGetCompanyOwnMonthlyApiUsageArgs, 'targetMonth'>>;
  getCompanyOwnTotalApiUsage?: Resolver<ResolversTypes['ApiMetricPayload'], ParentType, ContextType, Partial<QueryGetCompanyOwnTotalApiUsageArgs>>;
  getComparison?: Resolver<Maybe<ResolversTypes['Comparison']>, ParentType, ContextType, RequireFields<QueryGetComparisonArgs, 'portfolioFolderId'>>;
  getContentActivity?: Resolver<ResolversTypes['ContentActivity'], ParentType, ContextType, RequireFields<QueryGetContentActivityArgs, 'range'>>;
  getContentActivityLog?: Resolver<ResolversTypes['ContentActivityLog'], ParentType, ContextType, RequireFields<QueryGetContentActivityLogArgs, 'range'>>;
  getCurrentAccountProductSubscription?: Resolver<Maybe<ResolversTypes['ProductSubscription']>, ParentType, ContextType>;
  getCurrentAccountTrialProductSubscriptions?: Resolver<Maybe<ResolversTypes['ProductSubscriptionsPayload']>, ParentType, ContextType>;
  getCurrentBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType>;
  getCurrentDeveloperProperties?: Resolver<ResolversTypes['PropertiesPayload'], ParentType, ContextType, Partial<QueryGetCurrentDeveloperPropertiesArgs>>;
  getCurrentDeveloperUser?: Resolver<ResolversTypes['Developer'], ParentType, ContextType>;
  getCurrentStripeAccount?: Resolver<Maybe<ResolversTypes['StripeAccount']>, ParentType, ContextType>;
  getCurrentStripeAccountTransactions?: Resolver<ResolversTypes['StripeAccountTransactionsFlatPayload'], ParentType, ContextType, Partial<QueryGetCurrentStripeAccountTransactionsArgs>>;
  getDevelopersAsSaleUsersBySaleTeamAndRole?: Resolver<Array<ResolversTypes['DeveloperAsSaleUser']>, ParentType, ContextType, RequireFields<QueryGetDevelopersAsSaleUsersBySaleTeamAndRoleArgs, 'saleTeamId'>>;
  getExternalSaleTeamByIdForDeveloper?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<QueryGetExternalSaleTeamByIdForDeveloperArgs, 'saleTeamId'>>;
  getExternalSaleTeamsForDeveloper?: Resolver<ResolversTypes['SaleTeamsPayload'], ParentType, ContextType, Partial<QueryGetExternalSaleTeamsForDeveloperArgs>>;
  getFeaturedPortfolioById?: Resolver<ResolversTypes['FeaturedPortfolio'], ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioByIdArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioByIdPublic?: Resolver<ResolversTypes['FeaturedPortfolio'], ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioByIdPublicArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioMarketAreas?: Resolver<Array<ResolversTypes['MarketAreaCount']>, ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioMarketAreasArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioMarketAreasPublic?: Resolver<Array<ResolversTypes['MarketAreaCount']>, ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioMarketAreasPublicArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioProperties?: Resolver<ResolversTypes['FeaturedPortfolioPropertiesPayload'], ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioPropertiesArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioPropertiesAdmin?: Resolver<Array<ResolversTypes['PropertySummary']>, ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioPropertiesAdminArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioPropertiesPublic?: Resolver<ResolversTypes['FeaturedPortfolioPropertiesPayload'], ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioPropertiesPublicArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioSummary?: Resolver<Maybe<ResolversTypes['FeaturedPortfolioSummary']>, ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioSummaryArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioSummaryPublic?: Resolver<Maybe<ResolversTypes['FeaturedPortfolioSummary']>, ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioSummaryPublicArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolios?: Resolver<ResolversTypes['FeaturedPortfoliosPayload'], ParentType, ContextType, Partial<QueryGetFeaturedPortfoliosArgs>>;
  getFeaturedProperties?: Resolver<ResolversTypes['FeaturedPropertiesPayload'], ParentType, ContextType, Partial<QueryGetFeaturedPropertiesArgs>>;
  getFeaturedPropertyById?: Resolver<ResolversTypes['FeaturedProperty'], ParentType, ContextType, RequireFields<QueryGetFeaturedPropertyByIdArgs, 'featuredPropertyId'>>;
  getFileDownloadsStatistic?: Resolver<ResolversTypes['GetFileDownloadsStatisticPayload'], ParentType, ContextType, Partial<QueryGetFileDownloadsStatisticArgs>>;
  getFoldersPathOfMedia?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetFoldersPathOfMediaArgs, 'mediaId'>>;
  getGuestUserReactionsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryGetGuestUserReactionsCountArgs, 'filter'>>;
  getIdxActivity?: Resolver<ResolversTypes['IdxActivityPayload'], ParentType, ContextType, RequireFields<QueryGetIdxActivityArgs, 'idxId'>>;
  getIdxEmbeddedPortfolioFeed?: Resolver<ResolversTypes['IdxEmbeddedPortfolioFeedData'], ParentType, ContextType, RequireFields<QueryGetIdxEmbeddedPortfolioFeedArgs, 'input'>>;
  getIdxEmbeddedPropertyFeed?: Resolver<ResolversTypes['IdxEmbeddedPropertyFeedData'], ParentType, ContextType, RequireFields<QueryGetIdxEmbeddedPropertyFeedArgs, 'input'>>;
  getIdxEmbeddedSearchBarFeed?: Resolver<ResolversTypes['IdxEmbeddedSearchBarFeedData'], ParentType, ContextType, RequireFields<QueryGetIdxEmbeddedSearchBarFeedArgs, 'input'>>;
  getIdxFeedDetails?: Resolver<ResolversTypes['IdxFeed'], ParentType, ContextType, Partial<QueryGetIdxFeedDetailsArgs>>;
  getIdxFeedList?: Resolver<ResolversTypes['GetIdxFeedListPayload'], ParentType, ContextType, RequireFields<QueryGetIdxFeedListArgs, 'input'>>;
  getIdxPortfolioFeedProperties?: Resolver<ResolversTypes['IdxPortfolioFeedPropertiesData'], ParentType, ContextType, RequireFields<QueryGetIdxPortfolioFeedPropertiesArgs, 'input'>>;
  getIdxPropertyFiles?: Resolver<ResolversTypes['MediaFilesPayload'], ParentType, ContextType, RequireFields<QueryGetIdxPropertyFilesArgs, 'input'>>;
  getIdxSearchFeedProperties?: Resolver<ResolversTypes['IdxSearchFeedPropertiesData'], ParentType, ContextType, RequireFields<QueryGetIdxSearchFeedPropertiesArgs, 'input'>>;
  getIdxSettings?: Resolver<ResolversTypes['IdxSettings'], ParentType, ContextType>;
  getInternalOrganizationSaleTeam?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<QueryGetInternalOrganizationSaleTeamArgs, 'organizationId'>>;
  getIsFeaturedPortfolioSaved?: Resolver<Maybe<ResolversTypes['BrokerSavedFeaturedPortfolio']>, ParentType, ContextType, RequireFields<QueryGetIsFeaturedPortfolioSavedArgs, 'portfolioId'>>;
  getIsPropertyTracked?: Resolver<Maybe<ResolversTypes['BrokerTrackedProperty']>, ParentType, ContextType, RequireFields<QueryGetIsPropertyTrackedArgs, 'propertyId'>>;
  getMarketAreas?: Resolver<ResolversTypes['MarketAreasPayload'], ParentType, ContextType, Partial<QueryGetMarketAreasArgs>>;
  getMarketAreasForFilter?: Resolver<Array<ResolversTypes['MarketArea']>, ParentType, ContextType, RequireFields<QueryGetMarketAreasForFilterArgs, 'input'>>;
  getMediaFolderById?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<QueryGetMediaFolderByIdArgs, 'folderId'>>;
  getMediaFoldersAndFiles?: Resolver<ResolversTypes['MediaFilesAndFoldersPayload'], ParentType, ContextType, RequireFields<QueryGetMediaFoldersAndFilesArgs, 'filter'>>;
  getMonthlyApiUsageByAppId?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryGetMonthlyApiUsageByAppIdArgs, 'appId' | 'targetMonth'>>;
  getMyApiPluginUsers?: Resolver<ResolversTypes['ApiPluginUsersPayload'], ParentType, ContextType, Partial<QueryGetMyApiPluginUsersArgs>>;
  getNumberOfNewAlertItems?: Resolver<ResolversTypes['Float'], ParentType, ContextType, Partial<QueryGetNumberOfNewAlertItemsArgs>>;
  getNumberOfPortfolioPropertiesChangelogs?: Resolver<ResolversTypes['Float'], ParentType, ContextType, Partial<QueryGetNumberOfPortfolioPropertiesChangelogsArgs>>;
  getOrganizationById?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<QueryGetOrganizationByIdArgs, 'organizationId'>>;
  getOrganizationRoles?: Resolver<ResolversTypes['RolesPayload'], ParentType, ContextType>;
  getOrganizationUsers?: Resolver<ResolversTypes['OrganizationUsersPayload'], ParentType, ContextType, RequireFields<QueryGetOrganizationUsersArgs, 'filter'>>;
  getOrganizationUsersByOrganizationRole?: Resolver<ResolversTypes['OrganizationUsersPayload'], ParentType, ContextType, RequireFields<QueryGetOrganizationUsersByOrganizationRoleArgs, 'filter'>>;
  getOrganizations?: Resolver<ResolversTypes['OrganizationsPayload'], ParentType, ContextType, Partial<QueryGetOrganizationsArgs>>;
  getPlaceOptions?: Resolver<ResolversTypes['PlaceOptionsPayload'], ParentType, ContextType>;
  getPluginUserOwnApiQuotaStatus?: Resolver<ResolversTypes['ApiQuotaStatusPayload'], ParentType, ContextType>;
  getPluginUserOwnMonthlyApiUsage?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryGetPluginUserOwnMonthlyApiUsageArgs, 'targetMonth'>>;
  getPluginUserOwnTotalApiUsage?: Resolver<ResolversTypes['ApiMetricPayload'], ParentType, ContextType, Partial<QueryGetPluginUserOwnTotalApiUsageArgs>>;
  getPortfolioFirstPublicProperty?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType, RequireFields<QueryGetPortfolioFirstPublicPropertyArgs, 'brokerId' | 'portfolioFolderName'>>;
  getPortfolioFolderById?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<QueryGetPortfolioFolderByIdArgs, 'portfolioFolderId'>>;
  getPortfolioFolderItems?: Resolver<ResolversTypes['PortfoliosPayload'], ParentType, ContextType, RequireFields<QueryGetPortfolioFolderItemsArgs, 'portfolioFolderId'>>;
  getPortfolioFolderItemsBulk?: Resolver<Array<ResolversTypes['PortfolioFolderItemsGroup']>, ParentType, ContextType, RequireFields<QueryGetPortfolioFolderItemsBulkArgs, 'folderIds' | 'limitPerFolder'>>;
  getPortfolioFolderRoot?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType>;
  getPortfolioMediaKitItems?: Resolver<ResolversTypes['MediaKitPayload'], ParentType, ContextType, RequireFields<QueryGetPortfolioMediaKitItemsArgs, 'filter'>>;
  getPortfolioPassword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetPortfolioPasswordArgs, 'portfolioId'>>;
  getPortfolioPropertiesChangelogs?: Resolver<ResolversTypes['PropertyChangelogsPayload'], ParentType, ContextType, Partial<QueryGetPortfolioPropertiesChangelogsArgs>>;
  getPortfolioPropertiesToCompare?: Resolver<ResolversTypes['PropertiesPayload'], ParentType, ContextType, RequireFields<QueryGetPortfolioPropertiesToCompareArgs, 'portfolioFolderId' | 'portfolioIds'>>;
  getPortfolios?: Resolver<ResolversTypes['PortfoliosPayload'], ParentType, ContextType, Partial<QueryGetPortfoliosArgs>>;
  getPortfoliosByPublicFolder?: Resolver<ResolversTypes['PortfoliosPayload'], ParentType, ContextType, RequireFields<QueryGetPortfoliosByPublicFolderArgs, 'portfolioFolderId'>>;
  getPortfoliosTree?: Resolver<ResolversTypes['PortfoliosTreePayload'], ParentType, ContextType, Partial<QueryGetPortfoliosTreeArgs>>;
  getPortfoliosWithReactions?: Resolver<ResolversTypes['PortfoliosPayload'], ParentType, ContextType, Partial<QueryGetPortfoliosWithReactionsArgs>>;
  getPreviewInvoice?: Resolver<ResolversTypes['PreviewInvoicePayload'], ParentType, ContextType, RequireFields<QueryGetPreviewInvoiceArgs, 'input'>>;
  getProperties?: Resolver<ResolversTypes['PropertiesPayload'], ParentType, ContextType, Partial<QueryGetPropertiesArgs>>;
  getPropertiesByOrganizationRole?: Resolver<ResolversTypes['PropertiesPayload'], ParentType, ContextType, Partial<QueryGetPropertiesByOrganizationRoleArgs>>;
  getPropertyAmenitiesInPublicBrokerPortfolio?: Resolver<ResolversTypes['AmenitiesPayload'], ParentType, ContextType, RequireFields<QueryGetPropertyAmenitiesInPublicBrokerPortfolioArgs, 'brokerId' | 'propertyId'>>;
  getPropertyById?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<QueryGetPropertyByIdArgs, 'propertyId'>>;
  getPropertyChangelogs?: Resolver<ResolversTypes['PropertyChangelogsPayload'], ParentType, ContextType, RequireFields<QueryGetPropertyChangelogsArgs, 'filter'>>;
  getPropertyNotes?: Resolver<ResolversTypes['PropertyNotesPayload'], ParentType, ContextType, RequireFields<QueryGetPropertyNotesArgs, 'propertyId'>>;
  getPropertySlideshowMediaInPublicBrokerPortfolio?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType, RequireFields<QueryGetPropertySlideshowMediaInPublicBrokerPortfolioArgs, 'brokerId' | 'propertyId'>>;
  getPropertyUnitsInPublicBrokerPortfolio?: Resolver<ResolversTypes['UnitsPayload'], ParentType, ContextType, RequireFields<QueryGetPropertyUnitsInPublicBrokerPortfolioArgs, 'brokerId' | 'propertyId'>>;
  getPropertyUnitsSqftRange?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType, RequireFields<QueryGetPropertyUnitsSqftRangeArgs, 'propertyId'>>;
  getPropertyViewsByBroker?: Resolver<ResolversTypes['ViewHistoryPayload'], ParentType, ContextType, RequireFields<QueryGetPropertyViewsByBrokerArgs, 'filter'>>;
  getPropertyVisitActivities?: Resolver<ResolversTypes['PropertyVisitActivitiesPayload'], ParentType, ContextType, Partial<QueryGetPropertyVisitActivitiesArgs>>;
  getPublicBrokerPortfolio?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<QueryGetPublicBrokerPortfolioArgs, 'brokerId' | 'portfolioName'>>;
  getReactionsStatsForBroker?: Resolver<ResolversTypes['BrokerReactionsStats'], ParentType, ContextType, Partial<QueryGetReactionsStatsForBrokerArgs>>;
  getSaleTeamById?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<QueryGetSaleTeamByIdArgs, 'saleTeamId'>>;
  getSaleTeamUserNameByEmail?: Resolver<Maybe<ResolversTypes['SaleTeamUserNamePayload']>, ParentType, ContextType, RequireFields<QueryGetSaleTeamUserNameByEmailArgs, 'email'>>;
  getSaleTeamUsers?: Resolver<ResolversTypes['SaleTeamUsersPayload'], ParentType, ContextType, RequireFields<QueryGetSaleTeamUsersArgs, 'filter'>>;
  getSaleTeams?: Resolver<ResolversTypes['SaleTeamsPayload'], ParentType, ContextType, Partial<QueryGetSaleTeamsArgs>>;
  getSalesTeamRoles?: Resolver<ResolversTypes['RolesPayload'], ParentType, ContextType>;
  getSavedFeaturedPortfolios?: Resolver<ResolversTypes['BrokerSavedFeaturedPortfoliosPayload'], ParentType, ContextType, Partial<QueryGetSavedFeaturedPortfoliosArgs>>;
  getSavedFeaturedPortfoliosCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType, Partial<QueryGetSavedFeaturedPortfoliosCountArgs>>;
  getSingleBrokerById?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<QueryGetSingleBrokerByIdArgs, 'brokerId'>>;
  getSlideshowMediaByProperty?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType, RequireFields<QueryGetSlideshowMediaByPropertyArgs, 'propertyId'>>;
  getSubscriptionEmailSettings?: Resolver<ResolversTypes['SubscriptionEmailSettings'], ParentType, ContextType>;
  getSubscriptionProducts?: Resolver<Array<ResolversTypes['SubscriptionProduct']>, ParentType, ContextType, Partial<QueryGetSubscriptionProductsArgs>>;
  getSystemActionCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryGetSystemActionCountArgs, 'filter'>>;
  getTopLevelFoldersInProperty?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType, RequireFields<QueryGetTopLevelFoldersInPropertyArgs, 'propertyId'>>;
  getTotalApiUsage?: Resolver<ResolversTypes['ApiMetricPayload'], ParentType, ContextType, Partial<QueryGetTotalApiUsageArgs>>;
  getTotalApiUsageByAppId?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryGetTotalApiUsageByAppIdArgs, 'appId'>>;
  getTrackedProperties?: Resolver<ResolversTypes['BrokerTrackedPropertiesPayload'], ParentType, ContextType, Partial<QueryGetTrackedPropertiesArgs>>;
  getTrackedPropertiesByOrganizationCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType, Partial<QueryGetTrackedPropertiesByOrganizationCountArgs>>;
  getTrackedPropertyIds?: Resolver<Array<ResolversTypes['TrackedPropertyId']>, ParentType, ContextType>;
  getTrendingList?: Resolver<Maybe<ResolversTypes['TrendingList']>, ParentType, ContextType, RequireFields<QueryGetTrendingListArgs, 'type'>>;
  getUSStateByName?: Resolver<ResolversTypes['State'], ParentType, ContextType, RequireFields<QueryGetUsStateByNameArgs, 'stateName'>>;
  getUSStates?: Resolver<Array<ResolversTypes['State']>, ParentType, ContextType, Partial<QueryGetUsStatesArgs>>;
  getUniqPropertiesAmenities?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType, Partial<QueryGetUniqPropertiesAmenitiesArgs>>;
  getUniqPropertiesMarkets?: Resolver<Array<ResolversTypes['UnitPropertyMarket']>, ParentType, ContextType>;
  getUnits?: Resolver<ResolversTypes['UnitsPayload'], ParentType, ContextType, Partial<QueryGetUnitsArgs>>;
  getUnitsInPublicProperty?: Resolver<ResolversTypes['UnitsPayload'], ParentType, ContextType, RequireFields<QueryGetUnitsInPublicPropertyArgs, 'propertyId'>>;
  getUserByApiCredentialsId?: Resolver<ResolversTypes['ApiPluginUser'], ParentType, ContextType, Partial<QueryGetUserByApiCredentialsIdArgs>>;
  getUserPublicPortfolioFolders?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  globalSearch?: Resolver<ResolversTypes['SearchIndexPayload'], ParentType, ContextType, RequireFields<QueryGlobalSearchArgs, 'limit' | 'query'>>;
  myPendingApiAccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  recommendedProperties?: Resolver<Array<ResolversTypes['Property']>, ParentType, ContextType, Partial<QueryRecommendedPropertiesArgs>>;
  similarProperties?: Resolver<Array<ResolversTypes['Property']>, ParentType, ContextType, RequireFields<QuerySimilarPropertiesArgs, 'propertyId'>>;
  simulateError?: Resolver<ResolversTypes['Broker'], ParentType, ContextType>;
  validateApiInvitation?: Resolver<ResolversTypes['ApiInvitationValidation'], ParentType, ContextType, RequireFields<QueryValidateApiInvitationArgs, 'token'>>;
}>;

export type RestoreApiAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RestoreApiAccountResult'] = ResolversParentTypes['RestoreApiAccountResult']> = ResolversObject<{
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  restoredPluginUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Role'] = ResolversParentTypes['Role']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RolesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RolesPayload'] = ResolversParentTypes['RolesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Role']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaleTeam'] = ResolversParentTypes['SaleTeam']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countOfUsers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  logoFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['SalesTeamPhone']>, ParentType, ContextType>;
  relatedToSaleTeamOrganizationsNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workingHours?: Resolver<Maybe<ResolversTypes['WorkingHours']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleTeamUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaleTeamUser'] = ResolversParentTypes['SaleTeamUser']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  assignedPropertiesIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  saleTeamId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  saleTeamRoleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleTeamUserNamePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaleTeamUserNamePayload'] = ResolversParentTypes['SaleTeamUserNamePayload']> = ResolversObject<{
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleTeamUsersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaleTeamUsersPayload'] = ResolversParentTypes['SaleTeamUsersPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['SaleTeamUser']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleTeamsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaleTeamsPayload'] = ResolversParentTypes['SaleTeamsPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['SaleTeam']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SalesTeamPhoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesTeamPhone'] = ResolversParentTypes['SalesTeamPhone']> = ResolversObject<{
  dialCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchIndexResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchIndex'] = ResolversParentTypes['SearchIndex']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display?: Resolver<ResolversTypes['SearchIndexDisplay'], ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['SearchIndexMeta'], ParentType, ContextType>;
  refId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refs?: Resolver<Maybe<ResolversTypes['SearchIndexRefs']>, ParentType, ContextType>;
  search?: Resolver<ResolversTypes['SearchIndexSearch'], ParentType, ContextType>;
  subtype?: Resolver<ResolversTypes['SearchIndexSubtypeEnum'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SearchIndexTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchIndexDisplayResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchIndexDisplay'] = ResolversParentTypes['SearchIndexDisplay']> = ResolversObject<{
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchIndexMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchIndexMeta'] = ResolversParentTypes['SearchIndexMeta']> = ResolversObject<{
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  popularityScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchIndexPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchIndexPayload'] = ResolversParentTypes['SearchIndexPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['SearchIndex']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchIndexRefsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchIndexRefs'] = ResolversParentTypes['SearchIndexRefs']> = ResolversObject<{
  locationId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  marketAreaId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  stateId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchIndexSearchResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchIndexSearch'] = ResolversParentTypes['SearchIndexSearch']> = ResolversObject<{
  primaryTokens?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryTokens?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SimilarityBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimilarityBreakdown'] = ResolversParentTypes['SimilarityBreakdown']> = ResolversObject<{
  amenities?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bedrooms?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buildingTypes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  marketArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  priceRange?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  projectStatus?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SimilarityEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimilarityEntry'] = ResolversParentTypes['SimilarityEntry']> = ResolversObject<{
  breakdown?: Resolver<Maybe<ResolversTypes['SimilarityBreakdown']>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StateResolvers<ContextType = any, ParentType extends ResolversParentTypes['State'] = ResolversParentTypes['State']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  withMarketArea?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StripeAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['StripeAccount'] = ResolversParentTypes['StripeAccount']> = ResolversObject<{
  paymentMethods?: Resolver<Maybe<Array<ResolversTypes['StripeAccountPaymentMethod']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StripeAccountPaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['StripeAccountPaymentMethod'] = ResolversParentTypes['StripeAccountPaymentMethod']> = ResolversObject<{
  cardBrand?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cardNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiredMonth?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  expiredYear?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentMethodId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StripeAccountTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StripeAccountTransaction'] = ResolversParentTypes['StripeAccountTransaction']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dateOfCharge?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  invoiceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invoiceName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invoicePdfUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StripeAccountTransactionsFlatPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['StripeAccountTransactionsFlatPayload'] = ResolversParentTypes['StripeAccountTransactionsFlatPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['StripeAccountTransaction']>, ParentType, ContextType>;
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = ResolversObject<{
  observeBrokerAlertItemChanges?: SubscriptionResolver<ResolversTypes['ObserveBrokerAlertItemsPayload'], "observeBrokerAlertItemChanges", ParentType, ContextType>;
  observeCurrentAccountChanges?: SubscriptionResolver<ResolversTypes['ObserveAccountPayload'], "observeCurrentAccountChanges", ParentType, ContextType>;
  observeCurrentAccountProductSubscription?: SubscriptionResolver<ResolversTypes['ProductsSubscriptionsObserveSubscriptionPayload'], "observeCurrentAccountProductSubscription", ParentType, ContextType>;
  observeMediaChanges?: SubscriptionResolver<ResolversTypes['MediaObserveSubscriptionPayload'], "observeMediaChanges", ParentType, ContextType, RequireFields<SubscriptionObserveMediaChangesArgs, 'filter'>>;
  observePortfoliosChanges?: SubscriptionResolver<ResolversTypes['ObserveBrokerPortfolioPayload'], "observePortfoliosChanges", ParentType, ContextType>;
  observeProgressTrackingByType?: SubscriptionResolver<ResolversTypes['ObserveProgressTrackingPayload'], "observeProgressTrackingByType", ParentType, ContextType, RequireFields<SubscriptionObserveProgressTrackingByTypeArgs, 'type'>>;
  observePropertiesChanges?: SubscriptionResolver<ResolversTypes['ObservePropertyPayload'], "observePropertiesChanges", ParentType, ContextType>;
  observePropertyNotesChanges?: SubscriptionResolver<ResolversTypes['ObservePropertyNotesPayload'], "observePropertyNotesChanges", ParentType, ContextType, RequireFields<SubscriptionObservePropertyNotesChangesArgs, 'propertyId'>>;
  observeSubscriptionProductsChanges?: SubscriptionResolver<ResolversTypes['SubscriptionProductsObserveSubscriptionPayload'], "observeSubscriptionProductsChanges", ParentType, ContextType>;
}>;

export type SubscriptionEmailSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionEmailSettings'] = ResolversParentTypes['SubscriptionEmailSettings']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pausedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pausedUntil?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  planChangeEmailsPaused?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionProduct'] = ResolversParentTypes['SubscriptionProduct']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coupons?: Resolver<Maybe<Array<ResolversTypes['SubscriptionProductCoupon']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  features?: Resolver<Array<ResolversTypes['SubscriptionProductFeature']>, ParentType, ContextType>;
  legacy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  recurringType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stripePriceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stripeProductId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trial?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionProductCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionProductCoupon'] = ResolversParentTypes['SubscriptionProductCoupon']> = ResolversObject<{
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  amountOff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  duration_in_months?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  limitation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  percentOff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  stripeCouponId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionProductFeatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionProductFeature'] = ResolversParentTypes['SubscriptionProductFeature']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  feature?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionProductsObserveSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionProductsObserveSubscriptionPayload'] = ResolversParentTypes['SubscriptionProductsObserveSubscriptionPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['SubscriptionProduct'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionScheduleResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionSchedule'] = ResolversParentTypes['SubscriptionSchedule']> = ResolversObject<{
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  nextPhasePriceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nextPhaseStart?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  scheduleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SystemActionLogsMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SystemActionLogsMetadata'] = ResolversParentTypes['SystemActionLogsMetadata']> = ResolversObject<{
  mediaId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  portfolioId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TempAuthResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['TempAuthResult'] = ResolversParentTypes['TempAuthResult']> = ResolversObject<{
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  tempToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TokenResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TokenResponse'] = ResolversParentTypes['TokenResponse']> = ResolversObject<{
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TokensModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['TokensModel'] = ResolversParentTypes['TokensModel']> = ResolversObject<{
  accessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refreshToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refreshTokenExpiry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrackedPropertyIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrackedPropertyId'] = ResolversParentTypes['TrackedPropertyId']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrendingListResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrendingList'] = ResolversParentTypes['TrendingList']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['TrendingListItem']>, ParentType, ContextType>;
  periodEnd?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  periodStart?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrendingListItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrendingListItem'] = ResolversParentTypes['TrendingListItem']> = ResolversObject<{
  portfolio?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  portfolioId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['Property']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UnitResolvers<ContextType = any, ParentType extends ResolversParentTypes['Unit'] = ResolversParentTypes['Unit']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  averageBathroomsNumber?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageBedroomsNumber?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageExteriorSqft?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageInteriorSqft?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageTotalSqft?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customRooms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  floorPlanFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  floorPlanFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highestPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  inventoryType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startingPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UnitPropertyMarketResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnitPropertyMarket'] = ResolversParentTypes['UnitPropertyMarket']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UnitsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnitsPayload'] = ResolversParentTypes['UnitsPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Unit']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = ResolversObject<{
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UsersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPayload'] = ResolversParentTypes['UsersPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ValidateCouponPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateCouponPayload'] = ResolversParentTypes['ValidateCouponPayload']> = ResolversObject<{
  coupon?: Resolver<Maybe<ResolversTypes['SubscriptionProductCoupon']>, ParentType, ContextType>;
  invalidMessageType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ViewHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewHistory'] = ResolversParentTypes['ViewHistory']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  historyType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastViewAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  portfolio?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  portfolioId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['Property']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewedByAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewedByVisitorHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visitorType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ViewHistoryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewHistoryPayload'] = ResolversParentTypes['ViewHistoryPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['ViewHistory']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VirtualTourLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['VirtualTourLink'] = ResolversParentTypes['VirtualTourLink']> = ResolversObject<{
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WorkingHoursResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkingHours'] = ResolversParentTypes['WorkingHours']> = ResolversObject<{
  friday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  monday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  saturday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  sunday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  thursday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  tuesday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  wednesday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WorkingRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkingRange'] = ResolversParentTypes['WorkingRange']> = ResolversObject<{
  from?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type XmlDownloadResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['XmlDownloadResponse'] = ResolversParentTypes['XmlDownloadResponse']> = ResolversObject<{
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  AbortUploadEvent?: AbortUploadEventResolvers<ContextType>;
  Account?: AccountResolvers<ContextType>;
  Address?: AddressResolvers<ContextType>;
  AmenitiesPayload?: AmenitiesPayloadResolvers<ContextType>;
  Amenity?: AmenityResolvers<ContextType>;
  AmenityName?: AmenityNameResolvers<ContextType>;
  ApiBrokerInfo?: ApiBrokerInfoResolvers<ContextType>;
  ApiCredentialSafeDTO?: ApiCredentialSafeDtoResolvers<ContextType>;
  ApiCredentialsPluginUserResponse?: ApiCredentialsPluginUserResponseResolvers<ContextType>;
  ApiCredentialsUserResponse?: ApiCredentialsUserResponseResolvers<ContextType>;
  ApiInvitationSafeDTO?: ApiInvitationSafeDtoResolvers<ContextType>;
  ApiInvitationValidation?: ApiInvitationValidationResolvers<ContextType>;
  ApiInvitationsPayload?: ApiInvitationsPayloadResolvers<ContextType>;
  ApiMetric?: ApiMetricResolvers<ContextType>;
  ApiMetricPayload?: ApiMetricPayloadResolvers<ContextType>;
  ApiPluginUser?: ApiPluginUserResolvers<ContextType>;
  ApiPluginUsersPayload?: ApiPluginUsersPayloadResolvers<ContextType>;
  ApiQuotaStatusPayload?: ApiQuotaStatusPayloadResolvers<ContextType>;
  ApiUser?: ApiUserResolvers<ContextType>;
  ApiUsersPayload?: ApiUsersPayloadResolvers<ContextType>;
  AuthResult?: AuthResultResolvers<ContextType>;
  BasicInfoResponse?: BasicInfoResponseResolvers<ContextType>;
  Branding?: BrandingResolvers<ContextType>;
  Broker?: BrokerResolvers<ContextType>;
  BrokerActivity?: BrokerActivityResolvers<ContextType>;
  BrokerAlertConfig?: BrokerAlertConfigResolvers<ContextType>;
  BrokerAlertConfigConstructionDateRangeFilter?: BrokerAlertConfigConstructionDateRangeFilterResolvers<ContextType>;
  BrokerAlertConfigFilter?: BrokerAlertConfigFilterResolvers<ContextType>;
  BrokerAlertConfigLocationFilter?: BrokerAlertConfigLocationFilterResolvers<ContextType>;
  BrokerAlertConfigPayload?: BrokerAlertConfigPayloadResolvers<ContextType>;
  BrokerAlertItem?: BrokerAlertItemResolvers<ContextType>;
  BrokerAlertItemPayload?: BrokerAlertItemPayloadResolvers<ContextType>;
  BrokerLicense?: BrokerLicenseResolvers<ContextType>;
  BrokerReactionsStats?: BrokerReactionsStatsResolvers<ContextType>;
  BrokerSavedFeaturedPortfolio?: BrokerSavedFeaturedPortfolioResolvers<ContextType>;
  BrokerSavedFeaturedPortfoliosPayload?: BrokerSavedFeaturedPortfoliosPayloadResolvers<ContextType>;
  BrokerTrackedPropertiesPayload?: BrokerTrackedPropertiesPayloadResolvers<ContextType>;
  BrokerTrackedProperty?: BrokerTrackedPropertyResolvers<ContextType>;
  BrokersPayload?: BrokersPayloadResolvers<ContextType>;
  ChangelogDocument?: ChangelogDocumentResolvers<ContextType>;
  CheckoutSessionDetails?: CheckoutSessionDetailsResolvers<ContextType>;
  CmsSettings?: CmsSettingsResolvers<ContextType>;
  Comparison?: ComparisonResolvers<ContextType>;
  ContactPhone?: ContactPhoneResolvers<ContextType>;
  ContentActivity?: ContentActivityResolvers<ContextType>;
  ContentActivityChangeType?: ContentActivityChangeTypeResolvers<ContextType>;
  ContentActivityContributor?: ContentActivityContributorResolvers<ContextType>;
  ContentActivityLog?: ContentActivityLogResolvers<ContextType>;
  ContentActivityLogEntry?: ContentActivityLogEntryResolvers<ContextType>;
  ContentActivityValueChange?: ContentActivityValueChangeResolvers<ContextType>;
  CopyFeaturedPortfolioToBrokerPortfolioResult?: CopyFeaturedPortfolioToBrokerPortfolioResultResolvers<ContextType>;
  CreateCheckoutSessionPayload?: CreateCheckoutSessionPayloadResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DeleteApiAccountResult?: DeleteApiAccountResultResolvers<ContextType>;
  Developer?: DeveloperResolvers<ContextType>;
  DeveloperAsSaleUser?: DeveloperAsSaleUserResolvers<ContextType>;
  FeaturedPortfolio?: FeaturedPortfolioResolvers<ContextType>;
  FeaturedPortfolioPropertiesPayload?: FeaturedPortfolioPropertiesPayloadResolvers<ContextType>;
  FeaturedPortfolioSummary?: FeaturedPortfolioSummaryResolvers<ContextType>;
  FeaturedPortfoliosPayload?: FeaturedPortfoliosPayloadResolvers<ContextType>;
  FeaturedPropertiesPayload?: FeaturedPropertiesPayloadResolvers<ContextType>;
  FeaturedProperty?: FeaturedPropertyResolvers<ContextType>;
  File?: FileResolvers<ContextType>;
  FolderPathModel?: FolderPathModelResolvers<ContextType>;
  GenerateQrCodeResult?: GenerateQrCodeResultResolvers<ContextType>;
  GeoLocationJSON?: GeoLocationJsonResolvers<ContextType>;
  GetFileDownloadsStatisticItem?: GetFileDownloadsStatisticItemResolvers<ContextType>;
  GetFileDownloadsStatisticPayload?: GetFileDownloadsStatisticPayloadResolvers<ContextType>;
  GetIdxFeedListPayload?: GetIdxFeedListPayloadResolvers<ContextType>;
  GuestUser?: GuestUserResolvers<ContextType>;
  GuestUserPayload?: GuestUserPayloadResolvers<ContextType>;
  IdxActivity?: IdxActivityResolvers<ContextType>;
  IdxActivityCollection?: IdxActivityCollectionResolvers<ContextType>;
  IdxActivityPayload?: IdxActivityPayloadResolvers<ContextType>;
  IdxEmbeddedPortfolioFeedData?: IdxEmbeddedPortfolioFeedDataResolvers<ContextType>;
  IdxEmbeddedPropertyFeedData?: IdxEmbeddedPropertyFeedDataResolvers<ContextType>;
  IdxEmbeddedSearchBarFeedData?: IdxEmbeddedSearchBarFeedDataResolvers<ContextType>;
  IdxFeed?: IdxFeedResolvers<ContextType>;
  IdxPortfolioFeedPropertiesData?: IdxPortfolioFeedPropertiesDataResolvers<ContextType>;
  IdxSearchFeedPropertiesData?: IdxSearchFeedPropertiesDataResolvers<ContextType>;
  IdxSettings?: IdxSettingsResolvers<ContextType>;
  InvoiceCoupon?: InvoiceCouponResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  LocalTimeHours?: LocalTimeHoursResolvers<ContextType>;
  LocalTimeRange?: LocalTimeRangeResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  MarketArea?: MarketAreaResolvers<ContextType>;
  MarketAreaCount?: MarketAreaCountResolvers<ContextType>;
  MarketAreaPlaceOption?: MarketAreaPlaceOptionResolvers<ContextType>;
  MarketAreasPayload?: MarketAreasPayloadResolvers<ContextType>;
  Media?: MediaResolvers<ContextType>;
  MediaFilesAndFoldersPayload?: MediaFilesAndFoldersPayloadResolvers<ContextType>;
  MediaFilesPayload?: MediaFilesPayloadResolvers<ContextType>;
  MediaKitPayload?: MediaKitPayloadResolvers<ContextType>;
  MediaObserveSubscriptionPayload?: MediaObserveSubscriptionPayloadResolvers<ContextType>;
  MetricDataPoint?: MetricDataPointResolvers<ContextType>;
  MfaTempTokenModel?: MfaTempTokenModelResolvers<ContextType>;
  MinMax?: MinMaxResolvers<ContextType>;
  MinMaxRange?: MinMaxRangeResolvers<ContextType>;
  MinMaxRangePayload?: MinMaxRangePayloadResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NewPortfolioItemActivitiesPayload?: NewPortfolioItemActivitiesPayloadResolvers<ContextType>;
  NewPortfolioItemActivity?: NewPortfolioItemActivityResolvers<ContextType>;
  NewPortfolioItemActivityDoc?: NewPortfolioItemActivityDocResolvers<ContextType>;
  ObjectId?: GraphQLScalarType;
  ObserveAccountPayload?: ObserveAccountPayloadResolvers<ContextType>;
  ObserveBrokerAlertItemsPayload?: ObserveBrokerAlertItemsPayloadResolvers<ContextType>;
  ObserveBrokerPortfolioPayload?: ObserveBrokerPortfolioPayloadResolvers<ContextType>;
  ObserveProgressTrackingPayload?: ObserveProgressTrackingPayloadResolvers<ContextType>;
  ObservePropertyNotesPayload?: ObservePropertyNotesPayloadResolvers<ContextType>;
  ObservePropertyPayload?: ObservePropertyPayloadResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  OrganizationUser?: OrganizationUserResolvers<ContextType>;
  OrganizationUsersPayload?: OrganizationUsersPayloadResolvers<ContextType>;
  OrganizationsPayload?: OrganizationsPayloadResolvers<ContextType>;
  Phone?: PhoneResolvers<ContextType>;
  Place?: PlaceResolvers<ContextType>;
  PlaceOption?: PlaceOptionResolvers<ContextType>;
  PlaceOptionsPayload?: PlaceOptionsPayloadResolvers<ContextType>;
  Portfolio?: PortfolioResolvers<ContextType>;
  PortfolioFolderItemsGroup?: PortfolioFolderItemsGroupResolvers<ContextType>;
  PortfolioLocations?: PortfolioLocationsResolvers<ContextType>;
  PortfolioMediaKit?: PortfolioMediaKitResolvers<ContextType>;
  PortfolioReaction?: PortfolioReactionResolvers<ContextType>;
  PortfolioTree?: PortfolioTreeResolvers<ContextType>;
  PortfoliosPayload?: PortfoliosPayloadResolvers<ContextType>;
  PortfoliosTreePayload?: PortfoliosTreePayloadResolvers<ContextType>;
  PreferredPropertySettings?: PreferredPropertySettingsResolvers<ContextType>;
  PreviewInvoiceItem?: PreviewInvoiceItemResolvers<ContextType>;
  PreviewInvoicePayload?: PreviewInvoicePayloadResolvers<ContextType>;
  ProductSubscription?: ProductSubscriptionResolvers<ContextType>;
  ProductSubscriptionPayload?: ProductSubscriptionPayloadResolvers<ContextType>;
  ProductSubscriptionPayment?: ProductSubscriptionPaymentResolvers<ContextType>;
  ProductSubscriptionsPayload?: ProductSubscriptionsPayloadResolvers<ContextType>;
  ProductsSubscriptionsObserveSubscriptionPayload?: ProductsSubscriptionsObserveSubscriptionPayloadResolvers<ContextType>;
  Profile?: ProfileResolvers<ContextType>;
  ProgressTrackingModel?: ProgressTrackingModelResolvers<ContextType>;
  PropertiesPayload?: PropertiesPayloadResolvers<ContextType>;
  Property?: PropertyResolvers<ContextType>;
  PropertyAboutChangelog?: PropertyAboutChangelogResolvers<ContextType>;
  PropertyAdditionalInformationChangelog?: PropertyAdditionalInformationChangelogResolvers<ContextType>;
  PropertyChangelog?: PropertyChangelogResolvers<ContextType>;
  PropertyChangelogsPayload?: PropertyChangelogsPayloadResolvers<ContextType>;
  PropertyClick?: PropertyClickResolvers<ContextType>;
  PropertyCmsStatusChangelog?: PropertyCmsStatusChangelogResolvers<ContextType>;
  PropertyDataReviewedChangelog?: PropertyDataReviewedChangelogResolvers<ContextType>;
  PropertyDetail?: PropertyDetailResolvers<ContextType>;
  PropertyDeveloperOrganizationChangelog?: PropertyDeveloperOrganizationChangelogResolvers<ContextType>;
  PropertyFeaturesAndAmenitiesChangelog?: PropertyFeaturesAndAmenitiesChangelogResolvers<ContextType>;
  PropertyHighlightsChangelog?: PropertyHighlightsChangelogResolvers<ContextType>;
  PropertyInventoryUnitAddedChangelog?: PropertyInventoryUnitAddedChangelogResolvers<ContextType>;
  PropertyInventoryUnitRemovedChangelog?: PropertyInventoryUnitRemovedChangelogResolvers<ContextType>;
  PropertyInventoryUnitUpdatedChangelog?: PropertyInventoryUnitUpdatedChangelogResolvers<ContextType>;
  PropertyLocationChangelog?: PropertyLocationChangelogResolvers<ContextType>;
  PropertyMediaFilesMovedChangelog?: PropertyMediaFilesMovedChangelogResolvers<ContextType>;
  PropertyMediaRemovedChangelog?: PropertyMediaRemovedChangelogResolvers<ContextType>;
  PropertyMediaRenamedChangelog?: PropertyMediaRenamedChangelogResolvers<ContextType>;
  PropertyMediaUploadedChangelog?: PropertyMediaUploadedChangelogResolvers<ContextType>;
  PropertyNameChangelog?: PropertyNameChangelogResolvers<ContextType>;
  PropertyNote?: PropertyNoteResolvers<ContextType>;
  PropertyNotesPayload?: PropertyNotesPayloadResolvers<ContextType>;
  PropertyOrganizationSalesTeamsChangelog?: PropertyOrganizationSalesTeamsChangelogResolvers<ContextType>;
  PropertyPriceChangelog?: PropertyPriceChangelogResolvers<ContextType>;
  PropertySaleTeam?: PropertySaleTeamResolvers<ContextType>;
  PropertySummary?: PropertySummaryResolvers<ContextType>;
  PropertyVirtualToursChangelog?: PropertyVirtualToursChangelogResolvers<ContextType>;
  PropertyVisibilityChangelog?: PropertyVisibilityChangelogResolvers<ContextType>;
  PropertyVisitActivitiesPayload?: PropertyVisitActivitiesPayloadResolvers<ContextType>;
  PropertyVisitActivity?: PropertyVisitActivityResolvers<ContextType>;
  PropertyVisitActivityDoc?: PropertyVisitActivityDocResolvers<ContextType>;
  PropertyWebsiteChangelog?: PropertyWebsiteChangelogResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RestoreApiAccountResult?: RestoreApiAccountResultResolvers<ContextType>;
  Role?: RoleResolvers<ContextType>;
  RolesPayload?: RolesPayloadResolvers<ContextType>;
  SaleTeam?: SaleTeamResolvers<ContextType>;
  SaleTeamUser?: SaleTeamUserResolvers<ContextType>;
  SaleTeamUserNamePayload?: SaleTeamUserNamePayloadResolvers<ContextType>;
  SaleTeamUsersPayload?: SaleTeamUsersPayloadResolvers<ContextType>;
  SaleTeamsPayload?: SaleTeamsPayloadResolvers<ContextType>;
  SalesTeamPhone?: SalesTeamPhoneResolvers<ContextType>;
  SearchIndex?: SearchIndexResolvers<ContextType>;
  SearchIndexDisplay?: SearchIndexDisplayResolvers<ContextType>;
  SearchIndexMeta?: SearchIndexMetaResolvers<ContextType>;
  SearchIndexPayload?: SearchIndexPayloadResolvers<ContextType>;
  SearchIndexRefs?: SearchIndexRefsResolvers<ContextType>;
  SearchIndexSearch?: SearchIndexSearchResolvers<ContextType>;
  SimilarityBreakdown?: SimilarityBreakdownResolvers<ContextType>;
  SimilarityEntry?: SimilarityEntryResolvers<ContextType>;
  State?: StateResolvers<ContextType>;
  StripeAccount?: StripeAccountResolvers<ContextType>;
  StripeAccountPaymentMethod?: StripeAccountPaymentMethodResolvers<ContextType>;
  StripeAccountTransaction?: StripeAccountTransactionResolvers<ContextType>;
  StripeAccountTransactionsFlatPayload?: StripeAccountTransactionsFlatPayloadResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SubscriptionEmailSettings?: SubscriptionEmailSettingsResolvers<ContextType>;
  SubscriptionProduct?: SubscriptionProductResolvers<ContextType>;
  SubscriptionProductCoupon?: SubscriptionProductCouponResolvers<ContextType>;
  SubscriptionProductFeature?: SubscriptionProductFeatureResolvers<ContextType>;
  SubscriptionProductsObserveSubscriptionPayload?: SubscriptionProductsObserveSubscriptionPayloadResolvers<ContextType>;
  SubscriptionSchedule?: SubscriptionScheduleResolvers<ContextType>;
  SystemActionLogsMetadata?: SystemActionLogsMetadataResolvers<ContextType>;
  TempAuthResult?: TempAuthResultResolvers<ContextType>;
  TokenResponse?: TokenResponseResolvers<ContextType>;
  TokensModel?: TokensModelResolvers<ContextType>;
  TrackedPropertyId?: TrackedPropertyIdResolvers<ContextType>;
  TrendingList?: TrendingListResolvers<ContextType>;
  TrendingListItem?: TrendingListItemResolvers<ContextType>;
  Unit?: UnitResolvers<ContextType>;
  UnitPropertyMarket?: UnitPropertyMarketResolvers<ContextType>;
  UnitsPayload?: UnitsPayloadResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  UsersPayload?: UsersPayloadResolvers<ContextType>;
  ValidateCouponPayload?: ValidateCouponPayloadResolvers<ContextType>;
  ViewHistory?: ViewHistoryResolvers<ContextType>;
  ViewHistoryPayload?: ViewHistoryPayloadResolvers<ContextType>;
  VirtualTourLink?: VirtualTourLinkResolvers<ContextType>;
  WorkingHours?: WorkingHoursResolvers<ContextType>;
  WorkingRange?: WorkingRangeResolvers<ContextType>;
  XmlDownloadResponse?: XmlDownloadResponseResolvers<ContextType>;
}>;


export type TokensModelFragment = { __typename?: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null };

export type AccountFragment = { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, role: { __typename?: 'Role', _id: string, type: string } };

export type AuthorizationMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type AuthorizationMutation = { __typename?: 'Mutation', authorization: { __typename?: 'MfaTempTokenModel' } | { __typename?: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type RefreshTokensMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokensMutation = { __typename?: 'Mutation', refreshTokens: { __typename?: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type ResetPasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type UpdatePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean };

export type UpdateEmailMutationVariables = Exact<{
  password: Scalars['String'];
  newEmail: Scalars['String'];
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateEmail: { __typename?: 'TokensModel', accessToken: string, refreshTokenExpiry?: string | null, refreshToken: string } };

export type TemporaryAuthenticationMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type TemporaryAuthenticationMutation = { __typename?: 'Mutation', temporaryAuthentication: { __typename?: 'TempAuthResult', tempToken: string, account: { __typename?: 'Account', _id: string, email: string, mfaEnabled?: boolean | null } } };

export type GetAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountQuery = { __typename?: 'Query', getAccount: { __typename?: 'Account', _id: string, email: string } };

export type GetFullAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFullAccountQuery = { __typename?: 'Query', getAccount: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }, role: { __typename?: 'Role', _id: string, type: string } } };

export type AmenityFragment = { __typename?: 'Amenity', _id: string, createdAt: any, name: string, imageUrl?: string | null, isPrimary: boolean, primaryAmenityId?: any | null, propertyId?: any | null, imageFile?: { __typename?: 'File', _id: string, publicUrl: string } | null };

export type CreateAmenityMutationVariables = Exact<{
  input: CreateAmenityInput;
}>;


export type CreateAmenityMutation = { __typename?: 'Mutation', createAmenity: { __typename?: 'Amenity', _id: string, createdAt: any, name: string, imageUrl?: string | null, isPrimary: boolean, primaryAmenityId?: any | null, propertyId?: any | null, imageFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } };

export type EditAmenityMutationVariables = Exact<{
  input: EditAmenityInput;
}>;


export type EditAmenityMutation = { __typename?: 'Mutation', editAmenity: { __typename?: 'Amenity', _id: string, createdAt: any, name: string, imageUrl?: string | null, isPrimary: boolean, primaryAmenityId?: any | null, propertyId?: any | null, imageFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } };

export type DeleteAmenityMutationVariables = Exact<{
  amenityId: Scalars['ObjectId'];
}>;


export type DeleteAmenityMutation = { __typename?: 'Mutation', deleteAmenity: Array<{ __typename?: 'Amenity', _id: string }> };

export type GetAmenitiesQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetAmenitiesFilterInput>;
}>;


export type GetAmenitiesQuery = { __typename?: 'Query', getAmenities: { __typename?: 'AmenitiesPayload', totalCount: number, collection: Array<{ __typename?: 'Amenity', _id: string, createdAt: any, name: string, imageUrl?: string | null, isPrimary: boolean, primaryAmenityId?: any | null, propertyId?: any | null, imageFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }> } };

export type GetAmenitiesForManageQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter: GetAmenitiesForManageFilterInput;
}>;


export type GetAmenitiesForManageQuery = { __typename?: 'Query', getAmenitiesForManage: { __typename?: 'AmenitiesPayload', totalCount: number, collection: Array<{ __typename?: 'Amenity', _id: string, createdAt: any, name: string, imageUrl?: string | null, isPrimary: boolean, primaryAmenityId?: any | null, propertyId?: any | null, imageFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }> } };

export type ApiPluginUserForListFragment = { __typename?: 'ApiPluginUser', monthlyApiAccess?: number | null, account: { __typename?: 'Account', _id: string, email: string, status: string, excludeFromReports?: boolean | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null }, broker?: { __typename?: 'ApiBrokerInfo', _id?: string | null } | null, apiCredentials?: { __typename?: 'ApiCredentialsPluginUserResponse', _id: string, appId?: string | null, companyName?: string | null, associatedCompany?: string | null, isActive?: boolean | null, partnerDisabled?: boolean | null, adminDisabled?: boolean | null } | null };

export type GetApiPluginUsersQueryVariables = Exact<{
  filter?: InputMaybe<GetApiUsersFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetApiPluginUsersQuery = { __typename?: 'Query', getApiPluginUsers: { __typename?: 'ApiPluginUsersPayload', totalCount: number, collection: Array<{ __typename?: 'ApiPluginUser', monthlyApiAccess?: number | null, account: { __typename?: 'Account', _id: string, email: string, status: string, excludeFromReports?: boolean | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null }, broker?: { __typename?: 'ApiBrokerInfo', _id?: string | null } | null, apiCredentials?: { __typename?: 'ApiCredentialsPluginUserResponse', _id: string, appId?: string | null, companyName?: string | null, associatedCompany?: string | null, isActive?: boolean | null, partnerDisabled?: boolean | null, adminDisabled?: boolean | null } | null }> } };

export type GetApiCredentialsByIdQueryVariables = Exact<{
  apiCredentialsId: Scalars['String'];
}>;


export type GetApiCredentialsByIdQuery = { __typename?: 'Query', getApiCredentialsById: { __typename?: 'ApiCredentialSafeDTO', appId: string, companyName?: string | null, monthlyRequestLimit?: number | null, adminDisabled?: boolean | null, _id: string, type: ApiCredentialsTypesEnum, isActive: boolean, referralCode?: string | null, partnerDisabled?: boolean | null, deleted: boolean, deletedAt?: any | null, disabledAt?: any | null, disabledReason?: string | null, disabledBy?: string | null } };

export type SetApiCredentialAdminDisabledMutationVariables = Exact<{
  apiCredentialsId: Scalars['String'];
  adminDisabled: Scalars['Boolean'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type SetApiCredentialAdminDisabledMutation = { __typename?: 'Mutation', setApiCredentialAdminDisabled: { __typename?: 'ApiCredentialSafeDTO', _id: string, appId: string, adminDisabled?: boolean | null, isActive: boolean, disabledAt?: any | null, disabledReason?: string | null } };

export type SetApiCredentialMonthlyRequestLimitMutationVariables = Exact<{
  apiCredentialsId: Scalars['String'];
  monthlyRequestLimit?: InputMaybe<Scalars['Int']>;
}>;


export type SetApiCredentialMonthlyRequestLimitMutation = { __typename?: 'Mutation', setApiCredentialMonthlyRequestLimit: { __typename?: 'ApiCredentialSafeDTO', _id: string, appId: string, monthlyRequestLimit?: number | null } };

export type GetUserByApiCredentialsIdQueryVariables = Exact<{
  filter: GetUserByApiCredentialsFilterInput;
}>;


export type GetUserByApiCredentialsIdQuery = { __typename?: 'Query', getUserByApiCredentialsId: { __typename?: 'ApiPluginUser', monthlyApiAccess?: number | null, account: { __typename?: 'Account', _id: string, email: string, status: string, excludeFromReports?: boolean | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null }, broker?: { __typename?: 'ApiBrokerInfo', _id?: string | null } | null, apiCredentials?: { __typename?: 'ApiCredentialsPluginUserResponse', _id: string, appId?: string | null, companyName?: string | null, associatedCompany?: string | null, isActive?: boolean | null, partnerDisabled?: boolean | null, adminDisabled?: boolean | null } | null } };

export type ApiInvitationForListFragment = { __typename?: 'ApiInvitationSafeDTO', _id: string, email: string, status: ApiInvitationStatusEnum, expiresAt: any, companyName?: string | null, referralCode?: string | null, isMarketplacePartner?: boolean | null, createdAt: any, acceptedAt?: any | null };

export type CreateApiInvitationMutationVariables = Exact<{
  input: CreateApiInvitationInput;
}>;


export type CreateApiInvitationMutation = { __typename?: 'Mutation', createApiInvitation: { __typename?: 'ApiInvitationSafeDTO', _id: string, email: string, status: ApiInvitationStatusEnum, expiresAt: any, companyName?: string | null, referralCode?: string | null, isMarketplacePartner?: boolean | null, createdAt: any, acceptedAt?: any | null } };

export type RevokeApiInvitationMutationVariables = Exact<{
  invitationId: Scalars['String'];
}>;


export type RevokeApiInvitationMutation = { __typename?: 'Mutation', revokeApiInvitation: { __typename?: 'ApiInvitationSafeDTO', _id: string, email: string, status: ApiInvitationStatusEnum, expiresAt: any, companyName?: string | null, referralCode?: string | null, isMarketplacePartner?: boolean | null, createdAt: any, acceptedAt?: any | null } };

export type ResendApiInvitationMutationVariables = Exact<{
  input: ResendApiInvitationInput;
}>;


export type ResendApiInvitationMutation = { __typename?: 'Mutation', resendApiInvitation: { __typename?: 'ApiInvitationSafeDTO', _id: string, email: string, status: ApiInvitationStatusEnum, expiresAt: any, companyName?: string | null, referralCode?: string | null, isMarketplacePartner?: boolean | null, createdAt: any, acceptedAt?: any | null } };

export type GetApiInvitationsQueryVariables = Exact<{
  status?: InputMaybe<ApiInvitationStatusEnum>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetApiInvitationsQuery = { __typename?: 'Query', apiInvitations: { __typename?: 'ApiInvitationsPayload', totalCount: number, collection: Array<{ __typename?: 'ApiInvitationSafeDTO', _id: string, email: string, status: ApiInvitationStatusEnum, expiresAt: any, companyName?: string | null, referralCode?: string | null, isMarketplacePartner?: boolean | null, createdAt: any, acceptedAt?: any | null }> } };

export type ApiMetricFragment = { __typename?: 'ApiMetric', _id: string, startDate: any, endDate: any, totalRequests: number, dataPoints: Array<{ __typename?: 'MetricDataPoint', timestamp: any, requestCount: number }> };

export type GetTotalApiUsageQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<TotalApiUsageFilterInput>;
}>;


export type GetTotalApiUsageQuery = { __typename?: 'Query', getTotalApiUsage: { __typename?: 'ApiMetricPayload', totalCount: number, collection: Array<{ __typename?: 'ApiMetric', _id: string, startDate: any, endDate: any, totalRequests: number, dataPoints: Array<{ __typename?: 'MetricDataPoint', timestamp: any, requestCount: number }> }> } };

export type GetApiQuotaStatusByAppIdQueryVariables = Exact<{
  appId: Scalars['String'];
}>;


export type GetApiQuotaStatusByAppIdQuery = { __typename?: 'Query', getApiQuotaStatusByAppId: { __typename?: 'ApiQuotaStatusPayload', usage: number, limit: number, resetDate: any } };

export type EnableMFaMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type EnableMFaMutation = { __typename?: 'Mutation', enableMfa: { __typename?: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type MfaAuthenticationMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type MfaAuthenticationMutation = { __typename?: 'Mutation', mfaAuthentication: { __typename?: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type GenerateMfaqrCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateMfaqrCodeQuery = { __typename?: 'Query', generateMfaQrCode: { __typename?: 'GenerateQrCodeResult', qrCode: string } };

export type BrokerFragment = { __typename?: 'Broker', _id: string, agencyName?: string | null, agencyWebsite?: string | null, isRealUser: boolean, hasActiveApiCredential: boolean, subscriptionType: string, demoExpirationDate?: any | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseStatus: string } | null, account: { __typename?: 'Account', _id: string, email: string, status: string, excludeFromReports?: boolean | null, stripeCustomerId?: string | null, showAllBillingPlans?: boolean | null, phone?: { __typename?: 'Phone', dialCode?: string | null, number?: string | null, status: string } | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', radiusInMiles?: number | null, location?: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', state?: string | null } | null } | null } | null, accountSubscription?: { __typename?: 'ProductSubscription', _id: string, status: string, subscriptionProduct: { __typename?: 'SubscriptionProduct', _id: string, name: string } } | null };

export type BrokerForListFragment = { __typename?: 'Broker', _id: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null }, account: { __typename?: 'Account', _id: string, email: string, status: string, createdAt: any, phone?: { __typename?: 'Phone', dialCode?: string | null, number?: string | null, status: string } | null }, accountSubscription?: { __typename?: 'ProductSubscription', _id: string, status: string, subscriptionProduct: { __typename?: 'SubscriptionProduct', _id: string, name: string } } | null, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', location?: { __typename?: 'Location', address?: { __typename?: 'Address', state?: string | null } | null } | null } | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseStatus: string } | null };

export type UpdateBrokerMutationVariables = Exact<{
  brokerId: Scalars['ObjectId'];
  input: UpdateBrokerInCmsInput;
}>;


export type UpdateBrokerMutation = { __typename?: 'Mutation', updateBroker: { __typename?: 'Broker', _id: string, agencyName?: string | null, agencyWebsite?: string | null, isRealUser: boolean, hasActiveApiCredential: boolean, subscriptionType: string, demoExpirationDate?: any | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseStatus: string } | null, account: { __typename?: 'Account', _id: string, email: string, status: string, excludeFromReports?: boolean | null, stripeCustomerId?: string | null, showAllBillingPlans?: boolean | null, phone?: { __typename?: 'Phone', dialCode?: string | null, number?: string | null, status: string } | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', radiusInMiles?: number | null, location?: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', state?: string | null } | null } | null } | null, accountSubscription?: { __typename?: 'ProductSubscription', _id: string, status: string, subscriptionProduct: { __typename?: 'SubscriptionProduct', _id: string, name: string } } | null } };

export type UpdateBrokerLicenseStatusMutationVariables = Exact<{
  brokerId: Scalars['ObjectId'];
  input: UpdateBrokerLicenseStatusInput;
}>;


export type UpdateBrokerLicenseStatusMutation = { __typename?: 'Mutation', updateBrokerLicenseStatus: { __typename?: 'Broker', _id: string, agencyName?: string | null, agencyWebsite?: string | null, isRealUser: boolean, hasActiveApiCredential: boolean, subscriptionType: string, demoExpirationDate?: any | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseStatus: string } | null, account: { __typename?: 'Account', _id: string, email: string, status: string, excludeFromReports?: boolean | null, stripeCustomerId?: string | null, showAllBillingPlans?: boolean | null, phone?: { __typename?: 'Phone', dialCode?: string | null, number?: string | null, status: string } | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', radiusInMiles?: number | null, location?: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', state?: string | null } | null } | null } | null, accountSubscription?: { __typename?: 'ProductSubscription', _id: string, status: string, subscriptionProduct: { __typename?: 'SubscriptionProduct', _id: string, name: string } } | null } };

export type BlockBrokerMutationVariables = Exact<{
  brokerId: Scalars['ObjectId'];
  archivingReason: Scalars['String'];
}>;


export type BlockBrokerMutation = { __typename?: 'Mutation', archiveBroker: { __typename?: 'Broker', _id: string } };

export type UnblockBrokerMutationVariables = Exact<{
  brokerId: Scalars['ObjectId'];
}>;


export type UnblockBrokerMutation = { __typename?: 'Mutation', unarchiveBroker: { __typename?: 'Broker', _id: string } };

export type DeleteBrokerMutationVariables = Exact<{
  brokerId: Scalars['ObjectId'];
}>;


export type DeleteBrokerMutation = { __typename?: 'Mutation', deleteBroker: { __typename?: 'Broker', _id: string } };

export type SetBrokerShowAllBillingPlansMutationVariables = Exact<{
  brokerId: Scalars['ObjectId'];
  showAllBillingPlans: Scalars['Boolean'];
}>;


export type SetBrokerShowAllBillingPlansMutation = { __typename?: 'Mutation', setBrokerShowAllBillingPlans: { __typename?: 'Broker', _id: string, agencyName?: string | null, agencyWebsite?: string | null, isRealUser: boolean, hasActiveApiCredential: boolean, subscriptionType: string, demoExpirationDate?: any | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseStatus: string } | null, account: { __typename?: 'Account', _id: string, email: string, status: string, excludeFromReports?: boolean | null, stripeCustomerId?: string | null, showAllBillingPlans?: boolean | null, phone?: { __typename?: 'Phone', dialCode?: string | null, number?: string | null, status: string } | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', radiusInMiles?: number | null, location?: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', state?: string | null } | null } | null } | null, accountSubscription?: { __typename?: 'ProductSubscription', _id: string, status: string, subscriptionProduct: { __typename?: 'SubscriptionProduct', _id: string, name: string } } | null } };

export type GetBrokersQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetBrokersFilter>;
}>;


export type GetBrokersQuery = { __typename?: 'Query', getBrokers: { __typename?: 'BrokersPayload', totalCount: number, collection: Array<{ __typename?: 'Broker', _id: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null }, account: { __typename?: 'Account', _id: string, email: string, status: string, createdAt: any, phone?: { __typename?: 'Phone', dialCode?: string | null, number?: string | null, status: string } | null }, accountSubscription?: { __typename?: 'ProductSubscription', _id: string, status: string, subscriptionProduct: { __typename?: 'SubscriptionProduct', _id: string, name: string } } | null, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', location?: { __typename?: 'Location', address?: { __typename?: 'Address', state?: string | null } | null } | null } | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseStatus: string } | null }> } };

export type GetBrokerByIdQueryVariables = Exact<{
  brokerId: Scalars['ObjectId'];
}>;


export type GetBrokerByIdQuery = { __typename?: 'Query', getSingleBrokerById: { __typename?: 'Broker', _id: string, agencyName?: string | null, agencyWebsite?: string | null, isRealUser: boolean, hasActiveApiCredential: boolean, subscriptionType: string, demoExpirationDate?: any | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseStatus: string } | null, account: { __typename?: 'Account', _id: string, email: string, status: string, excludeFromReports?: boolean | null, stripeCustomerId?: string | null, showAllBillingPlans?: boolean | null, phone?: { __typename?: 'Phone', dialCode?: string | null, number?: string | null, status: string } | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', radiusInMiles?: number | null, location?: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', state?: string | null } | null } | null } | null, accountSubscription?: { __typename?: 'ProductSubscription', _id: string, status: string, subscriptionProduct: { __typename?: 'SubscriptionProduct', _id: string, name: string } } | null } };

export type UpdateCmsSettingsMutationVariables = Exact<{
  input: UpdateCmsSettingsInput;
}>;


export type UpdateCmsSettingsMutation = { __typename?: 'Mutation', updateCmsSettings: { __typename?: 'CmsSettings', _id: string, newListingToActiveDays: number, activeToAwaitingAuditDays: number, recentlyUpdatedToActiveDays: number, automatedTransitionsEnabled: boolean, createdAt: any, updatedAt: any } };

export type ResetCmsSettingsToDefaultsMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetCmsSettingsToDefaultsMutation = { __typename?: 'Mutation', resetCmsSettingsToDefaults: { __typename?: 'CmsSettings', _id: string, newListingToActiveDays: number, activeToAwaitingAuditDays: number, recentlyUpdatedToActiveDays: number, automatedTransitionsEnabled: boolean, createdAt: any, updatedAt: any } };

export type GetCmsSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCmsSettingsQuery = { __typename?: 'Query', getCmsSettings: { __typename?: 'CmsSettings', _id: string, newListingToActiveDays: number, activeToAwaitingAuditDays: number, recentlyUpdatedToActiveDays: number, automatedTransitionsEnabled: boolean, createdAt: any, updatedAt: any } };

export type GetContentActivityQueryVariables = Exact<{
  range: DateRangeInput;
}>;


export type GetContentActivityQuery = { __typename?: 'Query', getContentActivity: { __typename?: 'ContentActivity', propertiesEdited: number, changes: number, filesUploaded: number, propertiesCreated: number, changesByType: Array<{ __typename?: 'ContentActivityChangeType', type?: PropertyChangelogTypesEnum | null, changes: number, properties: number }>, contributors: Array<{ __typename?: 'ContentActivityContributor', accountId?: any | null, name?: string | null, email?: string | null, propertiesEdited: number, changes: number, filesUploaded: number, propertiesCreated: number }> } };

export type GetContentActivityLogQueryVariables = Exact<{
  range: DateRangeInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetContentActivityLogQuery = { __typename?: 'Query', getContentActivityLog: { __typename?: 'ContentActivityLog', totalCount: number, collection: Array<{ __typename?: 'ContentActivityLogEntry', _id: any, createdAt: any, type?: PropertyChangelogTypesEnum | null, propertyId: any, propertyName?: string | null, accountId?: any | null, authorName?: string | null, authorEmail?: string | null, cmsStatusChange?: { __typename?: 'ContentActivityValueChange', from?: string | null, to?: string | null } | null, visibilityChange?: { __typename?: 'ContentActivityValueChange', from?: string | null, to?: string | null } | null }> } };

export type SaleTeamUserFragment = { __typename?: 'SaleTeamUser', _id: string, saleTeamId: string, assignedPropertiesIds?: Array<string> | null, role: { __typename?: 'Role', _id: string, type: string }, account: { __typename?: 'Account', _id: string, status: string, email: string, excludeFromReports?: boolean | null }, profile: { __typename?: 'Profile', firstName: string, lastName?: string | null } };

export type AddSaleTeamUserMutationVariables = Exact<{
  input: AddSaleTeamUserInput;
}>;


export type AddSaleTeamUserMutation = { __typename?: 'Mutation', addSaleTeamUser: { __typename?: 'SaleTeamUser', _id: string, accountId: string } };

export type DeleteSaleTeamUserMutationVariables = Exact<{
  saleTeamId: Scalars['ObjectId'];
  saleTeamUserId: Scalars['ObjectId'];
}>;


export type DeleteSaleTeamUserMutation = { __typename?: 'Mutation', deleteSaleTeamUser: { __typename?: 'SaleTeamUser', _id: string } };

export type SetSaleTeamUserStatusMutationVariables = Exact<{
  saleTeamUserId: Scalars['ObjectId'];
  status: AccountActiveOrArchivedStatusesEnum;
}>;


export type SetSaleTeamUserStatusMutation = { __typename?: 'Mutation', setSaleTeamUserStatus: boolean };

export type EditSaleTeamUserMutationVariables = Exact<{
  input: EditSaleTeamUserInput;
}>;


export type EditSaleTeamUserMutation = { __typename?: 'Mutation', editSaleTeamUser: { __typename?: 'SaleTeamUser', _id: string, accountId: string } };

export type SendRegistrationLinkToDeveloperMutationVariables = Exact<{
  accountId: Scalars['ObjectId'];
}>;


export type SendRegistrationLinkToDeveloperMutation = { __typename?: 'Mutation', sendRegistrationLinkToDeveloper: boolean };

export type GetSaleTeamUserNameByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetSaleTeamUserNameByEmailQuery = { __typename?: 'Query', getSaleTeamUserNameByEmail?: { __typename?: 'SaleTeamUserNamePayload', firstName: string, lastName: string } | null };

export type GetSaleTeamUsersQueryVariables = Exact<{
  filter: GetSaleTeamUsersFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetSaleTeamUsersQuery = { __typename?: 'Query', getSaleTeamUsers: { __typename?: 'SaleTeamUsersPayload', totalCount: number, collection: Array<{ __typename?: 'SaleTeamUser', _id: string, saleTeamId: string, assignedPropertiesIds?: Array<string> | null, role: { __typename?: 'Role', _id: string, type: string }, account: { __typename?: 'Account', _id: string, status: string, email: string, excludeFromReports?: boolean | null }, profile: { __typename?: 'Profile', firstName: string, lastName?: string | null } }> } };

export type FeaturedPortfolioFragmentFragment = { __typename?: 'FeaturedPortfolio', _id: string, title: string, cardDescription?: string | null, propertyIds?: Array<string> | null, visibility: FeaturedPortfolioVisibilityEnum, displayOrder?: number | null, updatedAt: any, createdAt: any, coverImageFile?: { __typename?: 'File', _id: string, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null };

export type FeaturedPortfolioDetailFragmentFragment = { __typename?: 'FeaturedPortfolio', _id: string, title: string, cardDescription?: string | null, overview?: string | null, propertyIds?: Array<string> | null, visibility: FeaturedPortfolioVisibilityEnum, displayOrder?: number | null, createdAt: any, updatedAt: any, coverImageFile?: { __typename?: 'File', _id: string, name: string, type: string, size: number, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null };

export type CreateFeaturedPortfolioMutationVariables = Exact<{
  input: CreateFeaturedPortfolioInput;
}>;


export type CreateFeaturedPortfolioMutation = { __typename?: 'Mutation', createFeaturedPortfolio: { __typename?: 'FeaturedPortfolio', _id: string, title: string, cardDescription?: string | null, propertyIds?: Array<string> | null, visibility: FeaturedPortfolioVisibilityEnum, displayOrder?: number | null, updatedAt: any, createdAt: any, coverImageFile?: { __typename?: 'File', _id: string, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null } };

export type UpdateFeaturedPortfolioMutationVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
  input: UpdateFeaturedPortfolioInput;
}>;


export type UpdateFeaturedPortfolioMutation = { __typename?: 'Mutation', updateFeaturedPortfolio: { __typename?: 'FeaturedPortfolio', _id: string, title: string, cardDescription?: string | null, propertyIds?: Array<string> | null, visibility: FeaturedPortfolioVisibilityEnum, displayOrder?: number | null, updatedAt: any, createdAt: any, coverImageFile?: { __typename?: 'File', _id: string, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null } };

export type DeleteFeaturedPortfolioMutationVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
}>;


export type DeleteFeaturedPortfolioMutation = { __typename?: 'Mutation', deleteFeaturedPortfolio: { __typename?: 'FeaturedPortfolio', _id: string } };

export type OrderPropertiesInPortfolioMutationVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
  propertyIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrderPropertiesInPortfolioMutation = { __typename?: 'Mutation', orderPropertiesInPortfolio: { __typename?: 'FeaturedPortfolio', _id: string, title: string } };

export type OrderFeaturedPortfoliosMutationVariables = Exact<{
  orders: Array<FeaturedPortfolioOrder> | FeaturedPortfolioOrder;
}>;


export type OrderFeaturedPortfoliosMutation = { __typename?: 'Mutation', orderFeaturedPortfolios: Array<{ __typename?: 'FeaturedPortfolio', _id: string, title: string, cardDescription?: string | null, propertyIds?: Array<string> | null, visibility: FeaturedPortfolioVisibilityEnum, displayOrder?: number | null, updatedAt: any, createdAt: any, coverImageFile?: { __typename?: 'File', _id: string, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null }> };

export type MakePortfolioPublicMutationVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
  position: Scalars['String'];
}>;


export type MakePortfolioPublicMutation = { __typename?: 'Mutation', makePortfolioPublic: string };

export type GetFeaturedPortfoliosQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetFeaturedPortfoliosFilter>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetFeaturedPortfoliosQuery = { __typename?: 'Query', getFeaturedPortfolios: { __typename?: 'FeaturedPortfoliosPayload', totalCount: number, collection: Array<{ __typename?: 'FeaturedPortfolio', _id: string, title: string, cardDescription?: string | null, propertyIds?: Array<string> | null, visibility: FeaturedPortfolioVisibilityEnum, displayOrder?: number | null, updatedAt: any, createdAt: any, coverImageFile?: { __typename?: 'File', _id: string, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null }> } };

export type GetFeaturedPortfolioByIdQueryVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
}>;


export type GetFeaturedPortfolioByIdQuery = { __typename?: 'Query', getFeaturedPortfolioById: { __typename?: 'FeaturedPortfolio', _id: string, title: string, cardDescription?: string | null, overview?: string | null, propertyIds?: Array<string> | null, visibility: FeaturedPortfolioVisibilityEnum, displayOrder?: number | null, createdAt: any, updatedAt: any, coverImageFile?: { __typename?: 'File', _id: string, name: string, type: string, size: number, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null } };

export type GetFeaturedPortfolioPropertiesAdminQueryVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
}>;


export type GetFeaturedPortfolioPropertiesAdminQuery = { __typename?: 'Query', getFeaturedPortfolioPropertiesAdmin: Array<{ __typename?: 'PropertySummary', _id: string, name: string }> };

export type GetFeaturedPortfolioMarketAreasQueryVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
}>;


export type GetFeaturedPortfolioMarketAreasQuery = { __typename?: 'Query', getFeaturedPortfolioMarketAreas: Array<{ __typename?: 'MarketAreaCount', count: number, marketArea?: { __typename?: 'MarketArea', _id: string, name: string } | null }> };

export type GetFeaturedPortfolioSummaryQueryVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
}>;


export type GetFeaturedPortfolioSummaryQuery = { __typename?: 'Query', getFeaturedPortfolioSummary?: { __typename?: 'FeaturedPortfolioSummary', propertyCount: number, marketAreas: Array<{ __typename?: 'MarketAreaCount', count: number, marketArea?: { __typename?: 'MarketArea', _id: string, name: string } | null }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, completionYearRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null } | null };

export type GetFeaturedPortfolioPropertiesQueryVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
  pagination?: InputMaybe<FlatPaginationInput>;
}>;


export type GetFeaturedPortfolioPropertiesQuery = { __typename?: 'Query', getFeaturedPortfolioProperties: { __typename?: 'FeaturedPortfolioPropertiesPayload', totalCount: number, collection: Array<{ __typename?: 'PropertyDetail', _id: string, name: string, overview?: string | null, yearBuilt?: number | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, publicUrl: string, type: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }> } | null, marketArea?: { __typename?: 'MarketArea', _id: string, name: string } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBedroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBathroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null }> } };

export type FeaturedPropertyFragmentFragment = { __typename?: 'FeaturedProperty', _id: string, title: string, shortOverview?: string | null, visibility: FeaturedPropertyVisibilityEnum, displayOrder?: number | null, updatedAt: any, createdAt: any, coverImageFile?: { __typename?: 'File', _id: string, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null };

export type FeaturedPropertyDetailFragmentFragment = { __typename?: 'FeaturedProperty', _id: string, title: string, shortOverview?: string | null, propertyId: string, overview?: string | null, visibility: FeaturedPropertyVisibilityEnum, displayOrder?: number | null, createdAt: any, updatedAt: any, coverImageFile?: { __typename?: 'File', _id: string, name: string, type: string, size: number, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null };

export type CreateFeaturedPropertyMutationVariables = Exact<{
  input: CreateFeaturedPropertyInput;
}>;


export type CreateFeaturedPropertyMutation = { __typename?: 'Mutation', createFeaturedProperty: { __typename?: 'FeaturedProperty', _id: string, title: string, shortOverview?: string | null, visibility: FeaturedPropertyVisibilityEnum, displayOrder?: number | null, updatedAt: any, createdAt: any, coverImageFile?: { __typename?: 'File', _id: string, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null } };

export type UpdateFeaturedPropertyMutationVariables = Exact<{
  featuredPropertyId: Scalars['String'];
  input: UpdateFeaturedPropertyInput;
}>;


export type UpdateFeaturedPropertyMutation = { __typename?: 'Mutation', updateFeaturedProperty: { __typename?: 'FeaturedProperty', _id: string, title: string, shortOverview?: string | null, visibility: FeaturedPropertyVisibilityEnum, displayOrder?: number | null, updatedAt: any, createdAt: any, coverImageFile?: { __typename?: 'File', _id: string, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null } };

export type DeleteFeaturedPropertyMutationVariables = Exact<{
  featuredPropertyId: Scalars['String'];
}>;


export type DeleteFeaturedPropertyMutation = { __typename?: 'Mutation', deleteFeaturedProperty: { __typename?: 'FeaturedProperty', _id: string } };

export type OrderFeaturedPropertiesMutationVariables = Exact<{
  orders: Array<FeaturedPropertyOrder> | FeaturedPropertyOrder;
}>;


export type OrderFeaturedPropertiesMutation = { __typename?: 'Mutation', orderFeaturedProperties: Array<{ __typename?: 'FeaturedProperty', _id: string, title: string, shortOverview?: string | null, visibility: FeaturedPropertyVisibilityEnum, displayOrder?: number | null, updatedAt: any, createdAt: any, coverImageFile?: { __typename?: 'File', _id: string, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null }> };

export type MakeFeaturedPropertyPublicMutationVariables = Exact<{
  featuredPropertyId: Scalars['String'];
  position: Scalars['String'];
}>;


export type MakeFeaturedPropertyPublicMutation = { __typename?: 'Mutation', makeFeaturedPropertyPublic: string };

export type GetFeaturedPropertiesQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetFeaturedPropertiesFilter>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetFeaturedPropertiesQuery = { __typename?: 'Query', getFeaturedProperties: { __typename?: 'FeaturedPropertiesPayload', totalCount: number, collection: Array<{ __typename?: 'FeaturedProperty', _id: string, title: string, shortOverview?: string | null, visibility: FeaturedPropertyVisibilityEnum, displayOrder?: number | null, updatedAt: any, createdAt: any, coverImageFile?: { __typename?: 'File', _id: string, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null }> } };

export type GetFeaturedPropertyByIdQueryVariables = Exact<{
  featuredPropertyId: Scalars['String'];
}>;


export type GetFeaturedPropertyByIdQuery = { __typename?: 'Query', getFeaturedPropertyById: { __typename?: 'FeaturedProperty', _id: string, title: string, shortOverview?: string | null, propertyId: string, overview?: string | null, visibility: FeaturedPropertyVisibilityEnum, displayOrder?: number | null, createdAt: any, updatedAt: any, property: { __typename?: 'Property', projectStatus?: string | null, yearBuilt?: number | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null }, coverImageFile?: { __typename?: 'File', _id: string, name: string, type: string, size: number, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null } };

export type FileFragment = { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null };

export type UploadDraftFileMutationVariables = Exact<{
  input: FileUploadInput;
}>;


export type UploadDraftFileMutation = { __typename?: 'Mutation', uploadDraftFile: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } };

export type EditMediaFileMutationVariables = Exact<{
  fileId: Scalars['ObjectId'];
  input: EditMediaFileInput;
}>;


export type EditMediaFileMutation = { __typename?: 'Mutation', editMediaFile: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } };

export type AbortUploadFileMutationVariables = Exact<{
  progressTrackingId: Scalars['String'];
}>;


export type AbortUploadFileMutation = { __typename?: 'Mutation', abortUpload: { __typename?: 'AbortUploadEvent', _id: string } };

export type AbortAllUploadsMutationVariables = Exact<{ [key: string]: never; }>;


export type AbortAllUploadsMutation = { __typename?: 'Mutation', abortAllUploads: { __typename?: 'AbortUploadEvent', _id: string } };

export type MarketAreaFragment = { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } };

export type CreateMarketAreaMutationVariables = Exact<{
  input: CreateMarketAreaInput;
}>;


export type CreateMarketAreaMutation = { __typename?: 'Mutation', createMarketArea: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } };

export type EditMarketAreaMutationVariables = Exact<{
  input: EditMarketAreaInput;
}>;


export type EditMarketAreaMutation = { __typename?: 'Mutation', editMarketArea: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } };

export type DeleteMarketAreaMutationVariables = Exact<{
  marketAreaId: Scalars['ObjectId'];
}>;


export type DeleteMarketAreaMutation = { __typename?: 'Mutation', deleteMarketArea: { __typename?: 'MarketArea', _id: string } };

export type GetMarketAreasQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetMarketAreasFilterInput>;
}>;


export type GetMarketAreasQuery = { __typename?: 'Query', getMarketAreas: { __typename?: 'MarketAreasPayload', totalCount: number, collection: Array<{ __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } }> } };

export type MediaFragment = { __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> };

export type CreateMediaFileMutationVariables = Exact<{
  input: CreateMediaFileInput;
}>;


export type CreateMediaFileMutation = { __typename?: 'Mutation', createMediaFile: { __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> } };

export type CreateMediaFolderMutationVariables = Exact<{
  input: CreateMediaFolderInput;
}>;


export type CreateMediaFolderMutation = { __typename?: 'Mutation', createMediaFolder: { __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> } };

export type EditMediaFolderMutationVariables = Exact<{
  input: EditMediaFolderInput;
}>;


export type EditMediaFolderMutation = { __typename?: 'Mutation', editMediaFolder: { __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> } };

export type DeleteMediaFileByIdMutationVariables = Exact<{
  mediaId: Scalars['ObjectId'];
}>;


export type DeleteMediaFileByIdMutation = { __typename?: 'Mutation', deleteMediaFileById: { __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> } };

export type DeleteMediaFolderByIdMutationVariables = Exact<{
  mediaId: Scalars['ObjectId'];
  withContent?: InputMaybe<Scalars['Boolean']>;
}>;


export type DeleteMediaFolderByIdMutation = { __typename?: 'Mutation', deleteMediaFolderById: { __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> } };

export type DeleteMediaFilesMutationVariables = Exact<{
  mediaFilesIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
  filter?: InputMaybe<GetMediaFoldersAndFilesFilterInput>;
  excludedIds?: InputMaybe<Array<Scalars['ObjectId']> | Scalars['ObjectId']>;
}>;


export type DeleteMediaFilesMutation = { __typename?: 'Mutation', deleteMediaFiles: Array<{ __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> }> };

export type MoveMediaToFolderMutationVariables = Exact<{
  mediaFolderId: Scalars['ObjectId'];
  mediaIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
  filter?: InputMaybe<GetMediaFoldersAndFilesFilterInput>;
  excludedIds?: InputMaybe<Array<Scalars['ObjectId']> | Scalars['ObjectId']>;
}>;


export type MoveMediaToFolderMutation = { __typename?: 'Mutation', moveMediaToFolder: { __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> } };

export type MoveMediaInSortOrderMutationVariables = Exact<{
  sortedMediaIds: Array<SortedMediaIdsInput> | SortedMediaIdsInput;
}>;


export type MoveMediaInSortOrderMutation = { __typename?: 'Mutation', moveMediaInSortOrder: { __typename?: 'Media', _id: string } };

export type UpdateMediaBrandingTypeMutationVariables = Exact<{
  mediaId: Scalars['ObjectId'];
  brandingType: BrandingTypeEnum;
}>;


export type UpdateMediaBrandingTypeMutation = { __typename?: 'Mutation', updateMediaBrandingType: { __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> } };

export type BulkUpdateMediaBrandingTypeMutationVariables = Exact<{
  mediaFilesIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
  brandingType: BrandingTypeEnum;
  filter?: InputMaybe<GetMediaFoldersAndFilesFilterInput>;
  excludedIds?: InputMaybe<Array<Scalars['ObjectId']> | Scalars['ObjectId']>;
}>;


export type BulkUpdateMediaBrandingTypeMutation = { __typename?: 'Mutation', bulkUpdateMediaBrandingType: Array<{ __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> }> };

export type GetMediaFoldersAndFilesQueryVariables = Exact<{
  filter: GetMediaFoldersAndFilesFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetMediaFoldersAndFilesQuery = { __typename?: 'Query', getMediaFoldersAndFiles: { __typename?: 'MediaFilesAndFoldersPayload', filesTotalCount: number, foldersTotalCount: number, filesCollection?: Array<{ __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, mediaItemsCount: number, propertyId: string, brandingType?: string | null, systemFolderType?: string | null, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }> | null, foldersCollection: Array<{ __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, systemFolderType?: string | null, folderName?: string | null, type: string, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, publicUrl: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }> } };

export type GetMediaFilesQueryVariables = Exact<{
  filter: GetMediaFoldersAndFilesFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetMediaFilesQuery = { __typename?: 'Query', getMediaFoldersAndFiles: { __typename?: 'MediaFilesAndFoldersPayload', filesTotalCount: number, filesCollection?: Array<{ __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> }> | null } };

export type GetMediaFolderByIdQueryVariables = Exact<{
  folderId: Scalars['ObjectId'];
}>;


export type GetMediaFolderByIdQuery = { __typename?: 'Query', getMediaFolderById: { __typename?: 'Media', _id: string, folderName?: string | null, systemFolderType?: string | null, foldersPathCollection?: Array<{ __typename?: 'FolderPathModel', _id: string, folderName: string }> | null } };

export type GetAllFoldersInPropertyQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
  mediaFolderId?: InputMaybe<Scalars['ObjectId']>;
  includeRootFolder?: InputMaybe<Scalars['Boolean']>;
  excludeSlideshowFolder?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAllFoldersInPropertyQuery = { __typename?: 'Query', getAllFoldersInProperty: Array<{ __typename?: 'Media', _id: string, folderName?: string | null, type: string, systemFolderType?: string | null, parentMediaFoldersIds?: Array<string> | null, mediaFolderId?: string | null }> };

export type GetAllFilesInPropertyQueryVariables = Exact<{
  filter: GetAllFilesInPropertyFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetAllFilesInPropertyQuery = { __typename?: 'Query', getAllFilesInProperty: { __typename?: 'MediaFilesAndFoldersPayload', filesTotalCount: number, filesCollection?: Array<{ __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> }> | null } };

export type GetNumberOfAllMediaFilesToDownloadQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type GetNumberOfAllMediaFilesToDownloadQuery = { __typename?: 'Query', getAllFilesInProperty: { __typename?: 'MediaFilesAndFoldersPayload', filesTotalCount: number } };

export type GetAllFilesInPropertyPreviewQueryVariables = Exact<{
  filter: GetAllFilesInPropertyFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  previewAsSeeker?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAllFilesInPropertyPreviewQuery = { __typename?: 'Query', getAllFilesInPropertyPreview: { __typename?: 'MediaFilesAndFoldersPayload', filesTotalCount: number, filesCollection?: Array<{ __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> }> | null } };

export type GetSlideshowMediaByPropertyQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type GetSlideshowMediaByPropertyQuery = { __typename?: 'Query', getSlideshowMediaByProperty: Array<{ __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> }> };

export type GetTopLevelFoldersInPropertyQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type GetTopLevelFoldersInPropertyQuery = { __typename?: 'Query', getTopLevelFoldersInProperty: Array<{ __typename?: 'Media', _id: string, folderName?: string | null, systemFolderType?: string | null }> };

export type ObserveMediaChangesSubscriptionVariables = Exact<{
  filter: GetMediaFoldersAndFilesFilterInput;
}>;


export type ObserveMediaChangesSubscription = { __typename?: 'Subscription', observeMediaChanges: { __typename?: 'MediaObserveSubscriptionPayload', trigger: string, document: { __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> } } };

export type OrganizationUserFragment = { __typename?: 'OrganizationUser', _id: string, createdAt: any, internalSaleTeamId?: string | null, organizationId: string, saleTeamRoleId?: string | null, assignedPropertiesIds?: Array<string> | null, account: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, role: { __typename?: 'Role', _id: string, type: string } }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }, saleTeamRole?: { __typename?: 'Role', _id: string, type: string } | null };

export type OrganizationUserForTableFragment = { __typename?: 'OrganizationUser', _id: string, saleTeamRoleId?: string | null, assignedPropertiesIds?: Array<string> | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null }, saleTeamRole?: { __typename?: 'Role', _id: string, type: string } | null, account: { __typename?: 'Account', _id: string, email: string, excludeFromReports?: boolean | null, status: string, role: { __typename?: 'Role', _id: string, type: string } } };

export type CreateOrganizationUserMutationVariables = Exact<{
  input: CreateOrganizationUserInput;
}>;


export type CreateOrganizationUserMutation = { __typename?: 'Mutation', createOrganizationUser: { __typename?: 'OrganizationUser', _id: string, createdAt: any, internalSaleTeamId?: string | null, organizationId: string, saleTeamRoleId?: string | null, assignedPropertiesIds?: Array<string> | null, account: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, role: { __typename?: 'Role', _id: string, type: string } }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }, saleTeamRole?: { __typename?: 'Role', _id: string, type: string } | null } };

export type EditOrganizationUserMutationVariables = Exact<{
  input: EditOrganizationUserInput;
}>;


export type EditOrganizationUserMutation = { __typename?: 'Mutation', editOrganizationUser: { __typename?: 'OrganizationUser', _id: string, createdAt: any, internalSaleTeamId?: string | null, organizationId: string, saleTeamRoleId?: string | null, assignedPropertiesIds?: Array<string> | null, account: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, role: { __typename?: 'Role', _id: string, type: string } }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }, saleTeamRole?: { __typename?: 'Role', _id: string, type: string } | null } };

export type DeleteOrganizationUserMutationVariables = Exact<{
  organizationUserId: Scalars['ObjectId'];
}>;


export type DeleteOrganizationUserMutation = { __typename?: 'Mutation', deleteOrganizationUser: { __typename?: 'OrganizationUser', _id: string, createdAt: any, internalSaleTeamId?: string | null, organizationId: string, saleTeamRoleId?: string | null, assignedPropertiesIds?: Array<string> | null, account: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, role: { __typename?: 'Role', _id: string, type: string } }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }, saleTeamRole?: { __typename?: 'Role', _id: string, type: string } | null } };

export type SetOrganizationUserStatusMutationVariables = Exact<{
  organizationUserId: Scalars['ObjectId'];
  status: AccountActiveOrArchivedStatusesEnum;
}>;


export type SetOrganizationUserStatusMutation = { __typename?: 'Mutation', setOrganizationUserStatus: boolean };

export type GetOrganizationUsersQueryVariables = Exact<{
  filter: GetOrganizationUsersFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetOrganizationUsersQuery = { __typename?: 'Query', getOrganizationUsers: { __typename?: 'OrganizationUsersPayload', totalCount: number, collection: Array<{ __typename?: 'OrganizationUser', _id: string, createdAt: any, internalSaleTeamId?: string | null, organizationId: string, saleTeamRoleId?: string | null, assignedPropertiesIds?: Array<string> | null, account: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, role: { __typename?: 'Role', _id: string, type: string } }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }, saleTeamRole?: { __typename?: 'Role', _id: string, type: string } | null }> } };

export type GetOrganizationUsersForTableQueryVariables = Exact<{
  filter: GetOrganizationUsersFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetOrganizationUsersForTableQuery = { __typename?: 'Query', getOrganizationUsers: { __typename?: 'OrganizationUsersPayload', totalCount: number, collection: Array<{ __typename?: 'OrganizationUser', _id: string, saleTeamRoleId?: string | null, assignedPropertiesIds?: Array<string> | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null }, saleTeamRole?: { __typename?: 'Role', _id: string, type: string } | null, account: { __typename?: 'Account', _id: string, email: string, excludeFromReports?: boolean | null, status: string, role: { __typename?: 'Role', _id: string, type: string } } }> } };

export type OrganizationFragment = { __typename?: 'Organization', _id: string, createdAt: any, name: string, website?: string | null, locationId?: string | null, logoFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null, location?: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null } | null };

export type OrganizationForTableFragment = { __typename?: 'Organization', _id: string, createdAt: any, name: string, propertiesCount: number, logoFile?: { __typename?: 'File', _id: string, publicUrl: string } | null };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', _id: string, createdAt: any, name: string, website?: string | null, locationId?: string | null, logoFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null, location?: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null } | null } };

export type EditOrganizationMutationVariables = Exact<{
  input: EditOrganizationInput;
  organizationId: Scalars['ObjectId'];
}>;


export type EditOrganizationMutation = { __typename?: 'Mutation', editOrganization: { __typename?: 'Organization', _id: string, createdAt: any, name: string, website?: string | null, locationId?: string | null, logoFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null, location?: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null } | null } };

export type DeleteOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ObjectId'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization: { __typename?: 'Organization', _id: string } };

export type GetOrganizationsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchByName?: InputMaybe<Scalars['String']>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', getOrganizations: { __typename?: 'OrganizationsPayload', totalCount: number, collection: Array<{ __typename?: 'Organization', propertiesCount: number, _id: string, createdAt: any, name: string, website?: string | null, locationId?: string | null, logoFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null, location?: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null } | null }> } };

export type GetOrganizationsForTableQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchByName?: InputMaybe<Scalars['String']>;
}>;


export type GetOrganizationsForTableQuery = { __typename?: 'Query', getOrganizations: { __typename?: 'OrganizationsPayload', totalCount: number, collection: Array<{ __typename?: 'Organization', _id: string, createdAt: any, name: string, propertiesCount: number, logoFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }> } };

export type GetOrganizationsForSelectQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchByName?: InputMaybe<Scalars['String']>;
}>;


export type GetOrganizationsForSelectQuery = { __typename?: 'Query', getOrganizations: { __typename?: 'OrganizationsPayload', totalCount: number, collection: Array<{ __typename?: 'Organization', _id: string, name: string, internalSaleTeam: { __typename?: 'SaleTeam', _id: string } }> } };

export type GetOrganizationByIdQueryVariables = Exact<{
  organizationId: Scalars['ObjectId'];
}>;


export type GetOrganizationByIdQuery = { __typename?: 'Query', getOrganizationById: { __typename?: 'Organization', _id: string, createdAt: any, name: string, website?: string | null, locationId?: string | null, logoFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null, location?: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null } | null } };

export type ProfileFragment = { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null };

export type ProgressTrackingFragment = { __typename?: 'ProgressTrackingModel', expectedOperations?: Array<string> | null, operation?: string | null, progress?: number | null, progressTrackingId: string, status: string, type: string };

export type ObserveProgressTrackingByTypeSubscriptionVariables = Exact<{
  type: Scalars['String'];
}>;


export type ObserveProgressTrackingByTypeSubscription = { __typename?: 'Subscription', observeProgressTrackingByType: { __typename?: 'ObserveProgressTrackingPayload', document: { __typename?: 'ProgressTrackingModel', expectedOperations?: Array<string> | null, operation?: string | null, progress?: number | null, progressTrackingId: string, status: string, type: string } } };

export type PropertyFragment = { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, transactionType: PropertyTransactionTypesEnum, stories?: number | null, projectStatus?: string | null, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, overview?: string | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, verifiedAt?: any | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, updatedAt: any, amenityIds?: Array<string> | null, isMarkedAsVerified: boolean, contactEmail?: string | null, cmsStatus?: string | null, cmsStatusUpdatedAt?: any | null, brandedFilesReady?: boolean | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBathroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null };

export type PropertyChangelogFragment = { __typename?: 'PropertyChangelog', _id: string, type: string, createdAt: any, updatedAt: any, isHidden?: boolean | null, beforeUpdate?: { __typename: 'PropertyAboutChangelog' } | { __typename: 'PropertyAdditionalInformationChangelog' } | { __typename: 'PropertyCmsStatusChangelog', cmsStatus?: string | null, visibility?: string | null } | { __typename: 'PropertyDataReviewedChangelog' } | { __typename: 'PropertyDeveloperOrganizationChangelog' } | { __typename: 'PropertyFeaturesAndAmenitiesChangelog' } | { __typename: 'PropertyHighlightsChangelog' } | { __typename: 'PropertyInventoryUnitAddedChangelog' } | { __typename: 'PropertyInventoryUnitRemovedChangelog' } | { __typename: 'PropertyInventoryUnitUpdatedChangelog' } | { __typename: 'PropertyLocationChangelog' } | { __typename: 'PropertyMediaFilesMovedChangelog' } | { __typename: 'PropertyMediaRemovedChangelog' } | { __typename: 'PropertyMediaRenamedChangelog' } | { __typename: 'PropertyMediaUploadedChangelog' } | { __typename: 'PropertyNameChangelog' } | { __typename: 'PropertyOrganizationSalesTeamsChangelog' } | { __typename: 'PropertyPriceChangelog' } | { __typename: 'PropertyVirtualToursChangelog' } | { __typename: 'PropertyVisibilityChangelog', visibility?: string | null } | { __typename: 'PropertyWebsiteChangelog' } | null, afterUpdate: { __typename: 'PropertyAboutChangelog' } | { __typename: 'PropertyAdditionalInformationChangelog' } | { __typename: 'PropertyCmsStatusChangelog', cmsStatus?: string | null, visibility?: string | null } | { __typename: 'PropertyDataReviewedChangelog' } | { __typename: 'PropertyDeveloperOrganizationChangelog' } | { __typename: 'PropertyFeaturesAndAmenitiesChangelog' } | { __typename: 'PropertyHighlightsChangelog' } | { __typename: 'PropertyInventoryUnitAddedChangelog' } | { __typename: 'PropertyInventoryUnitRemovedChangelog' } | { __typename: 'PropertyInventoryUnitUpdatedChangelog' } | { __typename: 'PropertyLocationChangelog' } | { __typename: 'PropertyMediaFilesMovedChangelog' } | { __typename: 'PropertyMediaRemovedChangelog' } | { __typename: 'PropertyMediaRenamedChangelog' } | { __typename: 'PropertyMediaUploadedChangelog', mediaFolderId: string, uploadedMediaId: string, folderName?: string | null } | { __typename: 'PropertyNameChangelog' } | { __typename: 'PropertyOrganizationSalesTeamsChangelog' } | { __typename: 'PropertyPriceChangelog' } | { __typename: 'PropertyVirtualToursChangelog' } | { __typename: 'PropertyVisibilityChangelog', visibility?: string | null } | { __typename: 'PropertyWebsiteChangelog' }, property: { __typename?: 'Property', _id: string, name: string, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> } | null } };

export type CreatePropertyMutationVariables = Exact<{
  input: CreatePropertyInput;
}>;


export type CreatePropertyMutation = { __typename?: 'Mutation', createProperty: { __typename?: 'Property', _id: string } };

export type SetAdvancedPropertyDetailsMutationVariables = Exact<{
  input: SetAdvancedPropertyDetailsInput;
}>;


export type SetAdvancedPropertyDetailsMutation = { __typename?: 'Mutation', setAdvancedPropertyDetails: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, transactionType: PropertyTransactionTypesEnum, stories?: number | null, projectStatus?: string | null, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, overview?: string | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, verifiedAt?: any | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, updatedAt: any, amenityIds?: Array<string> | null, isMarkedAsVerified: boolean, contactEmail?: string | null, cmsStatus?: string | null, cmsStatusUpdatedAt?: any | null, brandedFilesReady?: boolean | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBathroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null } };

export type SetGeneralPropertyDetailsMutationVariables = Exact<{
  input: SetGeneralPropertyDetailsInput;
}>;


export type SetGeneralPropertyDetailsMutation = { __typename?: 'Mutation', setGeneralPropertyDetails: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, transactionType: PropertyTransactionTypesEnum, stories?: number | null, projectStatus?: string | null, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, overview?: string | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, verifiedAt?: any | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, updatedAt: any, amenityIds?: Array<string> | null, isMarkedAsVerified: boolean, contactEmail?: string | null, cmsStatus?: string | null, cmsStatusUpdatedAt?: any | null, brandedFilesReady?: boolean | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBathroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null } };

export type SetPropertyStatusMutationVariables = Exact<{
  input: SetPropertyStatusInput;
}>;


export type SetPropertyStatusMutation = { __typename?: 'Mutation', setPropertyStatus: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, transactionType: PropertyTransactionTypesEnum, stories?: number | null, projectStatus?: string | null, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, overview?: string | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, verifiedAt?: any | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, updatedAt: any, amenityIds?: Array<string> | null, isMarkedAsVerified: boolean, contactEmail?: string | null, cmsStatus?: string | null, cmsStatusUpdatedAt?: any | null, brandedFilesReady?: boolean | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBathroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null } };

export type RemoveAmenitiesFromPropertyMutationVariables = Exact<{
  propertyId: Scalars['ObjectId'];
  amenitiesIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type RemoveAmenitiesFromPropertyMutation = { __typename?: 'Mutation', removeAmenitiesFromProperty: { __typename?: 'Property', _id: string } };

export type SetAmenitiesToPropertyMutationVariables = Exact<{
  input: SetAmenitiesToPropertyInput;
}>;


export type SetAmenitiesToPropertyMutation = { __typename?: 'Mutation', setAmenitiesToProperty: { __typename?: 'Property', _id: string } };

export type SetAmenityNameInPropertyMutationVariables = Exact<{
  propertyId: Scalars['ObjectId'];
  amenityId: Scalars['ObjectId'];
  name: Scalars['String'];
  isPrimary: Scalars['Boolean'];
}>;


export type SetAmenityNameInPropertyMutation = { __typename?: 'Mutation', setAmenityNameInProperty: { __typename?: 'Property', _id: string } };

export type RemovePropertyByIdMutationVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type RemovePropertyByIdMutation = { __typename?: 'Mutation', removePropertyById: boolean };

export type ChangeVerifiedStatusInPropertyMutationVariables = Exact<{
  propertyId: Scalars['ObjectId'];
  isMarkedAsVerified: Scalars['Boolean'];
}>;


export type ChangeVerifiedStatusInPropertyMutation = { __typename?: 'Mutation', changeVerifiedStatusInProperty: { __typename?: 'Property', _id: string } };

export type DuplicateAmenityMutationVariables = Exact<{
  propertyId: Scalars['ObjectId'];
  amenityId: Scalars['ObjectId'];
}>;


export type DuplicateAmenityMutation = { __typename?: 'Mutation', duplicateAmenity: { __typename?: 'Property', _id: string } };

export type UpdateBrandedFilesReadyMutationVariables = Exact<{
  input: UpdateBrandedFilesReadyInput;
}>;


export type UpdateBrandedFilesReadyMutation = { __typename?: 'Mutation', updateBrandedFilesReady: { __typename?: 'Property', _id: string, brandedFilesReady?: boolean | null } };

export type ToggleChangelogVisibilityMutationVariables = Exact<{
  input: ToggleChangelogVisibilityInput;
}>;


export type ToggleChangelogVisibilityMutation = { __typename?: 'Mutation', toggleChangelogVisibility: { __typename?: 'PropertyChangelog', _id: string, isHidden?: boolean | null } };

export type GetPropertiesQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetPropertiesFilterInput>;
}>;


export type GetPropertiesQuery = { __typename?: 'Query', getProperties: { __typename?: 'PropertiesPayload', totalCount: number, collection: Array<{ __typename?: 'Property', _id: string, name: string, primaryOrganizationId?: string | null, updatedAt: any, projectStatus?: string | null, status: string, cmsStatus?: string | null, cmsStatusUpdatedAt?: any | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, location: { __typename?: 'Location', _id: string, address?: { __typename?: 'Address', state?: string | null } | null }, marketArea?: { __typename?: 'MarketArea', _id: string } | null, primaryOrganization?: { __typename?: 'Organization', name: string } | null }> } };

export type GetPropertyByIdQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type GetPropertyByIdQuery = { __typename?: 'Query', getPropertyById: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, transactionType: PropertyTransactionTypesEnum, stories?: number | null, projectStatus?: string | null, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, overview?: string | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, verifiedAt?: any | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, updatedAt: any, amenityIds?: Array<string> | null, isMarkedAsVerified: boolean, contactEmail?: string | null, cmsStatus?: string | null, cmsStatusUpdatedAt?: any | null, brandedFilesReady?: boolean | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBathroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null } };

export type GetPropertyNameByIdQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type GetPropertyNameByIdQuery = { __typename?: 'Query', getPropertyById: { __typename?: 'Property', _id: string, name: string } };

export type GetPropertyChangelogsQueryVariables = Exact<{
  filter: GetPropertyChangelogsFilterInput;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetPropertyChangelogsQuery = { __typename?: 'Query', getPropertyChangelogs: { __typename?: 'PropertyChangelogsPayload', totalCount: number, collection: Array<{ __typename?: 'PropertyChangelog', _id: string, type: string, createdAt: any, updatedAt: any, isHidden?: boolean | null, beforeUpdate?: { __typename: 'PropertyAboutChangelog' } | { __typename: 'PropertyAdditionalInformationChangelog' } | { __typename: 'PropertyCmsStatusChangelog', cmsStatus?: string | null, visibility?: string | null } | { __typename: 'PropertyDataReviewedChangelog' } | { __typename: 'PropertyDeveloperOrganizationChangelog' } | { __typename: 'PropertyFeaturesAndAmenitiesChangelog' } | { __typename: 'PropertyHighlightsChangelog' } | { __typename: 'PropertyInventoryUnitAddedChangelog' } | { __typename: 'PropertyInventoryUnitRemovedChangelog' } | { __typename: 'PropertyInventoryUnitUpdatedChangelog' } | { __typename: 'PropertyLocationChangelog' } | { __typename: 'PropertyMediaFilesMovedChangelog' } | { __typename: 'PropertyMediaRemovedChangelog' } | { __typename: 'PropertyMediaRenamedChangelog' } | { __typename: 'PropertyMediaUploadedChangelog' } | { __typename: 'PropertyNameChangelog' } | { __typename: 'PropertyOrganizationSalesTeamsChangelog' } | { __typename: 'PropertyPriceChangelog' } | { __typename: 'PropertyVirtualToursChangelog' } | { __typename: 'PropertyVisibilityChangelog', visibility?: string | null } | { __typename: 'PropertyWebsiteChangelog' } | null, afterUpdate: { __typename: 'PropertyAboutChangelog' } | { __typename: 'PropertyAdditionalInformationChangelog' } | { __typename: 'PropertyCmsStatusChangelog', cmsStatus?: string | null, visibility?: string | null } | { __typename: 'PropertyDataReviewedChangelog' } | { __typename: 'PropertyDeveloperOrganizationChangelog' } | { __typename: 'PropertyFeaturesAndAmenitiesChangelog' } | { __typename: 'PropertyHighlightsChangelog' } | { __typename: 'PropertyInventoryUnitAddedChangelog' } | { __typename: 'PropertyInventoryUnitRemovedChangelog' } | { __typename: 'PropertyInventoryUnitUpdatedChangelog' } | { __typename: 'PropertyLocationChangelog' } | { __typename: 'PropertyMediaFilesMovedChangelog' } | { __typename: 'PropertyMediaRemovedChangelog' } | { __typename: 'PropertyMediaRenamedChangelog' } | { __typename: 'PropertyMediaUploadedChangelog', mediaFolderId: string, uploadedMediaId: string, folderName?: string | null } | { __typename: 'PropertyNameChangelog' } | { __typename: 'PropertyOrganizationSalesTeamsChangelog' } | { __typename: 'PropertyPriceChangelog' } | { __typename: 'PropertyVirtualToursChangelog' } | { __typename: 'PropertyVisibilityChangelog', visibility?: string | null } | { __typename: 'PropertyWebsiteChangelog' }, property: { __typename?: 'Property', _id: string, name: string, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> } | null } }> } };

export type GetAllPropertyChangelogsQueryVariables = Exact<{
  filter: GetAllPropertyChangelogsFilterInput;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetAllPropertyChangelogsQuery = { __typename?: 'Query', getAllPropertyChangelogs: { __typename?: 'PropertyChangelogsPayload', totalCount: number, collection: Array<{ __typename?: 'PropertyChangelog', _id: string, type: string, createdAt: any, updatedAt: any, isHidden?: boolean | null, beforeUpdate?: { __typename: 'PropertyAboutChangelog' } | { __typename: 'PropertyAdditionalInformationChangelog' } | { __typename: 'PropertyCmsStatusChangelog', cmsStatus?: string | null, visibility?: string | null } | { __typename: 'PropertyDataReviewedChangelog' } | { __typename: 'PropertyDeveloperOrganizationChangelog' } | { __typename: 'PropertyFeaturesAndAmenitiesChangelog' } | { __typename: 'PropertyHighlightsChangelog' } | { __typename: 'PropertyInventoryUnitAddedChangelog' } | { __typename: 'PropertyInventoryUnitRemovedChangelog' } | { __typename: 'PropertyInventoryUnitUpdatedChangelog' } | { __typename: 'PropertyLocationChangelog' } | { __typename: 'PropertyMediaFilesMovedChangelog' } | { __typename: 'PropertyMediaRemovedChangelog' } | { __typename: 'PropertyMediaRenamedChangelog' } | { __typename: 'PropertyMediaUploadedChangelog' } | { __typename: 'PropertyNameChangelog' } | { __typename: 'PropertyOrganizationSalesTeamsChangelog' } | { __typename: 'PropertyPriceChangelog' } | { __typename: 'PropertyVirtualToursChangelog' } | { __typename: 'PropertyVisibilityChangelog', visibility?: string | null } | { __typename: 'PropertyWebsiteChangelog' } | null, afterUpdate: { __typename: 'PropertyAboutChangelog' } | { __typename: 'PropertyAdditionalInformationChangelog' } | { __typename: 'PropertyCmsStatusChangelog', cmsStatus?: string | null, visibility?: string | null } | { __typename: 'PropertyDataReviewedChangelog' } | { __typename: 'PropertyDeveloperOrganizationChangelog' } | { __typename: 'PropertyFeaturesAndAmenitiesChangelog' } | { __typename: 'PropertyHighlightsChangelog' } | { __typename: 'PropertyInventoryUnitAddedChangelog' } | { __typename: 'PropertyInventoryUnitRemovedChangelog' } | { __typename: 'PropertyInventoryUnitUpdatedChangelog' } | { __typename: 'PropertyLocationChangelog' } | { __typename: 'PropertyMediaFilesMovedChangelog' } | { __typename: 'PropertyMediaRemovedChangelog' } | { __typename: 'PropertyMediaRenamedChangelog' } | { __typename: 'PropertyMediaUploadedChangelog', mediaFolderId: string, uploadedMediaId: string, folderName?: string | null } | { __typename: 'PropertyNameChangelog' } | { __typename: 'PropertyOrganizationSalesTeamsChangelog' } | { __typename: 'PropertyPriceChangelog' } | { __typename: 'PropertyVirtualToursChangelog' } | { __typename: 'PropertyVisibilityChangelog', visibility?: string | null } | { __typename: 'PropertyWebsiteChangelog' }, property: { __typename?: 'Property', _id: string, name: string, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, updatedAt: any, createdAt: any, folderName?: string | null, type: string, sizeInBytes: number, systemFolderType?: string | null, mediaItemsCount: number, propertyId: string, brandingType?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> } | null } }> } };

export type UpdateCmsStatusMutationVariables = Exact<{
  input: UpdateCmsStatusInput;
}>;


export type UpdateCmsStatusMutation = { __typename?: 'Mutation', updateCmsStatus: { __typename?: 'Property', _id: string, cmsStatus?: string | null, cmsStatusUpdatedAt?: any | null } };

export type ApprovePropertyMutationVariables = Exact<{
  input: ApprovePropertyInput;
}>;


export type ApprovePropertyMutation = { __typename?: 'Mutation', approveProperty: { __typename?: 'Property', _id: string, cmsStatus?: string | null, cmsStatusUpdatedAt?: any | null, status: string } };

export type AuditPropertyMutationVariables = Exact<{
  input: AuditPropertyInput;
}>;


export type AuditPropertyMutation = { __typename?: 'Mutation', auditProperty: { __typename?: 'Property', _id: string, cmsStatus?: string | null, cmsStatusUpdatedAt?: any | null } };

export type ArchivePropertyMutationVariables = Exact<{
  input: ArchivePropertyInput;
}>;


export type ArchivePropertyMutation = { __typename?: 'Mutation', archiveProperty: { __typename?: 'Property', _id: string, cmsStatus?: string | null, cmsStatusUpdatedAt?: any | null, status: string } };

export type PropertyNoteFragment = { __typename?: 'PropertyNote', _id: string, createdAt: any, message: string, readBy: Array<string>, attachedFilesIds: Array<string>, attachedFiles?: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null }> | null, authorAccount?: { __typename?: 'Account', _id: string } | null, authorProfile?: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null } | null };

export type AddNoteToPropertyMutationVariables = Exact<{
  attachedFilesIds?: InputMaybe<Array<Scalars['ObjectId']> | Scalars['ObjectId']>;
  message: Scalars['String'];
  propertyId: Scalars['ObjectId'];
}>;


export type AddNoteToPropertyMutation = { __typename?: 'Mutation', addNoteToProperty: { __typename?: 'PropertyNote', _id: string, message: string, attachedFilesIds: Array<string>, propertyId: string } };

export type EditPropertyNoteMutationVariables = Exact<{
  attachedFilesIds?: InputMaybe<Array<Scalars['ObjectId']> | Scalars['ObjectId']>;
  message: Scalars['String'];
  propertyNoteId: Scalars['ObjectId'];
}>;


export type EditPropertyNoteMutation = { __typename?: 'Mutation', editPropertyNote: { __typename?: 'PropertyNote', _id: string, message: string, attachedFilesIds: Array<string>, propertyId: string } };

export type RemovePropertyNoteMutationVariables = Exact<{
  propertyNoteId: Scalars['ObjectId'];
}>;


export type RemovePropertyNoteMutation = { __typename?: 'Mutation', removePropertyNote: { __typename?: 'PropertyNote', _id: string, message: string, attachedFilesIds: Array<string>, propertyId: string } };

export type GetPropertyNotesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  propertyId: Scalars['ObjectId'];
}>;


export type GetPropertyNotesQuery = { __typename?: 'Query', getPropertyNotes: { __typename?: 'PropertyNotesPayload', totalCount: number, collection: Array<{ __typename?: 'PropertyNote', _id: string, createdAt: any, message: string, readBy: Array<string>, attachedFilesIds: Array<string>, attachedFiles?: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null }> | null, authorAccount?: { __typename?: 'Account', _id: string } | null, authorProfile?: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null } | null }> } };

export type RoleFragment = { __typename?: 'Role', _id: string, type: string };

export type GetOrganizationRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationRolesQuery = { __typename?: 'Query', getOrganizationRoles: { __typename?: 'RolesPayload', collection: Array<{ __typename?: 'Role', _id: string, type: string }> } };

export type GetSalesTeamRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesTeamRolesQuery = { __typename?: 'Query', getSalesTeamRoles: { __typename?: 'RolesPayload', collection: Array<{ __typename?: 'Role', _id: string, type: string }> } };

export type SaleTeamFragment = { __typename?: 'SaleTeam', _id: string, createdAt: any, name: string, website?: string | null, countOfUsers?: number | null, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null };

export type CreateSaleTeamMutationVariables = Exact<{
  input: CreateSaleTeamInput;
}>;


export type CreateSaleTeamMutation = { __typename?: 'Mutation', createSaleTeam: { __typename?: 'SaleTeam', _id: string, createdAt: any, name: string, website?: string | null, countOfUsers?: number | null, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null } };

export type EditSaleTeamMutationVariables = Exact<{
  saleTeamId: Scalars['ObjectId'];
  input: EditSaleTeamInput;
}>;


export type EditSaleTeamMutation = { __typename?: 'Mutation', editSaleTeam: { __typename?: 'SaleTeam', _id: string, createdAt: any, name: string, website?: string | null, countOfUsers?: number | null, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null } };

export type EditInternalSaleTeamByOrganizationIdMutationVariables = Exact<{
  organizationId: Scalars['ObjectId'];
  input: EditSaleTeamInput;
}>;


export type EditInternalSaleTeamByOrganizationIdMutation = { __typename?: 'Mutation', editInternalSaleTeamByOrganizationId: { __typename?: 'SaleTeam', _id: string, createdAt: any, name: string, website?: string | null, countOfUsers?: number | null, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null } };

export type DeleteSaleTeamMutationVariables = Exact<{
  saleTeamId: Scalars['ObjectId'];
}>;


export type DeleteSaleTeamMutation = { __typename?: 'Mutation', deleteSaleTeam: { __typename?: 'SaleTeam', _id: string, createdAt: any, name: string, website?: string | null, countOfUsers?: number | null, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null } };

export type GetSaleTeamsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetSaleTeamsFilterInput>;
}>;


export type GetSaleTeamsQuery = { __typename?: 'Query', getSaleTeams: { __typename?: 'SaleTeamsPayload', totalCount: number, collection: Array<{ __typename?: 'SaleTeam', countOfUsers?: number | null, relatedToSaleTeamOrganizationsNames?: Array<string> | null, _id: string, createdAt: any, name: string, website?: string | null, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null }> } };

export type GetSaleTeamsForPropertySelectQueryVariables = Exact<{
  filter?: InputMaybe<GetSaleTeamsFilterInput>;
}>;


export type GetSaleTeamsForPropertySelectQuery = { __typename?: 'Query', getSaleTeams: { __typename?: 'SaleTeamsPayload', totalCount: number, collection: Array<{ __typename?: 'SaleTeam', _id: string, name: string, type: string, organizationId?: string | null }> } };

export type GetSaleTeamByIdQueryVariables = Exact<{
  saleTeamId: Scalars['ObjectId'];
}>;


export type GetSaleTeamByIdQuery = { __typename?: 'Query', getSaleTeamById: { __typename?: 'SaleTeam', _id: string, createdAt: any, name: string, website?: string | null, countOfUsers?: number | null, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null } };

export type GetInternalOrganizationSaleTeamQueryVariables = Exact<{
  organizationId: Scalars['ObjectId'];
}>;


export type GetInternalOrganizationSaleTeamQuery = { __typename?: 'Query', getInternalOrganizationSaleTeam: { __typename?: 'SaleTeam', _id: string, createdAt: any, name: string, website?: string | null, countOfUsers?: number | null, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null } };

export type StateFragment = { __typename?: 'State', _id: string, code: string, name: string };

export type GetUsStatesQueryVariables = Exact<{
  filter?: InputMaybe<GetStatesFilterInput>;
}>;


export type GetUsStatesQuery = { __typename?: 'Query', getUSStates: Array<{ __typename?: 'State', _id: string, code: string, name: string }> };

export type GetUsStateByNameQueryVariables = Exact<{
  stateName: Scalars['String'];
}>;


export type GetUsStateByNameQuery = { __typename?: 'Query', getUSStateByName: { __typename?: 'State', _id: string, code: string, name: string } };

export type UnitFragment = { __typename?: 'Unit', _id: string, createdAt: any, floorPlanFileId?: string | null, highestPrice?: number | null, startingPrice?: number | null, customRooms?: string | null, name: string, inventoryType: string, updatedAt: any, updatedBy?: string | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageTotalSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageInteriorSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageExteriorSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, floorPlanFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null };

export type CreateUnitMutationVariables = Exact<{
  input: CreateUnitInput;
}>;


export type CreateUnitMutation = { __typename?: 'Mutation', createUnit: { __typename?: 'Unit', _id: string } };

export type DuplicateUnitMutationVariables = Exact<{
  unitId: Scalars['ObjectId'];
}>;


export type DuplicateUnitMutation = { __typename?: 'Mutation', duplicateUnit: { __typename?: 'Unit', _id: string } };

export type EditUnitMutationVariables = Exact<{
  input: EditUnitInput;
}>;


export type EditUnitMutation = { __typename?: 'Mutation', editUnit: { __typename?: 'Unit', _id: string } };

export type AddFloorPlanToUnitMutationVariables = Exact<{
  floorPlanFileId: Scalars['ObjectId'];
  unitId: Scalars['ObjectId'];
}>;


export type AddFloorPlanToUnitMutation = { __typename?: 'Mutation', addFloorPlanToUnit: { __typename?: 'Unit', _id: string } };

export type DeleteUnitMutationVariables = Exact<{
  unitId: Scalars['ObjectId'];
}>;


export type DeleteUnitMutation = { __typename?: 'Mutation', deleteUnit: { __typename?: 'Unit', _id: string } };

export type GetUnitsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetUnitsFilterInput>;
}>;


export type GetUnitsQuery = { __typename?: 'Query', getUnits: { __typename?: 'UnitsPayload', totalCount: number, collection: Array<{ __typename?: 'Unit', _id: string, createdAt: any, floorPlanFileId?: string | null, highestPrice?: number | null, startingPrice?: number | null, customRooms?: string | null, name: string, inventoryType: string, updatedAt: any, updatedBy?: string | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageTotalSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageInteriorSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageExteriorSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, floorPlanFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null }> } };

export type GetUnitsCountQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetUnitsFilterInput>;
}>;


export type GetUnitsCountQuery = { __typename?: 'Query', getUnits: { __typename?: 'UnitsPayload', totalCount: number } };

export type GetPropertyUnitsSqftRangeQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type GetPropertyUnitsSqftRangeQuery = { __typename?: 'Query', getPropertyUnitsSqftRange?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null };

export type UserFragment = { __typename?: 'User', account: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, role: { __typename?: 'Role', _id: string, type: string } }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null } };

export type ApiUserFragment = { __typename?: 'ApiUser', account: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, role: { __typename?: 'Role', _id: string, type: string } }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null } };

export type UserForListFragment = { __typename?: 'User', account: { __typename?: 'Account', _id: string, email: string, status: string, excludeFromReports?: boolean | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } };

export type ApiUserForListFragment = { __typename?: 'ApiUser', clientCount?: number | null, monthlyApiAccess?: number | null, account: { __typename?: 'Account', _id: string, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null }, apiCredentials?: { __typename?: 'ApiCredentialsUserResponse', _id: string, companyName?: string | null, referralCode?: string | null, appId?: string | null, adminDisabled?: boolean | null, deleted?: boolean | null, deletedAt?: any | null, disabledAt?: any | null, disabledReason?: string | null } | null };

export type AddUserToCmsMutationVariables = Exact<{
  accountInput: AccountInput;
  profileInput: ProfileInput;
}>;


export type AddUserToCmsMutation = { __typename?: 'Mutation', addUserToCMS: { __typename?: 'User', account: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, role: { __typename?: 'Role', _id: string, type: string } }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null } } };

export type AddUserToApiMutationVariables = Exact<{
  accountInput: AccountInput;
  profileInput: ProfileInput;
  apiCredentialsInput?: InputMaybe<ApiCredentialsInput>;
}>;


export type AddUserToApiMutation = { __typename?: 'Mutation', addUserToAPI: { __typename?: 'ApiUser', account: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, role: { __typename?: 'Role', _id: string, type: string } }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null } } };

export type UpdateUserCmsMutationVariables = Exact<{
  accountUpdateInput: UpdateAccountInput;
  profileInput: ProfileInput;
}>;


export type UpdateUserCmsMutation = { __typename?: 'Mutation', updateUserCMS: { __typename?: 'User', account: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, role: { __typename?: 'Role', _id: string, type: string } }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null } } };

export type UpdateUserApiMutationVariables = Exact<{
  accountUpdateInput: UpdateAccountInput;
  profileInput: ProfileInput;
  apiCredentialsInput?: InputMaybe<ApiCredentialsInput>;
}>;


export type UpdateUserApiMutation = { __typename?: 'Mutation', updateUserAPI: { __typename?: 'ApiUser', account: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, role: { __typename?: 'Role', _id: string, type: string } }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null } } };

export type DeleteUserCmsMutationVariables = Exact<{
  accountId: Scalars['ObjectId'];
  profileId: Scalars['ObjectId'];
}>;


export type DeleteUserCmsMutation = { __typename?: 'Mutation', deleteUserCMS: { __typename?: 'User', account: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null, role: { __typename?: 'Role', _id: string, type: string } }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null } } };

export type ArchiveCmsUserMutationVariables = Exact<{
  cmsUserAccountId: Scalars['ObjectId'];
  archive?: InputMaybe<Scalars['Boolean']>;
}>;


export type ArchiveCmsUserMutation = { __typename?: 'Mutation', archiveCMSUser: boolean };

export type UpdateCurrentUserMutationVariables = Exact<{
  profileInput: ProfileInput;
}>;


export type UpdateCurrentUserMutation = { __typename?: 'Mutation', updateCurrentUser: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, createdAt: any, avatarFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFileUrl?: string | null } | null } };

export type DeleteApiAccountMutationVariables = Exact<{
  apiCredentialsId: Scalars['String'];
}>;


export type DeleteApiAccountMutation = { __typename?: 'Mutation', deleteApiAccount: { __typename?: 'DeleteApiAccountResult', revokedPluginUsers: number } };

export type RestoreApiAccountMutationVariables = Exact<{
  apiCredentialsId: Scalars['String'];
}>;


export type RestoreApiAccountMutation = { __typename?: 'Mutation', restoreApiAccount: { __typename?: 'RestoreApiAccountResult', restoredPluginUsers: number, isActive: boolean } };

export type GetCmsUsersQueryVariables = Exact<{
  filter?: InputMaybe<GetCmsUsersFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetCmsUsersQuery = { __typename?: 'Query', getCMSUsers: { __typename?: 'UsersPayload', totalCount: number, collection: Array<{ __typename?: 'User', account: { __typename?: 'Account', _id: string, email: string, status: string, excludeFromReports?: boolean | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> } };

export type GetApiUsersQueryVariables = Exact<{
  filter?: InputMaybe<GetApiUsersFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetApiUsersQuery = { __typename?: 'Query', getApiUsers: { __typename?: 'ApiUsersPayload', totalCount: number, collection: Array<{ __typename?: 'ApiUser', clientCount?: number | null, monthlyApiAccess?: number | null, account: { __typename?: 'Account', _id: string, email: string, status: string, excludeFromReports?: boolean | null, mfaEnabled?: boolean | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null }, apiCredentials?: { __typename?: 'ApiCredentialsUserResponse', _id: string, companyName?: string | null, referralCode?: string | null, appId?: string | null, adminDisabled?: boolean | null, deleted?: boolean | null, deletedAt?: any | null, disabledAt?: any | null, disabledReason?: string | null } | null }> } };

export type GetDevelopersAsSaleUsersBySaleTeamAndRoleQueryVariables = Exact<{
  saleTeamId: Scalars['ObjectId'];
  roleType?: InputMaybe<RoleTypesEnum>;
}>;


export type GetDevelopersAsSaleUsersBySaleTeamAndRoleQuery = { __typename?: 'Query', getDevelopersAsSaleUsersBySaleTeamAndRole: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> };

export const TokensModelFragmentDoc = gql`
    fragment TokensModel on TokensModel {
  accessToken
  refreshToken
  refreshTokenExpiry
}
    `;
export const AmenityFragmentDoc = gql`
    fragment Amenity on Amenity {
  _id
  createdAt
  name
  imageUrl
  imageFile {
    _id
    publicUrl
  }
  isPrimary
  primaryAmenityId
  propertyId
}
    `;
export const ApiPluginUserForListFragmentDoc = gql`
    fragment ApiPluginUserForList on ApiPluginUser {
  account {
    _id
    email
    status
    excludeFromReports
  }
  profile {
    _id
    firstName
    lastName
  }
  broker {
    _id
  }
  apiCredentials {
    _id
    appId
    companyName
    associatedCompany
    isActive
    partnerDisabled
    adminDisabled
  }
  monthlyApiAccess
}
    `;
export const ApiInvitationForListFragmentDoc = gql`
    fragment ApiInvitationForList on ApiInvitationSafeDTO {
  _id
  email
  status
  expiresAt
  companyName
  referralCode
  isMarketplacePartner
  createdAt
  acceptedAt
}
    `;
export const ApiMetricFragmentDoc = gql`
    fragment ApiMetric on ApiMetric {
  _id
  startDate
  endDate
  totalRequests
  dataPoints {
    timestamp
    requestCount
  }
}
    `;
export const BrokerFragmentDoc = gql`
    fragment Broker on Broker {
  _id
  agencyName
  agencyWebsite
  isRealUser
  hasActiveApiCredential
  license {
    licenseNumber
    licenseStatus
  }
  subscriptionType
  demoExpirationDate
  account {
    _id
    email
    phone {
      dialCode
      number
      status
    }
    status
    excludeFromReports
    stripeCustomerId
    showAllBillingPlans
  }
  profile {
    _id
    firstName
    lastName
    avatarFile {
      _id
      publicUrl
    }
  }
  preferredPropertySettings {
    radiusInMiles
    location {
      _id
      googlePlaceId
      geoLocation {
        coordinates
      }
      address {
        state
      }
    }
  }
  accountSubscription {
    _id
    status
    subscriptionProduct {
      _id
      name
    }
  }
}
    `;
export const BrokerForListFragmentDoc = gql`
    fragment BrokerForList on Broker {
  _id
  profile {
    _id
    firstName
    lastName
  }
  account {
    _id
    email
    phone {
      dialCode
      number
      status
    }
    status
    createdAt
  }
  accountSubscription {
    _id
    status
    subscriptionProduct {
      _id
      name
    }
  }
  preferredPropertySettings {
    location {
      address {
        state
      }
    }
  }
  license {
    licenseNumber
    licenseStatus
  }
}
    `;
export const SaleTeamUserFragmentDoc = gql`
    fragment SaleTeamUser on SaleTeamUser {
  _id
  saleTeamId
  assignedPropertiesIds
  role {
    _id
    type
  }
  account {
    _id
    status
    email
    excludeFromReports
  }
  profile {
    firstName
    lastName
  }
}
    `;
export const FeaturedPortfolioFragmentFragmentDoc = gql`
    fragment FeaturedPortfolioFragment on FeaturedPortfolio {
  _id
  title
  cardDescription
  coverImageFile {
    _id
    publicUrl
    thumbnailFile {
      _id
      publicUrl
    }
  }
  propertyIds
  visibility
  displayOrder
  updatedAt
  createdAt
}
    `;
export const FeaturedPortfolioDetailFragmentFragmentDoc = gql`
    fragment FeaturedPortfolioDetailFragment on FeaturedPortfolio {
  _id
  title
  cardDescription
  coverImageFile {
    _id
    name
    type
    size
    publicUrl
    thumbnailFile {
      _id
      publicUrl
    }
  }
  overview
  propertyIds
  visibility
  displayOrder
  createdAt
  updatedAt
}
    `;
export const FeaturedPropertyFragmentFragmentDoc = gql`
    fragment FeaturedPropertyFragment on FeaturedProperty {
  _id
  title
  shortOverview
  coverImageFile {
    _id
    publicUrl
    thumbnailFile {
      _id
      publicUrl
    }
  }
  visibility
  displayOrder
  updatedAt
  createdAt
}
    `;
export const FeaturedPropertyDetailFragmentFragmentDoc = gql`
    fragment FeaturedPropertyDetailFragment on FeaturedProperty {
  _id
  title
  shortOverview
  propertyId
  coverImageFile {
    _id
    name
    type
    size
    publicUrl
    thumbnailFile {
      _id
      publicUrl
    }
  }
  overview
  visibility
  displayOrder
  createdAt
  updatedAt
}
    `;
export const RoleFragmentDoc = gql`
    fragment Role on Role {
  _id
  type
}
    `;
export const AccountFragmentDoc = gql`
    fragment Account on Account {
  _id
  createdAt
  role {
    ...Role
  }
  email
  status
  excludeFromReports
  mfaEnabled
}
    ${RoleFragmentDoc}`;
export const FileFragmentDoc = gql`
    fragment File on File {
  _id
  name
  size
  type
  s3Key
  publicUrl
  status
  updatedAt
  updatedBy
  createdAt
  createdBy
  deleted
  deletedAt
  deletedBy
  thumbnailFileUrl
}
    `;
export const ProfileFragmentDoc = gql`
    fragment Profile on Profile {
  _id
  firstName
  lastName
  createdAt
  avatarFile {
    ...File
  }
}
    ${FileFragmentDoc}`;
export const OrganizationUserFragmentDoc = gql`
    fragment OrganizationUser on OrganizationUser {
  _id
  createdAt
  internalSaleTeamId
  organizationId
  saleTeamRoleId
  assignedPropertiesIds
  account {
    ...Account
  }
  profile {
    ...Profile
  }
  saleTeamRole {
    _id
    type
  }
}
    ${AccountFragmentDoc}
${ProfileFragmentDoc}`;
export const OrganizationUserForTableFragmentDoc = gql`
    fragment OrganizationUserForTable on OrganizationUser {
  _id
  profile {
    _id
    firstName
    lastName
  }
  saleTeamRoleId
  saleTeamRole {
    _id
    type
  }
  assignedPropertiesIds
  account {
    _id
    email
    excludeFromReports
    role {
      _id
      type
    }
    status
  }
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment Organization on Organization {
  _id
  createdAt
  name
  website
  logoFile {
    ...File
  }
  locationId
  location {
    _id
    googlePlaceId
    geoLocation {
      coordinates
    }
    address {
      city
      county
      state
      street
      zipCode
    }
  }
}
    ${FileFragmentDoc}`;
export const OrganizationForTableFragmentDoc = gql`
    fragment OrganizationForTable on Organization {
  _id
  createdAt
  name
  propertiesCount
  logoFile {
    _id
    publicUrl
  }
}
    `;
export const ProgressTrackingFragmentDoc = gql`
    fragment ProgressTracking on ProgressTrackingModel {
  expectedOperations
  operation
  progress
  progressTrackingId
  status
  type
}
    `;
export const StateFragmentDoc = gql`
    fragment State on State {
  _id
  code
  name
}
    `;
export const MarketAreaFragmentDoc = gql`
    fragment MarketArea on MarketArea {
  _id
  createdAt
  name
  state {
    ...State
  }
}
    ${StateFragmentDoc}`;
export const PropertyFragmentDoc = gql`
    fragment Property on Property {
  _id
  market
  marketArea {
    ...MarketArea
  }
  name
  buildingTypes
  propertyTags
  transactionType
  stories
  projectStatus
  yearBuilt
  numberOfTowers
  numberOfUnits
  landscapeArchitect
  localArchitect
  interiorDesigner
  leadArchitect
  hasChangelog
  lastUpdatedAtByChangelog
  overview
  projectDetails
  taxInformation
  constructionStartDate
  slideshowMediaFolderId
  defaultInventoryDetails
  verifiedAt
  mainPropertyMediaId
  availableUnitsNumber
  mainPropertyMediaFile {
    _id
    files {
      thumbnailFile {
        publicUrl
      }
    }
  }
  cheapestUnit {
    averageBathroomsNumber {
      min
      max
    }
    averageBedroomsNumber {
      min
      max
    }
    startingPrice
  }
  completionDate
  priceRange {
    min
    max
  }
  website
  virtualTourLinks {
    url
    label
  }
  primaryOrganizationId
  primaryOrganization {
    _id
    name
    website
    logoUrl
  }
  organizationIds
  organizations {
    _id
    name
    website
    logoUrl
  }
  location {
    _id
    googlePlaceId
    geoLocation {
      coordinates
    }
    address {
      city
      county
      state
      street
      zipCode
    }
  }
  salesGalleryStatus
  salesGalleryAddress
  workingHours {
    monday {
      from
      to
    }
    tuesday {
      from
      to
    }
    wednesday {
      from
      to
    }
    thursday {
      from
      to
    }
    friday {
      from
      to
    }
    saturday {
      from
      to
    }
    sunday {
      from
      to
    }
  }
  salesGalleryHours {
    monday {
      from
      to
    }
    tuesday {
      from
      to
    }
    wednesday {
      from
      to
    }
    thursday {
      from
      to
    }
    friday {
      from
      to
    }
    saturday {
      from
      to
    }
    sunday {
      from
      to
    }
  }
  saleTeams {
    saleTeamId
    saleTeam {
      _id
      website
      name
      phone {
        dialCode
        number
      }
      logoFile {
        publicUrl
      }
    }
    saleAssociateIds
    saleAssociates {
      __typename
      ... on SaleTeamUser {
        _id
        saleTeamId
        profile {
          _id
          firstName
          lastName
        }
      }
      ... on OrganizationUser {
        _id
        internalSaleTeamId
        profile {
          _id
          firstName
          lastName
        }
      }
    }
    saleDirectorId
    saleDirector {
      __typename
      ... on SaleTeamUser {
        _id
        saleTeamId
        profile {
          _id
          firstName
          lastName
        }
      }
      ... on OrganizationUser {
        _id
        internalSaleTeamId
        profile {
          _id
          firstName
          lastName
        }
      }
    }
    contactUrl
    commission
  }
  status
  updatedAt
  amenityIds
  isMarkedAsVerified
  averageBedroomsNumberValue {
    min
    max
  }
  averageBathroomsNumberValue {
    min
    max
  }
  averageBedroomsNumber {
    min
    max
  }
  averageBathroomsNumber {
    min
    max
  }
  contactPhone {
    dialCode
    number
  }
  contactEmail
  cmsStatus
  cmsStatusUpdatedAt
  brandedFilesReady
}
    ${MarketAreaFragmentDoc}`;
export const MediaFragmentDoc = gql`
    fragment Media on Media {
  _id
  updatedAt
  createdAt
  files {
    ...File
    thumbnailFile {
      ...File
    }
  }
  folderName
  type
  sizeInBytes
  systemFolderType
  mediaItemsCount
  propertyId
  brandingType
}
    ${FileFragmentDoc}`;
export const PropertyChangelogFragmentDoc = gql`
    fragment PropertyChangelog on PropertyChangelog {
  _id
  type
  createdAt
  updatedAt
  isHidden
  beforeUpdate {
    __typename
    ... on PropertyCmsStatusChangelog {
      cmsStatus
      visibility
    }
    ... on PropertyVisibilityChangelog {
      visibility
    }
  }
  afterUpdate {
    __typename
    ... on PropertyMediaUploadedChangelog {
      mediaFolderId
      uploadedMediaId
      folderName
    }
    ... on PropertyCmsStatusChangelog {
      cmsStatus
      visibility
    }
    ... on PropertyVisibilityChangelog {
      visibility
    }
  }
  property {
    _id
    name
    mainPropertyMediaFile {
      ...Media
    }
  }
}
    ${MediaFragmentDoc}`;
export const PropertyNoteFragmentDoc = gql`
    fragment PropertyNote on PropertyNote {
  _id
  createdAt
  message
  readBy
  attachedFilesIds
  attachedFiles {
    ...File
  }
  authorAccount {
    _id
  }
  authorProfile {
    _id
    firstName
    lastName
    avatarFile {
      ...File
    }
  }
}
    ${FileFragmentDoc}`;
export const SaleTeamFragmentDoc = gql`
    fragment SaleTeam on SaleTeam {
  _id
  createdAt
  name
  website
  countOfUsers
  phone {
    dialCode
    number
  }
  logoFile {
    ...File
  }
  workingHours {
    monday {
      from
      to
    }
    tuesday {
      from
      to
    }
    wednesday {
      from
      to
    }
    thursday {
      from
      to
    }
    friday {
      from
      to
    }
    saturday {
      from
      to
    }
    sunday {
      from
      to
    }
  }
}
    ${FileFragmentDoc}`;
export const UnitFragmentDoc = gql`
    fragment Unit on Unit {
  _id
  averageBathroomsNumber {
    min
    max
  }
  averageBedroomsNumber {
    min
    max
  }
  createdAt
  floorPlanFileId
  highestPrice
  averageTotalSqft {
    min
    max
  }
  averageInteriorSqft {
    min
    max
  }
  averageExteriorSqft {
    min
    max
  }
  startingPrice
  customRooms
  name
  inventoryType
  updatedAt
  updatedBy
  floorPlanFile {
    ...File
  }
}
    ${FileFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on User {
  account {
    ...Account
  }
  profile {
    ...Profile
  }
}
    ${AccountFragmentDoc}
${ProfileFragmentDoc}`;
export const ApiUserFragmentDoc = gql`
    fragment ApiUser on ApiUser {
  account {
    ...Account
  }
  profile {
    ...Profile
  }
}
    ${AccountFragmentDoc}
${ProfileFragmentDoc}`;
export const UserForListFragmentDoc = gql`
    fragment UserForList on User {
  account {
    _id
    email
    status
    excludeFromReports
  }
  profile {
    _id
    firstName
    lastName
  }
}
    `;
export const ApiUserForListFragmentDoc = gql`
    fragment ApiUserForList on ApiUser {
  account {
    _id
    email
    status
    excludeFromReports
    mfaEnabled
  }
  profile {
    _id
    firstName
    lastName
  }
  apiCredentials {
    _id
    companyName
    referralCode
    appId
    adminDisabled
    deleted
    deletedAt
    disabledAt
    disabledReason
  }
  clientCount
  monthlyApiAccess
}
    `;
export const AuthorizationDocument = gql`
    mutation authorization($email: String!, $password: String!) {
  authorization(email: $email, password: $password) {
    ...TokensModel
  }
}
    ${TokensModelFragmentDoc}`;
export type AuthorizationMutationFn = Apollo.MutationFunction<AuthorizationMutation, AuthorizationMutationVariables>;

/**
 * __useAuthorizationMutation__
 *
 * To run a mutation, you first call `useAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authorizationMutation, { data, loading, error }] = useAuthorizationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<AuthorizationMutation, AuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthorizationMutation, AuthorizationMutationVariables>(AuthorizationDocument, options);
      }
export type AuthorizationMutationHookResult = ReturnType<typeof useAuthorizationMutation>;
export type AuthorizationMutationResult = Apollo.MutationResult<AuthorizationMutation>;
export type AuthorizationMutationOptions = Apollo.BaseMutationOptions<AuthorizationMutation, AuthorizationMutationVariables>;
export const RefreshTokensDocument = gql`
    mutation refreshTokens {
  refreshTokens {
    ...TokensModel
  }
}
    ${TokensModelFragmentDoc}`;
export type RefreshTokensMutationFn = Apollo.MutationFunction<RefreshTokensMutation, RefreshTokensMutationVariables>;

/**
 * __useRefreshTokensMutation__
 *
 * To run a mutation, you first call `useRefreshTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokensMutation, { data, loading, error }] = useRefreshTokensMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokensMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokensMutation, RefreshTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokensMutation, RefreshTokensMutationVariables>(RefreshTokensDocument, options);
      }
export type RefreshTokensMutationHookResult = ReturnType<typeof useRefreshTokensMutation>;
export type RefreshTokensMutationResult = Apollo.MutationResult<RefreshTokensMutation>;
export type RefreshTokensMutationOptions = Apollo.BaseMutationOptions<RefreshTokensMutation, RefreshTokensMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($newPassword: String!) {
  resetPassword(newPassword: $newPassword)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($oldPassword: String!, $newPassword: String!) {
  updatePassword(oldPassword: $oldPassword, newPassword: $newPassword)
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const UpdateEmailDocument = gql`
    mutation updateEmail($password: String!, $newEmail: String!) {
  updateEmail(password: $password, newEmail: $newEmail) {
    accessToken
    refreshTokenExpiry
    refreshToken
  }
}
    `;
export type UpdateEmailMutationFn = Apollo.MutationFunction<UpdateEmailMutation, UpdateEmailMutationVariables>;

/**
 * __useUpdateEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMutation, { data, loading, error }] = useUpdateEmailMutation({
 *   variables: {
 *      password: // value for 'password'
 *      newEmail: // value for 'newEmail'
 *   },
 * });
 */
export function useUpdateEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailMutation, UpdateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument, options);
      }
export type UpdateEmailMutationHookResult = ReturnType<typeof useUpdateEmailMutation>;
export type UpdateEmailMutationResult = Apollo.MutationResult<UpdateEmailMutation>;
export type UpdateEmailMutationOptions = Apollo.BaseMutationOptions<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const TemporaryAuthenticationDocument = gql`
    mutation temporaryAuthentication($email: String!, $password: String!) {
  temporaryAuthentication(email: $email, password: $password) {
    tempToken
    account {
      _id
      email
      mfaEnabled
    }
  }
}
    `;
export type TemporaryAuthenticationMutationFn = Apollo.MutationFunction<TemporaryAuthenticationMutation, TemporaryAuthenticationMutationVariables>;

/**
 * __useTemporaryAuthenticationMutation__
 *
 * To run a mutation, you first call `useTemporaryAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemporaryAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [temporaryAuthenticationMutation, { data, loading, error }] = useTemporaryAuthenticationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useTemporaryAuthenticationMutation(baseOptions?: Apollo.MutationHookOptions<TemporaryAuthenticationMutation, TemporaryAuthenticationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemporaryAuthenticationMutation, TemporaryAuthenticationMutationVariables>(TemporaryAuthenticationDocument, options);
      }
export type TemporaryAuthenticationMutationHookResult = ReturnType<typeof useTemporaryAuthenticationMutation>;
export type TemporaryAuthenticationMutationResult = Apollo.MutationResult<TemporaryAuthenticationMutation>;
export type TemporaryAuthenticationMutationOptions = Apollo.BaseMutationOptions<TemporaryAuthenticationMutation, TemporaryAuthenticationMutationVariables>;
export const GetAccountDocument = gql`
    query getAccount {
  getAccount {
    _id
    email
  }
}
    `;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const GetFullAccountDocument = gql`
    query getFullAccount {
  getAccount {
    profile {
      ...Profile
    }
    ...Account
  }
}
    ${ProfileFragmentDoc}
${AccountFragmentDoc}`;

/**
 * __useGetFullAccountQuery__
 *
 * To run a query within a React component, call `useGetFullAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFullAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetFullAccountQuery, GetFullAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullAccountQuery, GetFullAccountQueryVariables>(GetFullAccountDocument, options);
      }
export function useGetFullAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullAccountQuery, GetFullAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullAccountQuery, GetFullAccountQueryVariables>(GetFullAccountDocument, options);
        }
export type GetFullAccountQueryHookResult = ReturnType<typeof useGetFullAccountQuery>;
export type GetFullAccountLazyQueryHookResult = ReturnType<typeof useGetFullAccountLazyQuery>;
export type GetFullAccountQueryResult = Apollo.QueryResult<GetFullAccountQuery, GetFullAccountQueryVariables>;
export const CreateAmenityDocument = gql`
    mutation createAmenity($input: CreateAmenityInput!) {
  createAmenity(input: $input) {
    ...Amenity
  }
}
    ${AmenityFragmentDoc}`;
export type CreateAmenityMutationFn = Apollo.MutationFunction<CreateAmenityMutation, CreateAmenityMutationVariables>;

/**
 * __useCreateAmenityMutation__
 *
 * To run a mutation, you first call `useCreateAmenityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAmenityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAmenityMutation, { data, loading, error }] = useCreateAmenityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAmenityMutation(baseOptions?: Apollo.MutationHookOptions<CreateAmenityMutation, CreateAmenityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAmenityMutation, CreateAmenityMutationVariables>(CreateAmenityDocument, options);
      }
export type CreateAmenityMutationHookResult = ReturnType<typeof useCreateAmenityMutation>;
export type CreateAmenityMutationResult = Apollo.MutationResult<CreateAmenityMutation>;
export type CreateAmenityMutationOptions = Apollo.BaseMutationOptions<CreateAmenityMutation, CreateAmenityMutationVariables>;
export const EditAmenityDocument = gql`
    mutation editAmenity($input: EditAmenityInput!) {
  editAmenity(input: $input) {
    ...Amenity
  }
}
    ${AmenityFragmentDoc}`;
export type EditAmenityMutationFn = Apollo.MutationFunction<EditAmenityMutation, EditAmenityMutationVariables>;

/**
 * __useEditAmenityMutation__
 *
 * To run a mutation, you first call `useEditAmenityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAmenityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAmenityMutation, { data, loading, error }] = useEditAmenityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAmenityMutation(baseOptions?: Apollo.MutationHookOptions<EditAmenityMutation, EditAmenityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAmenityMutation, EditAmenityMutationVariables>(EditAmenityDocument, options);
      }
export type EditAmenityMutationHookResult = ReturnType<typeof useEditAmenityMutation>;
export type EditAmenityMutationResult = Apollo.MutationResult<EditAmenityMutation>;
export type EditAmenityMutationOptions = Apollo.BaseMutationOptions<EditAmenityMutation, EditAmenityMutationVariables>;
export const DeleteAmenityDocument = gql`
    mutation deleteAmenity($amenityId: ObjectId!) {
  deleteAmenity(amenityId: $amenityId) {
    _id
  }
}
    `;
export type DeleteAmenityMutationFn = Apollo.MutationFunction<DeleteAmenityMutation, DeleteAmenityMutationVariables>;

/**
 * __useDeleteAmenityMutation__
 *
 * To run a mutation, you first call `useDeleteAmenityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAmenityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAmenityMutation, { data, loading, error }] = useDeleteAmenityMutation({
 *   variables: {
 *      amenityId: // value for 'amenityId'
 *   },
 * });
 */
export function useDeleteAmenityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAmenityMutation, DeleteAmenityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAmenityMutation, DeleteAmenityMutationVariables>(DeleteAmenityDocument, options);
      }
export type DeleteAmenityMutationHookResult = ReturnType<typeof useDeleteAmenityMutation>;
export type DeleteAmenityMutationResult = Apollo.MutationResult<DeleteAmenityMutation>;
export type DeleteAmenityMutationOptions = Apollo.BaseMutationOptions<DeleteAmenityMutation, DeleteAmenityMutationVariables>;
export const GetAmenitiesDocument = gql`
    query getAmenities($sort: [SortInput!], $pagination: PaginationInput, $filter: GetAmenitiesFilterInput) {
  getAmenities(sort: $sort, pagination: $pagination, filter: $filter) {
    totalCount
    collection {
      ...Amenity
    }
  }
}
    ${AmenityFragmentDoc}`;

/**
 * __useGetAmenitiesQuery__
 *
 * To run a query within a React component, call `useGetAmenitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmenitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmenitiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAmenitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAmenitiesQuery, GetAmenitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmenitiesQuery, GetAmenitiesQueryVariables>(GetAmenitiesDocument, options);
      }
export function useGetAmenitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmenitiesQuery, GetAmenitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmenitiesQuery, GetAmenitiesQueryVariables>(GetAmenitiesDocument, options);
        }
export type GetAmenitiesQueryHookResult = ReturnType<typeof useGetAmenitiesQuery>;
export type GetAmenitiesLazyQueryHookResult = ReturnType<typeof useGetAmenitiesLazyQuery>;
export type GetAmenitiesQueryResult = Apollo.QueryResult<GetAmenitiesQuery, GetAmenitiesQueryVariables>;
export const GetAmenitiesForManageDocument = gql`
    query getAmenitiesForManage($sort: [SortInput!], $pagination: PaginationInput, $filter: GetAmenitiesForManageFilterInput!) {
  getAmenitiesForManage(sort: $sort, pagination: $pagination, filter: $filter) {
    totalCount
    collection {
      ...Amenity
    }
  }
}
    ${AmenityFragmentDoc}`;

/**
 * __useGetAmenitiesForManageQuery__
 *
 * To run a query within a React component, call `useGetAmenitiesForManageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmenitiesForManageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmenitiesForManageQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAmenitiesForManageQuery(baseOptions: Apollo.QueryHookOptions<GetAmenitiesForManageQuery, GetAmenitiesForManageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmenitiesForManageQuery, GetAmenitiesForManageQueryVariables>(GetAmenitiesForManageDocument, options);
      }
export function useGetAmenitiesForManageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmenitiesForManageQuery, GetAmenitiesForManageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmenitiesForManageQuery, GetAmenitiesForManageQueryVariables>(GetAmenitiesForManageDocument, options);
        }
export type GetAmenitiesForManageQueryHookResult = ReturnType<typeof useGetAmenitiesForManageQuery>;
export type GetAmenitiesForManageLazyQueryHookResult = ReturnType<typeof useGetAmenitiesForManageLazyQuery>;
export type GetAmenitiesForManageQueryResult = Apollo.QueryResult<GetAmenitiesForManageQuery, GetAmenitiesForManageQueryVariables>;
export const GetApiPluginUsersDocument = gql`
    query GetApiPluginUsers($filter: GetApiUsersFilterInput, $pagination: PaginationInput, $sort: [SortInput!]) {
  getApiPluginUsers(filter: $filter, pagination: $pagination, sort: $sort) {
    collection {
      ...ApiPluginUserForList
    }
    totalCount
  }
}
    ${ApiPluginUserForListFragmentDoc}`;

/**
 * __useGetApiPluginUsersQuery__
 *
 * To run a query within a React component, call `useGetApiPluginUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiPluginUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiPluginUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetApiPluginUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetApiPluginUsersQuery, GetApiPluginUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiPluginUsersQuery, GetApiPluginUsersQueryVariables>(GetApiPluginUsersDocument, options);
      }
export function useGetApiPluginUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiPluginUsersQuery, GetApiPluginUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiPluginUsersQuery, GetApiPluginUsersQueryVariables>(GetApiPluginUsersDocument, options);
        }
export type GetApiPluginUsersQueryHookResult = ReturnType<typeof useGetApiPluginUsersQuery>;
export type GetApiPluginUsersLazyQueryHookResult = ReturnType<typeof useGetApiPluginUsersLazyQuery>;
export type GetApiPluginUsersQueryResult = Apollo.QueryResult<GetApiPluginUsersQuery, GetApiPluginUsersQueryVariables>;
export const GetApiCredentialsByIdDocument = gql`
    query GetApiCredentialsById($apiCredentialsId: String!) {
  getApiCredentialsById(apiCredentialsId: $apiCredentialsId) {
    appId
    companyName
    monthlyRequestLimit
    adminDisabled
    _id
    type
    isActive
    referralCode
    partnerDisabled
    deleted
    deletedAt
    disabledAt
    disabledReason
    disabledBy
  }
}
    `;

/**
 * __useGetApiCredentialsByIdQuery__
 *
 * To run a query within a React component, call `useGetApiCredentialsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiCredentialsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiCredentialsByIdQuery({
 *   variables: {
 *      apiCredentialsId: // value for 'apiCredentialsId'
 *   },
 * });
 */
export function useGetApiCredentialsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetApiCredentialsByIdQuery, GetApiCredentialsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiCredentialsByIdQuery, GetApiCredentialsByIdQueryVariables>(GetApiCredentialsByIdDocument, options);
      }
export function useGetApiCredentialsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiCredentialsByIdQuery, GetApiCredentialsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiCredentialsByIdQuery, GetApiCredentialsByIdQueryVariables>(GetApiCredentialsByIdDocument, options);
        }
export type GetApiCredentialsByIdQueryHookResult = ReturnType<typeof useGetApiCredentialsByIdQuery>;
export type GetApiCredentialsByIdLazyQueryHookResult = ReturnType<typeof useGetApiCredentialsByIdLazyQuery>;
export type GetApiCredentialsByIdQueryResult = Apollo.QueryResult<GetApiCredentialsByIdQuery, GetApiCredentialsByIdQueryVariables>;
export const SetApiCredentialAdminDisabledDocument = gql`
    mutation SetApiCredentialAdminDisabled($apiCredentialsId: String!, $adminDisabled: Boolean!, $reason: String) {
  setApiCredentialAdminDisabled(
    apiCredentialsId: $apiCredentialsId
    adminDisabled: $adminDisabled
    reason: $reason
  ) {
    _id
    appId
    adminDisabled
    isActive
    disabledAt
    disabledReason
  }
}
    `;
export type SetApiCredentialAdminDisabledMutationFn = Apollo.MutationFunction<SetApiCredentialAdminDisabledMutation, SetApiCredentialAdminDisabledMutationVariables>;

/**
 * __useSetApiCredentialAdminDisabledMutation__
 *
 * To run a mutation, you first call `useSetApiCredentialAdminDisabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetApiCredentialAdminDisabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setApiCredentialAdminDisabledMutation, { data, loading, error }] = useSetApiCredentialAdminDisabledMutation({
 *   variables: {
 *      apiCredentialsId: // value for 'apiCredentialsId'
 *      adminDisabled: // value for 'adminDisabled'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useSetApiCredentialAdminDisabledMutation(baseOptions?: Apollo.MutationHookOptions<SetApiCredentialAdminDisabledMutation, SetApiCredentialAdminDisabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetApiCredentialAdminDisabledMutation, SetApiCredentialAdminDisabledMutationVariables>(SetApiCredentialAdminDisabledDocument, options);
      }
export type SetApiCredentialAdminDisabledMutationHookResult = ReturnType<typeof useSetApiCredentialAdminDisabledMutation>;
export type SetApiCredentialAdminDisabledMutationResult = Apollo.MutationResult<SetApiCredentialAdminDisabledMutation>;
export type SetApiCredentialAdminDisabledMutationOptions = Apollo.BaseMutationOptions<SetApiCredentialAdminDisabledMutation, SetApiCredentialAdminDisabledMutationVariables>;
export const SetApiCredentialMonthlyRequestLimitDocument = gql`
    mutation SetApiCredentialMonthlyRequestLimit($apiCredentialsId: String!, $monthlyRequestLimit: Int) {
  setApiCredentialMonthlyRequestLimit(
    apiCredentialsId: $apiCredentialsId
    monthlyRequestLimit: $monthlyRequestLimit
  ) {
    _id
    appId
    monthlyRequestLimit
  }
}
    `;
export type SetApiCredentialMonthlyRequestLimitMutationFn = Apollo.MutationFunction<SetApiCredentialMonthlyRequestLimitMutation, SetApiCredentialMonthlyRequestLimitMutationVariables>;

/**
 * __useSetApiCredentialMonthlyRequestLimitMutation__
 *
 * To run a mutation, you first call `useSetApiCredentialMonthlyRequestLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetApiCredentialMonthlyRequestLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setApiCredentialMonthlyRequestLimitMutation, { data, loading, error }] = useSetApiCredentialMonthlyRequestLimitMutation({
 *   variables: {
 *      apiCredentialsId: // value for 'apiCredentialsId'
 *      monthlyRequestLimit: // value for 'monthlyRequestLimit'
 *   },
 * });
 */
export function useSetApiCredentialMonthlyRequestLimitMutation(baseOptions?: Apollo.MutationHookOptions<SetApiCredentialMonthlyRequestLimitMutation, SetApiCredentialMonthlyRequestLimitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetApiCredentialMonthlyRequestLimitMutation, SetApiCredentialMonthlyRequestLimitMutationVariables>(SetApiCredentialMonthlyRequestLimitDocument, options);
      }
export type SetApiCredentialMonthlyRequestLimitMutationHookResult = ReturnType<typeof useSetApiCredentialMonthlyRequestLimitMutation>;
export type SetApiCredentialMonthlyRequestLimitMutationResult = Apollo.MutationResult<SetApiCredentialMonthlyRequestLimitMutation>;
export type SetApiCredentialMonthlyRequestLimitMutationOptions = Apollo.BaseMutationOptions<SetApiCredentialMonthlyRequestLimitMutation, SetApiCredentialMonthlyRequestLimitMutationVariables>;
export const GetUserByApiCredentialsIdDocument = gql`
    query GetUserByApiCredentialsId($filter: GetUserByApiCredentialsFilterInput!) {
  getUserByApiCredentialsId(filter: $filter) {
    ...ApiPluginUserForList
  }
}
    ${ApiPluginUserForListFragmentDoc}`;

/**
 * __useGetUserByApiCredentialsIdQuery__
 *
 * To run a query within a React component, call `useGetUserByApiCredentialsIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByApiCredentialsIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByApiCredentialsIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUserByApiCredentialsIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByApiCredentialsIdQuery, GetUserByApiCredentialsIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByApiCredentialsIdQuery, GetUserByApiCredentialsIdQueryVariables>(GetUserByApiCredentialsIdDocument, options);
      }
export function useGetUserByApiCredentialsIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByApiCredentialsIdQuery, GetUserByApiCredentialsIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByApiCredentialsIdQuery, GetUserByApiCredentialsIdQueryVariables>(GetUserByApiCredentialsIdDocument, options);
        }
export type GetUserByApiCredentialsIdQueryHookResult = ReturnType<typeof useGetUserByApiCredentialsIdQuery>;
export type GetUserByApiCredentialsIdLazyQueryHookResult = ReturnType<typeof useGetUserByApiCredentialsIdLazyQuery>;
export type GetUserByApiCredentialsIdQueryResult = Apollo.QueryResult<GetUserByApiCredentialsIdQuery, GetUserByApiCredentialsIdQueryVariables>;
export const CreateApiInvitationDocument = gql`
    mutation CreateApiInvitation($input: CreateApiInvitationInput!) {
  createApiInvitation(input: $input) {
    ...ApiInvitationForList
  }
}
    ${ApiInvitationForListFragmentDoc}`;
export type CreateApiInvitationMutationFn = Apollo.MutationFunction<CreateApiInvitationMutation, CreateApiInvitationMutationVariables>;

/**
 * __useCreateApiInvitationMutation__
 *
 * To run a mutation, you first call `useCreateApiInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiInvitationMutation, { data, loading, error }] = useCreateApiInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiInvitationMutation, CreateApiInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiInvitationMutation, CreateApiInvitationMutationVariables>(CreateApiInvitationDocument, options);
      }
export type CreateApiInvitationMutationHookResult = ReturnType<typeof useCreateApiInvitationMutation>;
export type CreateApiInvitationMutationResult = Apollo.MutationResult<CreateApiInvitationMutation>;
export type CreateApiInvitationMutationOptions = Apollo.BaseMutationOptions<CreateApiInvitationMutation, CreateApiInvitationMutationVariables>;
export const RevokeApiInvitationDocument = gql`
    mutation RevokeApiInvitation($invitationId: String!) {
  revokeApiInvitation(invitationId: $invitationId) {
    ...ApiInvitationForList
  }
}
    ${ApiInvitationForListFragmentDoc}`;
export type RevokeApiInvitationMutationFn = Apollo.MutationFunction<RevokeApiInvitationMutation, RevokeApiInvitationMutationVariables>;

/**
 * __useRevokeApiInvitationMutation__
 *
 * To run a mutation, you first call `useRevokeApiInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiInvitationMutation, { data, loading, error }] = useRevokeApiInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useRevokeApiInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RevokeApiInvitationMutation, RevokeApiInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeApiInvitationMutation, RevokeApiInvitationMutationVariables>(RevokeApiInvitationDocument, options);
      }
export type RevokeApiInvitationMutationHookResult = ReturnType<typeof useRevokeApiInvitationMutation>;
export type RevokeApiInvitationMutationResult = Apollo.MutationResult<RevokeApiInvitationMutation>;
export type RevokeApiInvitationMutationOptions = Apollo.BaseMutationOptions<RevokeApiInvitationMutation, RevokeApiInvitationMutationVariables>;
export const ResendApiInvitationDocument = gql`
    mutation ResendApiInvitation($input: ResendApiInvitationInput!) {
  resendApiInvitation(input: $input) {
    ...ApiInvitationForList
  }
}
    ${ApiInvitationForListFragmentDoc}`;
export type ResendApiInvitationMutationFn = Apollo.MutationFunction<ResendApiInvitationMutation, ResendApiInvitationMutationVariables>;

/**
 * __useResendApiInvitationMutation__
 *
 * To run a mutation, you first call `useResendApiInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendApiInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendApiInvitationMutation, { data, loading, error }] = useResendApiInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendApiInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendApiInvitationMutation, ResendApiInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendApiInvitationMutation, ResendApiInvitationMutationVariables>(ResendApiInvitationDocument, options);
      }
export type ResendApiInvitationMutationHookResult = ReturnType<typeof useResendApiInvitationMutation>;
export type ResendApiInvitationMutationResult = Apollo.MutationResult<ResendApiInvitationMutation>;
export type ResendApiInvitationMutationOptions = Apollo.BaseMutationOptions<ResendApiInvitationMutation, ResendApiInvitationMutationVariables>;
export const GetApiInvitationsDocument = gql`
    query GetApiInvitations($status: ApiInvitationStatusEnum, $searchText: String) {
  apiInvitations(status: $status, searchText: $searchText) {
    collection {
      ...ApiInvitationForList
    }
    totalCount
  }
}
    ${ApiInvitationForListFragmentDoc}`;

/**
 * __useGetApiInvitationsQuery__
 *
 * To run a query within a React component, call `useGetApiInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiInvitationsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetApiInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<GetApiInvitationsQuery, GetApiInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiInvitationsQuery, GetApiInvitationsQueryVariables>(GetApiInvitationsDocument, options);
      }
export function useGetApiInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiInvitationsQuery, GetApiInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiInvitationsQuery, GetApiInvitationsQueryVariables>(GetApiInvitationsDocument, options);
        }
export type GetApiInvitationsQueryHookResult = ReturnType<typeof useGetApiInvitationsQuery>;
export type GetApiInvitationsLazyQueryHookResult = ReturnType<typeof useGetApiInvitationsLazyQuery>;
export type GetApiInvitationsQueryResult = Apollo.QueryResult<GetApiInvitationsQuery, GetApiInvitationsQueryVariables>;
export const GetTotalApiUsageDocument = gql`
    query getTotalApiUsage($pagination: PaginationInput, $filter: TotalApiUsageFilterInput) {
  getTotalApiUsage(pagination: $pagination, filter: $filter) {
    collection {
      ...ApiMetric
    }
    totalCount
  }
}
    ${ApiMetricFragmentDoc}`;

/**
 * __useGetTotalApiUsageQuery__
 *
 * To run a query within a React component, call `useGetTotalApiUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalApiUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalApiUsageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTotalApiUsageQuery(baseOptions?: Apollo.QueryHookOptions<GetTotalApiUsageQuery, GetTotalApiUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalApiUsageQuery, GetTotalApiUsageQueryVariables>(GetTotalApiUsageDocument, options);
      }
export function useGetTotalApiUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalApiUsageQuery, GetTotalApiUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalApiUsageQuery, GetTotalApiUsageQueryVariables>(GetTotalApiUsageDocument, options);
        }
export type GetTotalApiUsageQueryHookResult = ReturnType<typeof useGetTotalApiUsageQuery>;
export type GetTotalApiUsageLazyQueryHookResult = ReturnType<typeof useGetTotalApiUsageLazyQuery>;
export type GetTotalApiUsageQueryResult = Apollo.QueryResult<GetTotalApiUsageQuery, GetTotalApiUsageQueryVariables>;
export const GetApiQuotaStatusByAppIdDocument = gql`
    query getApiQuotaStatusByAppId($appId: String!) {
  getApiQuotaStatusByAppId(appId: $appId) {
    usage
    limit
    resetDate
  }
}
    `;

/**
 * __useGetApiQuotaStatusByAppIdQuery__
 *
 * To run a query within a React component, call `useGetApiQuotaStatusByAppIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiQuotaStatusByAppIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiQuotaStatusByAppIdQuery({
 *   variables: {
 *      appId: // value for 'appId'
 *   },
 * });
 */
export function useGetApiQuotaStatusByAppIdQuery(baseOptions: Apollo.QueryHookOptions<GetApiQuotaStatusByAppIdQuery, GetApiQuotaStatusByAppIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiQuotaStatusByAppIdQuery, GetApiQuotaStatusByAppIdQueryVariables>(GetApiQuotaStatusByAppIdDocument, options);
      }
export function useGetApiQuotaStatusByAppIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiQuotaStatusByAppIdQuery, GetApiQuotaStatusByAppIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiQuotaStatusByAppIdQuery, GetApiQuotaStatusByAppIdQueryVariables>(GetApiQuotaStatusByAppIdDocument, options);
        }
export type GetApiQuotaStatusByAppIdQueryHookResult = ReturnType<typeof useGetApiQuotaStatusByAppIdQuery>;
export type GetApiQuotaStatusByAppIdLazyQueryHookResult = ReturnType<typeof useGetApiQuotaStatusByAppIdLazyQuery>;
export type GetApiQuotaStatusByAppIdQueryResult = Apollo.QueryResult<GetApiQuotaStatusByAppIdQuery, GetApiQuotaStatusByAppIdQueryVariables>;
export const EnableMFaDocument = gql`
    mutation EnableMFa($token: String!) {
  enableMfa(token: $token) {
    accessToken
    refreshToken
    refreshTokenExpiry
  }
}
    `;
export type EnableMFaMutationFn = Apollo.MutationFunction<EnableMFaMutation, EnableMFaMutationVariables>;

/**
 * __useEnableMFaMutation__
 *
 * To run a mutation, you first call `useEnableMFaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableMFaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableMFaMutation, { data, loading, error }] = useEnableMFaMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useEnableMFaMutation(baseOptions?: Apollo.MutationHookOptions<EnableMFaMutation, EnableMFaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableMFaMutation, EnableMFaMutationVariables>(EnableMFaDocument, options);
      }
export type EnableMFaMutationHookResult = ReturnType<typeof useEnableMFaMutation>;
export type EnableMFaMutationResult = Apollo.MutationResult<EnableMFaMutation>;
export type EnableMFaMutationOptions = Apollo.BaseMutationOptions<EnableMFaMutation, EnableMFaMutationVariables>;
export const MfaAuthenticationDocument = gql`
    mutation MfaAuthentication($token: String!) {
  mfaAuthentication(token: $token) {
    accessToken
    refreshToken
    refreshTokenExpiry
  }
}
    `;
export type MfaAuthenticationMutationFn = Apollo.MutationFunction<MfaAuthenticationMutation, MfaAuthenticationMutationVariables>;

/**
 * __useMfaAuthenticationMutation__
 *
 * To run a mutation, you first call `useMfaAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfaAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfaAuthenticationMutation, { data, loading, error }] = useMfaAuthenticationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useMfaAuthenticationMutation(baseOptions?: Apollo.MutationHookOptions<MfaAuthenticationMutation, MfaAuthenticationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfaAuthenticationMutation, MfaAuthenticationMutationVariables>(MfaAuthenticationDocument, options);
      }
export type MfaAuthenticationMutationHookResult = ReturnType<typeof useMfaAuthenticationMutation>;
export type MfaAuthenticationMutationResult = Apollo.MutationResult<MfaAuthenticationMutation>;
export type MfaAuthenticationMutationOptions = Apollo.BaseMutationOptions<MfaAuthenticationMutation, MfaAuthenticationMutationVariables>;
export const GenerateMfaqrCodeDocument = gql`
    query GenerateMFAQRCode {
  generateMfaQrCode {
    qrCode
  }
}
    `;

/**
 * __useGenerateMfaqrCodeQuery__
 *
 * To run a query within a React component, call `useGenerateMfaqrCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateMfaqrCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateMfaqrCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateMfaqrCodeQuery(baseOptions?: Apollo.QueryHookOptions<GenerateMfaqrCodeQuery, GenerateMfaqrCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateMfaqrCodeQuery, GenerateMfaqrCodeQueryVariables>(GenerateMfaqrCodeDocument, options);
      }
export function useGenerateMfaqrCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateMfaqrCodeQuery, GenerateMfaqrCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateMfaqrCodeQuery, GenerateMfaqrCodeQueryVariables>(GenerateMfaqrCodeDocument, options);
        }
export type GenerateMfaqrCodeQueryHookResult = ReturnType<typeof useGenerateMfaqrCodeQuery>;
export type GenerateMfaqrCodeLazyQueryHookResult = ReturnType<typeof useGenerateMfaqrCodeLazyQuery>;
export type GenerateMfaqrCodeQueryResult = Apollo.QueryResult<GenerateMfaqrCodeQuery, GenerateMfaqrCodeQueryVariables>;
export const UpdateBrokerDocument = gql`
    mutation updateBroker($brokerId: ObjectId!, $input: UpdateBrokerInCMSInput!) {
  updateBroker(brokerId: $brokerId, input: $input) {
    ...Broker
  }
}
    ${BrokerFragmentDoc}`;
export type UpdateBrokerMutationFn = Apollo.MutationFunction<UpdateBrokerMutation, UpdateBrokerMutationVariables>;

/**
 * __useUpdateBrokerMutation__
 *
 * To run a mutation, you first call `useUpdateBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrokerMutation, { data, loading, error }] = useUpdateBrokerMutation({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrokerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrokerMutation, UpdateBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrokerMutation, UpdateBrokerMutationVariables>(UpdateBrokerDocument, options);
      }
export type UpdateBrokerMutationHookResult = ReturnType<typeof useUpdateBrokerMutation>;
export type UpdateBrokerMutationResult = Apollo.MutationResult<UpdateBrokerMutation>;
export type UpdateBrokerMutationOptions = Apollo.BaseMutationOptions<UpdateBrokerMutation, UpdateBrokerMutationVariables>;
export const UpdateBrokerLicenseStatusDocument = gql`
    mutation updateBrokerLicenseStatus($brokerId: ObjectId!, $input: UpdateBrokerLicenseStatusInput!) {
  updateBrokerLicenseStatus(brokerId: $brokerId, input: $input) {
    ...Broker
  }
}
    ${BrokerFragmentDoc}`;
export type UpdateBrokerLicenseStatusMutationFn = Apollo.MutationFunction<UpdateBrokerLicenseStatusMutation, UpdateBrokerLicenseStatusMutationVariables>;

/**
 * __useUpdateBrokerLicenseStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBrokerLicenseStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrokerLicenseStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrokerLicenseStatusMutation, { data, loading, error }] = useUpdateBrokerLicenseStatusMutation({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrokerLicenseStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrokerLicenseStatusMutation, UpdateBrokerLicenseStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrokerLicenseStatusMutation, UpdateBrokerLicenseStatusMutationVariables>(UpdateBrokerLicenseStatusDocument, options);
      }
export type UpdateBrokerLicenseStatusMutationHookResult = ReturnType<typeof useUpdateBrokerLicenseStatusMutation>;
export type UpdateBrokerLicenseStatusMutationResult = Apollo.MutationResult<UpdateBrokerLicenseStatusMutation>;
export type UpdateBrokerLicenseStatusMutationOptions = Apollo.BaseMutationOptions<UpdateBrokerLicenseStatusMutation, UpdateBrokerLicenseStatusMutationVariables>;
export const BlockBrokerDocument = gql`
    mutation blockBroker($brokerId: ObjectId!, $archivingReason: String!) {
  archiveBroker(brokerId: $brokerId, archivingReason: $archivingReason) {
    _id
  }
}
    `;
export type BlockBrokerMutationFn = Apollo.MutationFunction<BlockBrokerMutation, BlockBrokerMutationVariables>;

/**
 * __useBlockBrokerMutation__
 *
 * To run a mutation, you first call `useBlockBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockBrokerMutation, { data, loading, error }] = useBlockBrokerMutation({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *      archivingReason: // value for 'archivingReason'
 *   },
 * });
 */
export function useBlockBrokerMutation(baseOptions?: Apollo.MutationHookOptions<BlockBrokerMutation, BlockBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockBrokerMutation, BlockBrokerMutationVariables>(BlockBrokerDocument, options);
      }
export type BlockBrokerMutationHookResult = ReturnType<typeof useBlockBrokerMutation>;
export type BlockBrokerMutationResult = Apollo.MutationResult<BlockBrokerMutation>;
export type BlockBrokerMutationOptions = Apollo.BaseMutationOptions<BlockBrokerMutation, BlockBrokerMutationVariables>;
export const UnblockBrokerDocument = gql`
    mutation unblockBroker($brokerId: ObjectId!) {
  unarchiveBroker(brokerId: $brokerId) {
    _id
  }
}
    `;
export type UnblockBrokerMutationFn = Apollo.MutationFunction<UnblockBrokerMutation, UnblockBrokerMutationVariables>;

/**
 * __useUnblockBrokerMutation__
 *
 * To run a mutation, you first call `useUnblockBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockBrokerMutation, { data, loading, error }] = useUnblockBrokerMutation({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *   },
 * });
 */
export function useUnblockBrokerMutation(baseOptions?: Apollo.MutationHookOptions<UnblockBrokerMutation, UnblockBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockBrokerMutation, UnblockBrokerMutationVariables>(UnblockBrokerDocument, options);
      }
export type UnblockBrokerMutationHookResult = ReturnType<typeof useUnblockBrokerMutation>;
export type UnblockBrokerMutationResult = Apollo.MutationResult<UnblockBrokerMutation>;
export type UnblockBrokerMutationOptions = Apollo.BaseMutationOptions<UnblockBrokerMutation, UnblockBrokerMutationVariables>;
export const DeleteBrokerDocument = gql`
    mutation deleteBroker($brokerId: ObjectId!) {
  deleteBroker(brokerId: $brokerId) {
    _id
  }
}
    `;
export type DeleteBrokerMutationFn = Apollo.MutationFunction<DeleteBrokerMutation, DeleteBrokerMutationVariables>;

/**
 * __useDeleteBrokerMutation__
 *
 * To run a mutation, you first call `useDeleteBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrokerMutation, { data, loading, error }] = useDeleteBrokerMutation({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *   },
 * });
 */
export function useDeleteBrokerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBrokerMutation, DeleteBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBrokerMutation, DeleteBrokerMutationVariables>(DeleteBrokerDocument, options);
      }
export type DeleteBrokerMutationHookResult = ReturnType<typeof useDeleteBrokerMutation>;
export type DeleteBrokerMutationResult = Apollo.MutationResult<DeleteBrokerMutation>;
export type DeleteBrokerMutationOptions = Apollo.BaseMutationOptions<DeleteBrokerMutation, DeleteBrokerMutationVariables>;
export const SetBrokerShowAllBillingPlansDocument = gql`
    mutation setBrokerShowAllBillingPlans($brokerId: ObjectId!, $showAllBillingPlans: Boolean!) {
  setBrokerShowAllBillingPlans(
    brokerId: $brokerId
    showAllBillingPlans: $showAllBillingPlans
  ) {
    ...Broker
  }
}
    ${BrokerFragmentDoc}`;
export type SetBrokerShowAllBillingPlansMutationFn = Apollo.MutationFunction<SetBrokerShowAllBillingPlansMutation, SetBrokerShowAllBillingPlansMutationVariables>;

/**
 * __useSetBrokerShowAllBillingPlansMutation__
 *
 * To run a mutation, you first call `useSetBrokerShowAllBillingPlansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBrokerShowAllBillingPlansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBrokerShowAllBillingPlansMutation, { data, loading, error }] = useSetBrokerShowAllBillingPlansMutation({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *      showAllBillingPlans: // value for 'showAllBillingPlans'
 *   },
 * });
 */
export function useSetBrokerShowAllBillingPlansMutation(baseOptions?: Apollo.MutationHookOptions<SetBrokerShowAllBillingPlansMutation, SetBrokerShowAllBillingPlansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBrokerShowAllBillingPlansMutation, SetBrokerShowAllBillingPlansMutationVariables>(SetBrokerShowAllBillingPlansDocument, options);
      }
export type SetBrokerShowAllBillingPlansMutationHookResult = ReturnType<typeof useSetBrokerShowAllBillingPlansMutation>;
export type SetBrokerShowAllBillingPlansMutationResult = Apollo.MutationResult<SetBrokerShowAllBillingPlansMutation>;
export type SetBrokerShowAllBillingPlansMutationOptions = Apollo.BaseMutationOptions<SetBrokerShowAllBillingPlansMutation, SetBrokerShowAllBillingPlansMutationVariables>;
export const GetBrokersDocument = gql`
    query getBrokers($sort: [SortInput!], $pagination: PaginationInput, $filter: GetBrokersFilter) {
  getBrokers(sort: $sort, pagination: $pagination, filter: $filter) {
    totalCount
    collection {
      ...BrokerForList
    }
  }
}
    ${BrokerForListFragmentDoc}`;

/**
 * __useGetBrokersQuery__
 *
 * To run a query within a React component, call `useGetBrokersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBrokersQuery(baseOptions?: Apollo.QueryHookOptions<GetBrokersQuery, GetBrokersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrokersQuery, GetBrokersQueryVariables>(GetBrokersDocument, options);
      }
export function useGetBrokersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrokersQuery, GetBrokersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrokersQuery, GetBrokersQueryVariables>(GetBrokersDocument, options);
        }
export type GetBrokersQueryHookResult = ReturnType<typeof useGetBrokersQuery>;
export type GetBrokersLazyQueryHookResult = ReturnType<typeof useGetBrokersLazyQuery>;
export type GetBrokersQueryResult = Apollo.QueryResult<GetBrokersQuery, GetBrokersQueryVariables>;
export const GetBrokerByIdDocument = gql`
    query getBrokerById($brokerId: ObjectId!) {
  getSingleBrokerById(brokerId: $brokerId) {
    ...Broker
  }
}
    ${BrokerFragmentDoc}`;

/**
 * __useGetBrokerByIdQuery__
 *
 * To run a query within a React component, call `useGetBrokerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokerByIdQuery({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *   },
 * });
 */
export function useGetBrokerByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBrokerByIdQuery, GetBrokerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrokerByIdQuery, GetBrokerByIdQueryVariables>(GetBrokerByIdDocument, options);
      }
export function useGetBrokerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrokerByIdQuery, GetBrokerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrokerByIdQuery, GetBrokerByIdQueryVariables>(GetBrokerByIdDocument, options);
        }
export type GetBrokerByIdQueryHookResult = ReturnType<typeof useGetBrokerByIdQuery>;
export type GetBrokerByIdLazyQueryHookResult = ReturnType<typeof useGetBrokerByIdLazyQuery>;
export type GetBrokerByIdQueryResult = Apollo.QueryResult<GetBrokerByIdQuery, GetBrokerByIdQueryVariables>;
export const UpdateCmsSettingsDocument = gql`
    mutation updateCmsSettings($input: UpdateCmsSettingsInput!) {
  updateCmsSettings(input: $input) {
    _id
    newListingToActiveDays
    activeToAwaitingAuditDays
    recentlyUpdatedToActiveDays
    automatedTransitionsEnabled
    createdAt
    updatedAt
  }
}
    `;
export type UpdateCmsSettingsMutationFn = Apollo.MutationFunction<UpdateCmsSettingsMutation, UpdateCmsSettingsMutationVariables>;

/**
 * __useUpdateCmsSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCmsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCmsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCmsSettingsMutation, { data, loading, error }] = useUpdateCmsSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCmsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCmsSettingsMutation, UpdateCmsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCmsSettingsMutation, UpdateCmsSettingsMutationVariables>(UpdateCmsSettingsDocument, options);
      }
export type UpdateCmsSettingsMutationHookResult = ReturnType<typeof useUpdateCmsSettingsMutation>;
export type UpdateCmsSettingsMutationResult = Apollo.MutationResult<UpdateCmsSettingsMutation>;
export type UpdateCmsSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCmsSettingsMutation, UpdateCmsSettingsMutationVariables>;
export const ResetCmsSettingsToDefaultsDocument = gql`
    mutation resetCmsSettingsToDefaults {
  resetCmsSettingsToDefaults {
    _id
    newListingToActiveDays
    activeToAwaitingAuditDays
    recentlyUpdatedToActiveDays
    automatedTransitionsEnabled
    createdAt
    updatedAt
  }
}
    `;
export type ResetCmsSettingsToDefaultsMutationFn = Apollo.MutationFunction<ResetCmsSettingsToDefaultsMutation, ResetCmsSettingsToDefaultsMutationVariables>;

/**
 * __useResetCmsSettingsToDefaultsMutation__
 *
 * To run a mutation, you first call `useResetCmsSettingsToDefaultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCmsSettingsToDefaultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCmsSettingsToDefaultsMutation, { data, loading, error }] = useResetCmsSettingsToDefaultsMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetCmsSettingsToDefaultsMutation(baseOptions?: Apollo.MutationHookOptions<ResetCmsSettingsToDefaultsMutation, ResetCmsSettingsToDefaultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetCmsSettingsToDefaultsMutation, ResetCmsSettingsToDefaultsMutationVariables>(ResetCmsSettingsToDefaultsDocument, options);
      }
export type ResetCmsSettingsToDefaultsMutationHookResult = ReturnType<typeof useResetCmsSettingsToDefaultsMutation>;
export type ResetCmsSettingsToDefaultsMutationResult = Apollo.MutationResult<ResetCmsSettingsToDefaultsMutation>;
export type ResetCmsSettingsToDefaultsMutationOptions = Apollo.BaseMutationOptions<ResetCmsSettingsToDefaultsMutation, ResetCmsSettingsToDefaultsMutationVariables>;
export const GetCmsSettingsDocument = gql`
    query getCmsSettings {
  getCmsSettings {
    _id
    newListingToActiveDays
    activeToAwaitingAuditDays
    recentlyUpdatedToActiveDays
    automatedTransitionsEnabled
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCmsSettingsQuery__
 *
 * To run a query within a React component, call `useGetCmsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCmsSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetCmsSettingsQuery, GetCmsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmsSettingsQuery, GetCmsSettingsQueryVariables>(GetCmsSettingsDocument, options);
      }
export function useGetCmsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmsSettingsQuery, GetCmsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmsSettingsQuery, GetCmsSettingsQueryVariables>(GetCmsSettingsDocument, options);
        }
export type GetCmsSettingsQueryHookResult = ReturnType<typeof useGetCmsSettingsQuery>;
export type GetCmsSettingsLazyQueryHookResult = ReturnType<typeof useGetCmsSettingsLazyQuery>;
export type GetCmsSettingsQueryResult = Apollo.QueryResult<GetCmsSettingsQuery, GetCmsSettingsQueryVariables>;
export const GetContentActivityDocument = gql`
    query getContentActivity($range: DateRangeInput!) {
  getContentActivity(range: $range) {
    propertiesEdited
    changes
    filesUploaded
    propertiesCreated
    changesByType {
      type
      changes
      properties
    }
    contributors {
      accountId
      name
      email
      propertiesEdited
      changes
      filesUploaded
      propertiesCreated
    }
  }
}
    `;

/**
 * __useGetContentActivityQuery__
 *
 * To run a query within a React component, call `useGetContentActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentActivityQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useGetContentActivityQuery(baseOptions: Apollo.QueryHookOptions<GetContentActivityQuery, GetContentActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentActivityQuery, GetContentActivityQueryVariables>(GetContentActivityDocument, options);
      }
export function useGetContentActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentActivityQuery, GetContentActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentActivityQuery, GetContentActivityQueryVariables>(GetContentActivityDocument, options);
        }
export type GetContentActivityQueryHookResult = ReturnType<typeof useGetContentActivityQuery>;
export type GetContentActivityLazyQueryHookResult = ReturnType<typeof useGetContentActivityLazyQuery>;
export type GetContentActivityQueryResult = Apollo.QueryResult<GetContentActivityQuery, GetContentActivityQueryVariables>;
export const GetContentActivityLogDocument = gql`
    query getContentActivityLog($range: DateRangeInput!, $pagination: PaginationInput) {
  getContentActivityLog(range: $range, pagination: $pagination) {
    totalCount
    collection {
      _id
      createdAt
      type
      propertyId
      propertyName
      accountId
      authorName
      authorEmail
      cmsStatusChange {
        from
        to
      }
      visibilityChange {
        from
        to
      }
    }
  }
}
    `;

/**
 * __useGetContentActivityLogQuery__
 *
 * To run a query within a React component, call `useGetContentActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentActivityLogQuery({
 *   variables: {
 *      range: // value for 'range'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetContentActivityLogQuery(baseOptions: Apollo.QueryHookOptions<GetContentActivityLogQuery, GetContentActivityLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentActivityLogQuery, GetContentActivityLogQueryVariables>(GetContentActivityLogDocument, options);
      }
export function useGetContentActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentActivityLogQuery, GetContentActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentActivityLogQuery, GetContentActivityLogQueryVariables>(GetContentActivityLogDocument, options);
        }
export type GetContentActivityLogQueryHookResult = ReturnType<typeof useGetContentActivityLogQuery>;
export type GetContentActivityLogLazyQueryHookResult = ReturnType<typeof useGetContentActivityLogLazyQuery>;
export type GetContentActivityLogQueryResult = Apollo.QueryResult<GetContentActivityLogQuery, GetContentActivityLogQueryVariables>;
export const AddSaleTeamUserDocument = gql`
    mutation addSaleTeamUser($input: AddSaleTeamUserInput!) {
  addSaleTeamUser(input: $input) {
    _id
    accountId
  }
}
    `;
export type AddSaleTeamUserMutationFn = Apollo.MutationFunction<AddSaleTeamUserMutation, AddSaleTeamUserMutationVariables>;

/**
 * __useAddSaleTeamUserMutation__
 *
 * To run a mutation, you first call `useAddSaleTeamUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSaleTeamUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSaleTeamUserMutation, { data, loading, error }] = useAddSaleTeamUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSaleTeamUserMutation(baseOptions?: Apollo.MutationHookOptions<AddSaleTeamUserMutation, AddSaleTeamUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSaleTeamUserMutation, AddSaleTeamUserMutationVariables>(AddSaleTeamUserDocument, options);
      }
export type AddSaleTeamUserMutationHookResult = ReturnType<typeof useAddSaleTeamUserMutation>;
export type AddSaleTeamUserMutationResult = Apollo.MutationResult<AddSaleTeamUserMutation>;
export type AddSaleTeamUserMutationOptions = Apollo.BaseMutationOptions<AddSaleTeamUserMutation, AddSaleTeamUserMutationVariables>;
export const DeleteSaleTeamUserDocument = gql`
    mutation deleteSaleTeamUser($saleTeamId: ObjectId!, $saleTeamUserId: ObjectId!) {
  deleteSaleTeamUser(saleTeamId: $saleTeamId, saleTeamUserId: $saleTeamUserId) {
    _id
  }
}
    `;
export type DeleteSaleTeamUserMutationFn = Apollo.MutationFunction<DeleteSaleTeamUserMutation, DeleteSaleTeamUserMutationVariables>;

/**
 * __useDeleteSaleTeamUserMutation__
 *
 * To run a mutation, you first call `useDeleteSaleTeamUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSaleTeamUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSaleTeamUserMutation, { data, loading, error }] = useDeleteSaleTeamUserMutation({
 *   variables: {
 *      saleTeamId: // value for 'saleTeamId'
 *      saleTeamUserId: // value for 'saleTeamUserId'
 *   },
 * });
 */
export function useDeleteSaleTeamUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSaleTeamUserMutation, DeleteSaleTeamUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSaleTeamUserMutation, DeleteSaleTeamUserMutationVariables>(DeleteSaleTeamUserDocument, options);
      }
export type DeleteSaleTeamUserMutationHookResult = ReturnType<typeof useDeleteSaleTeamUserMutation>;
export type DeleteSaleTeamUserMutationResult = Apollo.MutationResult<DeleteSaleTeamUserMutation>;
export type DeleteSaleTeamUserMutationOptions = Apollo.BaseMutationOptions<DeleteSaleTeamUserMutation, DeleteSaleTeamUserMutationVariables>;
export const SetSaleTeamUserStatusDocument = gql`
    mutation setSaleTeamUserStatus($saleTeamUserId: ObjectId!, $status: AccountActiveOrArchivedStatusesEnum!) {
  setSaleTeamUserStatus(saleTeamUserId: $saleTeamUserId, status: $status)
}
    `;
export type SetSaleTeamUserStatusMutationFn = Apollo.MutationFunction<SetSaleTeamUserStatusMutation, SetSaleTeamUserStatusMutationVariables>;

/**
 * __useSetSaleTeamUserStatusMutation__
 *
 * To run a mutation, you first call `useSetSaleTeamUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSaleTeamUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSaleTeamUserStatusMutation, { data, loading, error }] = useSetSaleTeamUserStatusMutation({
 *   variables: {
 *      saleTeamUserId: // value for 'saleTeamUserId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetSaleTeamUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetSaleTeamUserStatusMutation, SetSaleTeamUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSaleTeamUserStatusMutation, SetSaleTeamUserStatusMutationVariables>(SetSaleTeamUserStatusDocument, options);
      }
export type SetSaleTeamUserStatusMutationHookResult = ReturnType<typeof useSetSaleTeamUserStatusMutation>;
export type SetSaleTeamUserStatusMutationResult = Apollo.MutationResult<SetSaleTeamUserStatusMutation>;
export type SetSaleTeamUserStatusMutationOptions = Apollo.BaseMutationOptions<SetSaleTeamUserStatusMutation, SetSaleTeamUserStatusMutationVariables>;
export const EditSaleTeamUserDocument = gql`
    mutation editSaleTeamUser($input: EditSaleTeamUserInput!) {
  editSaleTeamUser(input: $input) {
    _id
    accountId
  }
}
    `;
export type EditSaleTeamUserMutationFn = Apollo.MutationFunction<EditSaleTeamUserMutation, EditSaleTeamUserMutationVariables>;

/**
 * __useEditSaleTeamUserMutation__
 *
 * To run a mutation, you first call `useEditSaleTeamUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSaleTeamUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSaleTeamUserMutation, { data, loading, error }] = useEditSaleTeamUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSaleTeamUserMutation(baseOptions?: Apollo.MutationHookOptions<EditSaleTeamUserMutation, EditSaleTeamUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSaleTeamUserMutation, EditSaleTeamUserMutationVariables>(EditSaleTeamUserDocument, options);
      }
export type EditSaleTeamUserMutationHookResult = ReturnType<typeof useEditSaleTeamUserMutation>;
export type EditSaleTeamUserMutationResult = Apollo.MutationResult<EditSaleTeamUserMutation>;
export type EditSaleTeamUserMutationOptions = Apollo.BaseMutationOptions<EditSaleTeamUserMutation, EditSaleTeamUserMutationVariables>;
export const SendRegistrationLinkToDeveloperDocument = gql`
    mutation sendRegistrationLinkToDeveloper($accountId: ObjectId!) {
  sendRegistrationLinkToDeveloper(accountId: $accountId)
}
    `;
export type SendRegistrationLinkToDeveloperMutationFn = Apollo.MutationFunction<SendRegistrationLinkToDeveloperMutation, SendRegistrationLinkToDeveloperMutationVariables>;

/**
 * __useSendRegistrationLinkToDeveloperMutation__
 *
 * To run a mutation, you first call `useSendRegistrationLinkToDeveloperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRegistrationLinkToDeveloperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRegistrationLinkToDeveloperMutation, { data, loading, error }] = useSendRegistrationLinkToDeveloperMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useSendRegistrationLinkToDeveloperMutation(baseOptions?: Apollo.MutationHookOptions<SendRegistrationLinkToDeveloperMutation, SendRegistrationLinkToDeveloperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendRegistrationLinkToDeveloperMutation, SendRegistrationLinkToDeveloperMutationVariables>(SendRegistrationLinkToDeveloperDocument, options);
      }
export type SendRegistrationLinkToDeveloperMutationHookResult = ReturnType<typeof useSendRegistrationLinkToDeveloperMutation>;
export type SendRegistrationLinkToDeveloperMutationResult = Apollo.MutationResult<SendRegistrationLinkToDeveloperMutation>;
export type SendRegistrationLinkToDeveloperMutationOptions = Apollo.BaseMutationOptions<SendRegistrationLinkToDeveloperMutation, SendRegistrationLinkToDeveloperMutationVariables>;
export const GetSaleTeamUserNameByEmailDocument = gql`
    query getSaleTeamUserNameByEmail($email: String!) {
  getSaleTeamUserNameByEmail(email: $email) {
    firstName
    lastName
  }
}
    `;

/**
 * __useGetSaleTeamUserNameByEmailQuery__
 *
 * To run a query within a React component, call `useGetSaleTeamUserNameByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleTeamUserNameByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleTeamUserNameByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetSaleTeamUserNameByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetSaleTeamUserNameByEmailQuery, GetSaleTeamUserNameByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleTeamUserNameByEmailQuery, GetSaleTeamUserNameByEmailQueryVariables>(GetSaleTeamUserNameByEmailDocument, options);
      }
export function useGetSaleTeamUserNameByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleTeamUserNameByEmailQuery, GetSaleTeamUserNameByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleTeamUserNameByEmailQuery, GetSaleTeamUserNameByEmailQueryVariables>(GetSaleTeamUserNameByEmailDocument, options);
        }
export type GetSaleTeamUserNameByEmailQueryHookResult = ReturnType<typeof useGetSaleTeamUserNameByEmailQuery>;
export type GetSaleTeamUserNameByEmailLazyQueryHookResult = ReturnType<typeof useGetSaleTeamUserNameByEmailLazyQuery>;
export type GetSaleTeamUserNameByEmailQueryResult = Apollo.QueryResult<GetSaleTeamUserNameByEmailQuery, GetSaleTeamUserNameByEmailQueryVariables>;
export const GetSaleTeamUsersDocument = gql`
    query getSaleTeamUsers($filter: GetSaleTeamUsersFilterInput!, $pagination: PaginationInput, $sort: [SortInput!]) {
  getSaleTeamUsers(filter: $filter, pagination: $pagination, sort: $sort) {
    collection {
      ...SaleTeamUser
    }
    totalCount
  }
}
    ${SaleTeamUserFragmentDoc}`;

/**
 * __useGetSaleTeamUsersQuery__
 *
 * To run a query within a React component, call `useGetSaleTeamUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleTeamUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleTeamUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetSaleTeamUsersQuery(baseOptions: Apollo.QueryHookOptions<GetSaleTeamUsersQuery, GetSaleTeamUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleTeamUsersQuery, GetSaleTeamUsersQueryVariables>(GetSaleTeamUsersDocument, options);
      }
export function useGetSaleTeamUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleTeamUsersQuery, GetSaleTeamUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleTeamUsersQuery, GetSaleTeamUsersQueryVariables>(GetSaleTeamUsersDocument, options);
        }
export type GetSaleTeamUsersQueryHookResult = ReturnType<typeof useGetSaleTeamUsersQuery>;
export type GetSaleTeamUsersLazyQueryHookResult = ReturnType<typeof useGetSaleTeamUsersLazyQuery>;
export type GetSaleTeamUsersQueryResult = Apollo.QueryResult<GetSaleTeamUsersQuery, GetSaleTeamUsersQueryVariables>;
export const CreateFeaturedPortfolioDocument = gql`
    mutation createFeaturedPortfolio($input: CreateFeaturedPortfolioInput!) {
  createFeaturedPortfolio(input: $input) {
    ...FeaturedPortfolioFragment
  }
}
    ${FeaturedPortfolioFragmentFragmentDoc}`;
export type CreateFeaturedPortfolioMutationFn = Apollo.MutationFunction<CreateFeaturedPortfolioMutation, CreateFeaturedPortfolioMutationVariables>;

/**
 * __useCreateFeaturedPortfolioMutation__
 *
 * To run a mutation, you first call `useCreateFeaturedPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeaturedPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeaturedPortfolioMutation, { data, loading, error }] = useCreateFeaturedPortfolioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeaturedPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeaturedPortfolioMutation, CreateFeaturedPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeaturedPortfolioMutation, CreateFeaturedPortfolioMutationVariables>(CreateFeaturedPortfolioDocument, options);
      }
export type CreateFeaturedPortfolioMutationHookResult = ReturnType<typeof useCreateFeaturedPortfolioMutation>;
export type CreateFeaturedPortfolioMutationResult = Apollo.MutationResult<CreateFeaturedPortfolioMutation>;
export type CreateFeaturedPortfolioMutationOptions = Apollo.BaseMutationOptions<CreateFeaturedPortfolioMutation, CreateFeaturedPortfolioMutationVariables>;
export const UpdateFeaturedPortfolioDocument = gql`
    mutation updateFeaturedPortfolio($featuredPortfolioId: String!, $input: UpdateFeaturedPortfolioInput!) {
  updateFeaturedPortfolio(
    featuredPortfolioId: $featuredPortfolioId
    input: $input
  ) {
    ...FeaturedPortfolioFragment
  }
}
    ${FeaturedPortfolioFragmentFragmentDoc}`;
export type UpdateFeaturedPortfolioMutationFn = Apollo.MutationFunction<UpdateFeaturedPortfolioMutation, UpdateFeaturedPortfolioMutationVariables>;

/**
 * __useUpdateFeaturedPortfolioMutation__
 *
 * To run a mutation, you first call `useUpdateFeaturedPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeaturedPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeaturedPortfolioMutation, { data, loading, error }] = useUpdateFeaturedPortfolioMutation({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeaturedPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeaturedPortfolioMutation, UpdateFeaturedPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeaturedPortfolioMutation, UpdateFeaturedPortfolioMutationVariables>(UpdateFeaturedPortfolioDocument, options);
      }
export type UpdateFeaturedPortfolioMutationHookResult = ReturnType<typeof useUpdateFeaturedPortfolioMutation>;
export type UpdateFeaturedPortfolioMutationResult = Apollo.MutationResult<UpdateFeaturedPortfolioMutation>;
export type UpdateFeaturedPortfolioMutationOptions = Apollo.BaseMutationOptions<UpdateFeaturedPortfolioMutation, UpdateFeaturedPortfolioMutationVariables>;
export const DeleteFeaturedPortfolioDocument = gql`
    mutation deleteFeaturedPortfolio($featuredPortfolioId: String!) {
  deleteFeaturedPortfolio(featuredPortfolioId: $featuredPortfolioId) {
    _id
  }
}
    `;
export type DeleteFeaturedPortfolioMutationFn = Apollo.MutationFunction<DeleteFeaturedPortfolioMutation, DeleteFeaturedPortfolioMutationVariables>;

/**
 * __useDeleteFeaturedPortfolioMutation__
 *
 * To run a mutation, you first call `useDeleteFeaturedPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeaturedPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeaturedPortfolioMutation, { data, loading, error }] = useDeleteFeaturedPortfolioMutation({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *   },
 * });
 */
export function useDeleteFeaturedPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeaturedPortfolioMutation, DeleteFeaturedPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeaturedPortfolioMutation, DeleteFeaturedPortfolioMutationVariables>(DeleteFeaturedPortfolioDocument, options);
      }
export type DeleteFeaturedPortfolioMutationHookResult = ReturnType<typeof useDeleteFeaturedPortfolioMutation>;
export type DeleteFeaturedPortfolioMutationResult = Apollo.MutationResult<DeleteFeaturedPortfolioMutation>;
export type DeleteFeaturedPortfolioMutationOptions = Apollo.BaseMutationOptions<DeleteFeaturedPortfolioMutation, DeleteFeaturedPortfolioMutationVariables>;
export const OrderPropertiesInPortfolioDocument = gql`
    mutation orderPropertiesInPortfolio($featuredPortfolioId: String!, $propertyIds: [String!]!) {
  orderPropertiesInPortfolio(
    featuredPortfolioId: $featuredPortfolioId
    propertyIds: $propertyIds
  ) {
    _id
    title
  }
}
    `;
export type OrderPropertiesInPortfolioMutationFn = Apollo.MutationFunction<OrderPropertiesInPortfolioMutation, OrderPropertiesInPortfolioMutationVariables>;

/**
 * __useOrderPropertiesInPortfolioMutation__
 *
 * To run a mutation, you first call `useOrderPropertiesInPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderPropertiesInPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderPropertiesInPortfolioMutation, { data, loading, error }] = useOrderPropertiesInPortfolioMutation({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useOrderPropertiesInPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<OrderPropertiesInPortfolioMutation, OrderPropertiesInPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderPropertiesInPortfolioMutation, OrderPropertiesInPortfolioMutationVariables>(OrderPropertiesInPortfolioDocument, options);
      }
export type OrderPropertiesInPortfolioMutationHookResult = ReturnType<typeof useOrderPropertiesInPortfolioMutation>;
export type OrderPropertiesInPortfolioMutationResult = Apollo.MutationResult<OrderPropertiesInPortfolioMutation>;
export type OrderPropertiesInPortfolioMutationOptions = Apollo.BaseMutationOptions<OrderPropertiesInPortfolioMutation, OrderPropertiesInPortfolioMutationVariables>;
export const OrderFeaturedPortfoliosDocument = gql`
    mutation orderFeaturedPortfolios($orders: [FeaturedPortfolioOrder!]!) {
  orderFeaturedPortfolios(orders: $orders) {
    ...FeaturedPortfolioFragment
  }
}
    ${FeaturedPortfolioFragmentFragmentDoc}`;
export type OrderFeaturedPortfoliosMutationFn = Apollo.MutationFunction<OrderFeaturedPortfoliosMutation, OrderFeaturedPortfoliosMutationVariables>;

/**
 * __useOrderFeaturedPortfoliosMutation__
 *
 * To run a mutation, you first call `useOrderFeaturedPortfoliosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderFeaturedPortfoliosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderFeaturedPortfoliosMutation, { data, loading, error }] = useOrderFeaturedPortfoliosMutation({
 *   variables: {
 *      orders: // value for 'orders'
 *   },
 * });
 */
export function useOrderFeaturedPortfoliosMutation(baseOptions?: Apollo.MutationHookOptions<OrderFeaturedPortfoliosMutation, OrderFeaturedPortfoliosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderFeaturedPortfoliosMutation, OrderFeaturedPortfoliosMutationVariables>(OrderFeaturedPortfoliosDocument, options);
      }
export type OrderFeaturedPortfoliosMutationHookResult = ReturnType<typeof useOrderFeaturedPortfoliosMutation>;
export type OrderFeaturedPortfoliosMutationResult = Apollo.MutationResult<OrderFeaturedPortfoliosMutation>;
export type OrderFeaturedPortfoliosMutationOptions = Apollo.BaseMutationOptions<OrderFeaturedPortfoliosMutation, OrderFeaturedPortfoliosMutationVariables>;
export const MakePortfolioPublicDocument = gql`
    mutation makePortfolioPublic($featuredPortfolioId: String!, $position: String!) {
  makePortfolioPublic(
    featuredPortfolioId: $featuredPortfolioId
    position: $position
  )
}
    `;
export type MakePortfolioPublicMutationFn = Apollo.MutationFunction<MakePortfolioPublicMutation, MakePortfolioPublicMutationVariables>;

/**
 * __useMakePortfolioPublicMutation__
 *
 * To run a mutation, you first call `useMakePortfolioPublicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakePortfolioPublicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makePortfolioPublicMutation, { data, loading, error }] = useMakePortfolioPublicMutation({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useMakePortfolioPublicMutation(baseOptions?: Apollo.MutationHookOptions<MakePortfolioPublicMutation, MakePortfolioPublicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakePortfolioPublicMutation, MakePortfolioPublicMutationVariables>(MakePortfolioPublicDocument, options);
      }
export type MakePortfolioPublicMutationHookResult = ReturnType<typeof useMakePortfolioPublicMutation>;
export type MakePortfolioPublicMutationResult = Apollo.MutationResult<MakePortfolioPublicMutation>;
export type MakePortfolioPublicMutationOptions = Apollo.BaseMutationOptions<MakePortfolioPublicMutation, MakePortfolioPublicMutationVariables>;
export const GetFeaturedPortfoliosDocument = gql`
    query getFeaturedPortfolios($sort: [SortInput!], $pagination: PaginationInput, $filter: GetFeaturedPortfoliosFilter, $searchText: String) {
  getFeaturedPortfolios(
    sort: $sort
    pagination: $pagination
    filter: $filter
    searchText: $searchText
  ) {
    collection {
      ...FeaturedPortfolioFragment
    }
    totalCount
  }
}
    ${FeaturedPortfolioFragmentFragmentDoc}`;

/**
 * __useGetFeaturedPortfoliosQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfoliosQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetFeaturedPortfoliosQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturedPortfoliosQuery, GetFeaturedPortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfoliosQuery, GetFeaturedPortfoliosQueryVariables>(GetFeaturedPortfoliosDocument, options);
      }
export function useGetFeaturedPortfoliosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfoliosQuery, GetFeaturedPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfoliosQuery, GetFeaturedPortfoliosQueryVariables>(GetFeaturedPortfoliosDocument, options);
        }
export type GetFeaturedPortfoliosQueryHookResult = ReturnType<typeof useGetFeaturedPortfoliosQuery>;
export type GetFeaturedPortfoliosLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfoliosLazyQuery>;
export type GetFeaturedPortfoliosQueryResult = Apollo.QueryResult<GetFeaturedPortfoliosQuery, GetFeaturedPortfoliosQueryVariables>;
export const GetFeaturedPortfolioByIdDocument = gql`
    query getFeaturedPortfolioById($featuredPortfolioId: String!) {
  getFeaturedPortfolioById(featuredPortfolioId: $featuredPortfolioId) {
    ...FeaturedPortfolioDetailFragment
  }
}
    ${FeaturedPortfolioDetailFragmentFragmentDoc}`;

/**
 * __useGetFeaturedPortfolioByIdQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfolioByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfolioByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfolioByIdQuery({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *   },
 * });
 */
export function useGetFeaturedPortfolioByIdQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPortfolioByIdQuery, GetFeaturedPortfolioByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfolioByIdQuery, GetFeaturedPortfolioByIdQueryVariables>(GetFeaturedPortfolioByIdDocument, options);
      }
export function useGetFeaturedPortfolioByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfolioByIdQuery, GetFeaturedPortfolioByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfolioByIdQuery, GetFeaturedPortfolioByIdQueryVariables>(GetFeaturedPortfolioByIdDocument, options);
        }
export type GetFeaturedPortfolioByIdQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioByIdQuery>;
export type GetFeaturedPortfolioByIdLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioByIdLazyQuery>;
export type GetFeaturedPortfolioByIdQueryResult = Apollo.QueryResult<GetFeaturedPortfolioByIdQuery, GetFeaturedPortfolioByIdQueryVariables>;
export const GetFeaturedPortfolioPropertiesAdminDocument = gql`
    query getFeaturedPortfolioPropertiesAdmin($featuredPortfolioId: String!) {
  getFeaturedPortfolioPropertiesAdmin(featuredPortfolioId: $featuredPortfolioId) {
    _id
    name
  }
}
    `;

/**
 * __useGetFeaturedPortfolioPropertiesAdminQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfolioPropertiesAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfolioPropertiesAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfolioPropertiesAdminQuery({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *   },
 * });
 */
export function useGetFeaturedPortfolioPropertiesAdminQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPortfolioPropertiesAdminQuery, GetFeaturedPortfolioPropertiesAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfolioPropertiesAdminQuery, GetFeaturedPortfolioPropertiesAdminQueryVariables>(GetFeaturedPortfolioPropertiesAdminDocument, options);
      }
export function useGetFeaturedPortfolioPropertiesAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfolioPropertiesAdminQuery, GetFeaturedPortfolioPropertiesAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfolioPropertiesAdminQuery, GetFeaturedPortfolioPropertiesAdminQueryVariables>(GetFeaturedPortfolioPropertiesAdminDocument, options);
        }
export type GetFeaturedPortfolioPropertiesAdminQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioPropertiesAdminQuery>;
export type GetFeaturedPortfolioPropertiesAdminLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioPropertiesAdminLazyQuery>;
export type GetFeaturedPortfolioPropertiesAdminQueryResult = Apollo.QueryResult<GetFeaturedPortfolioPropertiesAdminQuery, GetFeaturedPortfolioPropertiesAdminQueryVariables>;
export const GetFeaturedPortfolioMarketAreasDocument = gql`
    query getFeaturedPortfolioMarketAreas($featuredPortfolioId: String!) {
  getFeaturedPortfolioMarketAreas(featuredPortfolioId: $featuredPortfolioId) {
    marketArea {
      _id
      name
    }
    count
  }
}
    `;

/**
 * __useGetFeaturedPortfolioMarketAreasQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfolioMarketAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfolioMarketAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfolioMarketAreasQuery({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *   },
 * });
 */
export function useGetFeaturedPortfolioMarketAreasQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPortfolioMarketAreasQuery, GetFeaturedPortfolioMarketAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfolioMarketAreasQuery, GetFeaturedPortfolioMarketAreasQueryVariables>(GetFeaturedPortfolioMarketAreasDocument, options);
      }
export function useGetFeaturedPortfolioMarketAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfolioMarketAreasQuery, GetFeaturedPortfolioMarketAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfolioMarketAreasQuery, GetFeaturedPortfolioMarketAreasQueryVariables>(GetFeaturedPortfolioMarketAreasDocument, options);
        }
export type GetFeaturedPortfolioMarketAreasQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioMarketAreasQuery>;
export type GetFeaturedPortfolioMarketAreasLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioMarketAreasLazyQuery>;
export type GetFeaturedPortfolioMarketAreasQueryResult = Apollo.QueryResult<GetFeaturedPortfolioMarketAreasQuery, GetFeaturedPortfolioMarketAreasQueryVariables>;
export const GetFeaturedPortfolioSummaryDocument = gql`
    query getFeaturedPortfolioSummary($featuredPortfolioId: String!) {
  getFeaturedPortfolioSummary(featuredPortfolioId: $featuredPortfolioId) {
    marketAreas {
      marketArea {
        _id
        name
      }
      count
    }
    priceRange {
      min
      max
    }
    completionYearRange {
      min
      max
    }
    propertyCount
  }
}
    `;

/**
 * __useGetFeaturedPortfolioSummaryQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfolioSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfolioSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfolioSummaryQuery({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *   },
 * });
 */
export function useGetFeaturedPortfolioSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPortfolioSummaryQuery, GetFeaturedPortfolioSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfolioSummaryQuery, GetFeaturedPortfolioSummaryQueryVariables>(GetFeaturedPortfolioSummaryDocument, options);
      }
export function useGetFeaturedPortfolioSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfolioSummaryQuery, GetFeaturedPortfolioSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfolioSummaryQuery, GetFeaturedPortfolioSummaryQueryVariables>(GetFeaturedPortfolioSummaryDocument, options);
        }
export type GetFeaturedPortfolioSummaryQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioSummaryQuery>;
export type GetFeaturedPortfolioSummaryLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioSummaryLazyQuery>;
export type GetFeaturedPortfolioSummaryQueryResult = Apollo.QueryResult<GetFeaturedPortfolioSummaryQuery, GetFeaturedPortfolioSummaryQueryVariables>;
export const GetFeaturedPortfolioPropertiesDocument = gql`
    query getFeaturedPortfolioProperties($featuredPortfolioId: String!, $pagination: FlatPaginationInput) {
  getFeaturedPortfolioProperties(
    featuredPortfolioId: $featuredPortfolioId
    pagination: $pagination
  ) {
    collection {
      _id
      name
      overview
      yearBuilt
      mainPropertyMediaFile {
        _id
        files {
          _id
          publicUrl
          type
          thumbnailFile {
            _id
            publicUrl
          }
        }
      }
      marketArea {
        _id
        name
      }
      priceRange {
        min
        max
      }
      averageBedroomsNumber {
        min
        max
      }
      averageBathroomsNumber {
        min
        max
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetFeaturedPortfolioPropertiesQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfolioPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfolioPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfolioPropertiesQuery({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetFeaturedPortfolioPropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPortfolioPropertiesQuery, GetFeaturedPortfolioPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfolioPropertiesQuery, GetFeaturedPortfolioPropertiesQueryVariables>(GetFeaturedPortfolioPropertiesDocument, options);
      }
export function useGetFeaturedPortfolioPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfolioPropertiesQuery, GetFeaturedPortfolioPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfolioPropertiesQuery, GetFeaturedPortfolioPropertiesQueryVariables>(GetFeaturedPortfolioPropertiesDocument, options);
        }
export type GetFeaturedPortfolioPropertiesQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioPropertiesQuery>;
export type GetFeaturedPortfolioPropertiesLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioPropertiesLazyQuery>;
export type GetFeaturedPortfolioPropertiesQueryResult = Apollo.QueryResult<GetFeaturedPortfolioPropertiesQuery, GetFeaturedPortfolioPropertiesQueryVariables>;
export const CreateFeaturedPropertyDocument = gql`
    mutation createFeaturedProperty($input: CreateFeaturedPropertyInput!) {
  createFeaturedProperty(input: $input) {
    ...FeaturedPropertyFragment
  }
}
    ${FeaturedPropertyFragmentFragmentDoc}`;
export type CreateFeaturedPropertyMutationFn = Apollo.MutationFunction<CreateFeaturedPropertyMutation, CreateFeaturedPropertyMutationVariables>;

/**
 * __useCreateFeaturedPropertyMutation__
 *
 * To run a mutation, you first call `useCreateFeaturedPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeaturedPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeaturedPropertyMutation, { data, loading, error }] = useCreateFeaturedPropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeaturedPropertyMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeaturedPropertyMutation, CreateFeaturedPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeaturedPropertyMutation, CreateFeaturedPropertyMutationVariables>(CreateFeaturedPropertyDocument, options);
      }
export type CreateFeaturedPropertyMutationHookResult = ReturnType<typeof useCreateFeaturedPropertyMutation>;
export type CreateFeaturedPropertyMutationResult = Apollo.MutationResult<CreateFeaturedPropertyMutation>;
export type CreateFeaturedPropertyMutationOptions = Apollo.BaseMutationOptions<CreateFeaturedPropertyMutation, CreateFeaturedPropertyMutationVariables>;
export const UpdateFeaturedPropertyDocument = gql`
    mutation updateFeaturedProperty($featuredPropertyId: String!, $input: UpdateFeaturedPropertyInput!) {
  updateFeaturedProperty(featuredPropertyId: $featuredPropertyId, input: $input) {
    ...FeaturedPropertyFragment
  }
}
    ${FeaturedPropertyFragmentFragmentDoc}`;
export type UpdateFeaturedPropertyMutationFn = Apollo.MutationFunction<UpdateFeaturedPropertyMutation, UpdateFeaturedPropertyMutationVariables>;

/**
 * __useUpdateFeaturedPropertyMutation__
 *
 * To run a mutation, you first call `useUpdateFeaturedPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeaturedPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeaturedPropertyMutation, { data, loading, error }] = useUpdateFeaturedPropertyMutation({
 *   variables: {
 *      featuredPropertyId: // value for 'featuredPropertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeaturedPropertyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeaturedPropertyMutation, UpdateFeaturedPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeaturedPropertyMutation, UpdateFeaturedPropertyMutationVariables>(UpdateFeaturedPropertyDocument, options);
      }
export type UpdateFeaturedPropertyMutationHookResult = ReturnType<typeof useUpdateFeaturedPropertyMutation>;
export type UpdateFeaturedPropertyMutationResult = Apollo.MutationResult<UpdateFeaturedPropertyMutation>;
export type UpdateFeaturedPropertyMutationOptions = Apollo.BaseMutationOptions<UpdateFeaturedPropertyMutation, UpdateFeaturedPropertyMutationVariables>;
export const DeleteFeaturedPropertyDocument = gql`
    mutation deleteFeaturedProperty($featuredPropertyId: String!) {
  deleteFeaturedProperty(featuredPropertyId: $featuredPropertyId) {
    _id
  }
}
    `;
export type DeleteFeaturedPropertyMutationFn = Apollo.MutationFunction<DeleteFeaturedPropertyMutation, DeleteFeaturedPropertyMutationVariables>;

/**
 * __useDeleteFeaturedPropertyMutation__
 *
 * To run a mutation, you first call `useDeleteFeaturedPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeaturedPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeaturedPropertyMutation, { data, loading, error }] = useDeleteFeaturedPropertyMutation({
 *   variables: {
 *      featuredPropertyId: // value for 'featuredPropertyId'
 *   },
 * });
 */
export function useDeleteFeaturedPropertyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeaturedPropertyMutation, DeleteFeaturedPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeaturedPropertyMutation, DeleteFeaturedPropertyMutationVariables>(DeleteFeaturedPropertyDocument, options);
      }
export type DeleteFeaturedPropertyMutationHookResult = ReturnType<typeof useDeleteFeaturedPropertyMutation>;
export type DeleteFeaturedPropertyMutationResult = Apollo.MutationResult<DeleteFeaturedPropertyMutation>;
export type DeleteFeaturedPropertyMutationOptions = Apollo.BaseMutationOptions<DeleteFeaturedPropertyMutation, DeleteFeaturedPropertyMutationVariables>;
export const OrderFeaturedPropertiesDocument = gql`
    mutation orderFeaturedProperties($orders: [FeaturedPropertyOrder!]!) {
  orderFeaturedProperties(orders: $orders) {
    ...FeaturedPropertyFragment
  }
}
    ${FeaturedPropertyFragmentFragmentDoc}`;
export type OrderFeaturedPropertiesMutationFn = Apollo.MutationFunction<OrderFeaturedPropertiesMutation, OrderFeaturedPropertiesMutationVariables>;

/**
 * __useOrderFeaturedPropertiesMutation__
 *
 * To run a mutation, you first call `useOrderFeaturedPropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderFeaturedPropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderFeaturedPropertiesMutation, { data, loading, error }] = useOrderFeaturedPropertiesMutation({
 *   variables: {
 *      orders: // value for 'orders'
 *   },
 * });
 */
export function useOrderFeaturedPropertiesMutation(baseOptions?: Apollo.MutationHookOptions<OrderFeaturedPropertiesMutation, OrderFeaturedPropertiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderFeaturedPropertiesMutation, OrderFeaturedPropertiesMutationVariables>(OrderFeaturedPropertiesDocument, options);
      }
export type OrderFeaturedPropertiesMutationHookResult = ReturnType<typeof useOrderFeaturedPropertiesMutation>;
export type OrderFeaturedPropertiesMutationResult = Apollo.MutationResult<OrderFeaturedPropertiesMutation>;
export type OrderFeaturedPropertiesMutationOptions = Apollo.BaseMutationOptions<OrderFeaturedPropertiesMutation, OrderFeaturedPropertiesMutationVariables>;
export const MakeFeaturedPropertyPublicDocument = gql`
    mutation makeFeaturedPropertyPublic($featuredPropertyId: String!, $position: String!) {
  makeFeaturedPropertyPublic(
    featuredPropertyId: $featuredPropertyId
    position: $position
  )
}
    `;
export type MakeFeaturedPropertyPublicMutationFn = Apollo.MutationFunction<MakeFeaturedPropertyPublicMutation, MakeFeaturedPropertyPublicMutationVariables>;

/**
 * __useMakeFeaturedPropertyPublicMutation__
 *
 * To run a mutation, you first call `useMakeFeaturedPropertyPublicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeFeaturedPropertyPublicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeFeaturedPropertyPublicMutation, { data, loading, error }] = useMakeFeaturedPropertyPublicMutation({
 *   variables: {
 *      featuredPropertyId: // value for 'featuredPropertyId'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useMakeFeaturedPropertyPublicMutation(baseOptions?: Apollo.MutationHookOptions<MakeFeaturedPropertyPublicMutation, MakeFeaturedPropertyPublicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeFeaturedPropertyPublicMutation, MakeFeaturedPropertyPublicMutationVariables>(MakeFeaturedPropertyPublicDocument, options);
      }
export type MakeFeaturedPropertyPublicMutationHookResult = ReturnType<typeof useMakeFeaturedPropertyPublicMutation>;
export type MakeFeaturedPropertyPublicMutationResult = Apollo.MutationResult<MakeFeaturedPropertyPublicMutation>;
export type MakeFeaturedPropertyPublicMutationOptions = Apollo.BaseMutationOptions<MakeFeaturedPropertyPublicMutation, MakeFeaturedPropertyPublicMutationVariables>;
export const GetFeaturedPropertiesDocument = gql`
    query getFeaturedProperties($sort: [SortInput!], $pagination: PaginationInput, $filter: GetFeaturedPropertiesFilter, $searchText: String) {
  getFeaturedProperties(
    sort: $sort
    pagination: $pagination
    filter: $filter
    searchText: $searchText
  ) {
    collection {
      ...FeaturedPropertyFragment
    }
    totalCount
  }
}
    ${FeaturedPropertyFragmentFragmentDoc}`;

/**
 * __useGetFeaturedPropertiesQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPropertiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetFeaturedPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturedPropertiesQuery, GetFeaturedPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPropertiesQuery, GetFeaturedPropertiesQueryVariables>(GetFeaturedPropertiesDocument, options);
      }
export function useGetFeaturedPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPropertiesQuery, GetFeaturedPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPropertiesQuery, GetFeaturedPropertiesQueryVariables>(GetFeaturedPropertiesDocument, options);
        }
export type GetFeaturedPropertiesQueryHookResult = ReturnType<typeof useGetFeaturedPropertiesQuery>;
export type GetFeaturedPropertiesLazyQueryHookResult = ReturnType<typeof useGetFeaturedPropertiesLazyQuery>;
export type GetFeaturedPropertiesQueryResult = Apollo.QueryResult<GetFeaturedPropertiesQuery, GetFeaturedPropertiesQueryVariables>;
export const GetFeaturedPropertyByIdDocument = gql`
    query getFeaturedPropertyById($featuredPropertyId: String!) {
  getFeaturedPropertyById(featuredPropertyId: $featuredPropertyId) {
    ...FeaturedPropertyDetailFragment
    property {
      priceRange {
        min
        max
      }
      marketArea {
        ...MarketArea
      }
      projectStatus
      yearBuilt
    }
  }
}
    ${FeaturedPropertyDetailFragmentFragmentDoc}
${MarketAreaFragmentDoc}`;

/**
 * __useGetFeaturedPropertyByIdQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPropertyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPropertyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPropertyByIdQuery({
 *   variables: {
 *      featuredPropertyId: // value for 'featuredPropertyId'
 *   },
 * });
 */
export function useGetFeaturedPropertyByIdQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPropertyByIdQuery, GetFeaturedPropertyByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPropertyByIdQuery, GetFeaturedPropertyByIdQueryVariables>(GetFeaturedPropertyByIdDocument, options);
      }
export function useGetFeaturedPropertyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPropertyByIdQuery, GetFeaturedPropertyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPropertyByIdQuery, GetFeaturedPropertyByIdQueryVariables>(GetFeaturedPropertyByIdDocument, options);
        }
export type GetFeaturedPropertyByIdQueryHookResult = ReturnType<typeof useGetFeaturedPropertyByIdQuery>;
export type GetFeaturedPropertyByIdLazyQueryHookResult = ReturnType<typeof useGetFeaturedPropertyByIdLazyQuery>;
export type GetFeaturedPropertyByIdQueryResult = Apollo.QueryResult<GetFeaturedPropertyByIdQuery, GetFeaturedPropertyByIdQueryVariables>;
export const UploadDraftFileDocument = gql`
    mutation uploadDraftFile($input: FileUploadInput!) {
  uploadDraftFile(input: $input) {
    ...File
  }
}
    ${FileFragmentDoc}`;
export type UploadDraftFileMutationFn = Apollo.MutationFunction<UploadDraftFileMutation, UploadDraftFileMutationVariables>;

/**
 * __useUploadDraftFileMutation__
 *
 * To run a mutation, you first call `useUploadDraftFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDraftFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDraftFileMutation, { data, loading, error }] = useUploadDraftFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadDraftFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadDraftFileMutation, UploadDraftFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDraftFileMutation, UploadDraftFileMutationVariables>(UploadDraftFileDocument, options);
      }
export type UploadDraftFileMutationHookResult = ReturnType<typeof useUploadDraftFileMutation>;
export type UploadDraftFileMutationResult = Apollo.MutationResult<UploadDraftFileMutation>;
export type UploadDraftFileMutationOptions = Apollo.BaseMutationOptions<UploadDraftFileMutation, UploadDraftFileMutationVariables>;
export const EditMediaFileDocument = gql`
    mutation editMediaFile($fileId: ObjectId!, $input: EditMediaFileInput!) {
  editMediaFile(fileId: $fileId, input: $input) {
    ...File
  }
}
    ${FileFragmentDoc}`;
export type EditMediaFileMutationFn = Apollo.MutationFunction<EditMediaFileMutation, EditMediaFileMutationVariables>;

/**
 * __useEditMediaFileMutation__
 *
 * To run a mutation, you first call `useEditMediaFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMediaFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMediaFileMutation, { data, loading, error }] = useEditMediaFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMediaFileMutation(baseOptions?: Apollo.MutationHookOptions<EditMediaFileMutation, EditMediaFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMediaFileMutation, EditMediaFileMutationVariables>(EditMediaFileDocument, options);
      }
export type EditMediaFileMutationHookResult = ReturnType<typeof useEditMediaFileMutation>;
export type EditMediaFileMutationResult = Apollo.MutationResult<EditMediaFileMutation>;
export type EditMediaFileMutationOptions = Apollo.BaseMutationOptions<EditMediaFileMutation, EditMediaFileMutationVariables>;
export const AbortUploadFileDocument = gql`
    mutation abortUploadFile($progressTrackingId: String!) {
  abortUpload(progressTrackingId: $progressTrackingId) {
    _id
  }
}
    `;
export type AbortUploadFileMutationFn = Apollo.MutationFunction<AbortUploadFileMutation, AbortUploadFileMutationVariables>;

/**
 * __useAbortUploadFileMutation__
 *
 * To run a mutation, you first call `useAbortUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortUploadFileMutation, { data, loading, error }] = useAbortUploadFileMutation({
 *   variables: {
 *      progressTrackingId: // value for 'progressTrackingId'
 *   },
 * });
 */
export function useAbortUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<AbortUploadFileMutation, AbortUploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortUploadFileMutation, AbortUploadFileMutationVariables>(AbortUploadFileDocument, options);
      }
export type AbortUploadFileMutationHookResult = ReturnType<typeof useAbortUploadFileMutation>;
export type AbortUploadFileMutationResult = Apollo.MutationResult<AbortUploadFileMutation>;
export type AbortUploadFileMutationOptions = Apollo.BaseMutationOptions<AbortUploadFileMutation, AbortUploadFileMutationVariables>;
export const AbortAllUploadsDocument = gql`
    mutation abortAllUploads {
  abortAllUploads {
    _id
  }
}
    `;
export type AbortAllUploadsMutationFn = Apollo.MutationFunction<AbortAllUploadsMutation, AbortAllUploadsMutationVariables>;

/**
 * __useAbortAllUploadsMutation__
 *
 * To run a mutation, you first call `useAbortAllUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortAllUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortAllUploadsMutation, { data, loading, error }] = useAbortAllUploadsMutation({
 *   variables: {
 *   },
 * });
 */
export function useAbortAllUploadsMutation(baseOptions?: Apollo.MutationHookOptions<AbortAllUploadsMutation, AbortAllUploadsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortAllUploadsMutation, AbortAllUploadsMutationVariables>(AbortAllUploadsDocument, options);
      }
export type AbortAllUploadsMutationHookResult = ReturnType<typeof useAbortAllUploadsMutation>;
export type AbortAllUploadsMutationResult = Apollo.MutationResult<AbortAllUploadsMutation>;
export type AbortAllUploadsMutationOptions = Apollo.BaseMutationOptions<AbortAllUploadsMutation, AbortAllUploadsMutationVariables>;
export const CreateMarketAreaDocument = gql`
    mutation createMarketArea($input: CreateMarketAreaInput!) {
  createMarketArea(input: $input) {
    ...MarketArea
  }
}
    ${MarketAreaFragmentDoc}`;
export type CreateMarketAreaMutationFn = Apollo.MutationFunction<CreateMarketAreaMutation, CreateMarketAreaMutationVariables>;

/**
 * __useCreateMarketAreaMutation__
 *
 * To run a mutation, you first call `useCreateMarketAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarketAreaMutation, { data, loading, error }] = useCreateMarketAreaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMarketAreaMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarketAreaMutation, CreateMarketAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarketAreaMutation, CreateMarketAreaMutationVariables>(CreateMarketAreaDocument, options);
      }
export type CreateMarketAreaMutationHookResult = ReturnType<typeof useCreateMarketAreaMutation>;
export type CreateMarketAreaMutationResult = Apollo.MutationResult<CreateMarketAreaMutation>;
export type CreateMarketAreaMutationOptions = Apollo.BaseMutationOptions<CreateMarketAreaMutation, CreateMarketAreaMutationVariables>;
export const EditMarketAreaDocument = gql`
    mutation editMarketArea($input: EditMarketAreaInput!) {
  editMarketArea(input: $input) {
    ...MarketArea
  }
}
    ${MarketAreaFragmentDoc}`;
export type EditMarketAreaMutationFn = Apollo.MutationFunction<EditMarketAreaMutation, EditMarketAreaMutationVariables>;

/**
 * __useEditMarketAreaMutation__
 *
 * To run a mutation, you first call `useEditMarketAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMarketAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMarketAreaMutation, { data, loading, error }] = useEditMarketAreaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMarketAreaMutation(baseOptions?: Apollo.MutationHookOptions<EditMarketAreaMutation, EditMarketAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMarketAreaMutation, EditMarketAreaMutationVariables>(EditMarketAreaDocument, options);
      }
export type EditMarketAreaMutationHookResult = ReturnType<typeof useEditMarketAreaMutation>;
export type EditMarketAreaMutationResult = Apollo.MutationResult<EditMarketAreaMutation>;
export type EditMarketAreaMutationOptions = Apollo.BaseMutationOptions<EditMarketAreaMutation, EditMarketAreaMutationVariables>;
export const DeleteMarketAreaDocument = gql`
    mutation deleteMarketArea($marketAreaId: ObjectId!) {
  deleteMarketArea(marketAreaId: $marketAreaId) {
    _id
  }
}
    `;
export type DeleteMarketAreaMutationFn = Apollo.MutationFunction<DeleteMarketAreaMutation, DeleteMarketAreaMutationVariables>;

/**
 * __useDeleteMarketAreaMutation__
 *
 * To run a mutation, you first call `useDeleteMarketAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMarketAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMarketAreaMutation, { data, loading, error }] = useDeleteMarketAreaMutation({
 *   variables: {
 *      marketAreaId: // value for 'marketAreaId'
 *   },
 * });
 */
export function useDeleteMarketAreaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMarketAreaMutation, DeleteMarketAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMarketAreaMutation, DeleteMarketAreaMutationVariables>(DeleteMarketAreaDocument, options);
      }
export type DeleteMarketAreaMutationHookResult = ReturnType<typeof useDeleteMarketAreaMutation>;
export type DeleteMarketAreaMutationResult = Apollo.MutationResult<DeleteMarketAreaMutation>;
export type DeleteMarketAreaMutationOptions = Apollo.BaseMutationOptions<DeleteMarketAreaMutation, DeleteMarketAreaMutationVariables>;
export const GetMarketAreasDocument = gql`
    query getMarketAreas($sort: [SortInput!], $pagination: PaginationInput, $filter: GetMarketAreasFilterInput) {
  getMarketAreas(sort: $sort, pagination: $pagination, filter: $filter) {
    totalCount
    collection {
      ...MarketArea
    }
  }
}
    ${MarketAreaFragmentDoc}`;

/**
 * __useGetMarketAreasQuery__
 *
 * To run a query within a React component, call `useGetMarketAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketAreasQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMarketAreasQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketAreasQuery, GetMarketAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketAreasQuery, GetMarketAreasQueryVariables>(GetMarketAreasDocument, options);
      }
export function useGetMarketAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketAreasQuery, GetMarketAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketAreasQuery, GetMarketAreasQueryVariables>(GetMarketAreasDocument, options);
        }
export type GetMarketAreasQueryHookResult = ReturnType<typeof useGetMarketAreasQuery>;
export type GetMarketAreasLazyQueryHookResult = ReturnType<typeof useGetMarketAreasLazyQuery>;
export type GetMarketAreasQueryResult = Apollo.QueryResult<GetMarketAreasQuery, GetMarketAreasQueryVariables>;
export const CreateMediaFileDocument = gql`
    mutation createMediaFile($input: CreateMediaFileInput!) {
  createMediaFile(input: $input) {
    ...Media
  }
}
    ${MediaFragmentDoc}`;
export type CreateMediaFileMutationFn = Apollo.MutationFunction<CreateMediaFileMutation, CreateMediaFileMutationVariables>;

/**
 * __useCreateMediaFileMutation__
 *
 * To run a mutation, you first call `useCreateMediaFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMediaFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMediaFileMutation, { data, loading, error }] = useCreateMediaFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMediaFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateMediaFileMutation, CreateMediaFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMediaFileMutation, CreateMediaFileMutationVariables>(CreateMediaFileDocument, options);
      }
export type CreateMediaFileMutationHookResult = ReturnType<typeof useCreateMediaFileMutation>;
export type CreateMediaFileMutationResult = Apollo.MutationResult<CreateMediaFileMutation>;
export type CreateMediaFileMutationOptions = Apollo.BaseMutationOptions<CreateMediaFileMutation, CreateMediaFileMutationVariables>;
export const CreateMediaFolderDocument = gql`
    mutation createMediaFolder($input: CreateMediaFolderInput!) {
  createMediaFolder(input: $input) {
    ...Media
  }
}
    ${MediaFragmentDoc}`;
export type CreateMediaFolderMutationFn = Apollo.MutationFunction<CreateMediaFolderMutation, CreateMediaFolderMutationVariables>;

/**
 * __useCreateMediaFolderMutation__
 *
 * To run a mutation, you first call `useCreateMediaFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMediaFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMediaFolderMutation, { data, loading, error }] = useCreateMediaFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMediaFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateMediaFolderMutation, CreateMediaFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMediaFolderMutation, CreateMediaFolderMutationVariables>(CreateMediaFolderDocument, options);
      }
export type CreateMediaFolderMutationHookResult = ReturnType<typeof useCreateMediaFolderMutation>;
export type CreateMediaFolderMutationResult = Apollo.MutationResult<CreateMediaFolderMutation>;
export type CreateMediaFolderMutationOptions = Apollo.BaseMutationOptions<CreateMediaFolderMutation, CreateMediaFolderMutationVariables>;
export const EditMediaFolderDocument = gql`
    mutation editMediaFolder($input: EditMediaFolderInput!) {
  editMediaFolder(input: $input) {
    ...Media
  }
}
    ${MediaFragmentDoc}`;
export type EditMediaFolderMutationFn = Apollo.MutationFunction<EditMediaFolderMutation, EditMediaFolderMutationVariables>;

/**
 * __useEditMediaFolderMutation__
 *
 * To run a mutation, you first call `useEditMediaFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMediaFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMediaFolderMutation, { data, loading, error }] = useEditMediaFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMediaFolderMutation(baseOptions?: Apollo.MutationHookOptions<EditMediaFolderMutation, EditMediaFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMediaFolderMutation, EditMediaFolderMutationVariables>(EditMediaFolderDocument, options);
      }
export type EditMediaFolderMutationHookResult = ReturnType<typeof useEditMediaFolderMutation>;
export type EditMediaFolderMutationResult = Apollo.MutationResult<EditMediaFolderMutation>;
export type EditMediaFolderMutationOptions = Apollo.BaseMutationOptions<EditMediaFolderMutation, EditMediaFolderMutationVariables>;
export const DeleteMediaFileByIdDocument = gql`
    mutation deleteMediaFileById($mediaId: ObjectId!) {
  deleteMediaFileById(mediaId: $mediaId) {
    ...Media
  }
}
    ${MediaFragmentDoc}`;
export type DeleteMediaFileByIdMutationFn = Apollo.MutationFunction<DeleteMediaFileByIdMutation, DeleteMediaFileByIdMutationVariables>;

/**
 * __useDeleteMediaFileByIdMutation__
 *
 * To run a mutation, you first call `useDeleteMediaFileByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaFileByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaFileByIdMutation, { data, loading, error }] = useDeleteMediaFileByIdMutation({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *   },
 * });
 */
export function useDeleteMediaFileByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMediaFileByIdMutation, DeleteMediaFileByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMediaFileByIdMutation, DeleteMediaFileByIdMutationVariables>(DeleteMediaFileByIdDocument, options);
      }
export type DeleteMediaFileByIdMutationHookResult = ReturnType<typeof useDeleteMediaFileByIdMutation>;
export type DeleteMediaFileByIdMutationResult = Apollo.MutationResult<DeleteMediaFileByIdMutation>;
export type DeleteMediaFileByIdMutationOptions = Apollo.BaseMutationOptions<DeleteMediaFileByIdMutation, DeleteMediaFileByIdMutationVariables>;
export const DeleteMediaFolderByIdDocument = gql`
    mutation deleteMediaFolderById($mediaId: ObjectId!, $withContent: Boolean) {
  deleteMediaFolderById(mediaId: $mediaId, withContent: $withContent) {
    ...Media
  }
}
    ${MediaFragmentDoc}`;
export type DeleteMediaFolderByIdMutationFn = Apollo.MutationFunction<DeleteMediaFolderByIdMutation, DeleteMediaFolderByIdMutationVariables>;

/**
 * __useDeleteMediaFolderByIdMutation__
 *
 * To run a mutation, you first call `useDeleteMediaFolderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaFolderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaFolderByIdMutation, { data, loading, error }] = useDeleteMediaFolderByIdMutation({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useDeleteMediaFolderByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMediaFolderByIdMutation, DeleteMediaFolderByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMediaFolderByIdMutation, DeleteMediaFolderByIdMutationVariables>(DeleteMediaFolderByIdDocument, options);
      }
export type DeleteMediaFolderByIdMutationHookResult = ReturnType<typeof useDeleteMediaFolderByIdMutation>;
export type DeleteMediaFolderByIdMutationResult = Apollo.MutationResult<DeleteMediaFolderByIdMutation>;
export type DeleteMediaFolderByIdMutationOptions = Apollo.BaseMutationOptions<DeleteMediaFolderByIdMutation, DeleteMediaFolderByIdMutationVariables>;
export const DeleteMediaFilesDocument = gql`
    mutation deleteMediaFiles($mediaFilesIds: [ObjectId!]!, $filter: GetMediaFoldersAndFilesFilterInput, $excludedIds: [ObjectId!]) {
  deleteMediaFiles(
    mediaFilesIds: $mediaFilesIds
    filter: $filter
    excludedIds: $excludedIds
  ) {
    ...Media
  }
}
    ${MediaFragmentDoc}`;
export type DeleteMediaFilesMutationFn = Apollo.MutationFunction<DeleteMediaFilesMutation, DeleteMediaFilesMutationVariables>;

/**
 * __useDeleteMediaFilesMutation__
 *
 * To run a mutation, you first call `useDeleteMediaFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaFilesMutation, { data, loading, error }] = useDeleteMediaFilesMutation({
 *   variables: {
 *      mediaFilesIds: // value for 'mediaFilesIds'
 *      filter: // value for 'filter'
 *      excludedIds: // value for 'excludedIds'
 *   },
 * });
 */
export function useDeleteMediaFilesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMediaFilesMutation, DeleteMediaFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMediaFilesMutation, DeleteMediaFilesMutationVariables>(DeleteMediaFilesDocument, options);
      }
export type DeleteMediaFilesMutationHookResult = ReturnType<typeof useDeleteMediaFilesMutation>;
export type DeleteMediaFilesMutationResult = Apollo.MutationResult<DeleteMediaFilesMutation>;
export type DeleteMediaFilesMutationOptions = Apollo.BaseMutationOptions<DeleteMediaFilesMutation, DeleteMediaFilesMutationVariables>;
export const MoveMediaToFolderDocument = gql`
    mutation moveMediaToFolder($mediaFolderId: ObjectId!, $mediaIds: [ObjectId!]!, $filter: GetMediaFoldersAndFilesFilterInput, $excludedIds: [ObjectId!]) {
  moveMediaToFolder(
    mediaFolderId: $mediaFolderId
    mediaIds: $mediaIds
    filter: $filter
    excludedIds: $excludedIds
  ) {
    ...Media
  }
}
    ${MediaFragmentDoc}`;
export type MoveMediaToFolderMutationFn = Apollo.MutationFunction<MoveMediaToFolderMutation, MoveMediaToFolderMutationVariables>;

/**
 * __useMoveMediaToFolderMutation__
 *
 * To run a mutation, you first call `useMoveMediaToFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveMediaToFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveMediaToFolderMutation, { data, loading, error }] = useMoveMediaToFolderMutation({
 *   variables: {
 *      mediaFolderId: // value for 'mediaFolderId'
 *      mediaIds: // value for 'mediaIds'
 *      filter: // value for 'filter'
 *      excludedIds: // value for 'excludedIds'
 *   },
 * });
 */
export function useMoveMediaToFolderMutation(baseOptions?: Apollo.MutationHookOptions<MoveMediaToFolderMutation, MoveMediaToFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveMediaToFolderMutation, MoveMediaToFolderMutationVariables>(MoveMediaToFolderDocument, options);
      }
export type MoveMediaToFolderMutationHookResult = ReturnType<typeof useMoveMediaToFolderMutation>;
export type MoveMediaToFolderMutationResult = Apollo.MutationResult<MoveMediaToFolderMutation>;
export type MoveMediaToFolderMutationOptions = Apollo.BaseMutationOptions<MoveMediaToFolderMutation, MoveMediaToFolderMutationVariables>;
export const MoveMediaInSortOrderDocument = gql`
    mutation moveMediaInSortOrder($sortedMediaIds: [SortedMediaIdsInput!]!) {
  moveMediaInSortOrder(sortedMediaIds: $sortedMediaIds) {
    _id
  }
}
    `;
export type MoveMediaInSortOrderMutationFn = Apollo.MutationFunction<MoveMediaInSortOrderMutation, MoveMediaInSortOrderMutationVariables>;

/**
 * __useMoveMediaInSortOrderMutation__
 *
 * To run a mutation, you first call `useMoveMediaInSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveMediaInSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveMediaInSortOrderMutation, { data, loading, error }] = useMoveMediaInSortOrderMutation({
 *   variables: {
 *      sortedMediaIds: // value for 'sortedMediaIds'
 *   },
 * });
 */
export function useMoveMediaInSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<MoveMediaInSortOrderMutation, MoveMediaInSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveMediaInSortOrderMutation, MoveMediaInSortOrderMutationVariables>(MoveMediaInSortOrderDocument, options);
      }
export type MoveMediaInSortOrderMutationHookResult = ReturnType<typeof useMoveMediaInSortOrderMutation>;
export type MoveMediaInSortOrderMutationResult = Apollo.MutationResult<MoveMediaInSortOrderMutation>;
export type MoveMediaInSortOrderMutationOptions = Apollo.BaseMutationOptions<MoveMediaInSortOrderMutation, MoveMediaInSortOrderMutationVariables>;
export const UpdateMediaBrandingTypeDocument = gql`
    mutation UpdateMediaBrandingType($mediaId: ObjectId!, $brandingType: BrandingTypeEnum!) {
  updateMediaBrandingType(mediaId: $mediaId, brandingType: $brandingType) {
    ...Media
  }
}
    ${MediaFragmentDoc}`;
export type UpdateMediaBrandingTypeMutationFn = Apollo.MutationFunction<UpdateMediaBrandingTypeMutation, UpdateMediaBrandingTypeMutationVariables>;

/**
 * __useUpdateMediaBrandingTypeMutation__
 *
 * To run a mutation, you first call `useUpdateMediaBrandingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaBrandingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMediaBrandingTypeMutation, { data, loading, error }] = useUpdateMediaBrandingTypeMutation({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *      brandingType: // value for 'brandingType'
 *   },
 * });
 */
export function useUpdateMediaBrandingTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMediaBrandingTypeMutation, UpdateMediaBrandingTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMediaBrandingTypeMutation, UpdateMediaBrandingTypeMutationVariables>(UpdateMediaBrandingTypeDocument, options);
      }
export type UpdateMediaBrandingTypeMutationHookResult = ReturnType<typeof useUpdateMediaBrandingTypeMutation>;
export type UpdateMediaBrandingTypeMutationResult = Apollo.MutationResult<UpdateMediaBrandingTypeMutation>;
export type UpdateMediaBrandingTypeMutationOptions = Apollo.BaseMutationOptions<UpdateMediaBrandingTypeMutation, UpdateMediaBrandingTypeMutationVariables>;
export const BulkUpdateMediaBrandingTypeDocument = gql`
    mutation BulkUpdateMediaBrandingType($mediaFilesIds: [ObjectId!]!, $brandingType: BrandingTypeEnum!, $filter: GetMediaFoldersAndFilesFilterInput, $excludedIds: [ObjectId!]) {
  bulkUpdateMediaBrandingType(
    mediaFilesIds: $mediaFilesIds
    brandingType: $brandingType
    filter: $filter
    excludedIds: $excludedIds
  ) {
    ...Media
  }
}
    ${MediaFragmentDoc}`;
export type BulkUpdateMediaBrandingTypeMutationFn = Apollo.MutationFunction<BulkUpdateMediaBrandingTypeMutation, BulkUpdateMediaBrandingTypeMutationVariables>;

/**
 * __useBulkUpdateMediaBrandingTypeMutation__
 *
 * To run a mutation, you first call `useBulkUpdateMediaBrandingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateMediaBrandingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateMediaBrandingTypeMutation, { data, loading, error }] = useBulkUpdateMediaBrandingTypeMutation({
 *   variables: {
 *      mediaFilesIds: // value for 'mediaFilesIds'
 *      brandingType: // value for 'brandingType'
 *      filter: // value for 'filter'
 *      excludedIds: // value for 'excludedIds'
 *   },
 * });
 */
export function useBulkUpdateMediaBrandingTypeMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateMediaBrandingTypeMutation, BulkUpdateMediaBrandingTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateMediaBrandingTypeMutation, BulkUpdateMediaBrandingTypeMutationVariables>(BulkUpdateMediaBrandingTypeDocument, options);
      }
export type BulkUpdateMediaBrandingTypeMutationHookResult = ReturnType<typeof useBulkUpdateMediaBrandingTypeMutation>;
export type BulkUpdateMediaBrandingTypeMutationResult = Apollo.MutationResult<BulkUpdateMediaBrandingTypeMutation>;
export type BulkUpdateMediaBrandingTypeMutationOptions = Apollo.BaseMutationOptions<BulkUpdateMediaBrandingTypeMutation, BulkUpdateMediaBrandingTypeMutationVariables>;
export const GetMediaFoldersAndFilesDocument = gql`
    query getMediaFoldersAndFiles($filter: GetMediaFoldersAndFilesFilterInput!, $pagination: PaginationInput, $sort: [SortInput!]) {
  getMediaFoldersAndFiles(filter: $filter, pagination: $pagination, sort: $sort) {
    filesCollection {
      _id
      updatedAt
      createdAt
      files {
        _id
        type
        name
        publicUrl
        s3Key
        thumbnailFileUrl
        thumbnailFile {
          publicUrl
        }
      }
      folderName
      type
      sizeInBytes
      mediaItemsCount
      propertyId
      brandingType
      systemFolderType
    }
    filesTotalCount
    foldersCollection {
      _id
      updatedAt
      createdAt
      systemFolderType
      files {
        _id
        type
        publicUrl
        thumbnailFileUrl
        thumbnailFile {
          publicUrl
        }
      }
      folderName
      type
      sizeInBytes
      mediaItemsCount
      propertyId
    }
    foldersTotalCount
  }
}
    `;

/**
 * __useGetMediaFoldersAndFilesQuery__
 *
 * To run a query within a React component, call `useGetMediaFoldersAndFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaFoldersAndFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaFoldersAndFilesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetMediaFoldersAndFilesQuery(baseOptions: Apollo.QueryHookOptions<GetMediaFoldersAndFilesQuery, GetMediaFoldersAndFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMediaFoldersAndFilesQuery, GetMediaFoldersAndFilesQueryVariables>(GetMediaFoldersAndFilesDocument, options);
      }
export function useGetMediaFoldersAndFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMediaFoldersAndFilesQuery, GetMediaFoldersAndFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMediaFoldersAndFilesQuery, GetMediaFoldersAndFilesQueryVariables>(GetMediaFoldersAndFilesDocument, options);
        }
export type GetMediaFoldersAndFilesQueryHookResult = ReturnType<typeof useGetMediaFoldersAndFilesQuery>;
export type GetMediaFoldersAndFilesLazyQueryHookResult = ReturnType<typeof useGetMediaFoldersAndFilesLazyQuery>;
export type GetMediaFoldersAndFilesQueryResult = Apollo.QueryResult<GetMediaFoldersAndFilesQuery, GetMediaFoldersAndFilesQueryVariables>;
export const GetMediaFilesDocument = gql`
    query getMediaFiles($filter: GetMediaFoldersAndFilesFilterInput!, $pagination: PaginationInput, $sort: [SortInput!]) {
  getMediaFoldersAndFiles(filter: $filter, pagination: $pagination, sort: $sort) {
    filesCollection {
      ...Media
    }
    filesTotalCount
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useGetMediaFilesQuery__
 *
 * To run a query within a React component, call `useGetMediaFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaFilesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetMediaFilesQuery(baseOptions: Apollo.QueryHookOptions<GetMediaFilesQuery, GetMediaFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMediaFilesQuery, GetMediaFilesQueryVariables>(GetMediaFilesDocument, options);
      }
export function useGetMediaFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMediaFilesQuery, GetMediaFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMediaFilesQuery, GetMediaFilesQueryVariables>(GetMediaFilesDocument, options);
        }
export type GetMediaFilesQueryHookResult = ReturnType<typeof useGetMediaFilesQuery>;
export type GetMediaFilesLazyQueryHookResult = ReturnType<typeof useGetMediaFilesLazyQuery>;
export type GetMediaFilesQueryResult = Apollo.QueryResult<GetMediaFilesQuery, GetMediaFilesQueryVariables>;
export const GetMediaFolderByIdDocument = gql`
    query getMediaFolderById($folderId: ObjectId!) {
  getMediaFolderById(folderId: $folderId) {
    _id
    folderName
    systemFolderType
    foldersPathCollection {
      _id
      folderName
    }
  }
}
    `;

/**
 * __useGetMediaFolderByIdQuery__
 *
 * To run a query within a React component, call `useGetMediaFolderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaFolderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaFolderByIdQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useGetMediaFolderByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMediaFolderByIdQuery, GetMediaFolderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMediaFolderByIdQuery, GetMediaFolderByIdQueryVariables>(GetMediaFolderByIdDocument, options);
      }
export function useGetMediaFolderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMediaFolderByIdQuery, GetMediaFolderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMediaFolderByIdQuery, GetMediaFolderByIdQueryVariables>(GetMediaFolderByIdDocument, options);
        }
export type GetMediaFolderByIdQueryHookResult = ReturnType<typeof useGetMediaFolderByIdQuery>;
export type GetMediaFolderByIdLazyQueryHookResult = ReturnType<typeof useGetMediaFolderByIdLazyQuery>;
export type GetMediaFolderByIdQueryResult = Apollo.QueryResult<GetMediaFolderByIdQuery, GetMediaFolderByIdQueryVariables>;
export const GetAllFoldersInPropertyDocument = gql`
    query getAllFoldersInProperty($propertyId: ObjectId!, $mediaFolderId: ObjectId, $includeRootFolder: Boolean, $excludeSlideshowFolder: Boolean) {
  getAllFoldersInProperty(
    propertyId: $propertyId
    mediaFolderId: $mediaFolderId
    includeRootFolder: $includeRootFolder
    excludeSlideshowFolder: $excludeSlideshowFolder
  ) {
    _id
    folderName
    type
    systemFolderType
    parentMediaFoldersIds
    mediaFolderId
  }
}
    `;

/**
 * __useGetAllFoldersInPropertyQuery__
 *
 * To run a query within a React component, call `useGetAllFoldersInPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFoldersInPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFoldersInPropertyQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      mediaFolderId: // value for 'mediaFolderId'
 *      includeRootFolder: // value for 'includeRootFolder'
 *      excludeSlideshowFolder: // value for 'excludeSlideshowFolder'
 *   },
 * });
 */
export function useGetAllFoldersInPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetAllFoldersInPropertyQuery, GetAllFoldersInPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFoldersInPropertyQuery, GetAllFoldersInPropertyQueryVariables>(GetAllFoldersInPropertyDocument, options);
      }
export function useGetAllFoldersInPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFoldersInPropertyQuery, GetAllFoldersInPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFoldersInPropertyQuery, GetAllFoldersInPropertyQueryVariables>(GetAllFoldersInPropertyDocument, options);
        }
export type GetAllFoldersInPropertyQueryHookResult = ReturnType<typeof useGetAllFoldersInPropertyQuery>;
export type GetAllFoldersInPropertyLazyQueryHookResult = ReturnType<typeof useGetAllFoldersInPropertyLazyQuery>;
export type GetAllFoldersInPropertyQueryResult = Apollo.QueryResult<GetAllFoldersInPropertyQuery, GetAllFoldersInPropertyQueryVariables>;
export const GetAllFilesInPropertyDocument = gql`
    query getAllFilesInProperty($filter: GetAllFilesInPropertyFilterInput!, $pagination: PaginationInput, $sort: [SortInput!]) {
  getAllFilesInProperty(filter: $filter, pagination: $pagination, sort: $sort) {
    filesCollection {
      ...Media
    }
    filesTotalCount
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useGetAllFilesInPropertyQuery__
 *
 * To run a query within a React component, call `useGetAllFilesInPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFilesInPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFilesInPropertyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAllFilesInPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetAllFilesInPropertyQuery, GetAllFilesInPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFilesInPropertyQuery, GetAllFilesInPropertyQueryVariables>(GetAllFilesInPropertyDocument, options);
      }
export function useGetAllFilesInPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFilesInPropertyQuery, GetAllFilesInPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFilesInPropertyQuery, GetAllFilesInPropertyQueryVariables>(GetAllFilesInPropertyDocument, options);
        }
export type GetAllFilesInPropertyQueryHookResult = ReturnType<typeof useGetAllFilesInPropertyQuery>;
export type GetAllFilesInPropertyLazyQueryHookResult = ReturnType<typeof useGetAllFilesInPropertyLazyQuery>;
export type GetAllFilesInPropertyQueryResult = Apollo.QueryResult<GetAllFilesInPropertyQuery, GetAllFilesInPropertyQueryVariables>;
export const GetNumberOfAllMediaFilesToDownloadDocument = gql`
    query getNumberOfAllMediaFilesToDownload($propertyId: ObjectId!) {
  getAllFilesInProperty(filter: {propertyId: $propertyId}) {
    filesTotalCount
  }
}
    `;

/**
 * __useGetNumberOfAllMediaFilesToDownloadQuery__
 *
 * To run a query within a React component, call `useGetNumberOfAllMediaFilesToDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfAllMediaFilesToDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfAllMediaFilesToDownloadQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetNumberOfAllMediaFilesToDownloadQuery(baseOptions: Apollo.QueryHookOptions<GetNumberOfAllMediaFilesToDownloadQuery, GetNumberOfAllMediaFilesToDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfAllMediaFilesToDownloadQuery, GetNumberOfAllMediaFilesToDownloadQueryVariables>(GetNumberOfAllMediaFilesToDownloadDocument, options);
      }
export function useGetNumberOfAllMediaFilesToDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfAllMediaFilesToDownloadQuery, GetNumberOfAllMediaFilesToDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfAllMediaFilesToDownloadQuery, GetNumberOfAllMediaFilesToDownloadQueryVariables>(GetNumberOfAllMediaFilesToDownloadDocument, options);
        }
export type GetNumberOfAllMediaFilesToDownloadQueryHookResult = ReturnType<typeof useGetNumberOfAllMediaFilesToDownloadQuery>;
export type GetNumberOfAllMediaFilesToDownloadLazyQueryHookResult = ReturnType<typeof useGetNumberOfAllMediaFilesToDownloadLazyQuery>;
export type GetNumberOfAllMediaFilesToDownloadQueryResult = Apollo.QueryResult<GetNumberOfAllMediaFilesToDownloadQuery, GetNumberOfAllMediaFilesToDownloadQueryVariables>;
export const GetAllFilesInPropertyPreviewDocument = gql`
    query getAllFilesInPropertyPreview($filter: GetAllFilesInPropertyFilterInput!, $pagination: PaginationInput, $sort: [SortInput!], $previewAsSeeker: Boolean) {
  getAllFilesInPropertyPreview(
    filter: $filter
    pagination: $pagination
    sort: $sort
    previewAsSeeker: $previewAsSeeker
  ) {
    filesCollection {
      ...Media
    }
    filesTotalCount
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useGetAllFilesInPropertyPreviewQuery__
 *
 * To run a query within a React component, call `useGetAllFilesInPropertyPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFilesInPropertyPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFilesInPropertyPreviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      previewAsSeeker: // value for 'previewAsSeeker'
 *   },
 * });
 */
export function useGetAllFilesInPropertyPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetAllFilesInPropertyPreviewQuery, GetAllFilesInPropertyPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFilesInPropertyPreviewQuery, GetAllFilesInPropertyPreviewQueryVariables>(GetAllFilesInPropertyPreviewDocument, options);
      }
export function useGetAllFilesInPropertyPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFilesInPropertyPreviewQuery, GetAllFilesInPropertyPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFilesInPropertyPreviewQuery, GetAllFilesInPropertyPreviewQueryVariables>(GetAllFilesInPropertyPreviewDocument, options);
        }
export type GetAllFilesInPropertyPreviewQueryHookResult = ReturnType<typeof useGetAllFilesInPropertyPreviewQuery>;
export type GetAllFilesInPropertyPreviewLazyQueryHookResult = ReturnType<typeof useGetAllFilesInPropertyPreviewLazyQuery>;
export type GetAllFilesInPropertyPreviewQueryResult = Apollo.QueryResult<GetAllFilesInPropertyPreviewQuery, GetAllFilesInPropertyPreviewQueryVariables>;
export const GetSlideshowMediaByPropertyDocument = gql`
    query getSlideshowMediaByProperty($propertyId: ObjectId!) {
  getSlideshowMediaByProperty(propertyId: $propertyId) {
    ...Media
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useGetSlideshowMediaByPropertyQuery__
 *
 * To run a query within a React component, call `useGetSlideshowMediaByPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlideshowMediaByPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlideshowMediaByPropertyQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetSlideshowMediaByPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetSlideshowMediaByPropertyQuery, GetSlideshowMediaByPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlideshowMediaByPropertyQuery, GetSlideshowMediaByPropertyQueryVariables>(GetSlideshowMediaByPropertyDocument, options);
      }
export function useGetSlideshowMediaByPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlideshowMediaByPropertyQuery, GetSlideshowMediaByPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlideshowMediaByPropertyQuery, GetSlideshowMediaByPropertyQueryVariables>(GetSlideshowMediaByPropertyDocument, options);
        }
export type GetSlideshowMediaByPropertyQueryHookResult = ReturnType<typeof useGetSlideshowMediaByPropertyQuery>;
export type GetSlideshowMediaByPropertyLazyQueryHookResult = ReturnType<typeof useGetSlideshowMediaByPropertyLazyQuery>;
export type GetSlideshowMediaByPropertyQueryResult = Apollo.QueryResult<GetSlideshowMediaByPropertyQuery, GetSlideshowMediaByPropertyQueryVariables>;
export const GetTopLevelFoldersInPropertyDocument = gql`
    query getTopLevelFoldersInProperty($propertyId: ObjectId!) {
  getTopLevelFoldersInProperty(propertyId: $propertyId) {
    _id
    folderName
    systemFolderType
  }
}
    `;

/**
 * __useGetTopLevelFoldersInPropertyQuery__
 *
 * To run a query within a React component, call `useGetTopLevelFoldersInPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopLevelFoldersInPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopLevelFoldersInPropertyQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetTopLevelFoldersInPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetTopLevelFoldersInPropertyQuery, GetTopLevelFoldersInPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopLevelFoldersInPropertyQuery, GetTopLevelFoldersInPropertyQueryVariables>(GetTopLevelFoldersInPropertyDocument, options);
      }
export function useGetTopLevelFoldersInPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopLevelFoldersInPropertyQuery, GetTopLevelFoldersInPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopLevelFoldersInPropertyQuery, GetTopLevelFoldersInPropertyQueryVariables>(GetTopLevelFoldersInPropertyDocument, options);
        }
export type GetTopLevelFoldersInPropertyQueryHookResult = ReturnType<typeof useGetTopLevelFoldersInPropertyQuery>;
export type GetTopLevelFoldersInPropertyLazyQueryHookResult = ReturnType<typeof useGetTopLevelFoldersInPropertyLazyQuery>;
export type GetTopLevelFoldersInPropertyQueryResult = Apollo.QueryResult<GetTopLevelFoldersInPropertyQuery, GetTopLevelFoldersInPropertyQueryVariables>;
export const ObserveMediaChangesDocument = gql`
    subscription observeMediaChanges($filter: GetMediaFoldersAndFilesFilterInput!) {
  observeMediaChanges(filter: $filter) {
    trigger
    document {
      ...Media
    }
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useObserveMediaChangesSubscription__
 *
 * To run a query within a React component, call `useObserveMediaChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useObserveMediaChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObserveMediaChangesSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useObserveMediaChangesSubscription(baseOptions: Apollo.SubscriptionHookOptions<ObserveMediaChangesSubscription, ObserveMediaChangesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ObserveMediaChangesSubscription, ObserveMediaChangesSubscriptionVariables>(ObserveMediaChangesDocument, options);
      }
export type ObserveMediaChangesSubscriptionHookResult = ReturnType<typeof useObserveMediaChangesSubscription>;
export type ObserveMediaChangesSubscriptionResult = Apollo.SubscriptionResult<ObserveMediaChangesSubscription>;
export const CreateOrganizationUserDocument = gql`
    mutation createOrganizationUser($input: CreateOrganizationUserInput!) {
  createOrganizationUser(input: $input) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export type CreateOrganizationUserMutationFn = Apollo.MutationFunction<CreateOrganizationUserMutation, CreateOrganizationUserMutationVariables>;

/**
 * __useCreateOrganizationUserMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationUserMutation, { data, loading, error }] = useCreateOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationUserMutation, CreateOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationUserMutation, CreateOrganizationUserMutationVariables>(CreateOrganizationUserDocument, options);
      }
export type CreateOrganizationUserMutationHookResult = ReturnType<typeof useCreateOrganizationUserMutation>;
export type CreateOrganizationUserMutationResult = Apollo.MutationResult<CreateOrganizationUserMutation>;
export type CreateOrganizationUserMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationUserMutation, CreateOrganizationUserMutationVariables>;
export const EditOrganizationUserDocument = gql`
    mutation editOrganizationUser($input: EditOrganizationUserInput!) {
  editOrganizationUser(input: $input) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export type EditOrganizationUserMutationFn = Apollo.MutationFunction<EditOrganizationUserMutation, EditOrganizationUserMutationVariables>;

/**
 * __useEditOrganizationUserMutation__
 *
 * To run a mutation, you first call `useEditOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationUserMutation, { data, loading, error }] = useEditOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<EditOrganizationUserMutation, EditOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrganizationUserMutation, EditOrganizationUserMutationVariables>(EditOrganizationUserDocument, options);
      }
export type EditOrganizationUserMutationHookResult = ReturnType<typeof useEditOrganizationUserMutation>;
export type EditOrganizationUserMutationResult = Apollo.MutationResult<EditOrganizationUserMutation>;
export type EditOrganizationUserMutationOptions = Apollo.BaseMutationOptions<EditOrganizationUserMutation, EditOrganizationUserMutationVariables>;
export const DeleteOrganizationUserDocument = gql`
    mutation deleteOrganizationUser($organizationUserId: ObjectId!) {
  deleteOrganizationUser(organizationUserId: $organizationUserId) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export type DeleteOrganizationUserMutationFn = Apollo.MutationFunction<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>;

/**
 * __useDeleteOrganizationUserMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationUserMutation, { data, loading, error }] = useDeleteOrganizationUserMutation({
 *   variables: {
 *      organizationUserId: // value for 'organizationUserId'
 *   },
 * });
 */
export function useDeleteOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>(DeleteOrganizationUserDocument, options);
      }
export type DeleteOrganizationUserMutationHookResult = ReturnType<typeof useDeleteOrganizationUserMutation>;
export type DeleteOrganizationUserMutationResult = Apollo.MutationResult<DeleteOrganizationUserMutation>;
export type DeleteOrganizationUserMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>;
export const SetOrganizationUserStatusDocument = gql`
    mutation setOrganizationUserStatus($organizationUserId: ObjectId!, $status: AccountActiveOrArchivedStatusesEnum!) {
  setOrganizationUserStatus(
    organizationUserId: $organizationUserId
    status: $status
  )
}
    `;
export type SetOrganizationUserStatusMutationFn = Apollo.MutationFunction<SetOrganizationUserStatusMutation, SetOrganizationUserStatusMutationVariables>;

/**
 * __useSetOrganizationUserStatusMutation__
 *
 * To run a mutation, you first call `useSetOrganizationUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganizationUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganizationUserStatusMutation, { data, loading, error }] = useSetOrganizationUserStatusMutation({
 *   variables: {
 *      organizationUserId: // value for 'organizationUserId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetOrganizationUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganizationUserStatusMutation, SetOrganizationUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrganizationUserStatusMutation, SetOrganizationUserStatusMutationVariables>(SetOrganizationUserStatusDocument, options);
      }
export type SetOrganizationUserStatusMutationHookResult = ReturnType<typeof useSetOrganizationUserStatusMutation>;
export type SetOrganizationUserStatusMutationResult = Apollo.MutationResult<SetOrganizationUserStatusMutation>;
export type SetOrganizationUserStatusMutationOptions = Apollo.BaseMutationOptions<SetOrganizationUserStatusMutation, SetOrganizationUserStatusMutationVariables>;
export const GetOrganizationUsersDocument = gql`
    query getOrganizationUsers($filter: GetOrganizationUsersFilterInput!, $pagination: PaginationInput, $sort: [SortInput!]) {
  getOrganizationUsers(filter: $filter, pagination: $pagination, sort: $sort) {
    collection {
      ...OrganizationUser
    }
    totalCount
  }
}
    ${OrganizationUserFragmentDoc}`;

/**
 * __useGetOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetOrganizationUsersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
      }
export function useGetOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
        }
export type GetOrganizationUsersQueryHookResult = ReturnType<typeof useGetOrganizationUsersQuery>;
export type GetOrganizationUsersLazyQueryHookResult = ReturnType<typeof useGetOrganizationUsersLazyQuery>;
export type GetOrganizationUsersQueryResult = Apollo.QueryResult<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>;
export const GetOrganizationUsersForTableDocument = gql`
    query getOrganizationUsersForTable($filter: GetOrganizationUsersFilterInput!, $pagination: PaginationInput, $sort: [SortInput!]) {
  getOrganizationUsers(filter: $filter, pagination: $pagination, sort: $sort) {
    collection {
      ...OrganizationUserForTable
    }
    totalCount
  }
}
    ${OrganizationUserForTableFragmentDoc}`;

/**
 * __useGetOrganizationUsersForTableQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUsersForTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUsersForTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUsersForTableQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetOrganizationUsersForTableQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationUsersForTableQuery, GetOrganizationUsersForTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUsersForTableQuery, GetOrganizationUsersForTableQueryVariables>(GetOrganizationUsersForTableDocument, options);
      }
export function useGetOrganizationUsersForTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUsersForTableQuery, GetOrganizationUsersForTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUsersForTableQuery, GetOrganizationUsersForTableQueryVariables>(GetOrganizationUsersForTableDocument, options);
        }
export type GetOrganizationUsersForTableQueryHookResult = ReturnType<typeof useGetOrganizationUsersForTableQuery>;
export type GetOrganizationUsersForTableLazyQueryHookResult = ReturnType<typeof useGetOrganizationUsersForTableLazyQuery>;
export type GetOrganizationUsersForTableQueryResult = Apollo.QueryResult<GetOrganizationUsersForTableQuery, GetOrganizationUsersForTableQueryVariables>;
export const CreateOrganizationDocument = gql`
    mutation createOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const EditOrganizationDocument = gql`
    mutation editOrganization($input: EditOrganizationInput!, $organizationId: ObjectId!) {
  editOrganization(input: $input, organizationId: $organizationId) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export type EditOrganizationMutationFn = Apollo.MutationFunction<EditOrganizationMutation, EditOrganizationMutationVariables>;

/**
 * __useEditOrganizationMutation__
 *
 * To run a mutation, you first call `useEditOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationMutation, { data, loading, error }] = useEditOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEditOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditOrganizationMutation, EditOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, options);
      }
export type EditOrganizationMutationHookResult = ReturnType<typeof useEditOrganizationMutation>;
export type EditOrganizationMutationResult = Apollo.MutationResult<EditOrganizationMutation>;
export type EditOrganizationMutationOptions = Apollo.BaseMutationOptions<EditOrganizationMutation, EditOrganizationMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation deleteOrganization($organizationId: ObjectId!) {
  deleteOrganization(organizationId: $organizationId) {
    _id
  }
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const GetOrganizationsDocument = gql`
    query getOrganizations($sort: [SortInput!], $pagination: PaginationInput, $searchByName: String) {
  getOrganizations(
    sort: $sort
    pagination: $pagination
    searchByName: $searchByName
  ) {
    totalCount
    collection {
      ...Organization
      propertiesCount
    }
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      searchByName: // value for 'searchByName'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetOrganizationsForTableDocument = gql`
    query getOrganizationsForTable($sort: [SortInput!], $pagination: PaginationInput, $searchByName: String) {
  getOrganizations(
    sort: $sort
    pagination: $pagination
    searchByName: $searchByName
  ) {
    totalCount
    collection {
      ...OrganizationForTable
    }
  }
}
    ${OrganizationForTableFragmentDoc}`;

/**
 * __useGetOrganizationsForTableQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsForTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsForTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsForTableQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      searchByName: // value for 'searchByName'
 *   },
 * });
 */
export function useGetOrganizationsForTableQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsForTableQuery, GetOrganizationsForTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsForTableQuery, GetOrganizationsForTableQueryVariables>(GetOrganizationsForTableDocument, options);
      }
export function useGetOrganizationsForTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsForTableQuery, GetOrganizationsForTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsForTableQuery, GetOrganizationsForTableQueryVariables>(GetOrganizationsForTableDocument, options);
        }
export type GetOrganizationsForTableQueryHookResult = ReturnType<typeof useGetOrganizationsForTableQuery>;
export type GetOrganizationsForTableLazyQueryHookResult = ReturnType<typeof useGetOrganizationsForTableLazyQuery>;
export type GetOrganizationsForTableQueryResult = Apollo.QueryResult<GetOrganizationsForTableQuery, GetOrganizationsForTableQueryVariables>;
export const GetOrganizationsForSelectDocument = gql`
    query getOrganizationsForSelect($sort: [SortInput!], $pagination: PaginationInput, $searchByName: String) {
  getOrganizations(
    sort: $sort
    pagination: $pagination
    searchByName: $searchByName
  ) {
    totalCount
    collection {
      _id
      name
      internalSaleTeam {
        _id
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationsForSelectQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsForSelectQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      searchByName: // value for 'searchByName'
 *   },
 * });
 */
export function useGetOrganizationsForSelectQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsForSelectQuery, GetOrganizationsForSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsForSelectQuery, GetOrganizationsForSelectQueryVariables>(GetOrganizationsForSelectDocument, options);
      }
export function useGetOrganizationsForSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsForSelectQuery, GetOrganizationsForSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsForSelectQuery, GetOrganizationsForSelectQueryVariables>(GetOrganizationsForSelectDocument, options);
        }
export type GetOrganizationsForSelectQueryHookResult = ReturnType<typeof useGetOrganizationsForSelectQuery>;
export type GetOrganizationsForSelectLazyQueryHookResult = ReturnType<typeof useGetOrganizationsForSelectLazyQuery>;
export type GetOrganizationsForSelectQueryResult = Apollo.QueryResult<GetOrganizationsForSelectQuery, GetOrganizationsForSelectQueryVariables>;
export const GetOrganizationByIdDocument = gql`
    query getOrganizationById($organizationId: ObjectId!) {
  getOrganizationById(organizationId: $organizationId) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useGetOrganizationByIdQuery__
 *
 * To run a query within a React component, call `useGetOrganizationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationByIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>(GetOrganizationByIdDocument, options);
      }
export function useGetOrganizationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>(GetOrganizationByIdDocument, options);
        }
export type GetOrganizationByIdQueryHookResult = ReturnType<typeof useGetOrganizationByIdQuery>;
export type GetOrganizationByIdLazyQueryHookResult = ReturnType<typeof useGetOrganizationByIdLazyQuery>;
export type GetOrganizationByIdQueryResult = Apollo.QueryResult<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>;
export const ObserveProgressTrackingByTypeDocument = gql`
    subscription observeProgressTrackingByType($type: String!) {
  observeProgressTrackingByType(type: $type) {
    document {
      ...ProgressTracking
    }
  }
}
    ${ProgressTrackingFragmentDoc}`;

/**
 * __useObserveProgressTrackingByTypeSubscription__
 *
 * To run a query within a React component, call `useObserveProgressTrackingByTypeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useObserveProgressTrackingByTypeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObserveProgressTrackingByTypeSubscription({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useObserveProgressTrackingByTypeSubscription(baseOptions: Apollo.SubscriptionHookOptions<ObserveProgressTrackingByTypeSubscription, ObserveProgressTrackingByTypeSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ObserveProgressTrackingByTypeSubscription, ObserveProgressTrackingByTypeSubscriptionVariables>(ObserveProgressTrackingByTypeDocument, options);
      }
export type ObserveProgressTrackingByTypeSubscriptionHookResult = ReturnType<typeof useObserveProgressTrackingByTypeSubscription>;
export type ObserveProgressTrackingByTypeSubscriptionResult = Apollo.SubscriptionResult<ObserveProgressTrackingByTypeSubscription>;
export const CreatePropertyDocument = gql`
    mutation createProperty($input: CreatePropertyInput!) {
  createProperty(input: $input) {
    _id
  }
}
    `;
export type CreatePropertyMutationFn = Apollo.MutationFunction<CreatePropertyMutation, CreatePropertyMutationVariables>;

/**
 * __useCreatePropertyMutation__
 *
 * To run a mutation, you first call `useCreatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPropertyMutation, { data, loading, error }] = useCreatePropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePropertyMutation(baseOptions?: Apollo.MutationHookOptions<CreatePropertyMutation, CreatePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePropertyMutation, CreatePropertyMutationVariables>(CreatePropertyDocument, options);
      }
export type CreatePropertyMutationHookResult = ReturnType<typeof useCreatePropertyMutation>;
export type CreatePropertyMutationResult = Apollo.MutationResult<CreatePropertyMutation>;
export type CreatePropertyMutationOptions = Apollo.BaseMutationOptions<CreatePropertyMutation, CreatePropertyMutationVariables>;
export const SetAdvancedPropertyDetailsDocument = gql`
    mutation setAdvancedPropertyDetails($input: SetAdvancedPropertyDetailsInput!) {
  setAdvancedPropertyDetails(input: $input) {
    ...Property
  }
}
    ${PropertyFragmentDoc}`;
export type SetAdvancedPropertyDetailsMutationFn = Apollo.MutationFunction<SetAdvancedPropertyDetailsMutation, SetAdvancedPropertyDetailsMutationVariables>;

/**
 * __useSetAdvancedPropertyDetailsMutation__
 *
 * To run a mutation, you first call `useSetAdvancedPropertyDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAdvancedPropertyDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAdvancedPropertyDetailsMutation, { data, loading, error }] = useSetAdvancedPropertyDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAdvancedPropertyDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SetAdvancedPropertyDetailsMutation, SetAdvancedPropertyDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAdvancedPropertyDetailsMutation, SetAdvancedPropertyDetailsMutationVariables>(SetAdvancedPropertyDetailsDocument, options);
      }
export type SetAdvancedPropertyDetailsMutationHookResult = ReturnType<typeof useSetAdvancedPropertyDetailsMutation>;
export type SetAdvancedPropertyDetailsMutationResult = Apollo.MutationResult<SetAdvancedPropertyDetailsMutation>;
export type SetAdvancedPropertyDetailsMutationOptions = Apollo.BaseMutationOptions<SetAdvancedPropertyDetailsMutation, SetAdvancedPropertyDetailsMutationVariables>;
export const SetGeneralPropertyDetailsDocument = gql`
    mutation setGeneralPropertyDetails($input: SetGeneralPropertyDetailsInput!) {
  setGeneralPropertyDetails(input: $input) {
    ...Property
  }
}
    ${PropertyFragmentDoc}`;
export type SetGeneralPropertyDetailsMutationFn = Apollo.MutationFunction<SetGeneralPropertyDetailsMutation, SetGeneralPropertyDetailsMutationVariables>;

/**
 * __useSetGeneralPropertyDetailsMutation__
 *
 * To run a mutation, you first call `useSetGeneralPropertyDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGeneralPropertyDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGeneralPropertyDetailsMutation, { data, loading, error }] = useSetGeneralPropertyDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetGeneralPropertyDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SetGeneralPropertyDetailsMutation, SetGeneralPropertyDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGeneralPropertyDetailsMutation, SetGeneralPropertyDetailsMutationVariables>(SetGeneralPropertyDetailsDocument, options);
      }
export type SetGeneralPropertyDetailsMutationHookResult = ReturnType<typeof useSetGeneralPropertyDetailsMutation>;
export type SetGeneralPropertyDetailsMutationResult = Apollo.MutationResult<SetGeneralPropertyDetailsMutation>;
export type SetGeneralPropertyDetailsMutationOptions = Apollo.BaseMutationOptions<SetGeneralPropertyDetailsMutation, SetGeneralPropertyDetailsMutationVariables>;
export const SetPropertyStatusDocument = gql`
    mutation setPropertyStatus($input: SetPropertyStatusInput!) {
  setPropertyStatus(input: $input) {
    ...Property
  }
}
    ${PropertyFragmentDoc}`;
export type SetPropertyStatusMutationFn = Apollo.MutationFunction<SetPropertyStatusMutation, SetPropertyStatusMutationVariables>;

/**
 * __useSetPropertyStatusMutation__
 *
 * To run a mutation, you first call `useSetPropertyStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPropertyStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPropertyStatusMutation, { data, loading, error }] = useSetPropertyStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPropertyStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetPropertyStatusMutation, SetPropertyStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPropertyStatusMutation, SetPropertyStatusMutationVariables>(SetPropertyStatusDocument, options);
      }
export type SetPropertyStatusMutationHookResult = ReturnType<typeof useSetPropertyStatusMutation>;
export type SetPropertyStatusMutationResult = Apollo.MutationResult<SetPropertyStatusMutation>;
export type SetPropertyStatusMutationOptions = Apollo.BaseMutationOptions<SetPropertyStatusMutation, SetPropertyStatusMutationVariables>;
export const RemoveAmenitiesFromPropertyDocument = gql`
    mutation removeAmenitiesFromProperty($propertyId: ObjectId!, $amenitiesIds: [ObjectId!]!) {
  removeAmenitiesFromProperty(
    propertyId: $propertyId
    amenitiesIds: $amenitiesIds
  ) {
    _id
  }
}
    `;
export type RemoveAmenitiesFromPropertyMutationFn = Apollo.MutationFunction<RemoveAmenitiesFromPropertyMutation, RemoveAmenitiesFromPropertyMutationVariables>;

/**
 * __useRemoveAmenitiesFromPropertyMutation__
 *
 * To run a mutation, you first call `useRemoveAmenitiesFromPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAmenitiesFromPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAmenitiesFromPropertyMutation, { data, loading, error }] = useRemoveAmenitiesFromPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      amenitiesIds: // value for 'amenitiesIds'
 *   },
 * });
 */
export function useRemoveAmenitiesFromPropertyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAmenitiesFromPropertyMutation, RemoveAmenitiesFromPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAmenitiesFromPropertyMutation, RemoveAmenitiesFromPropertyMutationVariables>(RemoveAmenitiesFromPropertyDocument, options);
      }
export type RemoveAmenitiesFromPropertyMutationHookResult = ReturnType<typeof useRemoveAmenitiesFromPropertyMutation>;
export type RemoveAmenitiesFromPropertyMutationResult = Apollo.MutationResult<RemoveAmenitiesFromPropertyMutation>;
export type RemoveAmenitiesFromPropertyMutationOptions = Apollo.BaseMutationOptions<RemoveAmenitiesFromPropertyMutation, RemoveAmenitiesFromPropertyMutationVariables>;
export const SetAmenitiesToPropertyDocument = gql`
    mutation setAmenitiesToProperty($input: SetAmenitiesToPropertyInput!) {
  setAmenitiesToProperty(input: $input) {
    _id
  }
}
    `;
export type SetAmenitiesToPropertyMutationFn = Apollo.MutationFunction<SetAmenitiesToPropertyMutation, SetAmenitiesToPropertyMutationVariables>;

/**
 * __useSetAmenitiesToPropertyMutation__
 *
 * To run a mutation, you first call `useSetAmenitiesToPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAmenitiesToPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAmenitiesToPropertyMutation, { data, loading, error }] = useSetAmenitiesToPropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAmenitiesToPropertyMutation(baseOptions?: Apollo.MutationHookOptions<SetAmenitiesToPropertyMutation, SetAmenitiesToPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAmenitiesToPropertyMutation, SetAmenitiesToPropertyMutationVariables>(SetAmenitiesToPropertyDocument, options);
      }
export type SetAmenitiesToPropertyMutationHookResult = ReturnType<typeof useSetAmenitiesToPropertyMutation>;
export type SetAmenitiesToPropertyMutationResult = Apollo.MutationResult<SetAmenitiesToPropertyMutation>;
export type SetAmenitiesToPropertyMutationOptions = Apollo.BaseMutationOptions<SetAmenitiesToPropertyMutation, SetAmenitiesToPropertyMutationVariables>;
export const SetAmenityNameInPropertyDocument = gql`
    mutation setAmenityNameInProperty($propertyId: ObjectId!, $amenityId: ObjectId!, $name: String!, $isPrimary: Boolean!) {
  setAmenityNameInProperty(
    propertyId: $propertyId
    amenityId: $amenityId
    name: $name
    isPrimary: $isPrimary
  ) {
    _id
  }
}
    `;
export type SetAmenityNameInPropertyMutationFn = Apollo.MutationFunction<SetAmenityNameInPropertyMutation, SetAmenityNameInPropertyMutationVariables>;

/**
 * __useSetAmenityNameInPropertyMutation__
 *
 * To run a mutation, you first call `useSetAmenityNameInPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAmenityNameInPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAmenityNameInPropertyMutation, { data, loading, error }] = useSetAmenityNameInPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      amenityId: // value for 'amenityId'
 *      name: // value for 'name'
 *      isPrimary: // value for 'isPrimary'
 *   },
 * });
 */
export function useSetAmenityNameInPropertyMutation(baseOptions?: Apollo.MutationHookOptions<SetAmenityNameInPropertyMutation, SetAmenityNameInPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAmenityNameInPropertyMutation, SetAmenityNameInPropertyMutationVariables>(SetAmenityNameInPropertyDocument, options);
      }
export type SetAmenityNameInPropertyMutationHookResult = ReturnType<typeof useSetAmenityNameInPropertyMutation>;
export type SetAmenityNameInPropertyMutationResult = Apollo.MutationResult<SetAmenityNameInPropertyMutation>;
export type SetAmenityNameInPropertyMutationOptions = Apollo.BaseMutationOptions<SetAmenityNameInPropertyMutation, SetAmenityNameInPropertyMutationVariables>;
export const RemovePropertyByIdDocument = gql`
    mutation removePropertyById($propertyId: ObjectId!) {
  removePropertyById(propertyId: $propertyId)
}
    `;
export type RemovePropertyByIdMutationFn = Apollo.MutationFunction<RemovePropertyByIdMutation, RemovePropertyByIdMutationVariables>;

/**
 * __useRemovePropertyByIdMutation__
 *
 * To run a mutation, you first call `useRemovePropertyByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePropertyByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePropertyByIdMutation, { data, loading, error }] = useRemovePropertyByIdMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useRemovePropertyByIdMutation(baseOptions?: Apollo.MutationHookOptions<RemovePropertyByIdMutation, RemovePropertyByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePropertyByIdMutation, RemovePropertyByIdMutationVariables>(RemovePropertyByIdDocument, options);
      }
export type RemovePropertyByIdMutationHookResult = ReturnType<typeof useRemovePropertyByIdMutation>;
export type RemovePropertyByIdMutationResult = Apollo.MutationResult<RemovePropertyByIdMutation>;
export type RemovePropertyByIdMutationOptions = Apollo.BaseMutationOptions<RemovePropertyByIdMutation, RemovePropertyByIdMutationVariables>;
export const ChangeVerifiedStatusInPropertyDocument = gql`
    mutation changeVerifiedStatusInProperty($propertyId: ObjectId!, $isMarkedAsVerified: Boolean!) {
  changeVerifiedStatusInProperty(
    propertyId: $propertyId
    isMarkedAsVerified: $isMarkedAsVerified
  ) {
    _id
  }
}
    `;
export type ChangeVerifiedStatusInPropertyMutationFn = Apollo.MutationFunction<ChangeVerifiedStatusInPropertyMutation, ChangeVerifiedStatusInPropertyMutationVariables>;

/**
 * __useChangeVerifiedStatusInPropertyMutation__
 *
 * To run a mutation, you first call `useChangeVerifiedStatusInPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeVerifiedStatusInPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeVerifiedStatusInPropertyMutation, { data, loading, error }] = useChangeVerifiedStatusInPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      isMarkedAsVerified: // value for 'isMarkedAsVerified'
 *   },
 * });
 */
export function useChangeVerifiedStatusInPropertyMutation(baseOptions?: Apollo.MutationHookOptions<ChangeVerifiedStatusInPropertyMutation, ChangeVerifiedStatusInPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeVerifiedStatusInPropertyMutation, ChangeVerifiedStatusInPropertyMutationVariables>(ChangeVerifiedStatusInPropertyDocument, options);
      }
export type ChangeVerifiedStatusInPropertyMutationHookResult = ReturnType<typeof useChangeVerifiedStatusInPropertyMutation>;
export type ChangeVerifiedStatusInPropertyMutationResult = Apollo.MutationResult<ChangeVerifiedStatusInPropertyMutation>;
export type ChangeVerifiedStatusInPropertyMutationOptions = Apollo.BaseMutationOptions<ChangeVerifiedStatusInPropertyMutation, ChangeVerifiedStatusInPropertyMutationVariables>;
export const DuplicateAmenityDocument = gql`
    mutation duplicateAmenity($propertyId: ObjectId!, $amenityId: ObjectId!) {
  duplicateAmenity(propertyId: $propertyId, amenityId: $amenityId) {
    _id
  }
}
    `;
export type DuplicateAmenityMutationFn = Apollo.MutationFunction<DuplicateAmenityMutation, DuplicateAmenityMutationVariables>;

/**
 * __useDuplicateAmenityMutation__
 *
 * To run a mutation, you first call `useDuplicateAmenityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateAmenityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateAmenityMutation, { data, loading, error }] = useDuplicateAmenityMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      amenityId: // value for 'amenityId'
 *   },
 * });
 */
export function useDuplicateAmenityMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateAmenityMutation, DuplicateAmenityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateAmenityMutation, DuplicateAmenityMutationVariables>(DuplicateAmenityDocument, options);
      }
export type DuplicateAmenityMutationHookResult = ReturnType<typeof useDuplicateAmenityMutation>;
export type DuplicateAmenityMutationResult = Apollo.MutationResult<DuplicateAmenityMutation>;
export type DuplicateAmenityMutationOptions = Apollo.BaseMutationOptions<DuplicateAmenityMutation, DuplicateAmenityMutationVariables>;
export const UpdateBrandedFilesReadyDocument = gql`
    mutation updateBrandedFilesReady($input: UpdateBrandedFilesReadyInput!) {
  updateBrandedFilesReady(input: $input) {
    _id
    brandedFilesReady
  }
}
    `;
export type UpdateBrandedFilesReadyMutationFn = Apollo.MutationFunction<UpdateBrandedFilesReadyMutation, UpdateBrandedFilesReadyMutationVariables>;

/**
 * __useUpdateBrandedFilesReadyMutation__
 *
 * To run a mutation, you first call `useUpdateBrandedFilesReadyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandedFilesReadyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandedFilesReadyMutation, { data, loading, error }] = useUpdateBrandedFilesReadyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrandedFilesReadyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandedFilesReadyMutation, UpdateBrandedFilesReadyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandedFilesReadyMutation, UpdateBrandedFilesReadyMutationVariables>(UpdateBrandedFilesReadyDocument, options);
      }
export type UpdateBrandedFilesReadyMutationHookResult = ReturnType<typeof useUpdateBrandedFilesReadyMutation>;
export type UpdateBrandedFilesReadyMutationResult = Apollo.MutationResult<UpdateBrandedFilesReadyMutation>;
export type UpdateBrandedFilesReadyMutationOptions = Apollo.BaseMutationOptions<UpdateBrandedFilesReadyMutation, UpdateBrandedFilesReadyMutationVariables>;
export const ToggleChangelogVisibilityDocument = gql`
    mutation toggleChangelogVisibility($input: ToggleChangelogVisibilityInput!) {
  toggleChangelogVisibility(input: $input) {
    _id
    isHidden
  }
}
    `;
export type ToggleChangelogVisibilityMutationFn = Apollo.MutationFunction<ToggleChangelogVisibilityMutation, ToggleChangelogVisibilityMutationVariables>;

/**
 * __useToggleChangelogVisibilityMutation__
 *
 * To run a mutation, you first call `useToggleChangelogVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleChangelogVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleChangelogVisibilityMutation, { data, loading, error }] = useToggleChangelogVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleChangelogVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<ToggleChangelogVisibilityMutation, ToggleChangelogVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleChangelogVisibilityMutation, ToggleChangelogVisibilityMutationVariables>(ToggleChangelogVisibilityDocument, options);
      }
export type ToggleChangelogVisibilityMutationHookResult = ReturnType<typeof useToggleChangelogVisibilityMutation>;
export type ToggleChangelogVisibilityMutationResult = Apollo.MutationResult<ToggleChangelogVisibilityMutation>;
export type ToggleChangelogVisibilityMutationOptions = Apollo.BaseMutationOptions<ToggleChangelogVisibilityMutation, ToggleChangelogVisibilityMutationVariables>;
export const GetPropertiesDocument = gql`
    query getProperties($sort: [SortInput!], $pagination: PaginationInput, $filter: GetPropertiesFilterInput) {
  getProperties(sort: $sort, pagination: $pagination, filter: $filter) {
    totalCount
    collection {
      _id
      name
      mainPropertyMediaFile {
        _id
        files {
          thumbnailFile {
            publicUrl
          }
        }
      }
      location {
        _id
        address {
          state
        }
      }
      marketArea {
        _id
      }
      primaryOrganizationId
      primaryOrganization {
        name
      }
      updatedAt
      projectStatus
      status
      cmsStatus
      cmsStatusUpdatedAt
    }
  }
}
    `;

/**
 * __useGetPropertiesQuery__
 *
 * To run a query within a React component, call `useGetPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertiesQuery, GetPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertiesQuery, GetPropertiesQueryVariables>(GetPropertiesDocument, options);
      }
export function useGetPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertiesQuery, GetPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertiesQuery, GetPropertiesQueryVariables>(GetPropertiesDocument, options);
        }
export type GetPropertiesQueryHookResult = ReturnType<typeof useGetPropertiesQuery>;
export type GetPropertiesLazyQueryHookResult = ReturnType<typeof useGetPropertiesLazyQuery>;
export type GetPropertiesQueryResult = Apollo.QueryResult<GetPropertiesQuery, GetPropertiesQueryVariables>;
export const GetPropertyByIdDocument = gql`
    query getPropertyById($propertyId: ObjectId!) {
  getPropertyById(propertyId: $propertyId) {
    ...Property
  }
}
    ${PropertyFragmentDoc}`;

/**
 * __useGetPropertyByIdQuery__
 *
 * To run a query within a React component, call `useGetPropertyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyByIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetPropertyByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>(GetPropertyByIdDocument, options);
      }
export function useGetPropertyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>(GetPropertyByIdDocument, options);
        }
export type GetPropertyByIdQueryHookResult = ReturnType<typeof useGetPropertyByIdQuery>;
export type GetPropertyByIdLazyQueryHookResult = ReturnType<typeof useGetPropertyByIdLazyQuery>;
export type GetPropertyByIdQueryResult = Apollo.QueryResult<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>;
export const GetPropertyNameByIdDocument = gql`
    query getPropertyNameById($propertyId: ObjectId!) {
  getPropertyById(propertyId: $propertyId) {
    _id
    name
  }
}
    `;

/**
 * __useGetPropertyNameByIdQuery__
 *
 * To run a query within a React component, call `useGetPropertyNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyNameByIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetPropertyNameByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyNameByIdQuery, GetPropertyNameByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyNameByIdQuery, GetPropertyNameByIdQueryVariables>(GetPropertyNameByIdDocument, options);
      }
export function useGetPropertyNameByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyNameByIdQuery, GetPropertyNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyNameByIdQuery, GetPropertyNameByIdQueryVariables>(GetPropertyNameByIdDocument, options);
        }
export type GetPropertyNameByIdQueryHookResult = ReturnType<typeof useGetPropertyNameByIdQuery>;
export type GetPropertyNameByIdLazyQueryHookResult = ReturnType<typeof useGetPropertyNameByIdLazyQuery>;
export type GetPropertyNameByIdQueryResult = Apollo.QueryResult<GetPropertyNameByIdQuery, GetPropertyNameByIdQueryVariables>;
export const GetPropertyChangelogsDocument = gql`
    query getPropertyChangelogs($filter: GetPropertyChangelogsFilterInput!, $sort: [SortInput!], $pagination: PaginationInput) {
  getPropertyChangelogs(filter: $filter, sort: $sort, pagination: $pagination) {
    collection {
      ...PropertyChangelog
    }
    totalCount
  }
}
    ${PropertyChangelogFragmentDoc}`;

/**
 * __useGetPropertyChangelogsQuery__
 *
 * To run a query within a React component, call `useGetPropertyChangelogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyChangelogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyChangelogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetPropertyChangelogsQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyChangelogsQuery, GetPropertyChangelogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyChangelogsQuery, GetPropertyChangelogsQueryVariables>(GetPropertyChangelogsDocument, options);
      }
export function useGetPropertyChangelogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyChangelogsQuery, GetPropertyChangelogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyChangelogsQuery, GetPropertyChangelogsQueryVariables>(GetPropertyChangelogsDocument, options);
        }
export type GetPropertyChangelogsQueryHookResult = ReturnType<typeof useGetPropertyChangelogsQuery>;
export type GetPropertyChangelogsLazyQueryHookResult = ReturnType<typeof useGetPropertyChangelogsLazyQuery>;
export type GetPropertyChangelogsQueryResult = Apollo.QueryResult<GetPropertyChangelogsQuery, GetPropertyChangelogsQueryVariables>;
export const GetAllPropertyChangelogsDocument = gql`
    query getAllPropertyChangelogs($filter: GetAllPropertyChangelogsFilterInput!, $sort: [SortInput!], $pagination: PaginationInput) {
  getAllPropertyChangelogs(filter: $filter, sort: $sort, pagination: $pagination) {
    collection {
      ...PropertyChangelog
    }
    totalCount
  }
}
    ${PropertyChangelogFragmentDoc}`;

/**
 * __useGetAllPropertyChangelogsQuery__
 *
 * To run a query within a React component, call `useGetAllPropertyChangelogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPropertyChangelogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPropertyChangelogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAllPropertyChangelogsQuery(baseOptions: Apollo.QueryHookOptions<GetAllPropertyChangelogsQuery, GetAllPropertyChangelogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPropertyChangelogsQuery, GetAllPropertyChangelogsQueryVariables>(GetAllPropertyChangelogsDocument, options);
      }
export function useGetAllPropertyChangelogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPropertyChangelogsQuery, GetAllPropertyChangelogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPropertyChangelogsQuery, GetAllPropertyChangelogsQueryVariables>(GetAllPropertyChangelogsDocument, options);
        }
export type GetAllPropertyChangelogsQueryHookResult = ReturnType<typeof useGetAllPropertyChangelogsQuery>;
export type GetAllPropertyChangelogsLazyQueryHookResult = ReturnType<typeof useGetAllPropertyChangelogsLazyQuery>;
export type GetAllPropertyChangelogsQueryResult = Apollo.QueryResult<GetAllPropertyChangelogsQuery, GetAllPropertyChangelogsQueryVariables>;
export const UpdateCmsStatusDocument = gql`
    mutation updateCmsStatus($input: UpdateCmsStatusInput!) {
  updateCmsStatus(input: $input) {
    _id
    cmsStatus
    cmsStatusUpdatedAt
  }
}
    `;
export type UpdateCmsStatusMutationFn = Apollo.MutationFunction<UpdateCmsStatusMutation, UpdateCmsStatusMutationVariables>;

/**
 * __useUpdateCmsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCmsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCmsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCmsStatusMutation, { data, loading, error }] = useUpdateCmsStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCmsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCmsStatusMutation, UpdateCmsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCmsStatusMutation, UpdateCmsStatusMutationVariables>(UpdateCmsStatusDocument, options);
      }
export type UpdateCmsStatusMutationHookResult = ReturnType<typeof useUpdateCmsStatusMutation>;
export type UpdateCmsStatusMutationResult = Apollo.MutationResult<UpdateCmsStatusMutation>;
export type UpdateCmsStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCmsStatusMutation, UpdateCmsStatusMutationVariables>;
export const ApprovePropertyDocument = gql`
    mutation approveProperty($input: ApprovePropertyInput!) {
  approveProperty(input: $input) {
    _id
    cmsStatus
    cmsStatusUpdatedAt
    status
  }
}
    `;
export type ApprovePropertyMutationFn = Apollo.MutationFunction<ApprovePropertyMutation, ApprovePropertyMutationVariables>;

/**
 * __useApprovePropertyMutation__
 *
 * To run a mutation, you first call `useApprovePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePropertyMutation, { data, loading, error }] = useApprovePropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApprovePropertyMutation(baseOptions?: Apollo.MutationHookOptions<ApprovePropertyMutation, ApprovePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovePropertyMutation, ApprovePropertyMutationVariables>(ApprovePropertyDocument, options);
      }
export type ApprovePropertyMutationHookResult = ReturnType<typeof useApprovePropertyMutation>;
export type ApprovePropertyMutationResult = Apollo.MutationResult<ApprovePropertyMutation>;
export type ApprovePropertyMutationOptions = Apollo.BaseMutationOptions<ApprovePropertyMutation, ApprovePropertyMutationVariables>;
export const AuditPropertyDocument = gql`
    mutation auditProperty($input: AuditPropertyInput!) {
  auditProperty(input: $input) {
    _id
    cmsStatus
    cmsStatusUpdatedAt
  }
}
    `;
export type AuditPropertyMutationFn = Apollo.MutationFunction<AuditPropertyMutation, AuditPropertyMutationVariables>;

/**
 * __useAuditPropertyMutation__
 *
 * To run a mutation, you first call `useAuditPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuditPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [auditPropertyMutation, { data, loading, error }] = useAuditPropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditPropertyMutation(baseOptions?: Apollo.MutationHookOptions<AuditPropertyMutation, AuditPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuditPropertyMutation, AuditPropertyMutationVariables>(AuditPropertyDocument, options);
      }
export type AuditPropertyMutationHookResult = ReturnType<typeof useAuditPropertyMutation>;
export type AuditPropertyMutationResult = Apollo.MutationResult<AuditPropertyMutation>;
export type AuditPropertyMutationOptions = Apollo.BaseMutationOptions<AuditPropertyMutation, AuditPropertyMutationVariables>;
export const ArchivePropertyDocument = gql`
    mutation archiveProperty($input: ArchivePropertyInput!) {
  archiveProperty(input: $input) {
    _id
    cmsStatus
    cmsStatusUpdatedAt
    status
  }
}
    `;
export type ArchivePropertyMutationFn = Apollo.MutationFunction<ArchivePropertyMutation, ArchivePropertyMutationVariables>;

/**
 * __useArchivePropertyMutation__
 *
 * To run a mutation, you first call `useArchivePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePropertyMutation, { data, loading, error }] = useArchivePropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchivePropertyMutation(baseOptions?: Apollo.MutationHookOptions<ArchivePropertyMutation, ArchivePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchivePropertyMutation, ArchivePropertyMutationVariables>(ArchivePropertyDocument, options);
      }
export type ArchivePropertyMutationHookResult = ReturnType<typeof useArchivePropertyMutation>;
export type ArchivePropertyMutationResult = Apollo.MutationResult<ArchivePropertyMutation>;
export type ArchivePropertyMutationOptions = Apollo.BaseMutationOptions<ArchivePropertyMutation, ArchivePropertyMutationVariables>;
export const AddNoteToPropertyDocument = gql`
    mutation addNoteToProperty($attachedFilesIds: [ObjectId!], $message: String!, $propertyId: ObjectId!) {
  addNoteToProperty(
    attachedFilesIds: $attachedFilesIds
    message: $message
    propertyId: $propertyId
  ) {
    _id
    message
    attachedFilesIds
    propertyId
  }
}
    `;
export type AddNoteToPropertyMutationFn = Apollo.MutationFunction<AddNoteToPropertyMutation, AddNoteToPropertyMutationVariables>;

/**
 * __useAddNoteToPropertyMutation__
 *
 * To run a mutation, you first call `useAddNoteToPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteToPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteToPropertyMutation, { data, loading, error }] = useAddNoteToPropertyMutation({
 *   variables: {
 *      attachedFilesIds: // value for 'attachedFilesIds'
 *      message: // value for 'message'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useAddNoteToPropertyMutation(baseOptions?: Apollo.MutationHookOptions<AddNoteToPropertyMutation, AddNoteToPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNoteToPropertyMutation, AddNoteToPropertyMutationVariables>(AddNoteToPropertyDocument, options);
      }
export type AddNoteToPropertyMutationHookResult = ReturnType<typeof useAddNoteToPropertyMutation>;
export type AddNoteToPropertyMutationResult = Apollo.MutationResult<AddNoteToPropertyMutation>;
export type AddNoteToPropertyMutationOptions = Apollo.BaseMutationOptions<AddNoteToPropertyMutation, AddNoteToPropertyMutationVariables>;
export const EditPropertyNoteDocument = gql`
    mutation editPropertyNote($attachedFilesIds: [ObjectId!], $message: String!, $propertyNoteId: ObjectId!) {
  editPropertyNote(
    attachedFilesIds: $attachedFilesIds
    message: $message
    propertyNoteId: $propertyNoteId
  ) {
    _id
    message
    attachedFilesIds
    propertyId
  }
}
    `;
export type EditPropertyNoteMutationFn = Apollo.MutationFunction<EditPropertyNoteMutation, EditPropertyNoteMutationVariables>;

/**
 * __useEditPropertyNoteMutation__
 *
 * To run a mutation, you first call `useEditPropertyNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPropertyNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPropertyNoteMutation, { data, loading, error }] = useEditPropertyNoteMutation({
 *   variables: {
 *      attachedFilesIds: // value for 'attachedFilesIds'
 *      message: // value for 'message'
 *      propertyNoteId: // value for 'propertyNoteId'
 *   },
 * });
 */
export function useEditPropertyNoteMutation(baseOptions?: Apollo.MutationHookOptions<EditPropertyNoteMutation, EditPropertyNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPropertyNoteMutation, EditPropertyNoteMutationVariables>(EditPropertyNoteDocument, options);
      }
export type EditPropertyNoteMutationHookResult = ReturnType<typeof useEditPropertyNoteMutation>;
export type EditPropertyNoteMutationResult = Apollo.MutationResult<EditPropertyNoteMutation>;
export type EditPropertyNoteMutationOptions = Apollo.BaseMutationOptions<EditPropertyNoteMutation, EditPropertyNoteMutationVariables>;
export const RemovePropertyNoteDocument = gql`
    mutation removePropertyNote($propertyNoteId: ObjectId!) {
  removePropertyNote(propertyNoteId: $propertyNoteId) {
    _id
    message
    attachedFilesIds
    propertyId
  }
}
    `;
export type RemovePropertyNoteMutationFn = Apollo.MutationFunction<RemovePropertyNoteMutation, RemovePropertyNoteMutationVariables>;

/**
 * __useRemovePropertyNoteMutation__
 *
 * To run a mutation, you first call `useRemovePropertyNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePropertyNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePropertyNoteMutation, { data, loading, error }] = useRemovePropertyNoteMutation({
 *   variables: {
 *      propertyNoteId: // value for 'propertyNoteId'
 *   },
 * });
 */
export function useRemovePropertyNoteMutation(baseOptions?: Apollo.MutationHookOptions<RemovePropertyNoteMutation, RemovePropertyNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePropertyNoteMutation, RemovePropertyNoteMutationVariables>(RemovePropertyNoteDocument, options);
      }
export type RemovePropertyNoteMutationHookResult = ReturnType<typeof useRemovePropertyNoteMutation>;
export type RemovePropertyNoteMutationResult = Apollo.MutationResult<RemovePropertyNoteMutation>;
export type RemovePropertyNoteMutationOptions = Apollo.BaseMutationOptions<RemovePropertyNoteMutation, RemovePropertyNoteMutationVariables>;
export const GetPropertyNotesDocument = gql`
    query getPropertyNotes($pagination: PaginationInput, $propertyId: ObjectId!) {
  getPropertyNotes(propertyId: $propertyId, pagination: $pagination) {
    totalCount
    collection {
      ...PropertyNote
    }
  }
}
    ${PropertyNoteFragmentDoc}`;

/**
 * __useGetPropertyNotesQuery__
 *
 * To run a query within a React component, call `useGetPropertyNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyNotesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetPropertyNotesQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyNotesQuery, GetPropertyNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyNotesQuery, GetPropertyNotesQueryVariables>(GetPropertyNotesDocument, options);
      }
export function useGetPropertyNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyNotesQuery, GetPropertyNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyNotesQuery, GetPropertyNotesQueryVariables>(GetPropertyNotesDocument, options);
        }
export type GetPropertyNotesQueryHookResult = ReturnType<typeof useGetPropertyNotesQuery>;
export type GetPropertyNotesLazyQueryHookResult = ReturnType<typeof useGetPropertyNotesLazyQuery>;
export type GetPropertyNotesQueryResult = Apollo.QueryResult<GetPropertyNotesQuery, GetPropertyNotesQueryVariables>;
export const GetOrganizationRolesDocument = gql`
    query getOrganizationRoles {
  getOrganizationRoles {
    collection {
      ...Role
    }
  }
}
    ${RoleFragmentDoc}`;

/**
 * __useGetOrganizationRolesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationRolesQuery, GetOrganizationRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationRolesQuery, GetOrganizationRolesQueryVariables>(GetOrganizationRolesDocument, options);
      }
export function useGetOrganizationRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationRolesQuery, GetOrganizationRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationRolesQuery, GetOrganizationRolesQueryVariables>(GetOrganizationRolesDocument, options);
        }
export type GetOrganizationRolesQueryHookResult = ReturnType<typeof useGetOrganizationRolesQuery>;
export type GetOrganizationRolesLazyQueryHookResult = ReturnType<typeof useGetOrganizationRolesLazyQuery>;
export type GetOrganizationRolesQueryResult = Apollo.QueryResult<GetOrganizationRolesQuery, GetOrganizationRolesQueryVariables>;
export const GetSalesTeamRolesDocument = gql`
    query getSalesTeamRoles {
  getSalesTeamRoles {
    collection {
      ...Role
    }
  }
}
    ${RoleFragmentDoc}`;

/**
 * __useGetSalesTeamRolesQuery__
 *
 * To run a query within a React component, call `useGetSalesTeamRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesTeamRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesTeamRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesTeamRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesTeamRolesQuery, GetSalesTeamRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesTeamRolesQuery, GetSalesTeamRolesQueryVariables>(GetSalesTeamRolesDocument, options);
      }
export function useGetSalesTeamRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesTeamRolesQuery, GetSalesTeamRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesTeamRolesQuery, GetSalesTeamRolesQueryVariables>(GetSalesTeamRolesDocument, options);
        }
export type GetSalesTeamRolesQueryHookResult = ReturnType<typeof useGetSalesTeamRolesQuery>;
export type GetSalesTeamRolesLazyQueryHookResult = ReturnType<typeof useGetSalesTeamRolesLazyQuery>;
export type GetSalesTeamRolesQueryResult = Apollo.QueryResult<GetSalesTeamRolesQuery, GetSalesTeamRolesQueryVariables>;
export const CreateSaleTeamDocument = gql`
    mutation createSaleTeam($input: CreateSaleTeamInput!) {
  createSaleTeam(input: $input) {
    ...SaleTeam
  }
}
    ${SaleTeamFragmentDoc}`;
export type CreateSaleTeamMutationFn = Apollo.MutationFunction<CreateSaleTeamMutation, CreateSaleTeamMutationVariables>;

/**
 * __useCreateSaleTeamMutation__
 *
 * To run a mutation, you first call `useCreateSaleTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSaleTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSaleTeamMutation, { data, loading, error }] = useCreateSaleTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSaleTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateSaleTeamMutation, CreateSaleTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSaleTeamMutation, CreateSaleTeamMutationVariables>(CreateSaleTeamDocument, options);
      }
export type CreateSaleTeamMutationHookResult = ReturnType<typeof useCreateSaleTeamMutation>;
export type CreateSaleTeamMutationResult = Apollo.MutationResult<CreateSaleTeamMutation>;
export type CreateSaleTeamMutationOptions = Apollo.BaseMutationOptions<CreateSaleTeamMutation, CreateSaleTeamMutationVariables>;
export const EditSaleTeamDocument = gql`
    mutation editSaleTeam($saleTeamId: ObjectId!, $input: EditSaleTeamInput!) {
  editSaleTeam(saleTeamId: $saleTeamId, input: $input) {
    ...SaleTeam
  }
}
    ${SaleTeamFragmentDoc}`;
export type EditSaleTeamMutationFn = Apollo.MutationFunction<EditSaleTeamMutation, EditSaleTeamMutationVariables>;

/**
 * __useEditSaleTeamMutation__
 *
 * To run a mutation, you first call `useEditSaleTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSaleTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSaleTeamMutation, { data, loading, error }] = useEditSaleTeamMutation({
 *   variables: {
 *      saleTeamId: // value for 'saleTeamId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSaleTeamMutation(baseOptions?: Apollo.MutationHookOptions<EditSaleTeamMutation, EditSaleTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSaleTeamMutation, EditSaleTeamMutationVariables>(EditSaleTeamDocument, options);
      }
export type EditSaleTeamMutationHookResult = ReturnType<typeof useEditSaleTeamMutation>;
export type EditSaleTeamMutationResult = Apollo.MutationResult<EditSaleTeamMutation>;
export type EditSaleTeamMutationOptions = Apollo.BaseMutationOptions<EditSaleTeamMutation, EditSaleTeamMutationVariables>;
export const EditInternalSaleTeamByOrganizationIdDocument = gql`
    mutation editInternalSaleTeamByOrganizationId($organizationId: ObjectId!, $input: EditSaleTeamInput!) {
  editInternalSaleTeamByOrganizationId(
    organizationId: $organizationId
    input: $input
  ) {
    ...SaleTeam
  }
}
    ${SaleTeamFragmentDoc}`;
export type EditInternalSaleTeamByOrganizationIdMutationFn = Apollo.MutationFunction<EditInternalSaleTeamByOrganizationIdMutation, EditInternalSaleTeamByOrganizationIdMutationVariables>;

/**
 * __useEditInternalSaleTeamByOrganizationIdMutation__
 *
 * To run a mutation, you first call `useEditInternalSaleTeamByOrganizationIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditInternalSaleTeamByOrganizationIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editInternalSaleTeamByOrganizationIdMutation, { data, loading, error }] = useEditInternalSaleTeamByOrganizationIdMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditInternalSaleTeamByOrganizationIdMutation(baseOptions?: Apollo.MutationHookOptions<EditInternalSaleTeamByOrganizationIdMutation, EditInternalSaleTeamByOrganizationIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditInternalSaleTeamByOrganizationIdMutation, EditInternalSaleTeamByOrganizationIdMutationVariables>(EditInternalSaleTeamByOrganizationIdDocument, options);
      }
export type EditInternalSaleTeamByOrganizationIdMutationHookResult = ReturnType<typeof useEditInternalSaleTeamByOrganizationIdMutation>;
export type EditInternalSaleTeamByOrganizationIdMutationResult = Apollo.MutationResult<EditInternalSaleTeamByOrganizationIdMutation>;
export type EditInternalSaleTeamByOrganizationIdMutationOptions = Apollo.BaseMutationOptions<EditInternalSaleTeamByOrganizationIdMutation, EditInternalSaleTeamByOrganizationIdMutationVariables>;
export const DeleteSaleTeamDocument = gql`
    mutation deleteSaleTeam($saleTeamId: ObjectId!) {
  deleteSaleTeam(saleTeamId: $saleTeamId) {
    ...SaleTeam
  }
}
    ${SaleTeamFragmentDoc}`;
export type DeleteSaleTeamMutationFn = Apollo.MutationFunction<DeleteSaleTeamMutation, DeleteSaleTeamMutationVariables>;

/**
 * __useDeleteSaleTeamMutation__
 *
 * To run a mutation, you first call `useDeleteSaleTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSaleTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSaleTeamMutation, { data, loading, error }] = useDeleteSaleTeamMutation({
 *   variables: {
 *      saleTeamId: // value for 'saleTeamId'
 *   },
 * });
 */
export function useDeleteSaleTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSaleTeamMutation, DeleteSaleTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSaleTeamMutation, DeleteSaleTeamMutationVariables>(DeleteSaleTeamDocument, options);
      }
export type DeleteSaleTeamMutationHookResult = ReturnType<typeof useDeleteSaleTeamMutation>;
export type DeleteSaleTeamMutationResult = Apollo.MutationResult<DeleteSaleTeamMutation>;
export type DeleteSaleTeamMutationOptions = Apollo.BaseMutationOptions<DeleteSaleTeamMutation, DeleteSaleTeamMutationVariables>;
export const GetSaleTeamsDocument = gql`
    query getSaleTeams($sort: [SortInput!], $pagination: PaginationInput, $filter: GetSaleTeamsFilterInput) {
  getSaleTeams(sort: $sort, pagination: $pagination, filter: $filter) {
    totalCount
    collection {
      ...SaleTeam
      countOfUsers
      relatedToSaleTeamOrganizationsNames
    }
  }
}
    ${SaleTeamFragmentDoc}`;

/**
 * __useGetSaleTeamsQuery__
 *
 * To run a query within a React component, call `useGetSaleTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleTeamsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSaleTeamsQuery(baseOptions?: Apollo.QueryHookOptions<GetSaleTeamsQuery, GetSaleTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleTeamsQuery, GetSaleTeamsQueryVariables>(GetSaleTeamsDocument, options);
      }
export function useGetSaleTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleTeamsQuery, GetSaleTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleTeamsQuery, GetSaleTeamsQueryVariables>(GetSaleTeamsDocument, options);
        }
export type GetSaleTeamsQueryHookResult = ReturnType<typeof useGetSaleTeamsQuery>;
export type GetSaleTeamsLazyQueryHookResult = ReturnType<typeof useGetSaleTeamsLazyQuery>;
export type GetSaleTeamsQueryResult = Apollo.QueryResult<GetSaleTeamsQuery, GetSaleTeamsQueryVariables>;
export const GetSaleTeamsForPropertySelectDocument = gql`
    query getSaleTeamsForPropertySelect($filter: GetSaleTeamsFilterInput) {
  getSaleTeams(filter: $filter) {
    totalCount
    collection {
      _id
      name
      type
      organizationId
    }
  }
}
    `;

/**
 * __useGetSaleTeamsForPropertySelectQuery__
 *
 * To run a query within a React component, call `useGetSaleTeamsForPropertySelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleTeamsForPropertySelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleTeamsForPropertySelectQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSaleTeamsForPropertySelectQuery(baseOptions?: Apollo.QueryHookOptions<GetSaleTeamsForPropertySelectQuery, GetSaleTeamsForPropertySelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleTeamsForPropertySelectQuery, GetSaleTeamsForPropertySelectQueryVariables>(GetSaleTeamsForPropertySelectDocument, options);
      }
export function useGetSaleTeamsForPropertySelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleTeamsForPropertySelectQuery, GetSaleTeamsForPropertySelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleTeamsForPropertySelectQuery, GetSaleTeamsForPropertySelectQueryVariables>(GetSaleTeamsForPropertySelectDocument, options);
        }
export type GetSaleTeamsForPropertySelectQueryHookResult = ReturnType<typeof useGetSaleTeamsForPropertySelectQuery>;
export type GetSaleTeamsForPropertySelectLazyQueryHookResult = ReturnType<typeof useGetSaleTeamsForPropertySelectLazyQuery>;
export type GetSaleTeamsForPropertySelectQueryResult = Apollo.QueryResult<GetSaleTeamsForPropertySelectQuery, GetSaleTeamsForPropertySelectQueryVariables>;
export const GetSaleTeamByIdDocument = gql`
    query getSaleTeamById($saleTeamId: ObjectId!) {
  getSaleTeamById(saleTeamId: $saleTeamId) {
    ...SaleTeam
  }
}
    ${SaleTeamFragmentDoc}`;

/**
 * __useGetSaleTeamByIdQuery__
 *
 * To run a query within a React component, call `useGetSaleTeamByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleTeamByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleTeamByIdQuery({
 *   variables: {
 *      saleTeamId: // value for 'saleTeamId'
 *   },
 * });
 */
export function useGetSaleTeamByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSaleTeamByIdQuery, GetSaleTeamByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleTeamByIdQuery, GetSaleTeamByIdQueryVariables>(GetSaleTeamByIdDocument, options);
      }
export function useGetSaleTeamByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleTeamByIdQuery, GetSaleTeamByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleTeamByIdQuery, GetSaleTeamByIdQueryVariables>(GetSaleTeamByIdDocument, options);
        }
export type GetSaleTeamByIdQueryHookResult = ReturnType<typeof useGetSaleTeamByIdQuery>;
export type GetSaleTeamByIdLazyQueryHookResult = ReturnType<typeof useGetSaleTeamByIdLazyQuery>;
export type GetSaleTeamByIdQueryResult = Apollo.QueryResult<GetSaleTeamByIdQuery, GetSaleTeamByIdQueryVariables>;
export const GetInternalOrganizationSaleTeamDocument = gql`
    query getInternalOrganizationSaleTeam($organizationId: ObjectId!) {
  getInternalOrganizationSaleTeam(organizationId: $organizationId) {
    ...SaleTeam
  }
}
    ${SaleTeamFragmentDoc}`;

/**
 * __useGetInternalOrganizationSaleTeamQuery__
 *
 * To run a query within a React component, call `useGetInternalOrganizationSaleTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInternalOrganizationSaleTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInternalOrganizationSaleTeamQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetInternalOrganizationSaleTeamQuery(baseOptions: Apollo.QueryHookOptions<GetInternalOrganizationSaleTeamQuery, GetInternalOrganizationSaleTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInternalOrganizationSaleTeamQuery, GetInternalOrganizationSaleTeamQueryVariables>(GetInternalOrganizationSaleTeamDocument, options);
      }
export function useGetInternalOrganizationSaleTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInternalOrganizationSaleTeamQuery, GetInternalOrganizationSaleTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInternalOrganizationSaleTeamQuery, GetInternalOrganizationSaleTeamQueryVariables>(GetInternalOrganizationSaleTeamDocument, options);
        }
export type GetInternalOrganizationSaleTeamQueryHookResult = ReturnType<typeof useGetInternalOrganizationSaleTeamQuery>;
export type GetInternalOrganizationSaleTeamLazyQueryHookResult = ReturnType<typeof useGetInternalOrganizationSaleTeamLazyQuery>;
export type GetInternalOrganizationSaleTeamQueryResult = Apollo.QueryResult<GetInternalOrganizationSaleTeamQuery, GetInternalOrganizationSaleTeamQueryVariables>;
export const GetUsStatesDocument = gql`
    query getUSStates($filter: GetStatesFilterInput) {
  getUSStates(filter: $filter) {
    ...State
  }
}
    ${StateFragmentDoc}`;

/**
 * __useGetUsStatesQuery__
 *
 * To run a query within a React component, call `useGetUsStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsStatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUsStatesQuery(baseOptions?: Apollo.QueryHookOptions<GetUsStatesQuery, GetUsStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsStatesQuery, GetUsStatesQueryVariables>(GetUsStatesDocument, options);
      }
export function useGetUsStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsStatesQuery, GetUsStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsStatesQuery, GetUsStatesQueryVariables>(GetUsStatesDocument, options);
        }
export type GetUsStatesQueryHookResult = ReturnType<typeof useGetUsStatesQuery>;
export type GetUsStatesLazyQueryHookResult = ReturnType<typeof useGetUsStatesLazyQuery>;
export type GetUsStatesQueryResult = Apollo.QueryResult<GetUsStatesQuery, GetUsStatesQueryVariables>;
export const GetUsStateByNameDocument = gql`
    query getUSStateByName($stateName: String!) {
  getUSStateByName(stateName: $stateName) {
    ...State
  }
}
    ${StateFragmentDoc}`;

/**
 * __useGetUsStateByNameQuery__
 *
 * To run a query within a React component, call `useGetUsStateByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsStateByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsStateByNameQuery({
 *   variables: {
 *      stateName: // value for 'stateName'
 *   },
 * });
 */
export function useGetUsStateByNameQuery(baseOptions: Apollo.QueryHookOptions<GetUsStateByNameQuery, GetUsStateByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsStateByNameQuery, GetUsStateByNameQueryVariables>(GetUsStateByNameDocument, options);
      }
export function useGetUsStateByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsStateByNameQuery, GetUsStateByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsStateByNameQuery, GetUsStateByNameQueryVariables>(GetUsStateByNameDocument, options);
        }
export type GetUsStateByNameQueryHookResult = ReturnType<typeof useGetUsStateByNameQuery>;
export type GetUsStateByNameLazyQueryHookResult = ReturnType<typeof useGetUsStateByNameLazyQuery>;
export type GetUsStateByNameQueryResult = Apollo.QueryResult<GetUsStateByNameQuery, GetUsStateByNameQueryVariables>;
export const CreateUnitDocument = gql`
    mutation createUnit($input: CreateUnitInput!) {
  createUnit(input: $input) {
    _id
  }
}
    `;
export type CreateUnitMutationFn = Apollo.MutationFunction<CreateUnitMutation, CreateUnitMutationVariables>;

/**
 * __useCreateUnitMutation__
 *
 * To run a mutation, you first call `useCreateUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnitMutation, { data, loading, error }] = useCreateUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUnitMutation(baseOptions?: Apollo.MutationHookOptions<CreateUnitMutation, CreateUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUnitMutation, CreateUnitMutationVariables>(CreateUnitDocument, options);
      }
export type CreateUnitMutationHookResult = ReturnType<typeof useCreateUnitMutation>;
export type CreateUnitMutationResult = Apollo.MutationResult<CreateUnitMutation>;
export type CreateUnitMutationOptions = Apollo.BaseMutationOptions<CreateUnitMutation, CreateUnitMutationVariables>;
export const DuplicateUnitDocument = gql`
    mutation duplicateUnit($unitId: ObjectId!) {
  duplicateUnit(unitId: $unitId) {
    _id
  }
}
    `;
export type DuplicateUnitMutationFn = Apollo.MutationFunction<DuplicateUnitMutation, DuplicateUnitMutationVariables>;

/**
 * __useDuplicateUnitMutation__
 *
 * To run a mutation, you first call `useDuplicateUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateUnitMutation, { data, loading, error }] = useDuplicateUnitMutation({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useDuplicateUnitMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateUnitMutation, DuplicateUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateUnitMutation, DuplicateUnitMutationVariables>(DuplicateUnitDocument, options);
      }
export type DuplicateUnitMutationHookResult = ReturnType<typeof useDuplicateUnitMutation>;
export type DuplicateUnitMutationResult = Apollo.MutationResult<DuplicateUnitMutation>;
export type DuplicateUnitMutationOptions = Apollo.BaseMutationOptions<DuplicateUnitMutation, DuplicateUnitMutationVariables>;
export const EditUnitDocument = gql`
    mutation editUnit($input: EditUnitInput!) {
  editUnit(input: $input) {
    _id
  }
}
    `;
export type EditUnitMutationFn = Apollo.MutationFunction<EditUnitMutation, EditUnitMutationVariables>;

/**
 * __useEditUnitMutation__
 *
 * To run a mutation, you first call `useEditUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUnitMutation, { data, loading, error }] = useEditUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUnitMutation(baseOptions?: Apollo.MutationHookOptions<EditUnitMutation, EditUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUnitMutation, EditUnitMutationVariables>(EditUnitDocument, options);
      }
export type EditUnitMutationHookResult = ReturnType<typeof useEditUnitMutation>;
export type EditUnitMutationResult = Apollo.MutationResult<EditUnitMutation>;
export type EditUnitMutationOptions = Apollo.BaseMutationOptions<EditUnitMutation, EditUnitMutationVariables>;
export const AddFloorPlanToUnitDocument = gql`
    mutation addFloorPlanToUnit($floorPlanFileId: ObjectId!, $unitId: ObjectId!) {
  addFloorPlanToUnit(floorPlanFileId: $floorPlanFileId, unitId: $unitId) {
    _id
  }
}
    `;
export type AddFloorPlanToUnitMutationFn = Apollo.MutationFunction<AddFloorPlanToUnitMutation, AddFloorPlanToUnitMutationVariables>;

/**
 * __useAddFloorPlanToUnitMutation__
 *
 * To run a mutation, you first call `useAddFloorPlanToUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFloorPlanToUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFloorPlanToUnitMutation, { data, loading, error }] = useAddFloorPlanToUnitMutation({
 *   variables: {
 *      floorPlanFileId: // value for 'floorPlanFileId'
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useAddFloorPlanToUnitMutation(baseOptions?: Apollo.MutationHookOptions<AddFloorPlanToUnitMutation, AddFloorPlanToUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFloorPlanToUnitMutation, AddFloorPlanToUnitMutationVariables>(AddFloorPlanToUnitDocument, options);
      }
export type AddFloorPlanToUnitMutationHookResult = ReturnType<typeof useAddFloorPlanToUnitMutation>;
export type AddFloorPlanToUnitMutationResult = Apollo.MutationResult<AddFloorPlanToUnitMutation>;
export type AddFloorPlanToUnitMutationOptions = Apollo.BaseMutationOptions<AddFloorPlanToUnitMutation, AddFloorPlanToUnitMutationVariables>;
export const DeleteUnitDocument = gql`
    mutation deleteUnit($unitId: ObjectId!) {
  deleteUnit(unitId: $unitId) {
    _id
  }
}
    `;
export type DeleteUnitMutationFn = Apollo.MutationFunction<DeleteUnitMutation, DeleteUnitMutationVariables>;

/**
 * __useDeleteUnitMutation__
 *
 * To run a mutation, you first call `useDeleteUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnitMutation, { data, loading, error }] = useDeleteUnitMutation({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useDeleteUnitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUnitMutation, DeleteUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUnitMutation, DeleteUnitMutationVariables>(DeleteUnitDocument, options);
      }
export type DeleteUnitMutationHookResult = ReturnType<typeof useDeleteUnitMutation>;
export type DeleteUnitMutationResult = Apollo.MutationResult<DeleteUnitMutation>;
export type DeleteUnitMutationOptions = Apollo.BaseMutationOptions<DeleteUnitMutation, DeleteUnitMutationVariables>;
export const GetUnitsDocument = gql`
    query getUnits($sort: [SortInput!], $pagination: PaginationInput, $filter: GetUnitsFilterInput) {
  getUnits(sort: $sort, pagination: $pagination, filter: $filter) {
    totalCount
    collection {
      ...Unit
    }
  }
}
    ${UnitFragmentDoc}`;

/**
 * __useGetUnitsQuery__
 *
 * To run a query within a React component, call `useGetUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUnitsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitsQuery, GetUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsQuery, GetUnitsQueryVariables>(GetUnitsDocument, options);
      }
export function useGetUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsQuery, GetUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsQuery, GetUnitsQueryVariables>(GetUnitsDocument, options);
        }
export type GetUnitsQueryHookResult = ReturnType<typeof useGetUnitsQuery>;
export type GetUnitsLazyQueryHookResult = ReturnType<typeof useGetUnitsLazyQuery>;
export type GetUnitsQueryResult = Apollo.QueryResult<GetUnitsQuery, GetUnitsQueryVariables>;
export const GetUnitsCountDocument = gql`
    query getUnitsCount($sort: [SortInput!], $pagination: PaginationInput, $filter: GetUnitsFilterInput) {
  getUnits(sort: $sort, pagination: $pagination, filter: $filter) {
    totalCount
  }
}
    `;

/**
 * __useGetUnitsCountQuery__
 *
 * To run a query within a React component, call `useGetUnitsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsCountQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUnitsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitsCountQuery, GetUnitsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsCountQuery, GetUnitsCountQueryVariables>(GetUnitsCountDocument, options);
      }
export function useGetUnitsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsCountQuery, GetUnitsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsCountQuery, GetUnitsCountQueryVariables>(GetUnitsCountDocument, options);
        }
export type GetUnitsCountQueryHookResult = ReturnType<typeof useGetUnitsCountQuery>;
export type GetUnitsCountLazyQueryHookResult = ReturnType<typeof useGetUnitsCountLazyQuery>;
export type GetUnitsCountQueryResult = Apollo.QueryResult<GetUnitsCountQuery, GetUnitsCountQueryVariables>;
export const GetPropertyUnitsSqftRangeDocument = gql`
    query getPropertyUnitsSqftRange($propertyId: ObjectId!) {
  getPropertyUnitsSqftRange(propertyId: $propertyId) {
    min
    max
  }
}
    `;

/**
 * __useGetPropertyUnitsSqftRangeQuery__
 *
 * To run a query within a React component, call `useGetPropertyUnitsSqftRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyUnitsSqftRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyUnitsSqftRangeQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetPropertyUnitsSqftRangeQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyUnitsSqftRangeQuery, GetPropertyUnitsSqftRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyUnitsSqftRangeQuery, GetPropertyUnitsSqftRangeQueryVariables>(GetPropertyUnitsSqftRangeDocument, options);
      }
export function useGetPropertyUnitsSqftRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyUnitsSqftRangeQuery, GetPropertyUnitsSqftRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyUnitsSqftRangeQuery, GetPropertyUnitsSqftRangeQueryVariables>(GetPropertyUnitsSqftRangeDocument, options);
        }
export type GetPropertyUnitsSqftRangeQueryHookResult = ReturnType<typeof useGetPropertyUnitsSqftRangeQuery>;
export type GetPropertyUnitsSqftRangeLazyQueryHookResult = ReturnType<typeof useGetPropertyUnitsSqftRangeLazyQuery>;
export type GetPropertyUnitsSqftRangeQueryResult = Apollo.QueryResult<GetPropertyUnitsSqftRangeQuery, GetPropertyUnitsSqftRangeQueryVariables>;
export const AddUserToCmsDocument = gql`
    mutation addUserToCMS($accountInput: AccountInput!, $profileInput: ProfileInput!) {
  addUserToCMS(accountInput: $accountInput, profileInput: $profileInput) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type AddUserToCmsMutationFn = Apollo.MutationFunction<AddUserToCmsMutation, AddUserToCmsMutationVariables>;

/**
 * __useAddUserToCmsMutation__
 *
 * To run a mutation, you first call `useAddUserToCmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToCmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToCmsMutation, { data, loading, error }] = useAddUserToCmsMutation({
 *   variables: {
 *      accountInput: // value for 'accountInput'
 *      profileInput: // value for 'profileInput'
 *   },
 * });
 */
export function useAddUserToCmsMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToCmsMutation, AddUserToCmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToCmsMutation, AddUserToCmsMutationVariables>(AddUserToCmsDocument, options);
      }
export type AddUserToCmsMutationHookResult = ReturnType<typeof useAddUserToCmsMutation>;
export type AddUserToCmsMutationResult = Apollo.MutationResult<AddUserToCmsMutation>;
export type AddUserToCmsMutationOptions = Apollo.BaseMutationOptions<AddUserToCmsMutation, AddUserToCmsMutationVariables>;
export const AddUserToApiDocument = gql`
    mutation addUserToAPI($accountInput: AccountInput!, $profileInput: ProfileInput!, $apiCredentialsInput: ApiCredentialsInput) {
  addUserToAPI(
    accountInput: $accountInput
    profileInput: $profileInput
    apiCredentialsInput: $apiCredentialsInput
  ) {
    ...ApiUser
  }
}
    ${ApiUserFragmentDoc}`;
export type AddUserToApiMutationFn = Apollo.MutationFunction<AddUserToApiMutation, AddUserToApiMutationVariables>;

/**
 * __useAddUserToApiMutation__
 *
 * To run a mutation, you first call `useAddUserToApiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToApiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToApiMutation, { data, loading, error }] = useAddUserToApiMutation({
 *   variables: {
 *      accountInput: // value for 'accountInput'
 *      profileInput: // value for 'profileInput'
 *      apiCredentialsInput: // value for 'apiCredentialsInput'
 *   },
 * });
 */
export function useAddUserToApiMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToApiMutation, AddUserToApiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToApiMutation, AddUserToApiMutationVariables>(AddUserToApiDocument, options);
      }
export type AddUserToApiMutationHookResult = ReturnType<typeof useAddUserToApiMutation>;
export type AddUserToApiMutationResult = Apollo.MutationResult<AddUserToApiMutation>;
export type AddUserToApiMutationOptions = Apollo.BaseMutationOptions<AddUserToApiMutation, AddUserToApiMutationVariables>;
export const UpdateUserCmsDocument = gql`
    mutation updateUserCMS($accountUpdateInput: UpdateAccountInput!, $profileInput: ProfileInput!) {
  updateUserCMS(
    accountUpdateInput: $accountUpdateInput
    profileInput: $profileInput
  ) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserCmsMutationFn = Apollo.MutationFunction<UpdateUserCmsMutation, UpdateUserCmsMutationVariables>;

/**
 * __useUpdateUserCmsMutation__
 *
 * To run a mutation, you first call `useUpdateUserCmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCmsMutation, { data, loading, error }] = useUpdateUserCmsMutation({
 *   variables: {
 *      accountUpdateInput: // value for 'accountUpdateInput'
 *      profileInput: // value for 'profileInput'
 *   },
 * });
 */
export function useUpdateUserCmsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCmsMutation, UpdateUserCmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCmsMutation, UpdateUserCmsMutationVariables>(UpdateUserCmsDocument, options);
      }
export type UpdateUserCmsMutationHookResult = ReturnType<typeof useUpdateUserCmsMutation>;
export type UpdateUserCmsMutationResult = Apollo.MutationResult<UpdateUserCmsMutation>;
export type UpdateUserCmsMutationOptions = Apollo.BaseMutationOptions<UpdateUserCmsMutation, UpdateUserCmsMutationVariables>;
export const UpdateUserApiDocument = gql`
    mutation updateUserAPI($accountUpdateInput: UpdateAccountInput!, $profileInput: ProfileInput!, $apiCredentialsInput: ApiCredentialsInput) {
  updateUserAPI(
    accountUpdateInput: $accountUpdateInput
    profileInput: $profileInput
    apiCredentialsInput: $apiCredentialsInput
  ) {
    ...ApiUser
  }
}
    ${ApiUserFragmentDoc}`;
export type UpdateUserApiMutationFn = Apollo.MutationFunction<UpdateUserApiMutation, UpdateUserApiMutationVariables>;

/**
 * __useUpdateUserApiMutation__
 *
 * To run a mutation, you first call `useUpdateUserApiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserApiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserApiMutation, { data, loading, error }] = useUpdateUserApiMutation({
 *   variables: {
 *      accountUpdateInput: // value for 'accountUpdateInput'
 *      profileInput: // value for 'profileInput'
 *      apiCredentialsInput: // value for 'apiCredentialsInput'
 *   },
 * });
 */
export function useUpdateUserApiMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserApiMutation, UpdateUserApiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserApiMutation, UpdateUserApiMutationVariables>(UpdateUserApiDocument, options);
      }
export type UpdateUserApiMutationHookResult = ReturnType<typeof useUpdateUserApiMutation>;
export type UpdateUserApiMutationResult = Apollo.MutationResult<UpdateUserApiMutation>;
export type UpdateUserApiMutationOptions = Apollo.BaseMutationOptions<UpdateUserApiMutation, UpdateUserApiMutationVariables>;
export const DeleteUserCmsDocument = gql`
    mutation deleteUserCMS($accountId: ObjectId!, $profileId: ObjectId!) {
  deleteUserCMS(accountId: $accountId, profileId: $profileId) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type DeleteUserCmsMutationFn = Apollo.MutationFunction<DeleteUserCmsMutation, DeleteUserCmsMutationVariables>;

/**
 * __useDeleteUserCmsMutation__
 *
 * To run a mutation, you first call `useDeleteUserCmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserCmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserCmsMutation, { data, loading, error }] = useDeleteUserCmsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useDeleteUserCmsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserCmsMutation, DeleteUserCmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserCmsMutation, DeleteUserCmsMutationVariables>(DeleteUserCmsDocument, options);
      }
export type DeleteUserCmsMutationHookResult = ReturnType<typeof useDeleteUserCmsMutation>;
export type DeleteUserCmsMutationResult = Apollo.MutationResult<DeleteUserCmsMutation>;
export type DeleteUserCmsMutationOptions = Apollo.BaseMutationOptions<DeleteUserCmsMutation, DeleteUserCmsMutationVariables>;
export const ArchiveCmsUserDocument = gql`
    mutation archiveCMSUser($cmsUserAccountId: ObjectId!, $archive: Boolean) {
  archiveCMSUser(cmsUserAccountId: $cmsUserAccountId, archive: $archive)
}
    `;
export type ArchiveCmsUserMutationFn = Apollo.MutationFunction<ArchiveCmsUserMutation, ArchiveCmsUserMutationVariables>;

/**
 * __useArchiveCmsUserMutation__
 *
 * To run a mutation, you first call `useArchiveCmsUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCmsUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCmsUserMutation, { data, loading, error }] = useArchiveCmsUserMutation({
 *   variables: {
 *      cmsUserAccountId: // value for 'cmsUserAccountId'
 *      archive: // value for 'archive'
 *   },
 * });
 */
export function useArchiveCmsUserMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCmsUserMutation, ArchiveCmsUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCmsUserMutation, ArchiveCmsUserMutationVariables>(ArchiveCmsUserDocument, options);
      }
export type ArchiveCmsUserMutationHookResult = ReturnType<typeof useArchiveCmsUserMutation>;
export type ArchiveCmsUserMutationResult = Apollo.MutationResult<ArchiveCmsUserMutation>;
export type ArchiveCmsUserMutationOptions = Apollo.BaseMutationOptions<ArchiveCmsUserMutation, ArchiveCmsUserMutationVariables>;
export const UpdateCurrentUserDocument = gql`
    mutation updateCurrentUser($profileInput: ProfileInput!) {
  updateCurrentUser(profileInput: $profileInput) {
    ...Profile
  }
}
    ${ProfileFragmentDoc}`;
export type UpdateCurrentUserMutationFn = Apollo.MutationFunction<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>;

/**
 * __useUpdateCurrentUserMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserMutation, { data, loading, error }] = useUpdateCurrentUserMutation({
 *   variables: {
 *      profileInput: // value for 'profileInput'
 *   },
 * });
 */
export function useUpdateCurrentUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>(UpdateCurrentUserDocument, options);
      }
export type UpdateCurrentUserMutationHookResult = ReturnType<typeof useUpdateCurrentUserMutation>;
export type UpdateCurrentUserMutationResult = Apollo.MutationResult<UpdateCurrentUserMutation>;
export type UpdateCurrentUserMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>;
export const DeleteApiAccountDocument = gql`
    mutation DeleteApiAccount($apiCredentialsId: String!) {
  deleteApiAccount(apiCredentialsId: $apiCredentialsId) {
    revokedPluginUsers
  }
}
    `;
export type DeleteApiAccountMutationFn = Apollo.MutationFunction<DeleteApiAccountMutation, DeleteApiAccountMutationVariables>;

/**
 * __useDeleteApiAccountMutation__
 *
 * To run a mutation, you first call `useDeleteApiAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiAccountMutation, { data, loading, error }] = useDeleteApiAccountMutation({
 *   variables: {
 *      apiCredentialsId: // value for 'apiCredentialsId'
 *   },
 * });
 */
export function useDeleteApiAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApiAccountMutation, DeleteApiAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApiAccountMutation, DeleteApiAccountMutationVariables>(DeleteApiAccountDocument, options);
      }
export type DeleteApiAccountMutationHookResult = ReturnType<typeof useDeleteApiAccountMutation>;
export type DeleteApiAccountMutationResult = Apollo.MutationResult<DeleteApiAccountMutation>;
export type DeleteApiAccountMutationOptions = Apollo.BaseMutationOptions<DeleteApiAccountMutation, DeleteApiAccountMutationVariables>;
export const RestoreApiAccountDocument = gql`
    mutation RestoreApiAccount($apiCredentialsId: String!) {
  restoreApiAccount(apiCredentialsId: $apiCredentialsId) {
    restoredPluginUsers
    isActive
  }
}
    `;
export type RestoreApiAccountMutationFn = Apollo.MutationFunction<RestoreApiAccountMutation, RestoreApiAccountMutationVariables>;

/**
 * __useRestoreApiAccountMutation__
 *
 * To run a mutation, you first call `useRestoreApiAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreApiAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreApiAccountMutation, { data, loading, error }] = useRestoreApiAccountMutation({
 *   variables: {
 *      apiCredentialsId: // value for 'apiCredentialsId'
 *   },
 * });
 */
export function useRestoreApiAccountMutation(baseOptions?: Apollo.MutationHookOptions<RestoreApiAccountMutation, RestoreApiAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreApiAccountMutation, RestoreApiAccountMutationVariables>(RestoreApiAccountDocument, options);
      }
export type RestoreApiAccountMutationHookResult = ReturnType<typeof useRestoreApiAccountMutation>;
export type RestoreApiAccountMutationResult = Apollo.MutationResult<RestoreApiAccountMutation>;
export type RestoreApiAccountMutationOptions = Apollo.BaseMutationOptions<RestoreApiAccountMutation, RestoreApiAccountMutationVariables>;
export const GetCmsUsersDocument = gql`
    query GetCMSUsers($filter: GetCMSUsersFilterInput, $pagination: PaginationInput, $sort: [SortInput!]) {
  getCMSUsers(filter: $filter, pagination: $pagination, sort: $sort) {
    collection {
      ...UserForList
    }
    totalCount
  }
}
    ${UserForListFragmentDoc}`;

/**
 * __useGetCmsUsersQuery__
 *
 * To run a query within a React component, call `useGetCmsUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCmsUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetCmsUsersQuery, GetCmsUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmsUsersQuery, GetCmsUsersQueryVariables>(GetCmsUsersDocument, options);
      }
export function useGetCmsUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmsUsersQuery, GetCmsUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmsUsersQuery, GetCmsUsersQueryVariables>(GetCmsUsersDocument, options);
        }
export type GetCmsUsersQueryHookResult = ReturnType<typeof useGetCmsUsersQuery>;
export type GetCmsUsersLazyQueryHookResult = ReturnType<typeof useGetCmsUsersLazyQuery>;
export type GetCmsUsersQueryResult = Apollo.QueryResult<GetCmsUsersQuery, GetCmsUsersQueryVariables>;
export const GetApiUsersDocument = gql`
    query GetApiUsers($filter: GetApiUsersFilterInput, $pagination: PaginationInput, $sort: [SortInput!]) {
  getApiUsers(filter: $filter, pagination: $pagination, sort: $sort) {
    collection {
      ...ApiUserForList
    }
    totalCount
  }
}
    ${ApiUserForListFragmentDoc}`;

/**
 * __useGetApiUsersQuery__
 *
 * To run a query within a React component, call `useGetApiUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetApiUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetApiUsersQuery, GetApiUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiUsersQuery, GetApiUsersQueryVariables>(GetApiUsersDocument, options);
      }
export function useGetApiUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiUsersQuery, GetApiUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiUsersQuery, GetApiUsersQueryVariables>(GetApiUsersDocument, options);
        }
export type GetApiUsersQueryHookResult = ReturnType<typeof useGetApiUsersQuery>;
export type GetApiUsersLazyQueryHookResult = ReturnType<typeof useGetApiUsersLazyQuery>;
export type GetApiUsersQueryResult = Apollo.QueryResult<GetApiUsersQuery, GetApiUsersQueryVariables>;
export const GetDevelopersAsSaleUsersBySaleTeamAndRoleDocument = gql`
    query getDevelopersAsSaleUsersBySaleTeamAndRole($saleTeamId: ObjectId!, $roleType: RoleTypesEnum) {
  getDevelopersAsSaleUsersBySaleTeamAndRole(
    saleTeamId: $saleTeamId
    roleType: $roleType
  ) {
    __typename
    ... on SaleTeamUser {
      _id
      saleTeamId
      profile {
        _id
        firstName
        lastName
      }
    }
    ... on OrganizationUser {
      _id
      internalSaleTeamId
      profile {
        _id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetDevelopersAsSaleUsersBySaleTeamAndRoleQuery__
 *
 * To run a query within a React component, call `useGetDevelopersAsSaleUsersBySaleTeamAndRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevelopersAsSaleUsersBySaleTeamAndRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevelopersAsSaleUsersBySaleTeamAndRoleQuery({
 *   variables: {
 *      saleTeamId: // value for 'saleTeamId'
 *      roleType: // value for 'roleType'
 *   },
 * });
 */
export function useGetDevelopersAsSaleUsersBySaleTeamAndRoleQuery(baseOptions: Apollo.QueryHookOptions<GetDevelopersAsSaleUsersBySaleTeamAndRoleQuery, GetDevelopersAsSaleUsersBySaleTeamAndRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDevelopersAsSaleUsersBySaleTeamAndRoleQuery, GetDevelopersAsSaleUsersBySaleTeamAndRoleQueryVariables>(GetDevelopersAsSaleUsersBySaleTeamAndRoleDocument, options);
      }
export function useGetDevelopersAsSaleUsersBySaleTeamAndRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDevelopersAsSaleUsersBySaleTeamAndRoleQuery, GetDevelopersAsSaleUsersBySaleTeamAndRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDevelopersAsSaleUsersBySaleTeamAndRoleQuery, GetDevelopersAsSaleUsersBySaleTeamAndRoleQueryVariables>(GetDevelopersAsSaleUsersBySaleTeamAndRoleDocument, options);
        }
export type GetDevelopersAsSaleUsersBySaleTeamAndRoleQueryHookResult = ReturnType<typeof useGetDevelopersAsSaleUsersBySaleTeamAndRoleQuery>;
export type GetDevelopersAsSaleUsersBySaleTeamAndRoleLazyQueryHookResult = ReturnType<typeof useGetDevelopersAsSaleUsersBySaleTeamAndRoleLazyQuery>;
export type GetDevelopersAsSaleUsersBySaleTeamAndRoleQueryResult = Apollo.QueryResult<GetDevelopersAsSaleUsersBySaleTeamAndRoleQuery, GetDevelopersAsSaleUsersBySaleTeamAndRoleQueryVariables>;